// Campaign Lists
export const campaignList = [
    {
        "campaignName": "Reach Skippable - Seasonal Offer",
        "budget": 10,
        "campaignId": 9,
        "platforms": 1,
        "advertiser": "Demo Advertiser",
        "startDate": "2025-01-10 11:29:28",
        "endDate": "2025-01-10 18:29:59",
        "status": 1,
        "recos": 0,
        "isDataPresent": 0,
        "campaigns": [
            {
                "campaignName": "Reach Skippable - Seasonal Offer_ads_1",
                "budget": 10,
                "campaignId": 1948,
                "platform": 4,
                "startDate": "2025-01-10 11:35:48",
                "endDate": "2025-01-10 18:29:59",
                "status": 1,
                "recos": 0,
                "type": "0",
                "dashRedir": 0,
                "synced": 0,
                "isErrorPresent": false,
                "errors": {
                    "strategy": []
                },
                "mandateId": 7,
                "isReco": 0,
                "isYoutubeCampaign": false,
                "isEditable": true
            }
        ],
        "advertiserId": 1832,
        "createdOn": "2025-01-10 11:29:28",
        "modifiedOn": "2025-01-10 11:45:20",
        "isErrorPresent": false,
        "isReco": 0
    },
    {
        "campaignName": "Audience Awareness - New Year Teaser",
        "budget": 10,
        "campaignId": 7,
        "platforms": 1,
        "advertiser": "Demo Advertiser",
        "startDate": "2025-01-10 11:29:28",
        "endDate": "2025-01-10 18:29:59",
        "status": 1,
        "recos": 0,
        "isDataPresent": 0,
        "campaigns": [
            {
                "campaignName": "Audience Awareness - New Year Teaser_ads_1",
                "budget": 10,
                "campaignId": 1748,
                "platform": 4,
                "startDate": "2025-01-10 11:35:48",
                "endDate": "2025-01-10 18:29:59",
                "status": 1,
                "recos": 0,
                "type": "0",
                "dashRedir": 0,
                "synced": 0,
                "isErrorPresent": false,
                "errors": {
                    "strategy": []
                },
                "mandateId": 7,
                "isReco": 0,
                "isYoutubeCampaign": false,
                "isEditable": true
            }
        ],
        "advertiserId": 1832,
        "createdOn": "2025-01-10 11:29:28",
        "modifiedOn": "2025-01-10 11:45:20",
        "isErrorPresent": false,
        "isReco": 0
    },
    {
        "campaignName": "Brand Awareness - Festive Teaser",
        "budget": 10,
        "campaignId": 5,
        "platforms": 1,
        "advertiser": "Demo Advertiser",
        "startDate": "2025-01-10 11:29:28",
        "endDate": "2025-01-10 18:29:59",
        "status": 1,
        "recos": 0,
        "isDataPresent": 0,
        "campaigns": [
            {
                "campaignName": "Brand Awareness - Festive Teaser_ads_1",
                "budget": 10,
                "campaignId": 1548,
                "platform": 4,
                "startDate": "2025-01-10 11:35:48",
                "endDate": "2025-01-10 18:29:59",
                "status": 1,
                "recos": 0,
                "type": "0",
                "dashRedir": 0,
                "synced": 0,
                "isErrorPresent": false,
                "errors": {
                    "strategy": []
                },
                "mandateId": 5,
                "isReco": 0,
                "isYoutubeCampaign": false,
                "isEditable": true
            }
        ],
        "advertiserId": 1832,
        "createdOn": "2025-01-10 11:29:28",
        "modifiedOn": "2025-01-10 11:45:20",
        "isErrorPresent": false,
        "isReco": 0
    },
    {
        "campaignName": "Customer Engagement - Holiday Campaign",
        "budget": 10,
        "campaignId": 4,
        "platforms": 1,
        "advertiser": "Demo Advertiser",
        "startDate": "2025-02-04 13:01:52",
        "endDate": "2025-02-04 22:59:59",
        "status": 1,
        "recos": 0,
        "isDataPresent": 0,
        "campaigns": [
            {
                "campaignName": "Customer Engagement - Holiday Campaign_1",
                "budget": 0,
                "campaignId": 1404,
                "platform": 5,
                "startDate": "2025-02-04 05:01:04",
                "endDate": "2025-02-04 22:59:59",
                "status": 1,
                "recos": 0,
                "type": "0",
                "dashRedir": 0,
                "synced": 0,
                "isErrorPresent": false,
                "errors": {
                    "strategy": [
                        {
                            "creative": []
                        }
                    ]
                },
                "mandateId": 4,
                "isReco": 0,
                "isYoutubeCampaign": false,
                "isEditable": true
            },
            {
                "campaignName": "Customer Engagement - Holiday Campaign_2",
                "budget": 0,
                "campaignId": 1505,
                "platform": 5,
                "startDate": "2025-02-04 11:43:52",
                "endDate": "2025-02-04 22:59:59",
                "status": 1,
                "recos": 0,
                "type": "",
                "dashRedir": 0,
                "synced": 0,
                "isErrorPresent": false,
                "errors": {
                    "strategy": []
                },
                "mandateId": 4,
                "isReco": 0,
                "isYoutubeCampaign": false,
                "isEditable": true
            }
        ],
        "advertiserId": 1872,
        "createdOn": "2025-02-04 13:01:53",
        "modifiedOn": "2025-02-05 04:52:58",
        "isErrorPresent": false,
        "isReco": 0
    },
    {
        "campaignName": "DV360 Campaign",
        "budget": 10,
        "campaignId": 928,
        "platforms": 1,
        "advertiser": "Demo Advertiser",
        "startDate": "2025-02-04 13:01:52",
        "endDate": "2025-02-04 22:59:59",
        "status": 2,
        "recos": 0,
        "isDataPresent": 0,
        "campaigns": [
            {
                "campaignName": "DV360 Campaign_dv360_1",
                "budget": 0,
                "campaignId": 1406,
                "platform": 5,
                "startDate": "2025-02-04 05:01:04",
                "endDate": "2025-02-04 22:59:59",
                "status": 2,
                "recos": 0,
                "type": "0",
                "dashRedir": 0,
                "synced": 0,
                "isErrorPresent": false,
                "errors": {
                    "strategy": [
                        {
                            "creative": []
                        }
                    ]
                },
                "mandateId": 928,
                "isReco": 0,
                "isYoutubeCampaign": false,
                "isEditable": true
            },
            {
                "campaignName": "DV360 Campaign_dv360_2",
                "budget": 0,
                "campaignId": 1407,
                "platform": 5,
                "startDate": "2025-02-04 11:43:52",
                "endDate": "2025-02-04 22:59:59",
                "status": 2,
                "recos": 0,
                "type": "",
                "dashRedir": 0,
                "synced": 0,
                "isErrorPresent": false,
                "errors": {
                    "strategy": []
                },
                "mandateId": 928,
                "isReco": 0,
                "isYoutubeCampaign": false,
                "isEditable": true
            }
        ],
        "advertiserId": 1872,
        "createdOn": "2025-02-04 13:01:53",
        "modifiedOn": "2025-02-05 04:52:58",
        "isErrorPresent": false,
        "isReco": 0
    },
    {
        "campaignName": "Google Ads Campaign",
        "budget": 10,
        "campaignId": 884,
        "platforms": 1,
        "advertiser": "Demo Advertiser",
        "startDate": "2025-01-10 11:29:28",
        "endDate": "2025-01-10 18:29:59",
        "status": 2,
        "recos": 0,
        "isDataPresent": 0,
        "campaigns": [
            {
                "campaignName": "Google Ads Campaign_ads_1",
                "budget": 10,
                "campaignId": 1348,
                "platform": 4,
                "startDate": "2025-01-10 11:35:48",
                "endDate": "2025-01-10 18:29:59",
                "status": 2,
                "recos": 0,
                "type": "0",
                "dashRedir": 0,
                "synced": 0,
                "isErrorPresent": false,
                "errors": {
                    "strategy": []
                },
                "mandateId": 884,
                "isReco": 0,
                "isYoutubeCampaign": false,
                "isEditable": true
            }
        ],
        "advertiserId": 1832,
        "createdOn": "2025-01-10 11:29:28",
        "modifiedOn": "2025-01-10 11:45:20",
        "isErrorPresent": false,
        "isReco": 0
    },
    {
        "campaignName": "Meta Campaign",
        "budget": 5.0,
        "campaignId": 887,
        "platforms": 1,
        "advertiser": "FroBecViAds",
        "startDate": "2025-01-15 05:40:57",
        "endDate": "2025-01-16 18:29:59",
        "status": 2,
        "recos": 0,
        "isDataPresent": 0,
        "campaigns": [
            {
                "campaignName": "Meta Campaign_meta_1",
                "budget": 0.0,
                "campaignId": 1351,
                "platform": 3,
                "startDate": "2025-01-15 05:41:04",
                "endDate": "2025-01-16 18:29:59",
                "status": 2,
                "recos": 0,
                "type": "0",
                "customerId": "735759678205531",
                "dashRedir": 0,
                "synced": 0,
                "isErrorPresent": false,
                "errors": {
                    "strategy": [
                        {
                            "creative": []
                        }
                    ]
                },
                "mandateId": 887,
                "isReco": 0,
                "isYoutubeCampaign": false,
                "isEditable": true
            }
        ],
        "advertiserId": 1760,
        "createdOn": "2025-01-15 05:40:58",
        "modifiedOn": "2025-01-30 05:19:34",
        "isErrorPresent": false,
        "isReco": 0
    },
    {
        "campaignName": "Google Ads Recommended Campaign",
        "budget": 100.0,
        "campaignId": 765,
        "platforms": 0,
        "advertiser": "Demo Advertiser",
        "startDate": "2024-10-09 11:47:15",
        "endDate": "2024-10-17 18:29:59",
        "status": 3,
        "recos": 0,
        "advertiserId": 1760,
        "createdOn": "2024-10-09 11:47:15",
        "isErrorPresent": false,
        "isReco": 1
    },
    {
        "campaignName": "Website Traffic - Winter Sale",
        "budget": 5.0,
        "campaignId": 6,
        "platforms": 1,
        "advertiser": "FroBecViAds",
        "startDate": "2025-01-15 05:40:57",
        "endDate": "2025-01-16 18:29:59",
        "status": 1,
        "recos": 0,
        "isDataPresent": 0,
        "campaigns": [
            {
                "campaignName": "Website Traffic - Winter Sale_meta_1",
                "budget": 0.0,
                "campaignId": 1361,
                "platform": 3,
                "startDate": "2025-01-15 05:41:04",
                "endDate": "2025-01-16 18:29:59",
                "status": 1,
                "recos": 0,
                "type": "0",
                "customerId": "735759678205531",
                "dashRedir": 0,
                "synced": 0,
                "isErrorPresent": false,
                "errors": {
                    "strategy": [
                        {
                            "creative": []
                        }
                    ]
                },
                "mandateId": 6,
                "isReco": 0,
                "isYoutubeCampaign": false,
                "isEditable": true
            }
        ],
        "advertiserId": 1760,
        "createdOn": "2025-01-15 05:40:58",
        "modifiedOn": "2025-01-30 05:19:34",
        "isErrorPresent": false,
        "isReco": 0
    },
    {
        "campaignName": "Truview Skippable - Product Launch",
        "budget": 5.0,
        "campaignId": 8,
        "platforms": 1,
        "advertiser": "FroBecViAds",
        "startDate": "2025-01-15 05:40:57",
        "endDate": "2025-01-16 18:29:59",
        "status": 1,
        "recos": 0,
        "isDataPresent": 0,
        "campaigns": [
            {
                "campaignName": "Truview Skippable - Product Launch_meta_1",
                "budget": 0.0,
                "campaignId": 1861,
                "platform": 3,
                "startDate": "2025-01-15 05:41:04",
                "endDate": "2025-01-16 18:29:59",
                "status": 1,
                "recos": 0,
                "type": "0",
                "customerId": "735759678205531",
                "dashRedir": 0,
                "synced": 0,
                "isErrorPresent": false,
                "errors": {
                    "strategy": [
                        {
                            "creative": []
                        }
                    ]
                },
                "mandateId": 8,
                "isReco": 0,
                "isYoutubeCampaign": false,
                "isEditable": true
            }
        ],
        "advertiserId": 1760,
        "createdOn": "2025-01-15 05:40:58",
        "modifiedOn": "2025-01-30 05:19:34",
        "isErrorPresent": false,
        "isReco": 0
    },
]

// Custom Plans & Strategy Data
export const campaignListData = [
    {
        "responseCode": {
            "msg": "Campaign List Fetched Successfully",
            "status": "Success",
            "code": 20010
        },
        "response": [
            {
                "mandateId": 9,
                "id": 1948,
                "name": "Reach Skippable - Seasonal Offer_1",
                "budget": 10.0,
                "pacingType": 29,
                "durationType": 4036,
                "platformName": "ads",
                "platformId": 4,
                "mediaType": 0,
                "startDate": "2025-01-10 11:35:48",
                "endDate": "2025-01-10 18:29:59",
                "status": 2,
                "targeting": {
                    "location": [],
                    "audience": [],
                    "language": [],
                    "daypart": [],
                    "device": [],
                    "adRotation": 1
                },
                "strategies": [
                    {
                        "name": "Reach Skippable - Seasonal Offer_1_ads_Strategy_1",
                        "id": 1473,
                        "campaignId": 1948,
                        "startDate": "2025-01-10 11:35:48",
                        "endDate": "2025-01-10 18:29:59",
                        "mediaType": 0,
                        "status": 2,
                        "pacingTypeName": "Standard",
                        "durationTypeName": "LifeTime",
                        "biddingStrategy": "146",
                        "biddingStrategyName": "Maximize click",
                        "bidCap": 0.2,
                        "platformId": 4,
                        "isLocationPresent": false,
                        "isAudiencePresent": false,
                        "isKeywordPresent": false,
                        "isDayPartPresent": false,
                        "isPositionPresent": false,
                        "isSitesPresent": false,
                        "targeting": {
                            "location": [],
                            "audience": [],
                            "language": [],
                            "daypart": [],
                            "device": [],
                            "age": [],
                            "position": [],
                            "keyword": [],
                            "sites": [],
                            "gender": []
                        },
                        "creative": {
                            "utm": "",
                            "campaignId": 1948,
                            "strategyId": 1473,
                            "creatives": [
                                {
                                    "status": 2,
                                    "id": 1069,
                                    "creativeId": 1282,
                                    "campaignId": 1948,
                                    "strategyId": 1473
                                }
                            ],
                            "creativeDetails": [
                                {
                                    "id": 1050,
                                    "platId": 4,
                                    "title": "GoogleAds Creative",
                                    "isApproved": 0,
                                    "crType": 18,
                                    "description": "",
                                    "heading": "",
                                    "landingUrl": "https://devbeki.torcai.com/atd",
                                    "tags": [],
                                    "isRecActive": 1,
                                    "isActive": 1,
                                    "mediaList": [
                                        {
                                            "id": 1069,
                                            "gcId": 1050,
                                            "adSize": "300X100",
                                            "isRecActive": 1,
                                            "isActive": 1,
                                            "url": "https://stagecdn.torcai.com/image/1832/1738932556037_images_(1).jpg",
                                            "mimeType": "image/jpeg",
                                            "bitrate": 0,
                                            "duration": 0.0,
                                            "tagUrl": "",
                                            "isApproved": 0,
                                            "trackers": []
                                        }
                                    ],
                                    "isSynced": 0
                                }
                            ]
                        },
                        "syncedAttributes": {},
                        "synced": 0
                    }
                ],
                "pacingTypeName": "Standard",
                "durationTypeName": "LifeTime",
                "biddingStrategy": "146",
                "biddingStrategyName": "Maximize click",
                "bidCap": 0.2,
                "checked": false,
                "pacingBudget": 10.0,
                "syncedAttributes": {},
                "totalBudget": 10.0,
                "synced": 0,
                "isReco": 0,
                "isEditable": true,
                "isYoutubeCampaign": false
            }
        ],
        "length": 0,
        "responseObj": {
            "totalBudget": 10.0,
            "campaignId": 9,
            "campaignName": "Reach Skippable - Seasonal Offer",
            "goal": 355,
            "goalValue": 2.0,
            "startDate": "2025-01-10 11:29:28",
            "endDate": "2025-01-10 18:29:59",
            "businessType": 353,
            "brandName": "google",
            "brandUrl": "https://cdn.freebiesupply.com/images/large/2x/nestle-logo-black-and-white.png",
            "category": 164,
            "subcategory": 210,
            "advId": 1832,
            "id": 884,
            "isRecActive": 2,
            "planList": [],
            "isReco": 0
        }
    },
    {
        "responseCode": {
            "msg": "Campaign List Fetched Successfully",
            "status": "Success",
            "code": 20010
        },
        "response": [
            {
                "mandateId": 7,
                "id": 1748,
                "name": "Audience Awareness - New Year Teaser_1",
                "budget": 10.0,
                "pacingType": 29,
                "durationType": 4036,
                "platformName": "ads",
                "platformId": 4,
                "mediaType": 0,
                "startDate": "2025-01-10 11:35:48",
                "endDate": "2025-01-10 18:29:59",
                "status": 2,
                "targeting": {
                    "location": [],
                    "audience": [],
                    "language": [],
                    "daypart": [],
                    "device": [],
                    "adRotation": 1
                },
                "strategies": [
                    {
                        "name": "Audience Awareness - New Year Teaser_1_ads_Strategy_1",
                        "id": 1473,
                        "campaignId": 1748,
                        "startDate": "2025-01-10 11:35:48",
                        "endDate": "2025-01-10 18:29:59",
                        "mediaType": 0,
                        "status": 2,
                        "pacingTypeName": "Standard",
                        "durationTypeName": "LifeTime",
                        "biddingStrategy": "146",
                        "biddingStrategyName": "Maximize click",
                        "bidCap": 0.2,
                        "platformId": 4,
                        "isLocationPresent": false,
                        "isAudiencePresent": false,
                        "isKeywordPresent": false,
                        "isDayPartPresent": false,
                        "isPositionPresent": false,
                        "isSitesPresent": false,
                        "targeting": {
                            "location": [],
                            "audience": [],
                            "language": [],
                            "daypart": [],
                            "device": [],
                            "age": [],
                            "position": [],
                            "keyword": [],
                            "sites": [],
                            "gender": []
                        },
                        "creative": {
                            "utm": "",
                            "campaignId": 1748,
                            "strategyId": 1473,
                            "creatives": [
                                {
                                    "status": 2,
                                    "id": 1069,
                                    "creativeId": 1282,
                                    "campaignId": 1748,
                                    "strategyId": 1473
                                }
                            ],
                            "creativeDetails": [
                                {
                                    "id": 1050,
                                    "platId": 4,
                                    "title": "GoogleAds Creative",
                                    "isApproved": 0,
                                    "crType": 18,
                                    "description": "",
                                    "heading": "",
                                    "landingUrl": "https://devbeki.torcai.com/atd",
                                    "tags": [],
                                    "isRecActive": 1,
                                    "isActive": 1,
                                    "mediaList": [
                                        {
                                            "id": 1069,
                                            "gcId": 1050,
                                            "adSize": "300X100",
                                            "isRecActive": 1,
                                            "isActive": 1,
                                            "url": "https://stagecdn.torcai.com/image/1832/1738932556037_images_(1).jpg",
                                            "mimeType": "image/jpeg",
                                            "bitrate": 0,
                                            "duration": 0.0,
                                            "tagUrl": "",
                                            "isApproved": 0,
                                            "trackers": []
                                        }
                                    ],
                                    "isSynced": 0
                                }
                            ]
                        },
                        "syncedAttributes": {},
                        "synced": 0
                    }
                ],
                "pacingTypeName": "Standard",
                "durationTypeName": "LifeTime",
                "biddingStrategy": "146",
                "biddingStrategyName": "Maximize click",
                "bidCap": 0.2,
                "checked": false,
                "pacingBudget": 10.0,
                "syncedAttributes": {},
                "totalBudget": 10.0,
                "synced": 0,
                "isReco": 0,
                "isEditable": true,
                "isYoutubeCampaign": false
            }
        ],
        "length": 0,
        "responseObj": {
            "totalBudget": 10.0,
            "campaignId": 7,
            "campaignName": "Audience Awareness - New Year Teaser",
            "goal": 355,
            "goalValue": 2.0,
            "startDate": "2025-01-10 11:29:28",
            "endDate": "2025-01-10 18:29:59",
            "businessType": 353,
            "brandName": "google",
            "brandUrl": "https://cdn.freebiesupply.com/images/large/2x/nestle-logo-black-and-white.png",
            "category": 164,
            "subcategory": 210,
            "advId": 1832,
            "id": 884,
            "isRecActive": 2,
            "planList": [],
            "isReco": 0
        }
    },
    {
        "responseCode": {
            "msg": "Campaign List Fetched Successfully",
            "status": "Success",
            "code": 20010
        },
        "response": [
            {
                "mandateId": 5,
                "id": 1548,
                "name": "Brand Awareness - Festive Teaser_1",
                "budget": 10.0,
                "pacingType": 29,
                "durationType": 4036,
                "platformName": "ads",
                "platformId": 4,
                "mediaType": 0,
                "startDate": "2025-01-10 11:35:48",
                "endDate": "2025-01-10 18:29:59",
                "status": 2,
                "targeting": {
                    "location": [],
                    "audience": [],
                    "language": [],
                    "daypart": [],
                    "device": [],
                    "adRotation": 1
                },
                "strategies": [
                    {
                        "name": "Brand Awareness - Festive Teaser_1_ads_Strategy_1",
                        "id": 1473,
                        "campaignId": 1548,
                        "startDate": "2025-01-10 11:35:48",
                        "endDate": "2025-01-10 18:29:59",
                        "mediaType": 0,
                        "status": 2,
                        "pacingTypeName": "Standard",
                        "durationTypeName": "LifeTime",
                        "biddingStrategy": "146",
                        "biddingStrategyName": "Maximize click",
                        "bidCap": 0.2,
                        "platformId": 4,
                        "isLocationPresent": false,
                        "isAudiencePresent": false,
                        "isKeywordPresent": false,
                        "isDayPartPresent": false,
                        "isPositionPresent": false,
                        "isSitesPresent": false,
                        "targeting": {
                            "location": [],
                            "audience": [],
                            "language": [],
                            "daypart": [],
                            "device": [],
                            "age": [],
                            "position": [],
                            "keyword": [],
                            "sites": [],
                            "gender": []
                        },
                        "creative": {
                            "utm": "",
                            "campaignId": 1548,
                            "strategyId": 1473,
                            "creatives": [
                                {
                                    "status": 2,
                                    "id": 1069,
                                    "creativeId": 1282,
                                    "campaignId": 1548,
                                    "strategyId": 1473
                                }
                            ],
                            "creativeDetails": [
                                {
                                    "id": 1050,
                                    "platId": 4,
                                    "title": "GoogleAds Creative",
                                    "isApproved": 0,
                                    "crType": 18,
                                    "description": "",
                                    "heading": "",
                                    "landingUrl": "https://devbeki.torcai.com/atd",
                                    "tags": [],
                                    "isRecActive": 1,
                                    "isActive": 1,
                                    "mediaList": [
                                        {
                                            "id": 1069,
                                            "gcId": 1050,
                                            "adSize": "300X100",
                                            "isRecActive": 1,
                                            "isActive": 1,
                                            "url": "https://stagecdn.torcai.com/image/1832/1738932556037_images_(1).jpg",
                                            "mimeType": "image/jpeg",
                                            "bitrate": 0,
                                            "duration": 0.0,
                                            "tagUrl": "",
                                            "isApproved": 0,
                                            "trackers": []
                                        }
                                    ],
                                    "isSynced": 0
                                }
                            ]
                        },
                        "syncedAttributes": {},
                        "synced": 0
                    }
                ],
                "pacingTypeName": "Standard",
                "durationTypeName": "LifeTime",
                "biddingStrategy": "146",
                "biddingStrategyName": "Maximize click",
                "bidCap": 0.2,
                "checked": false,
                "pacingBudget": 10.0,
                "syncedAttributes": {},
                "totalBudget": 10.0,
                "synced": 0,
                "isReco": 0,
                "isEditable": true,
                "isYoutubeCampaign": false
            }
        ],
        "length": 0,
        "responseObj": {
            "totalBudget": 10.0,
            "campaignId": 5,
            "campaignName": "Brand Awareness - Festive Teaser",
            "goal": 355,
            "goalValue": 2.0,
            "startDate": "2025-01-10 11:29:28",
            "endDate": "2025-01-10 18:29:59",
            "businessType": 353,
            "brandName": "google",
            "brandUrl": "https://cdn.freebiesupply.com/images/large/2x/nestle-logo-black-and-white.png",
            "category": 164,
            "subcategory": 210,
            "advId": 1832,
            "id": 884,
            "isRecActive": 2,
            "planList": [],
            "isReco": 0
        }
    },
    {
        "responseCode": {
            "msg": "Campaign List Fetched Successfully",
            "status": "Success",
            "code": 20010
        },
        "response": [
            {
                "mandateId": 4,
                "id": 1404,
                "name": "Customer Engagement - Holiday Campaign_1",
                "budget": 0.0,
                "pacingType": 27,
                "durationType": 140,
                "platformName": "dv360",
                "platformId": 5,
                "startDate": "2025-02-04 05:01:04",
                "endDate": "2025-02-04 22:59:59",
                "status": 1,
                "strategies": [
                    {
                        "name": "Customer Engagement - Holiday Campaign_1_dv360_Strategy_1",
                        "id": 1467,
                        "campaignId": 1404,
                        "budget": 5.0,
                        "startDate": "2025-02-04 05:01:35",
                        "endDate": "2025-02-04 22:59:59",
                        "mediaType": 0,
                        "status": 1,
                        "pacingBudget": 5.0,
                        "pacingType": 27,
                        "durationType": 140,
                        "pacingTypeName": "Even",
                        "durationTypeName": "Lifetime",
                        "biddingStrategy": "1799",
                        "biddingStrategyName": "CPM",
                        "bidCap": 0.2,
                        "platformId": 5,
                        "isLocationPresent": false,
                        "isAudiencePresent": false,
                        "isKeywordPresent": false,
                        "isDayPartPresent": false,
                        "isPositionPresent": false,
                        "isSitesPresent": false,
                        "targeting": {
                            "location": [],
                            "audience": [],
                            "language": [],
                            "daypart": [],
                            "device": [],
                            "age": [],
                            "position": [],
                            "keyword": [],
                            "sites": [],
                            "gender": []
                        },
                        "creative": {
                            "utm": "",
                            "campaignId": 1404,
                            "strategyId": 1467,
                            "creatives": [
                                {
                                    "status": 1,
                                    "id": 1067,
                                    "creativeId": 1276,
                                    "campaignId": 1404,
                                    "strategyId": 1467
                                }
                            ],
                            "creativeDetails": [
                                {
                                    "id": 1048,
                                    "platId": 5,
                                    "title": "DV360 Creative",
                                    "isApproved": 0,
                                    "crType": 21,
                                    "description": "",
                                    "heading": "",
                                    "landingUrl": "https://devbeki.torcai.com/atd",
                                    "tags": [],
                                    "isRecActive": 1,
                                    "isActive": 1,
                                    "mediaList": [
                                        {
                                            "id": 1067,
                                            "gcId": 1048,
                                            "adSize": "3840X2160",
                                            "isRecActive": 1,
                                            "isActive": 1,
                                            "url": "https://stagecdn.torcai.com/image/1872/1738733221512_Nestle-Logo.png",
                                            "mimeType": "image/png",
                                            "bitrate": 0,
                                            "duration": 0.0,
                                            "tagUrl": "",
                                            "isApproved": 0,
                                            "trackers": []
                                        }
                                    ],
                                    "isSynced": 0
                                }
                            ]
                        },
                        "syncedAttributes": {},
                        "synced": 0,
                        "io": {
                            "id": 195,
                            "name": "Customer Engagement - Holiday Campaign_1_IO_1",
                            "budget": 10.0,
                            "platformId": 5,
                            "startDate": "2025-02-05 05:01:04",
                            "endDate": "2025-02-04 22:59:59",
                            "pacingBudget": 10.0,
                            "isSynced": false,
                            "campaignId": 1404
                        }
                    }
                ],
                "pacingTypeName": "Even",
                "durationTypeName": "Lifetime",
                "checked": false,
                "pacingBudget": 0.0,
                "syncedAttributes": {},
                "totalBudget": 5.0,
                "synced": 0,
                "isReco": 0,
                "isEditable": true,
                "isYoutubeCampaign": false,
                "IOs": [
                    {
                        "id": 195,
                        "name": "Customer Engagement - Holiday Campaign_1_IO_1",
                        "budget": 10.0,
                        "platformId": 5,
                        "startDate": "2025-02-05 05:01:04",
                        "endDate": "2025-02-04 22:59:59",
                        "pacingBudget": 10.0,
                        "isSynced": false,
                        "campaignId": 1404
                    }
                ]
            }
        ],
        "length": 0,
        "responseObj": {
            "totalBudget": 10.0,
            "campaignId": 4,
            "campaignName": "Customer Engagement - Holiday Campaign",
            "goal": 355,
            "goalValue": 0.2,
            "startDate": "2025-02-04 13:01:52",
            "endDate": "2025-02-04 22:59:59",
            "businessType": 351,
            "brandName": "bru",
            "brandUrl": "https://cdn.freebiesupply.com/images/large/2x/nestle-logo-black-and-white.png",
            "category": 164,
            "subcategory": 216,
            "advId": 1872,
            "id": 4,
            "isRecActive": 1,
            "planList": [],
            "isReco": 0
        }
    },
    {
        "responseCode": {
            "msg": "Campaign List Fetched Successfully",
            "status": "Success",
            "code": 20010
        },
        "response": [
            {
                "mandateId": 928,
                "id": 1406,
                "name": "DV360 Campaign_dv360_1",
                "budget": 0.0,
                "pacingType": 27,
                "durationType": 140,
                "platformName": "dv360",
                "platformId": 5,
                "startDate": "2025-02-04 05:01:04",
                "endDate": "2025-02-04 22:59:59",
                "status": 2,
                "strategies": [
                    {
                        "name": "DV360 Campaign_dv360_1_dv360_Strategy_1",
                        "id": 1467,
                        "campaignId": 1406,
                        "budget": 5.0,
                        "startDate": "2025-02-04 05:01:35",
                        "endDate": "2025-02-04 22:59:59",
                        "mediaType": 0,
                        "status": 2,
                        "pacingBudget": 5.0,
                        "pacingType": 27,
                        "durationType": 140,
                        "pacingTypeName": "Even",
                        "durationTypeName": "Lifetime",
                        "biddingStrategy": "1799",
                        "biddingStrategyName": "CPM",
                        "bidCap": 0.2,
                        "platformId": 5,
                        "isLocationPresent": false,
                        "isAudiencePresent": false,
                        "isKeywordPresent": false,
                        "isDayPartPresent": false,
                        "isPositionPresent": false,
                        "isSitesPresent": false,
                        "targeting": {
                            "location": [],
                            "audience": [],
                            "language": [],
                            "daypart": [],
                            "device": [],
                            "age": [],
                            "position": [],
                            "keyword": [],
                            "sites": [],
                            "gender": []
                        },
                        "creative": {
                            "utm": "",
                            "campaignId": 1406,
                            "strategyId": 1467,
                            "creatives": [
                                {
                                    "status": 1,
                                    "id": 1067,
                                    "creativeId": 1276,
                                    "campaignId": 1406,
                                    "strategyId": 1467
                                }
                            ],
                            "creativeDetails": [
                                {
                                    "id": 1048,
                                    "platId": 5,
                                    "title": "DV360 Creative",
                                    "isApproved": 0,
                                    "crType": 21,
                                    "description": "",
                                    "heading": "",
                                    "landingUrl": "https://devbeki.torcai.com/atd",
                                    "tags": [],
                                    "isRecActive": 1,
                                    "isActive": 1,
                                    "mediaList": [
                                        {
                                            "id": 1067,
                                            "gcId": 1048,
                                            "adSize": "3840X2160",
                                            "isRecActive": 1,
                                            "isActive": 1,
                                            "url": "https://stagecdn.torcai.com/image/1872/1738733221512_Nestle-Logo.png",
                                            "mimeType": "image/png",
                                            "bitrate": 0,
                                            "duration": 0.0,
                                            "tagUrl": "",
                                            "isApproved": 0,
                                            "trackers": []
                                        }
                                    ],
                                    "isSynced": 0
                                }
                            ]
                        },
                        "syncedAttributes": {},
                        "synced": 0,
                        "io": {
                            "id": 195,
                            "name": "DV360 Campaign_dv360_1_IO_1",
                            "budget": 10.0,
                            "platformId": 5,
                            "startDate": "2025-02-05 05:01:04",
                            "endDate": "2025-02-04 22:59:59",
                            "pacingBudget": 10.0,
                            "isSynced": false,
                            "campaignId": 1406
                        }
                    }
                ],
                "pacingTypeName": "Even",
                "durationTypeName": "Lifetime",
                "checked": false,
                "pacingBudget": 0.0,
                "syncedAttributes": {},
                "totalBudget": 5.0,
                "synced": 0,
                "isReco": 0,
                "isEditable": true,
                "isYoutubeCampaign": false,
                "IOs": [
                    {
                        "id": 195,
                        "name": "DV360 Campaign_dv360_1_IO_1",
                        "budget": 10.0,
                        "platformId": 5,
                        "startDate": "2025-02-05 05:01:04",
                        "endDate": "2025-02-04 22:59:59",
                        "pacingBudget": 10.0,
                        "isSynced": false,
                        "campaignId": 1406
                    }
                ]
            }
        ],
        "length": 0,
        "responseObj": {
            "totalBudget": 10.0,
            "campaignId": 928,
            "campaignName": "DV360 Campaign",
            "goal": 355,
            "goalValue": 0.2,
            "startDate": "2025-02-04 13:01:52",
            "endDate": "2025-02-04 22:59:59",
            "businessType": 351,
            "brandName": "bru",
            "brandUrl": "https://cdn.freebiesupply.com/images/large/2x/nestle-logo-black-and-white.png",
            "category": 164,
            "subcategory": 216,
            "advId": 1872,
            "id": 928,
            "isRecActive": 2,
            "planList": [],
            "isReco": 0
        }
    },
    {
        "responseCode": {
            "msg": "Campaign List Fetched Successfully",
            "status": "Success",
            "code": 20010
        },
        "response": [
            {
                "mandateId": 884,
                "id": 1348,
                "name": "Google Ads Campaign_ads_1",
                "budget": 10.0,
                "pacingType": 29,
                "durationType": 4036,
                "platformName": "ads",
                "platformId": 4,
                "mediaType": 0,
                "startDate": "2025-01-10 11:35:48",
                "endDate": "2025-01-10 18:29:59",
                "status": 2,
                "targeting": {
                    "location": [],
                    "audience": [],
                    "language": [],
                    "daypart": [],
                    "device": [],
                    "adRotation": 1
                },
                "strategies": [
                    {
                        "name": "Google Ads Campaign_ads_1_ads_Strategy_1",
                        "id": 1473,
                        "campaignId": 1348,
                        "startDate": "2025-01-10 11:35:48",
                        "endDate": "2025-01-10 18:29:59",
                        "mediaType": 0,
                        "status": 2,
                        "pacingTypeName": "Standard",
                        "durationTypeName": "LifeTime",
                        "biddingStrategy": "146",
                        "biddingStrategyName": "Maximize click",
                        "bidCap": 0.2,
                        "platformId": 4,
                        "isLocationPresent": false,
                        "isAudiencePresent": false,
                        "isKeywordPresent": false,
                        "isDayPartPresent": false,
                        "isPositionPresent": false,
                        "isSitesPresent": false,
                        "targeting": {
                            "location": [],
                            "audience": [],
                            "language": [],
                            "daypart": [],
                            "device": [],
                            "age": [],
                            "position": [],
                            "keyword": [],
                            "sites": [],
                            "gender": []
                        },
                        "creative": {
                            "utm": "",
                            "campaignId": 1348,
                            "strategyId": 1473,
                            "creatives": [
                                {
                                    "status": 1,
                                    "id": 1069,
                                    "creativeId": 1282,
                                    "campaignId": 1348,
                                    "strategyId": 1473
                                }
                            ],
                            "creativeDetails": [
                                {
                                    "id": 1050,
                                    "platId": 4,
                                    "title": "GoogleAds Creative",
                                    "isApproved": 0,
                                    "crType": 18,
                                    "description": "",
                                    "heading": "",
                                    "landingUrl": "https://devbeki.torcai.com/atd",
                                    "tags": [],
                                    "isRecActive": 1,
                                    "isActive": 1,
                                    "mediaList": [
                                        {
                                            "id": 1069,
                                            "gcId": 1050,
                                            "adSize": "300X100",
                                            "isRecActive": 1,
                                            "isActive": 1,
                                            "url": "https://stagecdn.torcai.com/image/1832/1738932556037_images_(1).jpg",
                                            "mimeType": "image/jpeg",
                                            "bitrate": 0,
                                            "duration": 0.0,
                                            "tagUrl": "",
                                            "isApproved": 0,
                                            "trackers": []
                                        }
                                    ],
                                    "isSynced": 0
                                }
                            ]
                        },
                        "syncedAttributes": {},
                        "synced": 0
                    }
                ],
                "pacingTypeName": "Standard",
                "durationTypeName": "LifeTime",
                "biddingStrategy": "146",
                "biddingStrategyName": "Maximize click",
                "bidCap": 0.2,
                "checked": false,
                "pacingBudget": 10.0,
                "syncedAttributes": {},
                "totalBudget": 10.0,
                "synced": 0,
                "isReco": 0,
                "isEditable": true,
                "isYoutubeCampaign": false
            }
        ],
        "length": 0,
        "responseObj": {
            "totalBudget": 10.0,
            "campaignId": 884,
            "campaignName": "Google Ads Campaign",
            "goal": 355,
            "goalValue": 2.0,
            "startDate": "2025-01-10 11:29:28",
            "endDate": "2025-01-10 18:29:59",
            "businessType": 353,
            "brandName": "google",
            "brandUrl": "https://cdn.freebiesupply.com/images/large/2x/nestle-logo-black-and-white.png",
            "category": 164,
            "subcategory": 210,
            "advId": 1832,
            "id": 884,
            "isRecActive": 2,
            "planList": [],
            "isReco": 0
        }
    },
    {
        "responseCode": {
            "msg": "Campaign List Fetched Successfully",
            "status": "Success",
            "code": 20010
        },
        "response": [
            {
                "mandateId": 887,
                "id": 1351,
                "name": "Meta Campaign_meta_1",
                "budget": 0.0,
                "platformName": "meta",
                "platformId": 3,
                "startDate": "2025-01-15 05:41:04",
                "endDate": "2025-01-16 18:29:59",
                "status": 2,
                "accountId": "735759678205531",
                "strategies": [
                    {
                        "name": "Meta Campaign_meta_1_meta_Strategy_1",
                        "id": 1462,
                        "campaignId": 1351,
                        "budget": 5.0,
                        "startDate": "2025-01-15 05:20:46",
                        "endDate": "2025-01-16 18:29:59",
                        "mediaType": 0,
                        "status": 2,
                        "pacingBudget": 2.5,
                        "pacingType": 31,
                        "durationType": 26,
                        "pacingTypeName": "Standard",
                        "durationTypeName": "Lifetime",
                        "biddingStrategy": "1783",
                        "biddingStrategyName": "Maximize Click",
                        "bidCap": 0.1,
                        "platformId": 3,
                        "isLocationPresent": true,
                        "isAudiencePresent": false,
                        "isKeywordPresent": false,
                        "isDayPartPresent": false,
                        "isPositionPresent": false,
                        "isSitesPresent": false,
                        "targeting": {
                            "location": [
                                {
                                    "type": "neighborhood",
                                    "inex": 1,
                                    "value": " Central Delhi  \u003e  Central Delhi, Ohio, United States  \u003e  neighborhood",
                                    "meta": "2774845"
                                }
                            ],
                            "audience": [],
                            "language": [],
                            "daypart": [],
                            "device": [],
                            "age": [],
                            "position": [],
                            "page": [
                                {
                                    "key": 285250477997915,
                                    "value": "Beki",
                                    "inex": 1
                                }
                            ],
                            "keyword": [],
                            "sites": [],
                            "gender": [],
                            "publisherPlatform": []
                        },
                        "creative": {
                            "utm": "",
                            "campaignId": 1351,
                            "strategyId": 1462,
                            "creatives": [
                                {
                                    "status": 1,
                                    "id": 1065,
                                    "creativeId": 1274,
                                    "campaignId": 1351,
                                    "strategyId": 1462
                                }
                            ],
                            "creativeDetails": [
                                {
                                    "id": 1046,
                                    "platId": 3,
                                    "title": "test1",
                                    "isApproved": 0,
                                    "crType": 19,
                                    "description": "lorem",
                                    "heading": "meta_test_head",
                                    "landingUrl": "https://images.pexels.com/photos/247851/pexels-photo-247851.jpeg?auto\u003dcompress\u0026cs\u003dtinysrgb\u0026w\u003d600",
                                    "tags": [],
                                    "isRecActive": 1,
                                    "isActive": 1,
                                    "mediaList": [
                                        {
                                            "id": 1065,
                                            "gcId": 1046,
                                            "adSize": "1080X1080",
                                            "isRecActive": 1,
                                            "isActive": 1,
                                            "url": "https://stagecdn.torcai.com/image/1760/1738214475533_ATD-300x250_(1)_resize_(1).jpeg",
                                            "mimeType": "image/jpeg",
                                            "bitrate": 0,
                                            "duration": 0.0,
                                            "tagUrl": "",
                                            "isApproved": 0,
                                            "trackers": []
                                        }
                                    ],
                                    "isSynced": 0
                                }
                            ]
                        },
                        "syncedAttributes": {},
                        "synced": 0
                    }
                ],
                "checked": false,
                "accountName": "Torcai Internal",
                "pacingBudget": 0.0,
                "syncedAttributes": {},
                "totalBudget": 5.0,
                "synced": 0,
                "isReco": 0,
                "isEditable": true,
                "isYoutubeCampaign": false
            }
        ],
        "length": 0,
        "responseObj": {
            "totalBudget": 5.0,
            "campaignId": 887,
            "campaignName": "Meta Campaign",
            "goal": 359,
            "goalValue": 2.0,
            "startDate": "2025-01-15 05:40:57",
            "endDate": "2025-01-16 18:29:59",
            "businessType": 353,
            "brandName": "Dell",
            "brandUrl": "https://www.nike.com",
            "category": 162,
            "subcategory": 191,
            "advId": 1760,
            "id": 887,
            "isRecActive": 2,
            "planList": [],
            "isReco": 0
        }
    },
    {
        "responseCode": {
            "msg": "Campaign List Fetched Successfully",
            "status": "Success",
            "code": 20010
        },
        "response": [
            {
                "mandateId": 6,
                "id": 1361,
                "name": "Website Traffic - Winter Sale_1",
                "budget": 0.0,
                "platformName": "meta",
                "platformId": 3,
                "startDate": "2025-01-15 05:41:04",
                "endDate": "2025-01-16 18:29:59",
                "status": 1,
                "accountId": "735759678205531",
                "strategies": [
                    {
                        "name": "Website Traffic - Winter Sale_1_meta_Strategy_1",
                        "id": 1462,
                        "campaignId": 1361,
                        "budget": 5.0,
                        "startDate": "2025-01-15 05:20:46",
                        "endDate": "2025-01-16 18:29:59",
                        "mediaType": 0,
                        "status": 1,
                        "pacingBudget": 2.5,
                        "pacingType": 31,
                        "durationType": 26,
                        "pacingTypeName": "Standard",
                        "durationTypeName": "Lifetime",
                        "biddingStrategy": "1783",
                        "biddingStrategyName": "Maximize Click",
                        "bidCap": 0.1,
                        "platformId": 3,
                        "isLocationPresent": true,
                        "isAudiencePresent": false,
                        "isKeywordPresent": false,
                        "isDayPartPresent": false,
                        "isPositionPresent": false,
                        "isSitesPresent": false,
                        "targeting": {
                            "location": [
                                {
                                    "type": "neighborhood",
                                    "inex": 1,
                                    "value": " Central Delhi  \u003e  Central Delhi, Ohio, United States  \u003e  neighborhood",
                                    "meta": "2774845"
                                }
                            ],
                            "audience": [],
                            "language": [],
                            "daypart": [],
                            "device": [],
                            "age": [],
                            "position": [],
                            "page": [
                                {
                                    "key": 285250477997915,
                                    "value": "Beki",
                                    "inex": 1
                                }
                            ],
                            "keyword": [],
                            "sites": [],
                            "gender": [],
                            "publisherPlatform": []
                        },
                        "creative": {
                            "utm": "",
                            "campaignId": 1361,
                            "strategyId": 1462,
                            "creatives": [
                                {
                                    "status": 1,
                                    "id": 1065,
                                    "creativeId": 1274,
                                    "campaignId": 1361,
                                    "strategyId": 1462
                                }
                            ],
                            "creativeDetails": [
                                {
                                    "id": 1046,
                                    "platId": 3,
                                    "title": "test1",
                                    "isApproved": 0,
                                    "crType": 19,
                                    "description": "lorem",
                                    "heading": "meta_test_head",
                                    "landingUrl": "https://images.pexels.com/photos/247851/pexels-photo-247851.jpeg?auto\u003dcompress\u0026cs\u003dtinysrgb\u0026w\u003d600",
                                    "tags": [],
                                    "isRecActive": 1,
                                    "isActive": 1,
                                    "mediaList": [
                                        {
                                            "id": 1065,
                                            "gcId": 1046,
                                            "adSize": "1080X1080",
                                            "isRecActive": 1,
                                            "isActive": 1,
                                            "url": "https://stagecdn.torcai.com/image/1760/1738214475533_ATD-300x250_(1)_resize_(1).jpeg",
                                            "mimeType": "image/jpeg",
                                            "bitrate": 0,
                                            "duration": 0.0,
                                            "tagUrl": "",
                                            "isApproved": 0,
                                            "trackers": []
                                        }
                                    ],
                                    "isSynced": 0
                                }
                            ]
                        },
                        "syncedAttributes": {},
                        "synced": 0
                    }
                ],
                "checked": false,
                "accountName": "Torcai Internal",
                "pacingBudget": 0.0,
                "syncedAttributes": {},
                "totalBudget": 5.0,
                "synced": 0,
                "isReco": 0,
                "isEditable": true,
                "isYoutubeCampaign": false
            }
        ],
        "length": 0,
        "responseObj": {
            "totalBudget": 5.0,
            "campaignId": 6,
            "campaignName": "Website Traffic - Winter Sale",
            "goal": 359,
            "goalValue": 2.0,
            "startDate": "2025-01-15 05:40:57",
            "endDate": "2025-01-16 18:29:59",
            "businessType": 353,
            "brandName": "Dell",
            "brandUrl": "https://www.nike.com",
            "category": 162,
            "subcategory": 191,
            "advId": 1760,
            "id": 887,
            "isRecActive": 2,
            "planList": [],
            "isReco": 0
        }
    },
    {
        "responseCode": {
            "msg": "Campaign List Fetched Successfully",
            "status": "Success",
            "code": 20010
        },
        "response": [
            {
                "mandateId": 8,
                "id": 1861,
                "name": "Truview Skippable - Product Launch_1",
                "budget": 0.0,
                "platformName": "meta",
                "platformId": 3,
                "startDate": "2025-01-15 05:41:04",
                "endDate": "2025-01-16 18:29:59",
                "status": 1,
                "accountId": "735759678205531",
                "strategies": [
                    {
                        "name": "Truview Skippable - Product Launch_1_meta_Strategy_1",
                        "id": 1462,
                        "campaignId": 1861,
                        "budget": 5.0,
                        "startDate": "2025-01-15 05:20:46",
                        "endDate": "2025-01-16 18:29:59",
                        "mediaType": 0,
                        "status": 1,
                        "pacingBudget": 2.5,
                        "pacingType": 31,
                        "durationType": 26,
                        "pacingTypeName": "Standard",
                        "durationTypeName": "Lifetime",
                        "biddingStrategy": "1783",
                        "biddingStrategyName": "Maximize Click",
                        "bidCap": 0.1,
                        "platformId": 3,
                        "isLocationPresent": true,
                        "isAudiencePresent": false,
                        "isKeywordPresent": false,
                        "isDayPartPresent": false,
                        "isPositionPresent": false,
                        "isSitesPresent": false,
                        "targeting": {
                            "location": [
                                {
                                    "type": "neighborhood",
                                    "inex": 1,
                                    "value": " Central Delhi  \u003e  Central Delhi, Ohio, United States  \u003e  neighborhood",
                                    "meta": "2774845"
                                }
                            ],
                            "audience": [],
                            "language": [],
                            "daypart": [],
                            "device": [],
                            "age": [],
                            "position": [],
                            "page": [
                                {
                                    "key": 285250477997915,
                                    "value": "Beki",
                                    "inex": 1
                                }
                            ],
                            "keyword": [],
                            "sites": [],
                            "gender": [],
                            "publisherPlatform": []
                        },
                        "creative": {
                            "utm": "",
                            "campaignId": 1861,
                            "strategyId": 1462,
                            "creatives": [
                                {
                                    "status": 1,
                                    "id": 1065,
                                    "creativeId": 1274,
                                    "campaignId": 1861,
                                    "strategyId": 1462
                                }
                            ],
                            "creativeDetails": [
                                {
                                    "id": 1046,
                                    "platId": 3,
                                    "title": "test1",
                                    "isApproved": 0,
                                    "crType": 19,
                                    "description": "lorem",
                                    "heading": "meta_test_head",
                                    "landingUrl": "https://images.pexels.com/photos/247851/pexels-photo-247851.jpeg?auto\u003dcompress\u0026cs\u003dtinysrgb\u0026w\u003d600",
                                    "tags": [],
                                    "isRecActive": 1,
                                    "isActive": 1,
                                    "mediaList": [
                                        {
                                            "id": 1065,
                                            "gcId": 1046,
                                            "adSize": "1080X1080",
                                            "isRecActive": 1,
                                            "isActive": 1,
                                            "url": "https://stagecdn.torcai.com/image/1760/1738214475533_ATD-300x250_(1)_resize_(1).jpeg",
                                            "mimeType": "image/jpeg",
                                            "bitrate": 0,
                                            "duration": 0.0,
                                            "tagUrl": "",
                                            "isApproved": 0,
                                            "trackers": []
                                        }
                                    ],
                                    "isSynced": 0
                                }
                            ]
                        },
                        "syncedAttributes": {},
                        "synced": 0
                    }
                ],
                "checked": false,
                "accountName": "Torcai Internal",
                "pacingBudget": 0.0,
                "syncedAttributes": {},
                "totalBudget": 5.0,
                "synced": 0,
                "isReco": 0,
                "isEditable": true,
                "isYoutubeCampaign": false
            }
        ],
        "length": 0,
        "responseObj": {
            "totalBudget": 5.0,
            "campaignId": 6,
            "campaignName": "Truview Skippable - Product Launch",
            "goal": 359,
            "goalValue": 2.0,
            "startDate": "2025-01-15 05:40:57",
            "endDate": "2025-01-16 18:29:59",
            "businessType": 353,
            "brandName": "Dell",
            "brandUrl": "https://www.nike.com",
            "category": 162,
            "subcategory": 191,
            "advId": 1760,
            "id": 887,
            "isRecActive": 2,
            "planList": [],
            "isReco": 0
        }
    }
]

// Custom Plans & Strategy Data Preview Data
export const campaignListPreview = [
    {
        "responseCode": {
            "msg": "Preview Campaign List Fetched Successfully",
            "status": "Success",
            "code": 20040
        },
        "response": [
            {
                "mandateId": 9,
                "id": 1948,
                "name": "Reach Skippable - Seasonal Offer_1",
                "budget": 10.0,
                "pacingType": 29,
                "durationType": 4036,
                "platformName": "ads",
                "platformId": 4,
                "mediaType": 0,
                "startDate": "2025-01-10 11:35:48",
                "endDate": "2025-01-10 18:29:59",
                "status": 2,
                "targeting": {
                    "location": [],
                    "audience": [],
                    "language": [],
                    "daypart": [],
                    "device": [],
                    "adRotation": 1
                },
                "strategies": [
                    {
                        "name": "Reach Skippable - Seasonal Offer_1_ads_Strategy_1",
                        "id": 1473,
                        "campaignId": 1948,
                        "startDate": "2025-01-10 11:35:48",
                        "endDate": "2025-01-10 18:29:59",
                        "mediaType": 0,
                        "status": 2,
                        "pacingTypeName": "Standard",
                        "durationTypeName": "LifeTime",
                        "biddingStrategy": "146",
                        "biddingStrategyName": "Maximize click",
                        "bidCap": 0.2,
                        "platformId": 4,
                        "isLocationPresent": false,
                        "isAudiencePresent": false,
                        "isKeywordPresent": false,
                        "isDayPartPresent": false,
                        "isPositionPresent": false,
                        "isSitesPresent": false,
                        "targeting": {
                            "location": [],
                            "audience": [],
                            "language": [],
                            "daypart": [],
                            "device": [],
                            "age": [],
                            "position": [],
                            "keyword": [],
                            "sites": [],
                            "gender": []
                        },
                        "creative": {
                            "utm": "",
                            "campaignId": 1948,
                            "strategyId": 1473,
                            "creatives": [
                                {
                                    "status": 1,
                                    "id": 1069,
                                    "creativeId": 1282,
                                    "campaignId": 1948,
                                    "strategyId": 1473
                                }
                            ],
                            "creativeDetails": [
                                {
                                    "id": 1050,
                                    "platId": 4,
                                    "title": "GoogleAds Creative",
                                    "isApproved": 0,
                                    "crType": 18,
                                    "description": "",
                                    "heading": "",
                                    "landingUrl": "https://devbeki.torcai.com/atd",
                                    "tags": [],
                                    "isRecActive": 1,
                                    "isActive": 1,
                                    "mediaList": [
                                        {
                                            "id": 1069,
                                            "gcId": 1050,
                                            "adSize": "300X100",
                                            "isRecActive": 1,
                                            "isActive": 1,
                                            "url": "https://stagecdn.torcai.com/image/1832/1738932556037_images_(1).jpg",
                                            "mimeType": "image/jpeg",
                                            "bitrate": 0,
                                            "duration": 0.0,
                                            "tagUrl": "",
                                            "isApproved": 0,
                                            "trackers": []
                                        }
                                    ],
                                    "isSynced": 0
                                }
                            ]
                        },
                        "syncedAttributes": {},
                        "synced": 0
                    }
                ],
                "pacingTypeName": "Standard",
                "durationTypeName": "LifeTime",
                "biddingStrategy": "146",
                "biddingStrategyName": "Maximize click",
                "bidCap": 0.2,
                "checked": false,
                "pacingBudget": 10.0,
                "syncedAttributes": {},
                "totalBudget": 10.0,
                "synced": 0,
                "isReco": 0,
                "isEditable": true,
                "isYoutubeCampaign": false
            }
        ],
        "length": 0,
        "responseObj": [
            {
                "id": 1050,
                "platId": 4,
                "title": "GoogleAds Creative",
                "isApproved": 0,
                "crType": 18,
                "description": "",
                "heading": "",
                "landingUrl": "https://devbeki.torcai.com/atd",
                "tags": [],
                "isRecActive": 1,
                "isActive": 1,
                "mediaList": [
                    {
                        "id": 1069,
                        "gcId": 1050,
                        "adSize": "300X100",
                        "isRecActive": 1,
                        "isActive": 1,
                        "url": "https://stagecdn.torcai.com/image/1832/1738932556037_images_(1).jpg",
                        "mimeType": "image/jpeg",
                        "bitrate": 0,
                        "duration": 0.0,
                        "tagUrl": "",
                        "isApproved": 0,
                        "trackers": []
                    }
                ],
                "isSynced": 0
            }
        ]
    },
    {
        "responseCode": {
            "msg": "Preview Campaign List Fetched Successfully",
            "status": "Success",
            "code": 20040
        },
        "response": [
            {
                "mandateId": 7,
                "id": 1748,
                "name": "Audience Awareness - New Year Teaser_1",
                "budget": 10.0,
                "pacingType": 29,
                "durationType": 4036,
                "platformName": "ads",
                "platformId": 4,
                "mediaType": 0,
                "startDate": "2025-01-10 11:35:48",
                "endDate": "2025-01-10 18:29:59",
                "status": 2,
                "targeting": {
                    "location": [],
                    "audience": [],
                    "language": [],
                    "daypart": [],
                    "device": [],
                    "adRotation": 1
                },
                "strategies": [
                    {
                        "name": "Audience Awareness - New Year Teaser_1_ads_Strategy_1",
                        "id": 1473,
                        "campaignId": 1748,
                        "startDate": "2025-01-10 11:35:48",
                        "endDate": "2025-01-10 18:29:59",
                        "mediaType": 0,
                        "status": 2,
                        "pacingTypeName": "Standard",
                        "durationTypeName": "LifeTime",
                        "biddingStrategy": "146",
                        "biddingStrategyName": "Maximize click",
                        "bidCap": 0.2,
                        "platformId": 4,
                        "isLocationPresent": false,
                        "isAudiencePresent": false,
                        "isKeywordPresent": false,
                        "isDayPartPresent": false,
                        "isPositionPresent": false,
                        "isSitesPresent": false,
                        "targeting": {
                            "location": [],
                            "audience": [],
                            "language": [],
                            "daypart": [],
                            "device": [],
                            "age": [],
                            "position": [],
                            "keyword": [],
                            "sites": [],
                            "gender": []
                        },
                        "creative": {
                            "utm": "",
                            "campaignId": 1748,
                            "strategyId": 1473,
                            "creatives": [
                                {
                                    "status": 1,
                                    "id": 1069,
                                    "creativeId": 1282,
                                    "campaignId": 1748,
                                    "strategyId": 1473
                                }
                            ],
                            "creativeDetails": [
                                {
                                    "id": 1050,
                                    "platId": 4,
                                    "title": "GoogleAds Creative",
                                    "isApproved": 0,
                                    "crType": 18,
                                    "description": "",
                                    "heading": "",
                                    "landingUrl": "https://devbeki.torcai.com/atd",
                                    "tags": [],
                                    "isRecActive": 1,
                                    "isActive": 1,
                                    "mediaList": [
                                        {
                                            "id": 1069,
                                            "gcId": 1050,
                                            "adSize": "300X100",
                                            "isRecActive": 1,
                                            "isActive": 1,
                                            "url": "https://stagecdn.torcai.com/image/1832/1738932556037_images_(1).jpg",
                                            "mimeType": "image/jpeg",
                                            "bitrate": 0,
                                            "duration": 0.0,
                                            "tagUrl": "",
                                            "isApproved": 0,
                                            "trackers": []
                                        }
                                    ],
                                    "isSynced": 0
                                }
                            ]
                        },
                        "syncedAttributes": {},
                        "synced": 0
                    }
                ],
                "pacingTypeName": "Standard",
                "durationTypeName": "LifeTime",
                "biddingStrategy": "146",
                "biddingStrategyName": "Maximize click",
                "bidCap": 0.2,
                "checked": false,
                "pacingBudget": 10.0,
                "syncedAttributes": {},
                "totalBudget": 10.0,
                "synced": 0,
                "isReco": 0,
                "isEditable": true,
                "isYoutubeCampaign": false
            }
        ],
        "length": 0,
        "responseObj": [
            {
                "id": 1050,
                "platId": 4,
                "title": "GoogleAds Creative",
                "isApproved": 0,
                "crType": 18,
                "description": "",
                "heading": "",
                "landingUrl": "https://devbeki.torcai.com/atd",
                "tags": [],
                "isRecActive": 1,
                "isActive": 1,
                "mediaList": [
                    {
                        "id": 1069,
                        "gcId": 1050,
                        "adSize": "300X100",
                        "isRecActive": 1,
                        "isActive": 1,
                        "url": "https://stagecdn.torcai.com/image/1832/1738932556037_images_(1).jpg",
                        "mimeType": "image/jpeg",
                        "bitrate": 0,
                        "duration": 0.0,
                        "tagUrl": "",
                        "isApproved": 0,
                        "trackers": []
                    }
                ],
                "isSynced": 0
            }
        ]
    },
    {
        "responseCode": {
            "msg": "Preview Campaign List Fetched Successfully",
            "status": "Success",
            "code": 20040
        },
        "response": [
            {
                "mandateId": 5,
                "id": 1548,
                "name": "Brand Awareness - Festive Teaser_1",
                "budget": 10.0,
                "pacingType": 29,
                "durationType": 4036,
                "platformName": "ads",
                "platformId": 4,
                "mediaType": 0,
                "startDate": "2025-01-10 11:35:48",
                "endDate": "2025-01-10 18:29:59",
                "status": 2,
                "targeting": {
                    "location": [],
                    "audience": [],
                    "language": [],
                    "daypart": [],
                    "device": [],
                    "adRotation": 1
                },
                "strategies": [
                    {
                        "name": "Brand Awareness - Festive Teaser_1_ads_Strategy_1",
                        "id": 1473,
                        "campaignId": 1548,
                        "startDate": "2025-01-10 11:35:48",
                        "endDate": "2025-01-10 18:29:59",
                        "mediaType": 0,
                        "status": 2,
                        "pacingTypeName": "Standard",
                        "durationTypeName": "LifeTime",
                        "biddingStrategy": "146",
                        "biddingStrategyName": "Maximize click",
                        "bidCap": 0.2,
                        "platformId": 4,
                        "isLocationPresent": false,
                        "isAudiencePresent": false,
                        "isKeywordPresent": false,
                        "isDayPartPresent": false,
                        "isPositionPresent": false,
                        "isSitesPresent": false,
                        "targeting": {
                            "location": [],
                            "audience": [],
                            "language": [],
                            "daypart": [],
                            "device": [],
                            "age": [],
                            "position": [],
                            "keyword": [],
                            "sites": [],
                            "gender": []
                        },
                        "creative": {
                            "utm": "",
                            "campaignId": 1548,
                            "strategyId": 1473,
                            "creatives": [
                                {
                                    "status": 1,
                                    "id": 1069,
                                    "creativeId": 1282,
                                    "campaignId": 1548,
                                    "strategyId": 1473
                                }
                            ],
                            "creativeDetails": [
                                {
                                    "id": 1050,
                                    "platId": 4,
                                    "title": "GoogleAds Creative",
                                    "isApproved": 0,
                                    "crType": 18,
                                    "description": "",
                                    "heading": "",
                                    "landingUrl": "https://devbeki.torcai.com/atd",
                                    "tags": [],
                                    "isRecActive": 1,
                                    "isActive": 1,
                                    "mediaList": [
                                        {
                                            "id": 1069,
                                            "gcId": 1050,
                                            "adSize": "300X100",
                                            "isRecActive": 1,
                                            "isActive": 1,
                                            "url": "https://stagecdn.torcai.com/image/1832/1738932556037_images_(1).jpg",
                                            "mimeType": "image/jpeg",
                                            "bitrate": 0,
                                            "duration": 0.0,
                                            "tagUrl": "",
                                            "isApproved": 0,
                                            "trackers": []
                                        }
                                    ],
                                    "isSynced": 0
                                }
                            ]
                        },
                        "syncedAttributes": {},
                        "synced": 0
                    }
                ],
                "pacingTypeName": "Standard",
                "durationTypeName": "LifeTime",
                "biddingStrategy": "146",
                "biddingStrategyName": "Maximize click",
                "bidCap": 0.2,
                "checked": false,
                "pacingBudget": 10.0,
                "syncedAttributes": {},
                "totalBudget": 10.0,
                "synced": 0,
                "isReco": 0,
                "isEditable": true,
                "isYoutubeCampaign": false
            }
        ],
        "length": 0,
        "responseObj": [
            {
                "id": 1050,
                "platId": 4,
                "title": "GoogleAds Creative",
                "isApproved": 0,
                "crType": 18,
                "description": "",
                "heading": "",
                "landingUrl": "https://devbeki.torcai.com/atd",
                "tags": [],
                "isRecActive": 1,
                "isActive": 1,
                "mediaList": [
                    {
                        "id": 1069,
                        "gcId": 1050,
                        "adSize": "300X100",
                        "isRecActive": 1,
                        "isActive": 1,
                        "url": "https://stagecdn.torcai.com/image/1832/1738932556037_images_(1).jpg",
                        "mimeType": "image/jpeg",
                        "bitrate": 0,
                        "duration": 0.0,
                        "tagUrl": "",
                        "isApproved": 0,
                        "trackers": []
                    }
                ],
                "isSynced": 0
            }
        ]
    },
    {
        "responseCode": {
            "msg": "Preview Campaign List Fetched Successfully",
            "status": "Success",
            "code": 20040
        },
        "response": [
            {
                "mandateId": 4,
                "id": 1404,
                "name": "DV360 Campaign_dv360_1",
                "budget": 0.0,
                "pacingType": 27,
                "durationType": 140,
                "platformName": "dv360",
                "platformId": 5,
                "startDate": "2025-02-04 05:01:04",
                "endDate": "2025-02-04 22:59:59",
                "status": 2,
                "strategies": [
                    {
                        "name": "DV360 Campaign_dv360_1_dv360_Strategy_1",
                        "id": 1467,
                        "campaignId": 1404,
                        "budget": 5.0,
                        "startDate": "2025-02-04 05:01:35",
                        "endDate": "2025-02-04 22:59:59",
                        "mediaType": 0,
                        "status": 2,
                        "pacingBudget": 5.0,
                        "pacingType": 27,
                        "durationType": 140,
                        "pacingTypeName": "Even",
                        "durationTypeName": "Lifetime",
                        "biddingStrategy": "1799",
                        "biddingStrategyName": "CPM",
                        "bidCap": 0.2,
                        "platformId": 5,
                        "isLocationPresent": false,
                        "isAudiencePresent": false,
                        "isKeywordPresent": false,
                        "isDayPartPresent": false,
                        "isPositionPresent": false,
                        "isSitesPresent": false,
                        "targeting": {
                            "location": [],
                            "audience": [],
                            "language": [],
                            "daypart": [],
                            "device": [],
                            "age": [],
                            "position": [],
                            "keyword": [],
                            "sites": [],
                            "gender": []
                        },
                        "creative": {
                            "utm": "",
                            "campaignId": 1404,
                            "strategyId": 1467,
                            "creatives": [
                                {
                                    "status": 1,
                                    "id": 1067,
                                    "creativeId": 1276,
                                    "campaignId": 1404,
                                    "strategyId": 1467
                                }
                            ],
                            "creativeDetails": [
                                {
                                    "id": 1048,
                                    "platId": 5,
                                    "title": "DV360 Creative",
                                    "isApproved": 0,
                                    "crType": 21,
                                    "description": "",
                                    "heading": "",
                                    "landingUrl": "https://devbeki.torcai.com/atd",
                                    "tags": [],
                                    "isRecActive": 1,
                                    "isActive": 1,
                                    "mediaList": [
                                        {
                                            "id": 1067,
                                            "gcId": 1048,
                                            "adSize": "3840X2160",
                                            "isRecActive": 1,
                                            "isActive": 1,
                                            "url": "https://stagecdn.torcai.com/image/1872/1738733221512_Nestle-Logo.png",
                                            "mimeType": "image/png",
                                            "bitrate": 0,
                                            "duration": 0.0,
                                            "tagUrl": "",
                                            "isApproved": 0,
                                            "trackers": []
                                        }
                                    ],
                                    "isSynced": 0
                                }
                            ]
                        },
                        "syncedAttributes": {},
                        "synced": 0,
                        "io": {
                            "id": 195,
                            "name": "DV360 Campaign_dv360_1_IO_1",
                            "budget": 10.0,
                            "platformId": 5,
                            "startDate": "2025-02-05 05:01:04",
                            "endDate": "2025-02-04 22:59:59",
                            "pacingBudget": 10.0,
                            "isSynced": false,
                            "campaignId": 1404
                        }
                    }
                ],
                "pacingTypeName": "Even",
                "durationTypeName": "Lifetime",
                "checked": false,
                "pacingBudget": 0.0,
                "syncedAttributes": {},
                "totalBudget": 5.0,
                "synced": 0,
                "isReco": 0,
                "isEditable": true,
                "isYoutubeCampaign": false,
                "IOs": [
                    {
                        "id": 195,
                        "name": "DV360 Campaign_dv360_1_IO_1",
                        "budget": 10.0,
                        "platformId": 5,
                        "startDate": "2025-02-05 05:01:04",
                        "endDate": "2025-02-04 22:59:59",
                        "pacingBudget": 10.0,
                        "isSynced": false,
                        "campaignId": 1404
                    }
                ]
            }
        ],
        "length": 0,
        "responseObj": [
            {
                "id": 1048,
                "platId": 5,
                "title": "DV360 Creative",
                "isApproved": 0,
                "crType": 21,
                "description": "",
                "heading": "",
                "landingUrl": "https://devbeki.torcai.com/atd",
                "tags": [],
                "isRecActive": 1,
                "isActive": 1,
                "mediaList": [
                    {
                        "id": 1067,
                        "gcId": 1048,
                        "adSize": "3840X2160",
                        "isRecActive": 1,
                        "isActive": 1,
                        "url": "https://stagecdn.torcai.com/image/1872/1738733221512_Nestle-Logo.png",
                        "mimeType": "image/png",
                        "bitrate": 0,
                        "duration": 0.0,
                        "tagUrl": "",
                        "isApproved": 0,
                        "trackers": []
                    }
                ],
                "isSynced": 0
            }
        ]
    },
    {
        "responseCode": {
            "msg": "Preview Campaign List Fetched Successfully",
            "status": "Success",
            "code": 20040
        },
        "response": [
            {
                "mandateId": 928,
                "id": 1404,
                "name": "DV360 Campaign_dv360_1",
                "budget": 0.0,
                "pacingType": 27,
                "durationType": 140,
                "platformName": "dv360",
                "platformId": 5,
                "startDate": "2025-02-04 05:01:04",
                "endDate": "2025-02-04 22:59:59",
                "status": 2,
                "strategies": [
                    {
                        "name": "DV360 Campaign_dv360_1_dv360_Strategy_1",
                        "id": 1467,
                        "campaignId": 1404,
                        "budget": 5.0,
                        "startDate": "2025-02-04 05:01:35",
                        "endDate": "2025-02-04 22:59:59",
                        "mediaType": 0,
                        "status": 2,
                        "pacingBudget": 5.0,
                        "pacingType": 27,
                        "durationType": 140,
                        "pacingTypeName": "Even",
                        "durationTypeName": "Lifetime",
                        "biddingStrategy": "1799",
                        "biddingStrategyName": "CPM",
                        "bidCap": 0.2,
                        "platformId": 5,
                        "isLocationPresent": false,
                        "isAudiencePresent": false,
                        "isKeywordPresent": false,
                        "isDayPartPresent": false,
                        "isPositionPresent": false,
                        "isSitesPresent": false,
                        "targeting": {
                            "location": [],
                            "audience": [],
                            "language": [],
                            "daypart": [],
                            "device": [],
                            "age": [],
                            "position": [],
                            "keyword": [],
                            "sites": [],
                            "gender": []
                        },
                        "creative": {
                            "utm": "",
                            "campaignId": 1404,
                            "strategyId": 1467,
                            "creatives": [
                                {
                                    "status": 1,
                                    "id": 1067,
                                    "creativeId": 1276,
                                    "campaignId": 1404,
                                    "strategyId": 1467
                                }
                            ],
                            "creativeDetails": [
                                {
                                    "id": 1048,
                                    "platId": 5,
                                    "title": "DV360 Creative",
                                    "isApproved": 0,
                                    "crType": 21,
                                    "description": "",
                                    "heading": "",
                                    "landingUrl": "https://devbeki.torcai.com/atd",
                                    "tags": [],
                                    "isRecActive": 1,
                                    "isActive": 1,
                                    "mediaList": [
                                        {
                                            "id": 1067,
                                            "gcId": 1048,
                                            "adSize": "3840X2160",
                                            "isRecActive": 1,
                                            "isActive": 1,
                                            "url": "https://stagecdn.torcai.com/image/1872/1738733221512_Nestle-Logo.png",
                                            "mimeType": "image/png",
                                            "bitrate": 0,
                                            "duration": 0.0,
                                            "tagUrl": "",
                                            "isApproved": 0,
                                            "trackers": []
                                        }
                                    ],
                                    "isSynced": 0
                                }
                            ]
                        },
                        "syncedAttributes": {},
                        "synced": 0,
                        "io": {
                            "id": 195,
                            "name": "DV360 Campaign_dv360_1_IO_1",
                            "budget": 10.0,
                            "platformId": 5,
                            "startDate": "2025-02-05 05:01:04",
                            "endDate": "2025-02-04 22:59:59",
                            "pacingBudget": 10.0,
                            "isSynced": false,
                            "campaignId": 1404
                        }
                    }
                ],
                "pacingTypeName": "Even",
                "durationTypeName": "Lifetime",
                "checked": false,
                "pacingBudget": 0.0,
                "syncedAttributes": {},
                "totalBudget": 5.0,
                "synced": 0,
                "isReco": 0,
                "isEditable": true,
                "isYoutubeCampaign": false,
                "IOs": [
                    {
                        "id": 195,
                        "name": "DV360 Campaign_dv360_1_IO_1",
                        "budget": 10.0,
                        "platformId": 5,
                        "startDate": "2025-02-05 05:01:04",
                        "endDate": "2025-02-04 22:59:59",
                        "pacingBudget": 10.0,
                        "isSynced": false,
                        "campaignId": 1404
                    }
                ]
            }
        ],
        "length": 0,
        "responseObj": [
            {
                "id": 1048,
                "platId": 5,
                "title": "DV360 Creative",
                "isApproved": 0,
                "crType": 21,
                "description": "",
                "heading": "",
                "landingUrl": "https://devbeki.torcai.com/atd",
                "tags": [],
                "isRecActive": 1,
                "isActive": 1,
                "mediaList": [
                    {
                        "id": 1067,
                        "gcId": 1048,
                        "adSize": "3840X2160",
                        "isRecActive": 1,
                        "isActive": 1,
                        "url": "https://stagecdn.torcai.com/image/1872/1738733221512_Nestle-Logo.png",
                        "mimeType": "image/png",
                        "bitrate": 0,
                        "duration": 0.0,
                        "tagUrl": "",
                        "isApproved": 0,
                        "trackers": []
                    }
                ],
                "isSynced": 0
            }
        ]
    },
    {
        "responseCode": {
            "msg": "Preview Campaign List Fetched Successfully",
            "status": "Success",
            "code": 20040
        },
        "response": [
            {
                "mandateId": 884,
                "id": 1348,
                "name": "Google Ads Campaign_ads_1",
                "budget": 10.0,
                "pacingType": 29,
                "durationType": 4036,
                "platformName": "ads",
                "platformId": 4,
                "mediaType": 0,
                "startDate": "2025-01-10 11:35:48",
                "endDate": "2025-01-10 18:29:59",
                "status": 2,
                "targeting": {
                    "location": [],
                    "audience": [],
                    "language": [],
                    "daypart": [],
                    "device": [],
                    "adRotation": 1
                },
                "strategies": [
                    {
                        "name": "Google Ads Campaign_ads_1_ads_Strategy_1",
                        "id": 1473,
                        "campaignId": 1348,
                        "startDate": "2025-01-10 11:35:48",
                        "endDate": "2025-01-10 18:29:59",
                        "mediaType": 0,
                        "status": 2,
                        "pacingTypeName": "Standard",
                        "durationTypeName": "LifeTime",
                        "biddingStrategy": "146",
                        "biddingStrategyName": "Maximize click",
                        "bidCap": 0.2,
                        "platformId": 4,
                        "isLocationPresent": false,
                        "isAudiencePresent": false,
                        "isKeywordPresent": false,
                        "isDayPartPresent": false,
                        "isPositionPresent": false,
                        "isSitesPresent": false,
                        "targeting": {
                            "location": [],
                            "audience": [],
                            "language": [],
                            "daypart": [],
                            "device": [],
                            "age": [],
                            "position": [],
                            "keyword": [],
                            "sites": [],
                            "gender": []
                        },
                        "creative": {
                            "utm": "",
                            "campaignId": 1348,
                            "strategyId": 1473,
                            "creatives": [
                                {
                                    "status": 1,
                                    "id": 1069,
                                    "creativeId": 1282,
                                    "campaignId": 1348,
                                    "strategyId": 1473
                                }
                            ],
                            "creativeDetails": [
                                {
                                    "id": 1050,
                                    "platId": 4,
                                    "title": "GoogleAds Creative",
                                    "isApproved": 0,
                                    "crType": 18,
                                    "description": "",
                                    "heading": "",
                                    "landingUrl": "https://devbeki.torcai.com/atd",
                                    "tags": [],
                                    "isRecActive": 1,
                                    "isActive": 1,
                                    "mediaList": [
                                        {
                                            "id": 1069,
                                            "gcId": 1050,
                                            "adSize": "300X100",
                                            "isRecActive": 1,
                                            "isActive": 1,
                                            "url": "https://stagecdn.torcai.com/image/1832/1738932556037_images_(1).jpg",
                                            "mimeType": "image/jpeg",
                                            "bitrate": 0,
                                            "duration": 0.0,
                                            "tagUrl": "",
                                            "isApproved": 0,
                                            "trackers": []
                                        }
                                    ],
                                    "isSynced": 0
                                }
                            ]
                        },
                        "syncedAttributes": {},
                        "synced": 0
                    }
                ],
                "pacingTypeName": "Standard",
                "durationTypeName": "LifeTime",
                "biddingStrategy": "146",
                "biddingStrategyName": "Maximize click",
                "bidCap": 0.2,
                "checked": false,
                "pacingBudget": 10.0,
                "syncedAttributes": {},
                "totalBudget": 10.0,
                "synced": 0,
                "isReco": 0,
                "isEditable": true,
                "isYoutubeCampaign": false
            }
        ],
        "length": 0,
        "responseObj": [
            {
                "id": 1050,
                "platId": 4,
                "title": "GoogleAds Creative",
                "isApproved": 0,
                "crType": 18,
                "description": "",
                "heading": "",
                "landingUrl": "https://devbeki.torcai.com/atd",
                "tags": [],
                "isRecActive": 1,
                "isActive": 1,
                "mediaList": [
                    {
                        "id": 1069,
                        "gcId": 1050,
                        "adSize": "300X100",
                        "isRecActive": 1,
                        "isActive": 1,
                        "url": "https://stagecdn.torcai.com/image/1832/1738932556037_images_(1).jpg",
                        "mimeType": "image/jpeg",
                        "bitrate": 0,
                        "duration": 0.0,
                        "tagUrl": "",
                        "isApproved": 0,
                        "trackers": []
                    }
                ],
                "isSynced": 0
            }
        ]
    },
    {
        "responseCode": {
            "msg": "Preview Campaign List Fetched Successfully",
            "status": "Success",
            "code": 20040
        },
        "response": [
            {
                "mandateId": 887,
                "id": 1361,
                "name": "Meta Campaign_meta_1",
                "budget": 0.0,
                "platformName": "meta",
                "platformId": 3,
                "startDate": "2025-01-15 05:41:04",
                "endDate": "2025-01-16 18:29:59",
                "status": 2,
                "accountId": "735759678205531",
                "strategies": [
                    {
                        "name": "Meta Campaign_meta_1_meta_Strategy_1",
                        "id": 1462,
                        "campaignId": 1361,
                        "budget": 5.0,
                        "startDate": "2025-01-15 05:20:46",
                        "endDate": "2025-01-16 18:29:59",
                        "mediaType": 0,
                        "status": 2,
                        "pacingBudget": 2.5,
                        "pacingType": 31,
                        "durationType": 26,
                        "pacingTypeName": "Standard",
                        "durationTypeName": "Lifetime",
                        "biddingStrategy": "1783",
                        "biddingStrategyName": "Maximize Click",
                        "bidCap": 0.1,
                        "platformId": 3,
                        "isLocationPresent": true,
                        "isAudiencePresent": false,
                        "isKeywordPresent": false,
                        "isDayPartPresent": false,
                        "isPositionPresent": false,
                        "isSitesPresent": false,
                        "targeting": {
                            "location": [
                                {
                                    "type": "neighborhood",
                                    "inex": 1,
                                    "value": " Central Delhi  \u003e  Central Delhi, Ohio, United States  \u003e  neighborhood",
                                    "meta": "2774845"
                                }
                            ],
                            "audience": [],
                            "language": [],
                            "daypart": [],
                            "device": [],
                            "age": [],
                            "position": [],
                            "page": [
                                {
                                    "key": 285250477997915,
                                    "value": "Beki",
                                    "inex": 1
                                }
                            ],
                            "keyword": [],
                            "sites": [],
                            "gender": [],
                            "publisherPlatform": []
                        },
                        "creative": {
                            "utm": "",
                            "campaignId": 1361,
                            "strategyId": 1462,
                            "creatives": [
                                {
                                    "status": 1,
                                    "id": 1065,
                                    "creativeId": 1274,
                                    "campaignId": 1361,
                                    "strategyId": 1462
                                }
                            ],
                            "creativeDetails": [
                                {
                                    "id": 1046,
                                    "platId": 3,
                                    "title": "test1",
                                    "isApproved": 0,
                                    "crType": 19,
                                    "description": "lorem",
                                    "heading": "meta_test_head",
                                    "landingUrl": "https://images.pexels.com/photos/247851/pexels-photo-247851.jpeg?auto\u003dcompress\u0026cs\u003dtinysrgb\u0026w\u003d600",
                                    "tags": [],
                                    "isRecActive": 1,
                                    "isActive": 1,
                                    "mediaList": [
                                        {
                                            "id": 1065,
                                            "gcId": 1046,
                                            "adSize": "1080X1080",
                                            "isRecActive": 1,
                                            "isActive": 1,
                                            "url": "https://stagecdn.torcai.com/image/1760/1738214475533_ATD-300x250_(1)_resize_(1).jpeg",
                                            "mimeType": "image/jpeg",
                                            "bitrate": 0,
                                            "duration": 0.0,
                                            "tagUrl": "",
                                            "isApproved": 0,
                                            "trackers": []
                                        }
                                    ],
                                    "isSynced": 0
                                }
                            ]
                        },
                        "syncedAttributes": {},
                        "synced": 0
                    }
                ],
                "checked": false,
                "accountName": "Torcai Internal",
                "pacingBudget": 0.0,
                "syncedAttributes": {},
                "totalBudget": 5.0,
                "synced": 0,
                "isReco": 0,
                "isEditable": true,
                "isYoutubeCampaign": false
            }
        ],
        "length": 0,
        "responseObj": [
            {
                "id": 1046,
                "platId": 3,
                "title": "test1",
                "isApproved": 0,
                "crType": 19,
                "description": "lorem",
                "heading": "meta_test_head",
                "landingUrl": "https://images.pexels.com/photos/247851/pexels-photo-247851.jpeg?auto\u003dcompress\u0026cs\u003dtinysrgb\u0026w\u003d600",
                "tags": [],
                "isRecActive": 1,
                "isActive": 1,
                "mediaList": [
                    {
                        "id": 1065,
                        "gcId": 1046,
                        "adSize": "1080X1080",
                        "isRecActive": 1,
                        "isActive": 1,
                        "url": "https://stagecdn.torcai.com/image/1760/1738214475533_ATD-300x250_(1)_resize_(1).jpeg",
                        "mimeType": "image/jpeg",
                        "bitrate": 0,
                        "duration": 0.0,
                        "tagUrl": "",
                        "isApproved": 0,
                        "trackers": []
                    }
                ],
                "isSynced": 0
            }
        ]
    },
    {
        "responseCode": {
            "msg": "Preview Campaign List Fetched Successfully",
            "status": "Success",
            "code": 20040
        },
        "response": [
            {
                "mandateId": 6,
                "id": 1361,
                "name": "Website Traffic - Winter Sale_1",
                "budget": 0.0,
                "platformName": "meta",
                "platformId": 3,
                "startDate": "2025-01-15 05:41:04",
                "endDate": "2025-01-16 18:29:59",
                "status": 2,
                "accountId": "735759678205531",
                "strategies": [
                    {
                        "name": "Website Traffic - Winter Sale_1_meta_Strategy_1",
                        "id": 1462,
                        "campaignId": 1361,
                        "budget": 5.0,
                        "startDate": "2025-01-15 05:20:46",
                        "endDate": "2025-01-16 18:29:59",
                        "mediaType": 0,
                        "status": 2,
                        "pacingBudget": 2.5,
                        "pacingType": 31,
                        "durationType": 26,
                        "pacingTypeName": "Standard",
                        "durationTypeName": "Lifetime",
                        "biddingStrategy": "1783",
                        "biddingStrategyName": "Maximize Click",
                        "bidCap": 0.1,
                        "platformId": 3,
                        "isLocationPresent": true,
                        "isAudiencePresent": false,
                        "isKeywordPresent": false,
                        "isDayPartPresent": false,
                        "isPositionPresent": false,
                        "isSitesPresent": false,
                        "targeting": {
                            "location": [
                                {
                                    "type": "neighborhood",
                                    "inex": 1,
                                    "value": " Central Delhi  \u003e  Central Delhi, Ohio, United States  \u003e  neighborhood",
                                    "meta": "2774845"
                                }
                            ],
                            "audience": [],
                            "language": [],
                            "daypart": [],
                            "device": [],
                            "age": [],
                            "position": [],
                            "page": [
                                {
                                    "key": 285250477997915,
                                    "value": "Beki",
                                    "inex": 1
                                }
                            ],
                            "keyword": [],
                            "sites": [],
                            "gender": [],
                            "publisherPlatform": []
                        },
                        "creative": {
                            "utm": "",
                            "campaignId": 1361,
                            "strategyId": 1462,
                            "creatives": [
                                {
                                    "status": 1,
                                    "id": 1065,
                                    "creativeId": 1274,
                                    "campaignId": 1361,
                                    "strategyId": 1462
                                }
                            ],
                            "creativeDetails": [
                                {
                                    "id": 1046,
                                    "platId": 3,
                                    "title": "test1",
                                    "isApproved": 0,
                                    "crType": 19,
                                    "description": "lorem",
                                    "heading": "meta_test_head",
                                    "landingUrl": "https://images.pexels.com/photos/247851/pexels-photo-247851.jpeg?auto\u003dcompress\u0026cs\u003dtinysrgb\u0026w\u003d600",
                                    "tags": [],
                                    "isRecActive": 1,
                                    "isActive": 1,
                                    "mediaList": [
                                        {
                                            "id": 1065,
                                            "gcId": 1046,
                                            "adSize": "1080X1080",
                                            "isRecActive": 1,
                                            "isActive": 1,
                                            "url": "https://stagecdn.torcai.com/image/1760/1738214475533_ATD-300x250_(1)_resize_(1).jpeg",
                                            "mimeType": "image/jpeg",
                                            "bitrate": 0,
                                            "duration": 0.0,
                                            "tagUrl": "",
                                            "isApproved": 0,
                                            "trackers": []
                                        }
                                    ],
                                    "isSynced": 0
                                }
                            ]
                        },
                        "syncedAttributes": {},
                        "synced": 0
                    }
                ],
                "checked": false,
                "accountName": "Torcai Internal",
                "pacingBudget": 0.0,
                "syncedAttributes": {},
                "totalBudget": 5.0,
                "synced": 0,
                "isReco": 0,
                "isEditable": true,
                "isYoutubeCampaign": false
            }
        ],
        "length": 0,
        "responseObj": [
            {
                "id": 1046,
                "platId": 3,
                "title": "test1",
                "isApproved": 0,
                "crType": 19,
                "description": "lorem",
                "heading": "meta_test_head",
                "landingUrl": "https://images.pexels.com/photos/247851/pexels-photo-247851.jpeg?auto\u003dcompress\u0026cs\u003dtinysrgb\u0026w\u003d600",
                "tags": [],
                "isRecActive": 1,
                "isActive": 1,
                "mediaList": [
                    {
                        "id": 1065,
                        "gcId": 1046,
                        "adSize": "1080X1080",
                        "isRecActive": 1,
                        "isActive": 1,
                        "url": "https://stagecdn.torcai.com/image/1760/1738214475533_ATD-300x250_(1)_resize_(1).jpeg",
                        "mimeType": "image/jpeg",
                        "bitrate": 0,
                        "duration": 0.0,
                        "tagUrl": "",
                        "isApproved": 0,
                        "trackers": []
                    }
                ],
                "isSynced": 0
            }
        ]
    },
    {
        "responseCode": {
            "msg": "Preview Campaign List Fetched Successfully",
            "status": "Success",
            "code": 20040
        },
        "response": [
            {
                "mandateId": 8,
                "id": 1861,
                "name": "Truview Skippable - Product Launch_1",
                "budget": 0.0,
                "platformName": "meta",
                "platformId": 3,
                "startDate": "2025-01-15 05:41:04",
                "endDate": "2025-01-16 18:29:59",
                "status": 2,
                "accountId": "735759678205531",
                "strategies": [
                    {
                        "name": "Truview Skippable - Product Launch_1_meta_Strategy_1",
                        "id": 1462,
                        "campaignId": 1861,
                        "budget": 5.0,
                        "startDate": "2025-01-15 05:20:46",
                        "endDate": "2025-01-16 18:29:59",
                        "mediaType": 0,
                        "status": 2,
                        "pacingBudget": 2.5,
                        "pacingType": 31,
                        "durationType": 26,
                        "pacingTypeName": "Standard",
                        "durationTypeName": "Lifetime",
                        "biddingStrategy": "1783",
                        "biddingStrategyName": "Maximize Click",
                        "bidCap": 0.1,
                        "platformId": 3,
                        "isLocationPresent": true,
                        "isAudiencePresent": false,
                        "isKeywordPresent": false,
                        "isDayPartPresent": false,
                        "isPositionPresent": false,
                        "isSitesPresent": false,
                        "targeting": {
                            "location": [
                                {
                                    "type": "neighborhood",
                                    "inex": 1,
                                    "value": " Central Delhi  \u003e  Central Delhi, Ohio, United States  \u003e  neighborhood",
                                    "meta": "2774845"
                                }
                            ],
                            "audience": [],
                            "language": [],
                            "daypart": [],
                            "device": [],
                            "age": [],
                            "position": [],
                            "page": [
                                {
                                    "key": 285250477997915,
                                    "value": "Beki",
                                    "inex": 1
                                }
                            ],
                            "keyword": [],
                            "sites": [],
                            "gender": [],
                            "publisherPlatform": []
                        },
                        "creative": {
                            "utm": "",
                            "campaignId": 1861,
                            "strategyId": 1462,
                            "creatives": [
                                {
                                    "status": 1,
                                    "id": 1065,
                                    "creativeId": 1274,
                                    "campaignId": 1861,
                                    "strategyId": 1462
                                }
                            ],
                            "creativeDetails": [
                                {
                                    "id": 1046,
                                    "platId": 3,
                                    "title": "test1",
                                    "isApproved": 0,
                                    "crType": 19,
                                    "description": "lorem",
                                    "heading": "meta_test_head",
                                    "landingUrl": "https://images.pexels.com/photos/247851/pexels-photo-247851.jpeg?auto\u003dcompress\u0026cs\u003dtinysrgb\u0026w\u003d600",
                                    "tags": [],
                                    "isRecActive": 1,
                                    "isActive": 1,
                                    "mediaList": [
                                        {
                                            "id": 1065,
                                            "gcId": 1046,
                                            "adSize": "1080X1080",
                                            "isRecActive": 1,
                                            "isActive": 1,
                                            "url": "https://stagecdn.torcai.com/image/1760/1738214475533_ATD-300x250_(1)_resize_(1).jpeg",
                                            "mimeType": "image/jpeg",
                                            "bitrate": 0,
                                            "duration": 0.0,
                                            "tagUrl": "",
                                            "isApproved": 0,
                                            "trackers": []
                                        }
                                    ],
                                    "isSynced": 0
                                }
                            ]
                        },
                        "syncedAttributes": {},
                        "synced": 0
                    }
                ],
                "checked": false,
                "accountName": "Torcai Internal",
                "pacingBudget": 0.0,
                "syncedAttributes": {},
                "totalBudget": 5.0,
                "synced": 0,
                "isReco": 0,
                "isEditable": true,
                "isYoutubeCampaign": false
            }
        ],
        "length": 0,
        "responseObj": [
            {
                "id": 1046,
                "platId": 3,
                "title": "test1",
                "isApproved": 0,
                "crType": 19,
                "description": "lorem",
                "heading": "meta_test_head",
                "landingUrl": "https://images.pexels.com/photos/247851/pexels-photo-247851.jpeg?auto\u003dcompress\u0026cs\u003dtinysrgb\u0026w\u003d600",
                "tags": [],
                "isRecActive": 1,
                "isActive": 1,
                "mediaList": [
                    {
                        "id": 1065,
                        "gcId": 1046,
                        "adSize": "1080X1080",
                        "isRecActive": 1,
                        "isActive": 1,
                        "url": "https://stagecdn.torcai.com/image/1760/1738214475533_ATD-300x250_(1)_resize_(1).jpeg",
                        "mimeType": "image/jpeg",
                        "bitrate": 0,
                        "duration": 0.0,
                        "tagUrl": "",
                        "isApproved": 0,
                        "trackers": []
                    }
                ],
                "isSynced": 0
            }
        ]
    }
]

// Seat Accounts Options List at Preview & Publish
export const accountListAll = [
    {
        "ion": [
            {
                "key": 2,
                "value": "ION",
                "platformId": 2,
                "platformImage": "data:image/png;base64,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",
                "platformName": "ION"
            }
        ],
        "meta": [
            {
                "value": "735759678205531",
                "platform": {
                    "key": 3,
                    "value": "Meta",
                    "platformId": 3
                },
                "platformId": 3,
                "mccAccountId": null,
                "platformName": "Meta",
                "platformImage": "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAARCAYAAADOk8xKAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAORSURBVHgBhVVNjBRFFP5eVfX8gLqDgnrB9CoaEzwqiRdlLx6I0Xgw68EEcOJCCLqsUYMxSA8qwZjoBBOyWQhEEy9qSPzXC4kc9GKCrgcTYJmBAOEA7AABdran6/Gqe2Z6ZqcXXqZmqqvf+773vap6Q1jMyqfWKNArlvE4FFqwOIzmPYfx9X1XB3yDm2sB/SoYD4PU/4jsFD7M/ZsFS9lkp3cT7HudR6bETX7qDH4J+4f/ScnCzwVl2wAG817Am0BAtndZDThunNnTSyZgrdiR4ux8Uf2nKR9/Jn5Xae1tkzXA9mNh2SpE37SzexMq/BK3VfjayQ1E+lDyhi8y7CgOrDqCzTVfWQFgTLTFNvjeoe9t8a71QlIHRyMIivUuTiXc6bTHcxtNoFKoZhJSuVaTHz+piH0KBx/5u/e9GasFDNqphJW1hl2+DNbqx/BR4QQWWmV+UhA3JerNsJS20V/SzbUNbJTPWsDA+xaSOWtNDQcE+jkOjCLoS7N/ZZLFGXvb5euKzEqwzdc7y11CIrNeadkhyRwefYpFrPXgAyehkjAhfbqwpT6S6egURfyLlEoOsF7XT/jGiTx7+WetyUndzB+YHK5nguxqrhaycVsaijndfjLTQYzNDGX6q/A38XCztQi4lBKapWug5RyKOtbmKBYzSz85lqhY/E6Afo0rw+znjJnIDtBHY4XOwiurUkLS95PRcEOApjNjK80dQuYrJ8223hGgLcyyRwJIEcYLYzMPDcSc/+pcd+4teSIl9LzlcGSejELx4kBgwL647ohFWj7krsCclJ1sWHUVk2NWssbbPxA3tSkkGyWdKQpNSqgNszGunOlar1HrW5eWqD8DDnd1lpfk8Zmorrsyy+e5/NYzLywMZVJ9V6+9h+YalHanCch5q/sikkv8ZEKsP+m94Je/ePSqJFNmB0kKkfIO4K1zK7ux719aKet3J8y4kBKq4u/JsZNhlPS/m77LTfrku+h0DPAxfKD3LVQwNymdSKsppvjYrjCU+xHbZ30EgYIulLuOBfVfnHOqZP6IPPbeqXkZuTbZYPvqsdK22dJ1bh6ThutL85Ct8cBKz0sTyTEZ14h/QJB/MVXoTEcbhbAXMNcuxVmEvG4xMmeN6rKGJh6RbREfHRenEy9/BLJmxzu+/c1797UVCPPPS8So5HJDVqalD1Y7ffCO9vaFpZ7Jv2xJjUp555h42kZcxZ7SbMflFuDAQ+T1IzYvAAAAAElFTkSuQmCC",
                "label": "Torcai Internal  (735759678205531)",
                "disabled": false
            }
        ],
        "googleads": [
            {
                "value": "2557039093",
                "platform": {
                    "key": 4,
                    "value": "Google Ads",
                    "platformId": 4
                },
                "platformId": 4,
                "mccAccountId": "2557039093",
                "platformName": "Google Ads",
                "platformImage": "data:image/png;base64,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",
                "label": "Test Account (QA)  (2557039093)",
                "disabled": false
            },
            {
                "value": "4774633019",
                "platform": {
                    "key": 4,
                    "value": "Google Ads",
                    "platformId": 4
                },
                "platformId": 4,
                "mccAccountId": "4774633019",
                "platformName": "Google Ads",
                "platformImage": "data:image/png;base64,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",
                "label": "testing google ads  (4774633019)",
                "disabled": false
            }
        ],
        "dv360": [
            {
                "value": "6767031589",
                "platform": {
                    "key": 5,
                    "value": "DV360",
                    "platformId": 5
                },
                "platformId": 5,
                "mccAccountId": "2725631",
                "platformName": "DV360",
                "platformImage": "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAaCAYAAACtv5zzAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAALfSURBVHgBtZZNTNNgGMf/7T46xrZsiGMwphsRNBLRYCJDIRKICSLxph6INxMvJF4M4aCJ8UiCejFGY6IHE0kkXjQqiQnGKSAGNKAcEATGp8jXNrau7bbaLq5mznUfyK+X9n3+ff7p8z7v25eAAM/zdmwDBEFME7+TT8UGuQgnhqAilfgPOOKydE/04KXbBTbCwllwEOdKm5CvMWErSF/wZn4Q978+iQuqFSrUFztxprQRFKlGFjjI2F3f0nBClA1zeDXjQntfJ94uDiEbJAMuEkoq+hlYw73RLlz5cAsTnhlkZbBGexDmw7Liac88rg3exp0vj7HCbCAjAybMYtq7AC/rl3+D5/F+YRhtrg50fXuBEB9Kz0AkJJRp0b8Mt29RtmQirNDOz6d6cfldB1xLQ+kZxKBDQUx63FhnvCnbdIVex92RLrT3d2LGt5CegQghXGpShevOSzhprwVJkLJG4hze/PwQ3ZM92GB9qQ1iGNS5aCk7jRu17XBaDiXEcxQUbLpCFOssyKOMGFudxIOxp8JcbqZnEEMsVWtFC9oqL8CqK4CCUMCizYdNX4QcpSZO6xMaZXR1PDODGGUmB07Z61BisAlfp0+qE7tSJKMdbWhlDL2zAwhwQXGnTC4UQvvz9qRvIK7e1+5+LNNrKbViuZodddHypTQICrvqo/FnmPLMif8MOSmUwvZeY61ElfkAKGHipXFZA6EU3zdm5STRUu012tFkPw6dSpto/PdAJBKJrgGCJJAKm9CaDbZq7NIXJtVIBryQz7PuBUMz0WdKQyF3p+afL+WoNGiwVqHSXI5USAb0ZkBKLsIEGfg36TixgiRxrOgwqs0VoJQU0kH5JyGXEKTpoHS/L68EJ2xHYaIMyATJwGG0YmD2U1zQpDXArN2Bxt01sOutyAZpJbceOY9ig0UKGCgdrta14mL52ayTi8QdW+a8P/BxfgR+LoDmsnoYNXpsEUe0F7fz4PULt3gBeWD6LoEAAAAASUVORK5CYII=",
                "label": "Youtube_Seat  (6767031589)",
                "disabled": false
            },
            {
                "value": "1379087005",
                "platform": {
                    "key": 5,
                    "value": "DV360",
                    "platformId": 5
                },
                "platformId": 5,
                "mccAccountId": "2725631",
                "platformName": "DV360",
                "platformImage": "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAaCAYAAACtv5zzAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAALfSURBVHgBtZZNTNNgGMf/7T46xrZsiGMwphsRNBLRYCJDIRKICSLxph6INxMvJF4M4aCJ8UiCejFGY6IHE0kkXjQqiQnGKSAGNKAcEATGp8jXNrau7bbaLq5mznUfyK+X9n3+ff7p8z7v25eAAM/zdmwDBEFME7+TT8UGuQgnhqAilfgPOOKydE/04KXbBTbCwllwEOdKm5CvMWErSF/wZn4Q978+iQuqFSrUFztxprQRFKlGFjjI2F3f0nBClA1zeDXjQntfJ94uDiEbJAMuEkoq+hlYw73RLlz5cAsTnhlkZbBGexDmw7Liac88rg3exp0vj7HCbCAjAybMYtq7AC/rl3+D5/F+YRhtrg50fXuBEB9Kz0AkJJRp0b8Mt29RtmQirNDOz6d6cfldB1xLQ+kZxKBDQUx63FhnvCnbdIVex92RLrT3d2LGt5CegQghXGpShevOSzhprwVJkLJG4hze/PwQ3ZM92GB9qQ1iGNS5aCk7jRu17XBaDiXEcxQUbLpCFOssyKOMGFudxIOxp8JcbqZnEEMsVWtFC9oqL8CqK4CCUMCizYdNX4QcpSZO6xMaZXR1PDODGGUmB07Z61BisAlfp0+qE7tSJKMdbWhlDL2zAwhwQXGnTC4UQvvz9qRvIK7e1+5+LNNrKbViuZodddHypTQICrvqo/FnmPLMif8MOSmUwvZeY61ElfkAKGHipXFZA6EU3zdm5STRUu012tFkPw6dSpto/PdAJBKJrgGCJJAKm9CaDbZq7NIXJtVIBryQz7PuBUMz0WdKQyF3p+afL+WoNGiwVqHSXI5USAb0ZkBKLsIEGfg36TixgiRxrOgwqs0VoJQU0kH5JyGXEKTpoHS/L68EJ2xHYaIMyATJwGG0YmD2U1zQpDXArN2Bxt01sOutyAZpJbceOY9ig0UKGCgdrta14mL52ayTi8QdW+a8P/BxfgR+LoDmsnoYNXpsEUe0F7fz4PULt3gBeWD6LoEAAAAASUVORK5CYII=",
                "label": "Infomo Dubai  (1379087005)",
                "disabled": false
            }
        ],
        "tiktok": [
            {
                "key": 7,
                "value": "TikTok",
                "platformId": 7,
                "platformImage": "data:image/png;base64,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",
                "platformName": "TikTok"
            }
        ],
        "viads": [
            {
                "key": 8,
                "value": "ViAds",
                "platformId": 8,
                "platformImage": "data:image/png;base64,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",
                "platformName": "ViAds"
            }
        ],
        "ioh": [
            {
                "key": 9,
                "value": "IOH",
                "platformId": 9,
                "platformImage": "data:image/png;base64,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",
                "platformName": "IOH"
            }
        ]
    }
]

// Third Party Data
export const thirdPartyData = {
    "responseCode": {
        "msg": "All Third Party Seats Fetched",
        "status": "Success",
        "code": 3030
    },
    "response": [
        {
            "campaignSynced": 2,
            "advertiserMapped": 5,
            "campaignMapped": 2,
            "advertiserIds": [
                1760,
                1874,
                1875,
                1878,
                1883
            ],
            "accountType": 0,
            "margin": 30.0,
            "advertiserId": 1760,
            "agencyMargin": 0.0,
            "id": 9,
            "accountId": "6767031589",
            "masterAccountId": "2725631",
            "currency": "INR",
            "platformId": 5,
            "displayName": "BVT",
            "isActive": 1,
            "isRecActive": 1,
            "cDate": "Jan 16, 2025 5:50:25 AM",
            "cUser": 189,
            "mDate": "Jan 18, 2025 6:19:59 AM",
            "mUser": 0,
            "defaultSeat": 0,
            "seatType": 0,
            "masterAccountName": "CMR INR",
            "fees": 30.0,
            "timeZone": "Asia/Hong_Kong",
            "accountName": "BVT",
            "loginFlow": 0
        },
        {
            "campaignSynced": 3,
            "advertiserMapped": 6,
            "campaignMapped": 8,
            "advertiserIds": [
                1760,
                1867,
                1874,
                1875,
                1878,
                1883
            ],
            "accountType": 0,
            "margin": 30.0,
            "advertiserId": 1760,
            "agencyMargin": 0.0,
            "id": 55,
            "accountId": "2557039093",
            "masterAccountId": "2557039093",
            "currency": "INR",
            "platformId": 4,
            "displayName": "Test Account (QA)",
            "isActive": 1,
            "isRecActive": 1,
            "cDate": "Jan 19, 2025 8:31:01 AM",
            "cUser": 189,
            "mUser": 0,
            "defaultSeat": 1,
            "seatType": 0,
            "masterAccountName": "Test Account (QA)",
            "fees": 30.0,
            "timeZone": "Asia/Calcutta",
            "accountName": "Test Account (QA)",
            "loginFlow": 0
        },
        {
            "campaignSynced": 0,
            "advertiserMapped": 6,
            "campaignMapped": 2,
            "advertiserIds": [
                1760,
                1867,
                1874,
                1875,
                1878,
                1883
            ],
            "pages": [
                {
                    "advertiserId": 1760,
                    "id": 3096,
                    "tapId": 56,
                    "pageId": "317803264739781",
                    "accountId": "735759678205531",
                    "pageName": "Beki - Test "
                },
                {
                    "advertiserId": 1760,
                    "id": 3097,
                    "tapId": 56,
                    "pageId": "285250477997915",
                    "accountId": "735759678205531",
                    "pageName": "Beki"
                },
                {
                    "advertiserId": 1760,
                    "id": 3098,
                    "tapId": 56,
                    "pageId": "198764363327145",
                    "accountId": "735759678205531",
                    "pageName": "ATD "
                }
            ],
            "accountType": 0,
            "margin": 30.0,
            "advertiserId": 1760,
            "agencyMargin": 0.0,
            "id": 56,
            "accountId": "735759678205531",
            "currency": "INR",
            "platformId": 3,
            "displayName": "Torcai Internal",
            "isActive": 1,
            "isRecActive": 1,
            "cDate": "Jan 19, 2025 8:43:25 AM",
            "cUser": 189,
            "mDate": "Jan 27, 2025 7:19:51 AM",
            "mUser": 0,
            "defaultSeat": 1,
            "seatType": 0,
            "fees": 30.0,
            "timeZone": "Asia/Kolkata",
            "accountName": "Torcai Internal",
            "loginFlow": 1
        },
        {
            "campaignSynced": 0,
            "advertiserMapped": 5,
            "campaignMapped": 0,
            "advertiserIds": [
                1760,
                1874,
                1875,
                1878,
                1883
            ],
            "accountType": 0,
            "margin": 30.0,
            "advertiserId": 1760,
            "agencyMargin": 0.0,
            "id": 67,
            "accountId": "4774633019",
            "masterAccountId": "4774633019",
            "currency": "INR",
            "platformId": 4,
            "displayName": "testing google ads",
            "isActive": 1,
            "isRecActive": 1,
            "cDate": "Jan 22, 2025 12:01:26 PM",
            "cUser": 189,
            "mUser": 0,
            "defaultSeat": 0,
            "seatType": 0,
            "masterAccountName": "testing google ads",
            "fees": 30.0,
            "timeZone": "Asia/Calcutta",
            "accountName": "testing google ads",
            "loginFlow": 0
        }
    ],
    "length": 0
}

// Reco Campaign Strategy List
export const recoCampaignStrategyList = {
    "responseCode": {
        "msg": "Strategy Fetched Successfully",
        "status": "Success",
        "code": 4601
    },
    "length": 0,
    "responseObj": {
        "ads": [
            {
                "id": 1206,
                "budget": 50.0,
                "startDate": "2024-10-09 11:47:15",
                "endDate": "2024-10-17 18:29:59",
                "status": 3,
                "name": "Google_Ads_Campaign_display1728474479992",
                "type": 0,
                "stratgies": [
                    {
                        "name": "Google_Ads_Campaign_Strategy 1",
                        "id": 1237,
                        "campaignId": 1206,
                        "targeting": {
                            "location": [],
                            "audience": [],
                            "daypart": []
                        },
                        "budget": 0.0,
                        "pacingType": 0,
                        "duration": 0,
                        "sDate": "2024-10-09 11:47:15",
                        "eDate": "2024-10-17 18:29:59",
                        "status": 3,
                        "type": -1,
                        "bidStrategy": 0,
                        "bidCap": 2.0,
                        "freqCap": {
                            "cap": -1,
                            "time": -1,
                            "interval": -1
                        },
                        "synced": 0,
                        "isUsed": false
                    }
                ],
                "isReco": 0
            },
            {
                "id": 1207,
                "budget": 50.0,
                "startDate": "2024-10-09 11:47:15",
                "endDate": "2024-10-17 18:29:59",
                "status": 3,
                "name": "Google_Ads_Campaign_search1728474479995",
                "type": 2,
                "stratgies": [
                    {
                        "name": "Google_Ads_Campaign_searchStrategy 1",
                        "id": 1238,
                        "campaignId": 1207,
                        "targeting": {
                            "location": [],
                            "audience": [],
                            "daypart": []
                        },
                        "budget": 0.0,
                        "pacingType": 0,
                        "duration": 0,
                        "sDate": "2024-10-09 11:47:15",
                        "eDate": "2024-10-17 18:29:59",
                        "status": 3,
                        "type": -1,
                        "bidStrategy": 0,
                        "bidCap": 2.0,
                        "freqCap": {
                            "cap": -1,
                            "time": -1,
                            "interval": -1
                        },
                        "synced": 0,
                        "isUsed": false
                    }
                ],
                "isReco": 0
            }
        ]
    }
}

// Reco Campaign Daypart List
export const recoCampaignDaypartList = {
    "responseCode": {
        "msg": "DayPart List Fetched Successfully",
        "status": "Success",
        "code": 20046
    },
    "length": 0,
    "responseObj": {
        "eHour": "[01.00, 02.00, 03.00, 04.00, 05.00, 06.00, 07.00, 08.00, 09.00, 10.00, 11.00, 12.00,13.00, 14.00, 15.00, 16.00, 17.00, 18.00, 19.00, 20.00, 21.00, 22.00, 23.00, 24.00]",
        "sHour": "[00.00, 01.00, 02.00, 03.00, 04.00, 05.00, 06.00, 07.00, 08.00, 09.00, 10.00, 11.00,12.00, 13.00, 14.00, 15.00, 16.00, 17.00, 18.00, 19.00, 20.00, 21.00, 22.00, 23.00 ]"
    }
}

// Reco Targeting List
export const recoTargetingList = {
    "responseCode": {
        "msg": "Recommended Plan Attributes List fetched Successfully",
        "status": "Success",
        "code": 212
    },
    "length": 0,
    "responseObj": {
        "language": [
            {
                "id": "2895",
                "value": "Polish",
                "bekiId": "2895"
            },
            {
                "id": "1931",
                "value": "Urdu",
                "bekiId": "1931"
            },
            {
                "id": "1939",
                "value": "Romanian",
                "bekiId": "1939"
            },
            {
                "id": "2421",
                "value": "Japanese",
                "bekiId": "2421"
            },
            {
                "id": "2603",
                "value": "Korean",
                "bekiId": "2603"
            },
            {
                "id": "2059",
                "value": "Tamil",
                "bekiId": "2059"
            },
            {
                "id": "2447",
                "value": "Bengali",
                "bekiId": "2447"
            },
            {
                "id": "2311",
                "value": "Danish",
                "bekiId": "2311"
            },
            {
                "id": "2955",
                "value": "Punjabi",
                "bekiId": "2955"
            },
            {
                "id": "2679",
                "value": "Slovak",
                "bekiId": "2679"
            },
            {
                "id": "2831",
                "value": "Chinese (traditional)",
                "bekiId": "2831"
            },
            {
                "id": "2345",
                "value": "Hebrew",
                "bekiId": "2345"
            },
            {
                "id": "2495",
                "value": "German",
                "bekiId": "2495"
            },
            {
                "id": "2245",
                "value": "Slovenian",
                "bekiId": "2245"
            },
            {
                "id": "2001",
                "value": "French",
                "bekiId": "2001"
            },
            {
                "id": "2747",
                "value": "Arabic",
                "bekiId": "2747"
            },
            {
                "id": "2143",
                "value": "Portuguese",
                "bekiId": "2143"
            },
            {
                "id": "2365",
                "value": "Ukrainian",
                "bekiId": "2365"
            },
            {
                "id": "2875",
                "value": "Finnish",
                "bekiId": "2875"
            },
            {
                "id": "1903",
                "value": "Catalan",
                "bekiId": "1903"
            },
            {
                "id": "2765",
                "value": "Spanish",
                "bekiId": "2765"
            },
            {
                "id": "2167",
                "value": "Norwegian",
                "bekiId": "2167"
            },
            {
                "id": "2581",
                "value": "Malayalam",
                "bekiId": "2581"
            },
            {
                "id": "2591",
                "value": "Lithuanian",
                "bekiId": "2591"
            },
            {
                "id": "2051",
                "value": "Latvian",
                "bekiId": "2051"
            },
            {
                "id": "2913",
                "value": "Bulgarian",
                "bekiId": "2913"
            },
            {
                "id": "1979",
                "value": "Icelandic",
                "bekiId": "1979"
            },
            {
                "id": "2299",
                "value": "Croatian",
                "bekiId": "2299"
            },
            {
                "id": "2935",
                "value": "English",
                "bekiId": "2935"
            },
            {
                "id": "2431",
                "value": "Estonian",
                "bekiId": "2431"
            },
            {
                "id": "1969",
                "value": "Gujarati",
                "bekiId": "1969"
            },
            {
                "id": "2095",
                "value": "Dutch",
                "bekiId": "2095"
            },
            {
                "id": "2487",
                "value": "Persian",
                "bekiId": "2487"
            },
            {
                "id": "2645",
                "value": "Vietnamese",
                "bekiId": "2645"
            },
            {
                "id": "2085",
                "value": "Czech",
                "bekiId": "2085"
            },
            {
                "id": "2945",
                "value": "Hungarian",
                "bekiId": "2945"
            },
            {
                "id": "2227",
                "value": "Italian",
                "bekiId": "2227"
            },
            {
                "id": "2691",
                "value": "Serbian",
                "bekiId": "2691"
            },
            {
                "id": "2111",
                "value": "Russian",
                "bekiId": "2111"
            },
            {
                "id": "2323",
                "value": "Greek",
                "bekiId": "2323"
            },
            {
                "id": "2387",
                "value": "Malay",
                "bekiId": "2387"
            },
            {
                "id": "1871",
                "value": "Turkish",
                "bekiId": "1871"
            },
            {
                "id": "2709",
                "value": "Marathi",
                "bekiId": "2709"
            },
            {
                "id": "1861",
                "value": "Swedish",
                "bekiId": "1861"
            },
            {
                "id": "2529",
                "value": "Filipino",
                "bekiId": "2529"
            },
            {
                "id": "2015",
                "value": "Indonesian",
                "bekiId": "2015"
            },
            {
                "id": "2157",
                "value": "Hindi",
                "bekiId": "2157"
            },
            {
                "id": "1881",
                "value": "Kannada",
                "bekiId": "1881"
            },
            {
                "id": "2773",
                "value": "Thai",
                "bekiId": "2773"
            },
            {
                "id": "2519",
                "value": "Telugu",
                "bekiId": "2519"
            },
            {
                "id": "2871",
                "value": "Chinese (simplified)",
                "bekiId": "2871"
            }
        ],
        "device": [
            {
                "id": "42",
                "value": "Desktop",
                "bekiId": "42"
            },
            {
                "id": "43",
                "value": "Tablet",
                "bekiId": "43"
            },
            {
                "id": "41",
                "value": "Mobile",
                "bekiId": "41"
            }
        ],
        "age": [
            {
                "id": "93",
                "value": "18-54",
                "bekiId": "93"
            },
            {
                "id": "85",
                "value": "55-64",
                "bekiId": "85"
            },
            {
                "id": "94",
                "value": "18-44",
                "bekiId": "94"
            },
            {
                "id": "95",
                "value": "18-34",
                "bekiId": "95"
            },
            {
                "id": "81",
                "value": "18-24",
                "bekiId": "81"
            },
            {
                "id": "83",
                "value": "35-44",
                "bekiId": "83"
            },
            {
                "id": "88",
                "value": "35-54",
                "bekiId": "88"
            },
            {
                "id": "92",
                "value": "18-64",
                "bekiId": "92"
            },
            {
                "id": "87",
                "value": "35-64",
                "bekiId": "87"
            },
            {
                "id": "90",
                "value": "25-44",
                "bekiId": "90"
            },
            {
                "id": "91",
                "value": "25-54",
                "bekiId": "91"
            },
            {
                "id": "82",
                "value": "25-34",
                "bekiId": "82"
            },
            {
                "id": "86",
                "value": "45-64",
                "bekiId": "86"
            },
            {
                "id": "89",
                "value": "25-64",
                "bekiId": "89"
            },
            {
                "id": "84",
                "value": "45-54",
                "bekiId": "84"
            }
        ],
        "gender": [
            {
                "id": "64",
                "value": "All",
                "bekiId": "64"
            },
            {
                "id": "62",
                "value": "Male",
                "bekiId": "62"
            },
            {
                "id": "63",
                "value": "Female",
                "bekiId": "63"
            }
        ]
    }
}

// Reco recoCampaignStrategyTypeReco
export const recoCampaignStrategyTypeReco = {
    "responseCode": {
        "msg": "Strategy Fetched Successfully",
        "status": "Success",
        "code": 4601
    },
    "length": 0,
    "responseObj": {
        "beki": [
            {
                "startDate": "2024-10-09 11:47:15",
                "endDate": "2024-10-17 18:29:59",
                "status": 3,
                "name": "Google_Ads_Campaign_display1728474479992",
                "stratgies": [
                    {
                        "name": "Google_Ads_Campaign_searchStrategy 1",
                        "id": 1238,
                        "campaignId": 1207,
                        "targeting": {
                            "location": [],
                            "device": [],
                            "gender": [],
                            "daypart": [],
                            "languages": []
                        },
                        "pacingType": 1,
                        "duration": 5,
                        "sDate": "2024-10-09 11:47:15",
                        "eDate": "2024-10-17 18:29:59",
                        "status": 3,
                        "type": -1,
                        "bidStrategy": 1763,
                        "bidCap": 2.0,
                        "freqCap": {
                            "cap": -1,
                            "interval": 1
                        },
                        "isUsed": false
                    }
                ],
                "isReco": 0
            }
        ]
    }
}

// Reco Creative Data
export const recoCampaignCreativeData = {
    "responseCode": {
        "msg": "Strategy Created Successfully",
        "status": "Success",
        "code": 213
    },
    "length": 0,
    "responseObj": {
        "ads": {
            "display": [
                {
                    "name": "Google_Ads_Campaign_Strategy 1",
                    "campaignId": 1206,
                    "id": 1237,
                    "creatives": [
                        {
                            "id": 777,
                            "platId": 4,
                            "title": "Google Ads Creative",
                            "isApproved": 0,
                            "crType": 18,
                            "description": "Step into comfort and style with our latest shoe collection. From sleek sneakers to timeless classics, find the perfect fit for every occasion. Walk with confidence—your feet will thank you!",
                            "heading": "",
                            "landingUrl": "https://www.google.com",
                            "tags": [],
                            "isRecActive": 1,
                            "isActive": 1,
                            "mediaList": [
                                {
                                    "id": 884,
                                    "gcId": 777,
                                    "adSize": "300X250",
                                    "isRecActive": 1,
                                    "isActive": 1,
                                    "url": "https://stagecdn.torcai.com/image/1760/1728474840616_imgpsh_fullsize_anim_(1).jpeg",
                                    "mimeType": "image/jpeg",
                                    "bitrate": 0,
                                    "duration": 0.0,
                                    "tagUrl": "",
                                    "isApproved": 0,
                                    "trackers": []
                                }
                            ],
                            "mappedCampaigns": [
                                {
                                    "key": 1206,
                                    "value": "Google_Ads_Campaign_display1728474479992"
                                }
                            ],
                            "isSynced": 0
                        }
                    ],
                    "utm": ""
                }
            ],
            "search": [
                {
                    "name": "Google_Ads_Campaign_searchStrategy 1",
                    "campaignId": 1207,
                    "id": 1238,
                    "creatives": [
                        {
                            "description": [
                                "Find exactly what you’re looking for at unbeatable prices. Fast shipping, great customer service, and more!",
                                "Discover amazing discounts on top-rated products. Limited-time offers—shop now and save big!",
                                "Don’t miss out! Shop now for exclusive deals on the latest products. Hurry, offer ends soon!"
                            ],
                            "heading": [
                                "Save Big with Our Special Deals",
                                "Unlock Exclusive Offers Today!",
                                "Shop the Latest Trends Now"
                            ],
                            "landingUrl": "https://www.google.com"
                        }
                    ],
                    "utm": ""
                }
            ]
        }
    }
}

// Reco Campaign List Preview
export const recoCampaignListPreview = {
    "responseCode": {
        "msg": "Preview Campaign List Fetched Successfully",
        "status": "Success",
        "code": 20040
    },
    "response": [
        {
            "mandateId": 765,
            "id": 1206,
            "name": "Google_Ads_Campaign_display1728474479992",
            "budget": 50.0,
            "pacingType": 29,
            "durationType": 23,
            "platformName": "ads",
            "platformId": 4,
            "mediaType": 0,
            "startDate": "2024-10-09 11:47:15",
            "endDate": "2024-10-17 18:29:59",
            "status": 3,
            "targeting": {
                "location": [],
                "audience": [],
                "language": [],
                "daypart": [],
                "device": [],
                "adRotation": 0
            },
            "strategies": [
                {
                    "name": "Google_Ads_Campaign_displayStrategy 1",
                    "id": 1237,
                    "campaignId": 1206,
                    "startDate": "2024-10-09 11:47:15",
                    "endDate": "2024-10-17 18:29:59",
                    "mediaType": 0,
                    "status": 3,
                    "pacingTypeName": "Standard",
                    "durationTypeName": "Daily",
                    "biddingStrategy": "148",
                    "biddingStrategyName": "Manual CPC",
                    "bidCap": 2.0,
                    "platformId": 4,
                    "isLocationPresent": false,
                    "isAudiencePresent": false,
                    "isKeywordPresent": false,
                    "isDayPartPresent": false,
                    "isPositionPresent": false,
                    "isSitesPresent": false,
                    "targeting": {
                        "location": [],
                        "audience": [],
                        "language": [],
                        "daypart": [],
                        "device": [],
                        "age": [],
                        "position": [],
                        "keyword": [],
                        "sites": [],
                        "gender": []
                    },
                    "creative": {
                        "utm": "",
                        "campaignId": 1206,
                        "strategyId": 1237,
                        "creatives": [
                            {
                                "status": 1,
                                "id": 884,
                                "creativeId": 975,
                                "campaignId": 1206,
                                "strategyId": 1237
                            }
                        ],
                        "creativeDetails": [
                            {
                                "id": 777,
                                "platId": 4,
                                "title": "Google Ads Creative",
                                "isApproved": 0,
                                "crType": 18,
                                "description": "",
                                "heading": "",
                                "landingUrl": "https://www.google.com",
                                "tags": [],
                                "isRecActive": 1,
                                "isActive": 1,
                                "mediaList": [
                                    {
                                        "id": 884,
                                        "gcId": 777,
                                        "adSize": "300X250",
                                        "isRecActive": 1,
                                        "isActive": 1,
                                        "url": "https://stagecdn.torcai.com/image/1760/1728474840616_imgpsh_fullsize_anim_(1).jpeg",
                                        "mimeType": "image/jpeg",
                                        "bitrate": 0,
                                        "duration": 0.0,
                                        "tagUrl": "",
                                        "isApproved": 0,
                                        "trackers": []
                                    }
                                ],
                                "isSynced": 0
                            }
                        ]
                    },
                    "syncedAttributes": {},
                    "synced": 0
                }
            ],
            "pacingTypeName": "Standard",
            "durationTypeName": "Daily",
            "biddingStrategy": "148",
            "biddingStrategyName": "Manual CPC",
            "checked": false,
            "pacingBudget": 5.56,
            "syncedAttributes": {},
            "totalBudget": 50.0,
            "synced": 0,
            "isReco": 0,
            "isEditable": true,
            "isYoutubeCampaign": false
        },
        {
            "mandateId": 765,
            "id": 1207,
            "name": "Google_Ads_Campaign_search1728474479995",
            "budget": 50.0,
            "pacingType": 29,
            "durationType": 23,
            "platformName": "ads",
            "platformId": 4,
            "mediaType": 2,
            "startDate": "2024-10-09 11:47:15",
            "endDate": "2024-10-17 18:29:59",
            "status": 3,
            "targeting": {
                "location": [],
                "audience": [],
                "language": [],
                "daypart": [],
                "device": [],
                "adRotation": 0
            },
            "strategies": [
                {
                    "name": "Google_Ads_Campaign_searchStrategy 1",
                    "id": 1238,
                    "campaignId": 1207,
                    "startDate": "2024-10-09 11:47:15",
                    "endDate": "2024-10-17 18:29:59",
                    "mediaType": 2,
                    "status": 3,
                    "pacingTypeName": "Standard",
                    "durationTypeName": "Daily",
                    "biddingStrategy": "1797",
                    "biddingStrategyName": "Manual CPC",
                    "bidCap": 2.0,
                    "platformId": 4,
                    "isLocationPresent": false,
                    "isAudiencePresent": false,
                    "isKeywordPresent": false,
                    "isDayPartPresent": false,
                    "isPositionPresent": false,
                    "isSitesPresent": false,
                    "targeting": {
                        "location": [],
                        "audience": [],
                        "language": [],
                        "daypart": [],
                        "device": [],
                        "age": [],
                        "position": [],
                        "keyword": [],
                        "sites": [],
                        "gender": []
                    },
                    "creative": {
                        "utm": "",
                        "campaignId": 1207,
                        "strategyId": 1238,
                        "creatives": [
                            {
                                "status": 1,
                                "creativeId": 976,
                                "campaignId": 1207,
                                "strategyId": 1238,
                                "heading": [
                                    "Save Big with Our Special Deals",
                                    "Unlock Exclusive Offers Today!",
                                    "Shop the Latest Trends Now"
                                ],
                                "description": [
                                    "Find exactly what you’re looking for at unbeatable prices. Fast shipping, great customer service, and more!",
                                    "Discover amazing discounts on top-rated products. Limited-time offers—shop now and save big!",
                                    "Don’t miss out! Shop now for exclusive deals on the latest products. Hurry, offer ends soon!"
                                ],
                                "landingUrl": "https://www.google.com"
                            }
                        ]
                    },
                    "syncedAttributes": {},
                    "synced": 0
                }
            ],
            "pacingTypeName": "Standard",
            "durationTypeName": "Daily",
            "biddingStrategy": "1797",
            "biddingStrategyName": "Manual CPC",
            "checked": false,
            "pacingBudget": 5.56,
            "syncedAttributes": {},
            "totalBudget": 50.0,
            "synced": 0,
            "isReco": 0,
            "isEditable": true,
            "isYoutubeCampaign": false
        }
    ],
    "length": 0,
    "responseObj": [
        {
            "id": 777,
            "platId": 4,
            "title": "Google Ads Creative",
            "isApproved": 0,
            "crType": 18,
            "description": "",
            "heading": "",
            "landingUrl": "https://www.google.com",
            "tags": [],
            "isRecActive": 1,
            "isActive": 1,
            "mediaList": [
                {
                    "id": 884,
                    "gcId": 777,
                    "adSize": "300X250",
                    "isRecActive": 1,
                    "isActive": 1,
                    "url": "https://stagecdn.torcai.com/image/1760/1728474840616_imgpsh_fullsize_anim_(1).jpeg",
                    "mimeType": "image/jpeg",
                    "bitrate": 0,
                    "duration": 0.0,
                    "tagUrl": "",
                    "isApproved": 0,
                    "trackers": []
                }
            ],
            "isSynced": 0
        }
    ]
}

// Reco Creative Edit Response
export const recoCreativeEditResponse = {
    "responseCode": {
        "msg": "Creatives Updated Successfully",
        "status": "Success",
        "code": 200
    },
    "length": 0,
    "responseObj": {
        "ads": [
            {
                "id": 0,
                "mandateId": 765,
                "campaignId": 1206,
                "strategyId": 1237,
                "globalCreativeId": [
                    777
                ],
                "creativeType": 18,
                "utm": "",
                "globalCreativeList": [
                    {
                        "id": 777,
                        "platId": 4,
                        "title": "Google Ads Creative",
                        "isApproved": 0,
                        "crType": 18,
                        "description": "Step into comfort and style with our latest shoe collection. From sleek sneakers to timeless classics, find the perfect fit for every occasion. Walk with confidence—your feet will thank you!",
                        "heading": "",
                        "landingUrl": "https://www.google.com",
                        "tags": [],
                        "isRecActive": 1,
                        "isActive": 1,
                        "mediaList": [
                            {
                                "id": 884,
                                "gcId": 777,
                                "adSize": "300X250",
                                "isRecActive": 1,
                                "isActive": 1,
                                "url": "https://stagecdn.torcai.com/image/1760/1728474840616_imgpsh_fullsize_anim_(1).jpeg",
                                "mimeType": "image/jpeg",
                                "bitrate": 0,
                                "duration": 0.0,
                                "tagUrl": "",
                                "isApproved": 0,
                                "trackers": []
                            }
                        ],
                        "mappedCampaigns": [
                            {
                                "key": 1206,
                                "value": "Google_Ads_Campaign_display1728474479992"
                            }
                        ],
                        "isSynced": 0
                    }
                ]
            },
            {
                "id": 1,
                "mandateId": 765,
                "campaignId": 1207,
                "strategyId": 1238,
                "creativeType": 17,
                "description": [
                    "Find exactly what you’re looking for at unbeatable prices. Fast shipping, great customer service, and more!",
                    "Discover amazing discounts on top-rated products. Limited-time offers—shop now and save big!",
                    "Don’t miss out! Shop now for exclusive deals on the latest products. Hurry, offer ends soon!"
                ],
                "heading": [
                    "Save Big with Our Special Deals",
                    "Unlock Exclusive Offers Today!",
                    "Shop the Latest Trends Now"
                ],
                "landingUrl": "https://www.google.com",
                "utm": "",
                "isactive": 1
            }
        ],
        "meta": [],
        "dv360": [],
        "ion": [],
        "tiktok": [],
        "viads": [],
        "ioh": []
    }
}

// Data Config
export const dataConfig = {
    "responseCode": {
        "msg": "Variable List Fetched Successfully",
        "status": "Success",
        "code": 4100
    },
    "response": [
        {
            "id": 1,
            "name": "Pacing_Type",
            "platformId": 1,
            "isActive": 1,
            "platformName": "Beki",
            "displayName": "Pacing Type",
            "description": "",
            "mappingDetails": [
                {
                    "id": 9,
                    "name": "Pacing_Type",
                    "platformId": 5,
                    "isActive": 1,
                    "platformName": "DV360",
                    "displayName": "Pacing Type"
                },
                {
                    "id": 10,
                    "name": "Pacing_Type",
                    "platformId": 4,
                    "isActive": 1,
                    "platformName": "Google Ads",
                    "displayName": "Pacing Type",
                    "description": ""
                },
                {
                    "id": 11,
                    "name": "Pacing_Type",
                    "platformId": 3,
                    "isActive": 1,
                    "platformName": "Meta",
                    "displayName": "Pacing Type"
                },
                {
                    "id": 12,
                    "name": "Pacing_Type",
                    "platformId": 2,
                    "isActive": 1,
                    "platformName": "ION",
                    "displayName": "Pacing Type"
                },
                {
                    "id": 103,
                    "name": "Pacing_Type",
                    "platformId": 7,
                    "isActive": 1,
                    "platformName": "TikTok",
                    "displayName": "",
                    "description": ""
                },
                {
                    "id": 87,
                    "name": "Pacing_Type",
                    "platformId": 8,
                    "isActive": 1,
                    "platformName": "ViAds",
                    "displayName": "",
                    "description": ""
                }
            ],
            "mappedPlatformsValueSet": [
                "Google Ads",
                "Meta",
                "ViAds",
                "ION",
                "TikTok",
                "DV360"
            ],
            "mappedPlatformsIdSet": [
                2,
                3,
                4,
                5,
                7,
                8
            ],
            "list": [
                {
                    "id": 1,
                    "name": "Even",
                    "platformId": 1,
                    "isActive": 1,
                    "platformName": "Beki",
                    "displayName": "Even",
                    "mappingDetails": [
                        {
                            "id": 27,
                            "name": "PACING_TYPE_EVEN",
                            "platformId": 5,
                            "isActive": 1,
                            "platformName": "DV360",
                            "displayName": "Even",
                            "dbMappingId": 10
                        },
                        {
                            "id": 29,
                            "name": "STANDARD",
                            "platformId": 4,
                            "isActive": 1,
                            "platformName": "Google Ads",
                            "displayName": "Standard",
                            "dbMappingId": 11
                        },
                        {
                            "id": 31,
                            "name": "standard",
                            "platformId": 3,
                            "isActive": 1,
                            "platformName": "Meta",
                            "displayName": "Standard",
                            "dbMappingId": 12
                        },
                        {
                            "id": 33,
                            "name": "EVEN",
                            "platformId": 2,
                            "isActive": 1,
                            "platformName": "ION",
                            "displayName": "Even",
                            "dbMappingId": 13
                        },
                        {
                            "id": 2997,
                            "name": "1",
                            "platformId": 8,
                            "isActive": 1,
                            "platformName": "ViAds",
                            "displayName": "Even",
                            "dbMappingId": 938
                        }
                    ]
                },
                {
                    "id": 3,
                    "name": "ASAP",
                    "platformId": 1,
                    "isActive": 1,
                    "platformName": "Beki",
                    "displayName": "Asap",
                    "mappingDetails": [
                        {
                            "id": 35,
                            "name": "ASAP",
                            "platformId": 2,
                            "isActive": 1,
                            "platformName": "ION",
                            "dbMappingId": 14
                        },
                        {
                            "id": 136,
                            "name": "PACING_TYPE_ASAP",
                            "platformId": 5,
                            "isActive": 1,
                            "platformName": "DV360",
                            "displayName": "ASAP",
                            "dbMappingId": 70
                        },
                        {
                            "id": 141,
                            "name": "no_pacing",
                            "platformId": 3,
                            "isActive": 1,
                            "platformName": "Meta",
                            "displayName": "Accelerated",
                            "dbMappingId": 540
                        },
                        {
                            "id": 2995,
                            "name": "0",
                            "platformId": 8,
                            "isActive": 1,
                            "platformName": "ViAds",
                            "displayName": "ASAP",
                            "dbMappingId": 937
                        }
                    ]
                }
            ]
        },
        {
            "id": 2,
            "name": "Duration_Type",
            "platformId": 1,
            "isActive": 1,
            "platformName": "Beki",
            "displayName": "Duration Type",
            "mappingDetails": [
                {
                    "id": 7,
                    "name": "Duration_Type",
                    "platformId": 4,
                    "isActive": 1,
                    "platformName": "Google Ads",
                    "displayName": "Duration Type",
                    "description": ""
                },
                {
                    "id": 8,
                    "name": "Duration_Type",
                    "platformId": 3,
                    "isActive": 1,
                    "platformName": "Meta",
                    "displayName": "Duration Type"
                },
                {
                    "id": 29,
                    "name": "Duration_Type",
                    "platformId": 5,
                    "isActive": 1,
                    "platformName": "DV360",
                    "displayName": "Duration Type"
                },
                {
                    "id": 85,
                    "name": "Duration_Type",
                    "platformId": 8,
                    "isActive": 1,
                    "platformName": "ViAds",
                    "displayName": "",
                    "description": ""
                }
            ],
            "mappedPlatformsValueSet": [
                "Google Ads",
                "Meta",
                "ViAds",
                "DV360"
            ],
            "mappedPlatformsIdSet": [
                3,
                4,
                5,
                8
            ],
            "list": [
                {
                    "id": 5,
                    "name": "Daily",
                    "platformId": 1,
                    "isActive": 1,
                    "platformName": "Beki",
                    "displayName": "Daily",
                    "mappingDetails": [
                        {
                            "id": 23,
                            "name": "DAILY",
                            "platformId": 4,
                            "isActive": 1,
                            "platformName": "Google Ads",
                            "displayName": "Daily",
                            "dbMappingId": 7
                        },
                        {
                            "id": 25,
                            "name": "daily",
                            "platformId": 3,
                            "isActive": 1,
                            "platformName": "Meta",
                            "displayName": "Daily",
                            "dbMappingId": 8
                        },
                        {
                            "id": 138,
                            "name": "PACING_PERIOD_DAILY",
                            "platformId": 5,
                            "isActive": 1,
                            "platformName": "DV360",
                            "displayName": "Daily",
                            "dbMappingId": 71
                        },
                        {
                            "id": 2985,
                            "name": "1",
                            "platformId": 8,
                            "isActive": 1,
                            "platformName": "ViAds",
                            "displayName": "Daily",
                            "dbMappingId": 933
                        }
                    ]
                },
                {
                    "id": 7,
                    "name": "Lifetime",
                    "platformId": 1,
                    "isActive": 1,
                    "platformName": "Beki",
                    "displayName": "Lifetime",
                    "mappingDetails": [
                        {
                            "id": 26,
                            "name": "lifetime",
                            "platformId": 3,
                            "isActive": 1,
                            "platformName": "Meta",
                            "displayName": "Lifetime",
                            "dbMappingId": 9
                        },
                        {
                            "id": 140,
                            "name": "PACING_PERIOD_FLIGHT",
                            "platformId": 5,
                            "isActive": 1,
                            "platformName": "DV360",
                            "displayName": "Lifetime",
                            "dbMappingId": 561
                        },
                        {
                            "id": 4036,
                            "name": "LIFETIME",
                            "platformId": 4,
                            "isActive": 1,
                            "platformName": "Google Ads",
                            "displayName": "LifeTime",
                            "dbMappingId": 1130
                        }
                    ]
                },
                {
                    "id": 9,
                    "name": "Hourly",
                    "platformId": 1,
                    "isActive": 1,
                    "platformName": "Beki",
                    "displayName": "Hourly",
                    "mappingDetails": [
                        {
                            "id": 2987,
                            "name": "0",
                            "platformId": 8,
                            "isActive": 1,
                            "platformName": "ViAds",
                            "displayName": "Hourly",
                            "dbMappingId": 934
                        }
                    ]
                }
            ]
        },
        {
            "id": 3,
            "name": "Media_Type",
            "platformId": 1,
            "isActive": 1,
            "platformName": "Beki",
            "displayName": "Media Type",
            "mappingDetails": [
                {
                    "id": 4,
                    "name": "Media_Type",
                    "platformId": 4,
                    "isActive": 1,
                    "platformName": "Google Ads",
                    "displayName": "Media Type",
                    "description": ""
                },
                {
                    "id": 5,
                    "name": "Media_Type",
                    "platformId": 3,
                    "isActive": 1,
                    "platformName": "Meta",
                    "displayName": "Media Type"
                },
                {
                    "id": 6,
                    "name": "Media_Type",
                    "platformId": 5,
                    "isActive": 1,
                    "platformName": "DV360",
                    "displayName": "Media Type",
                    "description": ""
                },
                {
                    "id": 84,
                    "name": "Media_Type",
                    "platformId": 8,
                    "isActive": 1,
                    "platformName": "ViAds",
                    "displayName": "",
                    "description": ""
                }
            ],
            "mappedPlatformsValueSet": [
                "Google Ads",
                "Meta",
                "ViAds",
                "DV360"
            ],
            "mappedPlatformsIdSet": [
                3,
                4,
                5,
                8
            ],
            "list": [
                {
                    "id": 11,
                    "name": "Search",
                    "platformId": 1,
                    "isActive": 1,
                    "platformName": "Beki",
                    "mappingDetails": [
                        {
                            "id": 17,
                            "name": "Search",
                            "platformId": 4,
                            "isActive": 1,
                            "platformName": "Google Ads",
                            "dbMappingId": 1
                        }
                    ]
                },
                {
                    "id": 13,
                    "name": "Display",
                    "platformId": 1,
                    "isActive": 1,
                    "platformName": "Beki",
                    "mappingDetails": [
                        {
                            "id": 18,
                            "name": "Display",
                            "platformId": 4,
                            "isActive": 1,
                            "platformName": "Google Ads",
                            "dbMappingId": 2
                        },
                        {
                            "id": 19,
                            "name": "Display",
                            "platformId": 3,
                            "isActive": 1,
                            "platformName": "Meta",
                            "displayName": "Display",
                            "dbMappingId": 3
                        },
                        {
                            "id": 21,
                            "name": "Display",
                            "platformId": 5,
                            "isActive": 1,
                            "platformName": "DV360",
                            "dbMappingId": 5
                        },
                        {
                            "id": 2981,
                            "name": "7",
                            "platformId": 8,
                            "isActive": 1,
                            "platformName": "ViAds",
                            "displayName": "Display",
                            "dbMappingId": 931
                        }
                    ]
                },
                {
                    "id": 15,
                    "name": "Video",
                    "platformId": 1,
                    "isActive": 1,
                    "platformName": "Beki",
                    "mappingDetails": [
                        {
                            "id": 20,
                            "name": "Video",
                            "platformId": 3,
                            "isActive": 1,
                            "platformName": "Meta",
                            "displayName": "Video",
                            "dbMappingId": 4
                        },
                        {
                            "id": 22,
                            "name": "Video",
                            "platformId": 5,
                            "isActive": 1,
                            "platformName": "DV360",
                            "dbMappingId": 6
                        },
                        {
                            "id": 2983,
                            "name": "9",
                            "platformId": 8,
                            "isActive": 1,
                            "platformName": "ViAds",
                            "displayName": "Video",
                            "dbMappingId": 932
                        },
                        {
                            "id": 4040,
                            "name": "DEMAND_GEN",
                            "platformId": 4,
                            "isActive": 1,
                            "platformName": "Google Ads",
                            "displayName": "Video",
                            "dbMappingId": 1131
                        }
                    ]
                }
            ]
        },
        {
            "id": 4,
            "name": "Media_Type",
            "platformId": 4,
            "isActive": 1,
            "platformName": "Google Ads",
            "displayName": "Media Type",
            "description": "",
            "attributeMapping": 3,
            "mappingDetails": [
                {
                    "id": 3,
                    "name": "Media_Type",
                    "platformId": 1,
                    "isActive": 1,
                    "platformName": "Beki",
                    "displayName": "Media Type"
                }
            ],
            "mappedPlatformsValueSet": [],
            "mappedPlatformsIdSet": [],
            "list": [
                {
                    "id": 17,
                    "name": "Search",
                    "platformId": 4,
                    "isActive": 1,
                    "platformName": "Google Ads",
                    "attributeMapping": 11,
                    "mappingDetails": [
                        {
                            "id": 11,
                            "name": "Search",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "dbMappingId": 1
                        }
                    ]
                },
                {
                    "id": 18,
                    "name": "Display",
                    "platformId": 4,
                    "isActive": 1,
                    "platformName": "Google Ads",
                    "attributeMapping": 13,
                    "mappingDetails": [
                        {
                            "id": 13,
                            "name": "Display",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "dbMappingId": 2
                        }
                    ]
                },
                {
                    "id": 4040,
                    "name": "DEMAND_GEN",
                    "platformId": 4,
                    "isActive": 1,
                    "platformName": "Google Ads",
                    "displayName": "Video",
                    "attributeMapping": 15,
                    "mappingDetails": [
                        {
                            "id": 15,
                            "name": "Video",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "dbMappingId": 1131
                        }
                    ]
                }
            ]
        },
        {
            "id": 5,
            "name": "Media_Type",
            "platformId": 3,
            "isActive": 1,
            "platformName": "Meta",
            "displayName": "Media Type",
            "attributeMapping": 3,
            "mappingDetails": [
                {
                    "id": 3,
                    "name": "Media_Type",
                    "platformId": 1,
                    "isActive": 1,
                    "platformName": "Beki",
                    "displayName": "Media Type"
                }
            ],
            "mappedPlatformsValueSet": [],
            "mappedPlatformsIdSet": [],
            "list": [
                {
                    "id": 19,
                    "name": "Display",
                    "platformId": 3,
                    "isActive": 1,
                    "platformName": "Meta",
                    "displayName": "Display",
                    "attributeMapping": 13,
                    "mappingDetails": [
                        {
                            "id": 13,
                            "name": "Display",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "dbMappingId": 3
                        }
                    ]
                },
                {
                    "id": 20,
                    "name": "Video",
                    "platformId": 3,
                    "isActive": 1,
                    "platformName": "Meta",
                    "displayName": "Video",
                    "attributeMapping": 15,
                    "mappingDetails": [
                        {
                            "id": 15,
                            "name": "Video",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "dbMappingId": 4
                        }
                    ]
                }
            ]
        },
        {
            "id": 6,
            "name": "Media_Type",
            "platformId": 5,
            "isActive": 1,
            "platformName": "DV360",
            "displayName": "Media Type",
            "description": "",
            "attributeMapping": 3,
            "mappingDetails": [
                {
                    "id": 3,
                    "name": "Media_Type",
                    "platformId": 1,
                    "isActive": 1,
                    "platformName": "Beki",
                    "displayName": "Media Type"
                }
            ],
            "mappedPlatformsValueSet": [],
            "mappedPlatformsIdSet": [],
            "list": [
                {
                    "id": 21,
                    "name": "Display",
                    "platformId": 5,
                    "isActive": 1,
                    "platformName": "DV360",
                    "attributeMapping": 13,
                    "mappingDetails": [
                        {
                            "id": 13,
                            "name": "Display",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "dbMappingId": 5
                        }
                    ]
                },
                {
                    "id": 22,
                    "name": "Video",
                    "platformId": 5,
                    "isActive": 1,
                    "platformName": "DV360",
                    "attributeMapping": 15,
                    "mappingDetails": [
                        {
                            "id": 15,
                            "name": "Video",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "dbMappingId": 6
                        }
                    ]
                },
                {
                    "id": 4035,
                    "name": "youtube",
                    "platformId": 5,
                    "isActive": 1,
                    "platformName": "DV360",
                    "displayName": "youtube",
                    "mappingDetails": []
                }
            ]
        },
        {
            "id": 7,
            "name": "Duration_Type",
            "platformId": 4,
            "isActive": 1,
            "platformName": "Google Ads",
            "displayName": "Duration Type",
            "description": "",
            "attributeMapping": 2,
            "mappingDetails": [
                {
                    "id": 2,
                    "name": "Duration_Type",
                    "platformId": 1,
                    "isActive": 1,
                    "platformName": "Beki",
                    "displayName": "Duration Type"
                }
            ],
            "mappedPlatformsValueSet": [],
            "mappedPlatformsIdSet": [],
            "list": [
                {
                    "id": 23,
                    "name": "DAILY",
                    "platformId": 4,
                    "isActive": 1,
                    "platformName": "Google Ads",
                    "displayName": "Daily",
                    "attributeMapping": 5,
                    "mappingDetails": [
                        {
                            "id": 5,
                            "name": "Daily",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Daily",
                            "dbMappingId": 7
                        }
                    ]
                },
                {
                    "id": 4036,
                    "name": "LIFETIME",
                    "platformId": 4,
                    "isActive": 1,
                    "platformName": "Google Ads",
                    "displayName": "LifeTime",
                    "attributeMapping": 7,
                    "mappingDetails": [
                        {
                            "id": 7,
                            "name": "Lifetime",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Lifetime",
                            "dbMappingId": 1130
                        }
                    ]
                }
            ]
        },
        {
            "id": 8,
            "name": "Duration_Type",
            "platformId": 3,
            "isActive": 1,
            "platformName": "Meta",
            "displayName": "Duration Type",
            "attributeMapping": 2,
            "mappingDetails": [
                {
                    "id": 2,
                    "name": "Duration_Type",
                    "platformId": 1,
                    "isActive": 1,
                    "platformName": "Beki",
                    "displayName": "Duration Type"
                }
            ],
            "mappedPlatformsValueSet": [],
            "mappedPlatformsIdSet": [],
            "list": [
                {
                    "id": 25,
                    "name": "daily",
                    "platformId": 3,
                    "isActive": 1,
                    "platformName": "Meta",
                    "displayName": "Daily",
                    "attributeMapping": 5,
                    "mappingDetails": [
                        {
                            "id": 5,
                            "name": "Daily",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Daily",
                            "dbMappingId": 8
                        }
                    ]
                },
                {
                    "id": 26,
                    "name": "lifetime",
                    "platformId": 3,
                    "isActive": 1,
                    "platformName": "Meta",
                    "displayName": "Lifetime",
                    "attributeMapping": 7,
                    "mappingDetails": [
                        {
                            "id": 7,
                            "name": "Lifetime",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Lifetime",
                            "dbMappingId": 9
                        }
                    ]
                }
            ]
        },
        {
            "id": 9,
            "name": "Pacing_Type",
            "platformId": 5,
            "isActive": 1,
            "platformName": "DV360",
            "displayName": "Pacing Type",
            "attributeMapping": 1,
            "mappingDetails": [
                {
                    "id": 1,
                    "name": "Pacing_Type",
                    "platformId": 1,
                    "isActive": 1,
                    "platformName": "Beki",
                    "displayName": "Pacing Type",
                    "description": ""
                }
            ],
            "mappedPlatformsValueSet": [],
            "mappedPlatformsIdSet": [],
            "list": [
                {
                    "id": 27,
                    "name": "PACING_TYPE_EVEN",
                    "platformId": 5,
                    "isActive": 1,
                    "platformName": "DV360",
                    "displayName": "Even",
                    "attributeMapping": 1,
                    "mappingDetails": [
                        {
                            "id": 1,
                            "name": "Even",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Even",
                            "dbMappingId": 10
                        }
                    ]
                },
                {
                    "id": 136,
                    "name": "PACING_TYPE_ASAP",
                    "platformId": 5,
                    "isActive": 1,
                    "platformName": "DV360",
                    "displayName": "ASAP",
                    "attributeMapping": 3,
                    "mappingDetails": [
                        {
                            "id": 3,
                            "name": "ASAP",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Asap",
                            "dbMappingId": 70
                        }
                    ]
                }
            ]
        },
        {
            "id": 10,
            "name": "Pacing_Type",
            "platformId": 4,
            "isActive": 1,
            "platformName": "Google Ads",
            "displayName": "Pacing Type",
            "description": "",
            "attributeMapping": 1,
            "mappingDetails": [
                {
                    "id": 1,
                    "name": "Pacing_Type",
                    "platformId": 1,
                    "isActive": 1,
                    "platformName": "Beki",
                    "displayName": "Pacing Type",
                    "description": ""
                }
            ],
            "mappedPlatformsValueSet": [],
            "mappedPlatformsIdSet": [],
            "list": [
                {
                    "id": 29,
                    "name": "STANDARD",
                    "platformId": 4,
                    "isActive": 1,
                    "platformName": "Google Ads",
                    "displayName": "Standard",
                    "attributeMapping": 1,
                    "mappingDetails": [
                        {
                            "id": 1,
                            "name": "Even",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Even",
                            "dbMappingId": 11
                        }
                    ]
                }
            ]
        },
        {
            "id": 11,
            "name": "Pacing_Type",
            "platformId": 3,
            "isActive": 1,
            "platformName": "Meta",
            "displayName": "Pacing Type",
            "attributeMapping": 1,
            "mappingDetails": [
                {
                    "id": 1,
                    "name": "Pacing_Type",
                    "platformId": 1,
                    "isActive": 1,
                    "platformName": "Beki",
                    "displayName": "Pacing Type",
                    "description": ""
                }
            ],
            "mappedPlatformsValueSet": [],
            "mappedPlatformsIdSet": [],
            "list": [
                {
                    "id": 31,
                    "name": "standard",
                    "platformId": 3,
                    "isActive": 1,
                    "platformName": "Meta",
                    "displayName": "Standard",
                    "attributeMapping": 1,
                    "mappingDetails": [
                        {
                            "id": 1,
                            "name": "Even",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Even",
                            "dbMappingId": 12
                        }
                    ]
                },
                {
                    "id": 141,
                    "name": "no_pacing",
                    "platformId": 3,
                    "isActive": 1,
                    "platformName": "Meta",
                    "displayName": "Accelerated",
                    "attributeMapping": 3,
                    "mappingDetails": [
                        {
                            "id": 3,
                            "name": "ASAP",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Asap",
                            "dbMappingId": 540
                        }
                    ]
                }
            ]
        },
        {
            "id": 12,
            "name": "Pacing_Type",
            "platformId": 2,
            "isActive": 1,
            "platformName": "ION",
            "displayName": "Pacing Type",
            "attributeMapping": 1,
            "mappingDetails": [
                {
                    "id": 1,
                    "name": "Pacing_Type",
                    "platformId": 1,
                    "isActive": 1,
                    "platformName": "Beki",
                    "displayName": "Pacing Type",
                    "description": ""
                }
            ],
            "mappedPlatformsValueSet": [],
            "mappedPlatformsIdSet": [],
            "list": [
                {
                    "id": 33,
                    "name": "EVEN",
                    "platformId": 2,
                    "isActive": 1,
                    "platformName": "ION",
                    "displayName": "Even",
                    "attributeMapping": 1,
                    "mappingDetails": [
                        {
                            "id": 1,
                            "name": "Even",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Even",
                            "dbMappingId": 13
                        }
                    ]
                },
                {
                    "id": 35,
                    "name": "ASAP",
                    "platformId": 2,
                    "isActive": 1,
                    "platformName": "ION",
                    "attributeMapping": 3,
                    "mappingDetails": [
                        {
                            "id": 3,
                            "name": "ASAP",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Asap",
                            "dbMappingId": 14
                        }
                    ]
                }
            ]
        },
        {
            "id": 13,
            "name": "Bidding_Strategy",
            "platformId": 1,
            "isActive": 1,
            "platformName": "Beki",
            "displayName": "Bidding Strategy",
            "mappingDetails": [
                {
                    "id": 96,
                    "name": "Bidding_Strategy",
                    "platformId": 8,
                    "isActive": 1,
                    "platformName": "ViAds",
                    "displayName": "",
                    "description": ""
                }
            ],
            "mappedPlatformsValueSet": [
                "ViAds"
            ],
            "mappedPlatformsIdSet": [
                8
            ],
            "list": [
                {
                    "id": 36,
                    "name": "CPM",
                    "platformId": 1,
                    "isActive": 1,
                    "platformName": "Beki",
                    "displayName": "CPM",
                    "mappingDetails": [
                        {
                            "id": 3059,
                            "name": "89",
                            "platformId": 8,
                            "isActive": 1,
                            "platformName": "ViAds",
                            "displayName": "CPM",
                            "dbMappingId": 944
                        }
                    ]
                },
                {
                    "id": 1763,
                    "name": "Manual CPC",
                    "platformId": 1,
                    "isActive": 1,
                    "platformName": "Beki",
                    "displayName": "Manual CPC",
                    "mappingDetails": [
                        {
                            "id": 3057,
                            "name": "90",
                            "platformId": 8,
                            "isActive": 1,
                            "platformName": "ViAds",
                            "displayName": "CPC",
                            "dbMappingId": 943
                        }
                    ]
                },
                {
                    "id": 1765,
                    "name": "Maximize Click",
                    "platformId": 1,
                    "isActive": 1,
                    "platformName": "Beki",
                    "displayName": "Maximize Click",
                    "mappingDetails": []
                }
            ]
        },
        {
            "id": 15,
            "name": "Bidding_Strategy",
            "platformId": 2,
            "isActive": 1,
            "platformName": "ION",
            "displayName": "Bidding Strategy",
            "mappingDetails": [],
            "mappedPlatformsValueSet": [],
            "mappedPlatformsIdSet": [],
            "list": [
                {
                    "id": 38,
                    "name": "CPM",
                    "platformId": 2,
                    "isActive": 1,
                    "platformName": "ION",
                    "mappingDetails": []
                }
            ]
        },
        {
            "id": 17,
            "name": "Device_Type",
            "platformId": 1,
            "isActive": 1,
            "platformName": "Beki",
            "displayName": "Device Type",
            "description": "",
            "mappingDetails": [
                {
                    "id": 18,
                    "name": "Device_Type",
                    "platformId": 4,
                    "isActive": 1,
                    "platformName": "Google Ads",
                    "displayName": "Device Type"
                },
                {
                    "id": 19,
                    "name": "Device_Type",
                    "platformId": 5,
                    "isActive": 1,
                    "platformName": "DV360",
                    "displayName": "Device Type"
                },
                {
                    "id": 20,
                    "name": "Device_Type",
                    "platformId": 3,
                    "isActive": 1,
                    "platformName": "Meta",
                    "displayName": "Device Type"
                },
                {
                    "id": 86,
                    "name": "Device_Type",
                    "platformId": 8,
                    "isActive": 1,
                    "platformName": "ViAds",
                    "displayName": "",
                    "description": ""
                }
            ],
            "mappedPlatformsValueSet": [
                "Google Ads",
                "Meta",
                "ViAds",
                "DV360"
            ],
            "mappedPlatformsIdSet": [
                3,
                4,
                5,
                8
            ],
            "list": [
                {
                    "id": 41,
                    "name": "Mobile",
                    "platformId": 1,
                    "isActive": 1,
                    "platformName": "Beki",
                    "displayName": "Mobile",
                    "mappingDetails": [
                        {
                            "id": 44,
                            "name": "MOBILE",
                            "platformId": 4,
                            "isActive": 1,
                            "platformName": "Google Ads",
                            "displayName": "Mobile",
                            "dbMappingId": 18
                        },
                        {
                            "id": 54,
                            "name": "DEVICE_TYPE_SMART_PHONE",
                            "platformId": 5,
                            "isActive": 1,
                            "platformName": "DV360",
                            "displayName": "Mobile",
                            "dbMappingId": 23
                        },
                        {
                            "id": 56,
                            "name": "mobile",
                            "platformId": 3,
                            "isActive": 1,
                            "platformName": "Meta",
                            "displayName": "Moblie",
                            "dbMappingId": 24
                        },
                        {
                            "id": 2989,
                            "name": "85",
                            "platformId": 8,
                            "isActive": 1,
                            "platformName": "ViAds",
                            "displayName": "Mobile",
                            "dbMappingId": 935
                        }
                    ]
                },
                {
                    "id": 42,
                    "name": "Desktop",
                    "platformId": 1,
                    "isActive": 1,
                    "platformName": "Beki",
                    "mappingDetails": [
                        {
                            "id": 46,
                            "name": "DESKTOP",
                            "platformId": 4,
                            "isActive": 1,
                            "platformName": "Google Ads",
                            "displayName": "Desktop",
                            "dbMappingId": 19
                        },
                        {
                            "id": 52,
                            "name": "DEVICE_TYPE_COMPUTER",
                            "platformId": 5,
                            "isActive": 1,
                            "platformName": "DV360",
                            "displayName": "Desktop",
                            "dbMappingId": 22
                        },
                        {
                            "id": 58,
                            "name": "desktop",
                            "platformId": 3,
                            "isActive": 1,
                            "platformName": "Meta",
                            "displayName": "Desktop",
                            "dbMappingId": 25
                        },
                        {
                            "id": 2991,
                            "name": "84",
                            "platformId": 8,
                            "isActive": 1,
                            "platformName": "ViAds",
                            "displayName": "Desktop",
                            "dbMappingId": 936
                        }
                    ]
                },
                {
                    "id": 43,
                    "name": "Tablet",
                    "platformId": 1,
                    "isActive": 1,
                    "platformName": "Beki",
                    "mappingDetails": [
                        {
                            "id": 48,
                            "name": "TABLET",
                            "platformId": 4,
                            "isActive": 1,
                            "platformName": "Google Ads",
                            "displayName": "Tablet",
                            "dbMappingId": 20
                        },
                        {
                            "id": 50,
                            "name": "DEVICE_TYPE_TABLET",
                            "platformId": 5,
                            "isActive": 1,
                            "platformName": "DV360",
                            "displayName": "Tablet",
                            "dbMappingId": 21
                        }
                    ]
                }
            ]
        },
        {
            "id": 18,
            "name": "Device_Type",
            "platformId": 4,
            "isActive": 1,
            "platformName": "Google Ads",
            "displayName": "Device Type",
            "attributeMapping": 17,
            "mappingDetails": [
                {
                    "id": 17,
                    "name": "Device_Type",
                    "platformId": 1,
                    "isActive": 1,
                    "platformName": "Beki",
                    "displayName": "Device Type",
                    "description": ""
                }
            ],
            "mappedPlatformsValueSet": [],
            "mappedPlatformsIdSet": [],
            "list": [
                {
                    "id": 44,
                    "name": "MOBILE",
                    "platformId": 4,
                    "isActive": 1,
                    "platformName": "Google Ads",
                    "displayName": "Mobile",
                    "attributeMapping": 41,
                    "mappingDetails": [
                        {
                            "id": 41,
                            "name": "Mobile",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Mobile",
                            "dbMappingId": 18
                        }
                    ]
                },
                {
                    "id": 46,
                    "name": "DESKTOP",
                    "platformId": 4,
                    "isActive": 1,
                    "platformName": "Google Ads",
                    "displayName": "Desktop",
                    "attributeMapping": 42,
                    "mappingDetails": [
                        {
                            "id": 42,
                            "name": "Desktop",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "dbMappingId": 19
                        }
                    ]
                },
                {
                    "id": 48,
                    "name": "TABLET",
                    "platformId": 4,
                    "isActive": 1,
                    "platformName": "Google Ads",
                    "displayName": "Tablet",
                    "attributeMapping": 43,
                    "mappingDetails": [
                        {
                            "id": 43,
                            "name": "Tablet",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "dbMappingId": 20
                        }
                    ]
                }
            ]
        },
        {
            "id": 19,
            "name": "Device_Type",
            "platformId": 5,
            "isActive": 1,
            "platformName": "DV360",
            "displayName": "Device Type",
            "attributeMapping": 17,
            "mappingDetails": [
                {
                    "id": 17,
                    "name": "Device_Type",
                    "platformId": 1,
                    "isActive": 1,
                    "platformName": "Beki",
                    "displayName": "Device Type",
                    "description": ""
                }
            ],
            "mappedPlatformsValueSet": [],
            "mappedPlatformsIdSet": [],
            "list": [
                {
                    "id": 50,
                    "name": "DEVICE_TYPE_TABLET",
                    "platformId": 5,
                    "isActive": 1,
                    "platformName": "DV360",
                    "displayName": "Tablet",
                    "attributeMapping": 43,
                    "mappingDetails": [
                        {
                            "id": 43,
                            "name": "Tablet",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "dbMappingId": 21
                        }
                    ]
                },
                {
                    "id": 52,
                    "name": "DEVICE_TYPE_COMPUTER",
                    "platformId": 5,
                    "isActive": 1,
                    "platformName": "DV360",
                    "displayName": "Desktop",
                    "attributeMapping": 42,
                    "mappingDetails": [
                        {
                            "id": 42,
                            "name": "Desktop",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "dbMappingId": 22
                        }
                    ]
                },
                {
                    "id": 54,
                    "name": "DEVICE_TYPE_SMART_PHONE",
                    "platformId": 5,
                    "isActive": 1,
                    "platformName": "DV360",
                    "displayName": "Mobile",
                    "attributeMapping": 41,
                    "mappingDetails": [
                        {
                            "id": 41,
                            "name": "Mobile",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Mobile",
                            "dbMappingId": 23
                        }
                    ]
                },
                {
                    "id": 60,
                    "name": "DEVICE_TYPE_CONNECTED_TV",
                    "platformId": 5,
                    "isActive": 1,
                    "platformName": "DV360",
                    "displayName": "TV",
                    "mappingDetails": []
                }
            ]
        },
        {
            "id": 20,
            "name": "Device_Type",
            "platformId": 3,
            "isActive": 1,
            "platformName": "Meta",
            "displayName": "Device Type",
            "attributeMapping": 17,
            "mappingDetails": [
                {
                    "id": 17,
                    "name": "Device_Type",
                    "platformId": 1,
                    "isActive": 1,
                    "platformName": "Beki",
                    "displayName": "Device Type",
                    "description": ""
                }
            ],
            "mappedPlatformsValueSet": [],
            "mappedPlatformsIdSet": [],
            "list": [
                {
                    "id": 56,
                    "name": "mobile",
                    "platformId": 3,
                    "isActive": 1,
                    "platformName": "Meta",
                    "displayName": "Moblie",
                    "attributeMapping": 41,
                    "mappingDetails": [
                        {
                            "id": 41,
                            "name": "Mobile",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Mobile",
                            "dbMappingId": 24
                        }
                    ]
                },
                {
                    "id": 58,
                    "name": "desktop",
                    "platformId": 3,
                    "isActive": 1,
                    "platformName": "Meta",
                    "displayName": "Desktop",
                    "attributeMapping": 42,
                    "mappingDetails": [
                        {
                            "id": 42,
                            "name": "Desktop",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "dbMappingId": 25
                        }
                    ]
                }
            ]
        },
        {
            "id": 21,
            "name": "Gender_Type",
            "platformId": 1,
            "isActive": 1,
            "platformName": "Beki",
            "displayName": "Gender Type",
            "mappingDetails": [
                {
                    "id": 22,
                    "name": "Gender_Type",
                    "platformId": 4,
                    "isActive": 1,
                    "platformName": "Google Ads",
                    "displayName": "Gender Type"
                },
                {
                    "id": 23,
                    "name": "Gender_Type",
                    "platformId": 3,
                    "isActive": 1,
                    "platformName": "Meta",
                    "displayName": "Gender Type"
                },
                {
                    "id": 24,
                    "name": "Gender_Type",
                    "platformId": 5,
                    "isActive": 1,
                    "platformName": "DV360",
                    "displayName": "Gender Type"
                }
            ],
            "mappedPlatformsValueSet": [
                "Google Ads",
                "Meta",
                "DV360"
            ],
            "mappedPlatformsIdSet": [
                3,
                4,
                5
            ],
            "list": [
                {
                    "id": 62,
                    "name": "Male",
                    "platformId": 1,
                    "isActive": 1,
                    "platformName": "Beki",
                    "mappingDetails": [
                        {
                            "id": 65,
                            "name": "MALE",
                            "platformId": 4,
                            "isActive": 1,
                            "platformName": "Google Ads",
                            "displayName": "Male",
                            "dbMappingId": 26
                        },
                        {
                            "id": 71,
                            "name": "1",
                            "platformId": 3,
                            "isActive": 1,
                            "platformName": "Meta",
                            "displayName": "Male",
                            "dbMappingId": 29
                        },
                        {
                            "id": 75,
                            "name": "GENDER_MALE",
                            "platformId": 5,
                            "isActive": 1,
                            "platformName": "DV360",
                            "displayName": "Male",
                            "dbMappingId": 32
                        }
                    ]
                },
                {
                    "id": 63,
                    "name": "Female",
                    "platformId": 1,
                    "isActive": 1,
                    "platformName": "Beki",
                    "mappingDetails": [
                        {
                            "id": 67,
                            "name": "FEMALE",
                            "platformId": 4,
                            "isActive": 1,
                            "platformName": "Google Ads",
                            "displayName": "Female",
                            "dbMappingId": 27
                        },
                        {
                            "id": 72,
                            "name": "2",
                            "platformId": 3,
                            "isActive": 1,
                            "platformName": "Meta",
                            "displayName": "Female",
                            "dbMappingId": 30
                        },
                        {
                            "id": 77,
                            "name": "GENDER_FEMALE",
                            "platformId": 5,
                            "isActive": 1,
                            "platformName": "DV360",
                            "displayName": "Female",
                            "dbMappingId": 33
                        }
                    ]
                },
                {
                    "id": 64,
                    "name": "All",
                    "platformId": 1,
                    "isActive": 1,
                    "platformName": "Beki",
                    "mappingDetails": [
                        {
                            "id": 69,
                            "name": "ALL",
                            "platformId": 4,
                            "isActive": 1,
                            "platformName": "Google Ads",
                            "displayName": "All",
                            "dbMappingId": 28
                        },
                        {
                            "id": 73,
                            "name": "All",
                            "platformId": 3,
                            "isActive": 1,
                            "platformName": "Meta",
                            "displayName": "All",
                            "dbMappingId": 31
                        },
                        {
                            "id": 79,
                            "name": "ALL",
                            "platformId": 5,
                            "isActive": 1,
                            "platformName": "DV360",
                            "displayName": "All",
                            "dbMappingId": 34
                        }
                    ]
                }
            ]
        },
        {
            "id": 22,
            "name": "Gender_Type",
            "platformId": 4,
            "isActive": 1,
            "platformName": "Google Ads",
            "displayName": "Gender Type",
            "attributeMapping": 21,
            "mappingDetails": [
                {
                    "id": 21,
                    "name": "Gender_Type",
                    "platformId": 1,
                    "isActive": 1,
                    "platformName": "Beki",
                    "displayName": "Gender Type"
                }
            ],
            "mappedPlatformsValueSet": [],
            "mappedPlatformsIdSet": [],
            "list": [
                {
                    "id": 65,
                    "name": "MALE",
                    "platformId": 4,
                    "isActive": 1,
                    "platformName": "Google Ads",
                    "displayName": "Male",
                    "attributeMapping": 62,
                    "mappingDetails": [
                        {
                            "id": 62,
                            "name": "Male",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "dbMappingId": 26
                        }
                    ]
                },
                {
                    "id": 67,
                    "name": "FEMALE",
                    "platformId": 4,
                    "isActive": 1,
                    "platformName": "Google Ads",
                    "displayName": "Female",
                    "attributeMapping": 63,
                    "mappingDetails": [
                        {
                            "id": 63,
                            "name": "Female",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "dbMappingId": 27
                        }
                    ]
                },
                {
                    "id": 69,
                    "name": "ALL",
                    "platformId": 4,
                    "isActive": 1,
                    "platformName": "Google Ads",
                    "displayName": "All",
                    "attributeMapping": 64,
                    "mappingDetails": [
                        {
                            "id": 64,
                            "name": "All",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "dbMappingId": 28
                        }
                    ]
                }
            ]
        },
        {
            "id": 23,
            "name": "Gender_Type",
            "platformId": 3,
            "isActive": 1,
            "platformName": "Meta",
            "displayName": "Gender Type",
            "attributeMapping": 21,
            "mappingDetails": [
                {
                    "id": 21,
                    "name": "Gender_Type",
                    "platformId": 1,
                    "isActive": 1,
                    "platformName": "Beki",
                    "displayName": "Gender Type"
                }
            ],
            "mappedPlatformsValueSet": [],
            "mappedPlatformsIdSet": [],
            "list": [
                {
                    "id": 71,
                    "name": "1",
                    "platformId": 3,
                    "isActive": 1,
                    "platformName": "Meta",
                    "displayName": "Male",
                    "attributeMapping": 62,
                    "mappingDetails": [
                        {
                            "id": 62,
                            "name": "Male",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "dbMappingId": 29
                        }
                    ]
                },
                {
                    "id": 72,
                    "name": "2",
                    "platformId": 3,
                    "isActive": 1,
                    "platformName": "Meta",
                    "displayName": "Female",
                    "attributeMapping": 63,
                    "mappingDetails": [
                        {
                            "id": 63,
                            "name": "Female",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "dbMappingId": 30
                        }
                    ]
                },
                {
                    "id": 73,
                    "name": "All",
                    "platformId": 3,
                    "isActive": 1,
                    "platformName": "Meta",
                    "displayName": "All",
                    "attributeMapping": 64,
                    "mappingDetails": [
                        {
                            "id": 64,
                            "name": "All",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "dbMappingId": 31
                        }
                    ]
                }
            ]
        },
        {
            "id": 24,
            "name": "Gender_Type",
            "platformId": 5,
            "isActive": 1,
            "platformName": "DV360",
            "displayName": "Gender Type",
            "attributeMapping": 21,
            "mappingDetails": [
                {
                    "id": 21,
                    "name": "Gender_Type",
                    "platformId": 1,
                    "isActive": 1,
                    "platformName": "Beki",
                    "displayName": "Gender Type"
                }
            ],
            "mappedPlatformsValueSet": [],
            "mappedPlatformsIdSet": [],
            "list": [
                {
                    "id": 75,
                    "name": "GENDER_MALE",
                    "platformId": 5,
                    "isActive": 1,
                    "platformName": "DV360",
                    "displayName": "Male",
                    "attributeMapping": 62,
                    "mappingDetails": [
                        {
                            "id": 62,
                            "name": "Male",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "dbMappingId": 32
                        }
                    ]
                },
                {
                    "id": 77,
                    "name": "GENDER_FEMALE",
                    "platformId": 5,
                    "isActive": 1,
                    "platformName": "DV360",
                    "displayName": "Female",
                    "attributeMapping": 63,
                    "mappingDetails": [
                        {
                            "id": 63,
                            "name": "Female",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "dbMappingId": 33
                        }
                    ]
                },
                {
                    "id": 79,
                    "name": "ALL",
                    "platformId": 5,
                    "isActive": 1,
                    "platformName": "DV360",
                    "displayName": "All",
                    "attributeMapping": 64,
                    "mappingDetails": [
                        {
                            "id": 64,
                            "name": "All",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "dbMappingId": 34
                        }
                    ]
                }
            ]
        },
        {
            "id": 25,
            "name": "Age_Type",
            "platformId": 1,
            "isActive": 1,
            "platformName": "Beki",
            "displayName": "Age Range",
            "mappingDetails": [
                {
                    "id": 26,
                    "name": "Age_Type",
                    "platformId": 4,
                    "isActive": 1,
                    "platformName": "Google Ads",
                    "displayName": "Age Range"
                },
                {
                    "id": 27,
                    "name": "Age_Type",
                    "platformId": 3,
                    "isActive": 1,
                    "platformName": "Meta",
                    "displayName": "Age Range"
                },
                {
                    "id": 28,
                    "name": "Age_Type",
                    "platformId": 5,
                    "isActive": 1,
                    "platformName": "DV360",
                    "displayName": "Age Range"
                }
            ],
            "mappedPlatformsValueSet": [
                "Google Ads",
                "Meta",
                "DV360"
            ],
            "mappedPlatformsIdSet": [
                3,
                4,
                5
            ],
            "list": [
                {
                    "id": 81,
                    "name": "18-24",
                    "platformId": 1,
                    "isActive": 1,
                    "platformName": "Beki",
                    "mappingDetails": [
                        {
                            "id": 96,
                            "name": "AGE_RANGE_18_24",
                            "platformId": 4,
                            "isActive": 1,
                            "platformName": "Google Ads",
                            "displayName": "18-24",
                            "dbMappingId": 35
                        },
                        {
                            "id": 106,
                            "name": "18-24",
                            "platformId": 3,
                            "isActive": 1,
                            "platformName": "Meta",
                            "dbMappingId": 40
                        },
                        {
                            "id": 121,
                            "name": "18-24",
                            "platformId": 5,
                            "isActive": 1,
                            "platformName": "DV360",
                            "dbMappingId": 55
                        }
                    ]
                },
                {
                    "id": 82,
                    "name": "25-34",
                    "platformId": 1,
                    "isActive": 1,
                    "platformName": "Beki",
                    "mappingDetails": [
                        {
                            "id": 98,
                            "name": "AGE_RANGE_25_34",
                            "platformId": 4,
                            "isActive": 1,
                            "platformName": "Google Ads",
                            "displayName": "25-34",
                            "dbMappingId": 36
                        },
                        {
                            "id": 107,
                            "name": "25-34",
                            "platformId": 3,
                            "isActive": 1,
                            "platformName": "Meta",
                            "dbMappingId": 41
                        },
                        {
                            "id": 122,
                            "name": "25-34",
                            "platformId": 5,
                            "isActive": 1,
                            "platformName": "DV360",
                            "dbMappingId": 56
                        }
                    ]
                },
                {
                    "id": 83,
                    "name": "35-44",
                    "platformId": 1,
                    "isActive": 1,
                    "platformName": "Beki",
                    "mappingDetails": [
                        {
                            "id": 100,
                            "name": "AGE_RANGE_35_44",
                            "platformId": 4,
                            "isActive": 1,
                            "platformName": "Google Ads",
                            "displayName": "35-44",
                            "dbMappingId": 37
                        },
                        {
                            "id": 108,
                            "name": "35-44",
                            "platformId": 3,
                            "isActive": 1,
                            "platformName": "Meta",
                            "dbMappingId": 42
                        },
                        {
                            "id": 123,
                            "name": "35-44",
                            "platformId": 5,
                            "isActive": 1,
                            "platformName": "DV360",
                            "dbMappingId": 57
                        }
                    ]
                },
                {
                    "id": 84,
                    "name": "45-54",
                    "platformId": 1,
                    "isActive": 1,
                    "platformName": "Beki",
                    "mappingDetails": [
                        {
                            "id": 102,
                            "name": "AGE_RANGE_45_54",
                            "platformId": 4,
                            "isActive": 1,
                            "platformName": "Google Ads",
                            "displayName": "45-54",
                            "dbMappingId": 38
                        },
                        {
                            "id": 109,
                            "name": "45-54",
                            "platformId": 3,
                            "isActive": 1,
                            "platformName": "Meta",
                            "dbMappingId": 43
                        },
                        {
                            "id": 124,
                            "name": "45-54",
                            "platformId": 5,
                            "isActive": 1,
                            "platformName": "DV360",
                            "dbMappingId": 58
                        }
                    ]
                },
                {
                    "id": 85,
                    "name": "55-64",
                    "platformId": 1,
                    "isActive": 1,
                    "platformName": "Beki",
                    "mappingDetails": [
                        {
                            "id": 104,
                            "name": "AGE_RANGE_55_64",
                            "platformId": 4,
                            "isActive": 1,
                            "platformName": "Google Ads",
                            "displayName": "55-64",
                            "dbMappingId": 39
                        },
                        {
                            "id": 110,
                            "name": "55-64",
                            "platformId": 3,
                            "isActive": 1,
                            "platformName": "Meta",
                            "dbMappingId": 44
                        },
                        {
                            "id": 125,
                            "name": "55-64",
                            "platformId": 5,
                            "isActive": 1,
                            "platformName": "DV360",
                            "dbMappingId": 59
                        }
                    ]
                },
                {
                    "id": 86,
                    "name": "45-64",
                    "platformId": 1,
                    "isActive": 1,
                    "platformName": "Beki",
                    "mappingDetails": [
                        {
                            "id": 120,
                            "name": "45-64",
                            "platformId": 3,
                            "isActive": 1,
                            "platformName": "Meta",
                            "dbMappingId": 54
                        },
                        {
                            "id": 135,
                            "name": "45-64",
                            "platformId": 5,
                            "isActive": 1,
                            "platformName": "DV360",
                            "dbMappingId": 69
                        }
                    ]
                },
                {
                    "id": 87,
                    "name": "35-64",
                    "platformId": 1,
                    "isActive": 1,
                    "platformName": "Beki",
                    "mappingDetails": [
                        {
                            "id": 119,
                            "name": "35-64",
                            "platformId": 3,
                            "isActive": 1,
                            "platformName": "Meta",
                            "dbMappingId": 53
                        },
                        {
                            "id": 134,
                            "name": "35-64",
                            "platformId": 5,
                            "isActive": 1,
                            "platformName": "DV360",
                            "dbMappingId": 68
                        }
                    ]
                },
                {
                    "id": 88,
                    "name": "35-54",
                    "platformId": 1,
                    "isActive": 1,
                    "platformName": "Beki",
                    "mappingDetails": [
                        {
                            "id": 118,
                            "name": "35-54",
                            "platformId": 3,
                            "isActive": 1,
                            "platformName": "Meta",
                            "dbMappingId": 52
                        },
                        {
                            "id": 133,
                            "name": "35-54",
                            "platformId": 5,
                            "isActive": 1,
                            "platformName": "DV360",
                            "dbMappingId": 67
                        }
                    ]
                },
                {
                    "id": 89,
                    "name": "25-64",
                    "platformId": 1,
                    "isActive": 1,
                    "platformName": "Beki",
                    "mappingDetails": [
                        {
                            "id": 117,
                            "name": "25-64",
                            "platformId": 3,
                            "isActive": 1,
                            "platformName": "Meta",
                            "dbMappingId": 51
                        },
                        {
                            "id": 132,
                            "name": "25-64",
                            "platformId": 5,
                            "isActive": 1,
                            "platformName": "DV360",
                            "dbMappingId": 66
                        }
                    ]
                },
                {
                    "id": 90,
                    "name": "25-44",
                    "platformId": 1,
                    "isActive": 1,
                    "platformName": "Beki",
                    "mappingDetails": [
                        {
                            "id": 115,
                            "name": "25-44",
                            "platformId": 3,
                            "isActive": 1,
                            "platformName": "Meta",
                            "dbMappingId": 49
                        },
                        {
                            "id": 130,
                            "name": "25-44",
                            "platformId": 5,
                            "isActive": 1,
                            "platformName": "DV360",
                            "dbMappingId": 64
                        }
                    ]
                },
                {
                    "id": 91,
                    "name": "25-54",
                    "platformId": 1,
                    "isActive": 1,
                    "platformName": "Beki",
                    "mappingDetails": [
                        {
                            "id": 116,
                            "name": "25-54",
                            "platformId": 3,
                            "isActive": 1,
                            "platformName": "Meta",
                            "dbMappingId": 50
                        },
                        {
                            "id": 131,
                            "name": "25-54",
                            "platformId": 5,
                            "isActive": 1,
                            "platformName": "DV360",
                            "dbMappingId": 65
                        }
                    ]
                },
                {
                    "id": 92,
                    "name": "18-64",
                    "platformId": 1,
                    "isActive": 1,
                    "platformName": "Beki",
                    "mappingDetails": [
                        {
                            "id": 114,
                            "name": "18-64",
                            "platformId": 3,
                            "isActive": 1,
                            "platformName": "Meta",
                            "dbMappingId": 48
                        },
                        {
                            "id": 129,
                            "name": "18-64",
                            "platformId": 5,
                            "isActive": 1,
                            "platformName": "DV360",
                            "dbMappingId": 63
                        }
                    ]
                },
                {
                    "id": 93,
                    "name": "18-54",
                    "platformId": 1,
                    "isActive": 1,
                    "platformName": "Beki",
                    "mappingDetails": [
                        {
                            "id": 113,
                            "name": "18-54",
                            "platformId": 3,
                            "isActive": 1,
                            "platformName": "Meta",
                            "dbMappingId": 47
                        },
                        {
                            "id": 128,
                            "name": "18-54",
                            "platformId": 5,
                            "isActive": 1,
                            "platformName": "DV360",
                            "dbMappingId": 62
                        }
                    ]
                },
                {
                    "id": 94,
                    "name": "18-44",
                    "platformId": 1,
                    "isActive": 1,
                    "platformName": "Beki",
                    "mappingDetails": [
                        {
                            "id": 112,
                            "name": "18-44",
                            "platformId": 3,
                            "isActive": 1,
                            "platformName": "Meta",
                            "dbMappingId": 46
                        },
                        {
                            "id": 127,
                            "name": "18-44",
                            "platformId": 5,
                            "isActive": 1,
                            "platformName": "DV360",
                            "dbMappingId": 61
                        }
                    ]
                },
                {
                    "id": 95,
                    "name": "18-34",
                    "platformId": 1,
                    "isActive": 1,
                    "platformName": "Beki",
                    "mappingDetails": [
                        {
                            "id": 111,
                            "name": "18-34",
                            "platformId": 3,
                            "isActive": 1,
                            "platformName": "Meta",
                            "dbMappingId": 45
                        },
                        {
                            "id": 126,
                            "name": "18-34",
                            "platformId": 5,
                            "isActive": 1,
                            "platformName": "DV360",
                            "dbMappingId": 60
                        }
                    ]
                }
            ]
        },
        {
            "id": 26,
            "name": "Age_Type",
            "platformId": 4,
            "isActive": 1,
            "platformName": "Google Ads",
            "displayName": "Age Range",
            "attributeMapping": 25,
            "mappingDetails": [
                {
                    "id": 25,
                    "name": "Age_Type",
                    "platformId": 1,
                    "isActive": 1,
                    "platformName": "Beki",
                    "displayName": "Age Range"
                }
            ],
            "mappedPlatformsValueSet": [],
            "mappedPlatformsIdSet": [],
            "list": [
                {
                    "id": 96,
                    "name": "AGE_RANGE_18_24",
                    "platformId": 4,
                    "isActive": 1,
                    "platformName": "Google Ads",
                    "displayName": "18-24",
                    "attributeMapping": 81,
                    "mappingDetails": [
                        {
                            "id": 81,
                            "name": "18-24",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "dbMappingId": 35
                        }
                    ]
                },
                {
                    "id": 98,
                    "name": "AGE_RANGE_25_34",
                    "platformId": 4,
                    "isActive": 1,
                    "platformName": "Google Ads",
                    "displayName": "25-34",
                    "attributeMapping": 82,
                    "mappingDetails": [
                        {
                            "id": 82,
                            "name": "25-34",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "dbMappingId": 36
                        }
                    ]
                },
                {
                    "id": 100,
                    "name": "AGE_RANGE_35_44",
                    "platformId": 4,
                    "isActive": 1,
                    "platformName": "Google Ads",
                    "displayName": "35-44",
                    "attributeMapping": 83,
                    "mappingDetails": [
                        {
                            "id": 83,
                            "name": "35-44",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "dbMappingId": 37
                        }
                    ]
                },
                {
                    "id": 102,
                    "name": "AGE_RANGE_45_54",
                    "platformId": 4,
                    "isActive": 1,
                    "platformName": "Google Ads",
                    "displayName": "45-54",
                    "attributeMapping": 84,
                    "mappingDetails": [
                        {
                            "id": 84,
                            "name": "45-54",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "dbMappingId": 38
                        }
                    ]
                },
                {
                    "id": 104,
                    "name": "AGE_RANGE_55_64",
                    "platformId": 4,
                    "isActive": 1,
                    "platformName": "Google Ads",
                    "displayName": "55-64",
                    "attributeMapping": 85,
                    "mappingDetails": [
                        {
                            "id": 85,
                            "name": "55-64",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "dbMappingId": 39
                        }
                    ]
                }
            ]
        },
        {
            "id": 27,
            "name": "Age_Type",
            "platformId": 3,
            "isActive": 1,
            "platformName": "Meta",
            "displayName": "Age Range",
            "attributeMapping": 25,
            "mappingDetails": [
                {
                    "id": 25,
                    "name": "Age_Type",
                    "platformId": 1,
                    "isActive": 1,
                    "platformName": "Beki",
                    "displayName": "Age Range"
                }
            ],
            "mappedPlatformsValueSet": [],
            "mappedPlatformsIdSet": [],
            "list": [
                {
                    "id": 106,
                    "name": "18-24",
                    "platformId": 3,
                    "isActive": 1,
                    "platformName": "Meta",
                    "attributeMapping": 81,
                    "mappingDetails": [
                        {
                            "id": 81,
                            "name": "18-24",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "dbMappingId": 40
                        }
                    ]
                },
                {
                    "id": 107,
                    "name": "25-34",
                    "platformId": 3,
                    "isActive": 1,
                    "platformName": "Meta",
                    "attributeMapping": 82,
                    "mappingDetails": [
                        {
                            "id": 82,
                            "name": "25-34",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "dbMappingId": 41
                        }
                    ]
                },
                {
                    "id": 108,
                    "name": "35-44",
                    "platformId": 3,
                    "isActive": 1,
                    "platformName": "Meta",
                    "attributeMapping": 83,
                    "mappingDetails": [
                        {
                            "id": 83,
                            "name": "35-44",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "dbMappingId": 42
                        }
                    ]
                },
                {
                    "id": 109,
                    "name": "45-54",
                    "platformId": 3,
                    "isActive": 1,
                    "platformName": "Meta",
                    "attributeMapping": 84,
                    "mappingDetails": [
                        {
                            "id": 84,
                            "name": "45-54",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "dbMappingId": 43
                        }
                    ]
                },
                {
                    "id": 110,
                    "name": "55-64",
                    "platformId": 3,
                    "isActive": 1,
                    "platformName": "Meta",
                    "attributeMapping": 85,
                    "mappingDetails": [
                        {
                            "id": 85,
                            "name": "55-64",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "dbMappingId": 44
                        }
                    ]
                },
                {
                    "id": 111,
                    "name": "18-34",
                    "platformId": 3,
                    "isActive": 1,
                    "platformName": "Meta",
                    "attributeMapping": 95,
                    "mappingDetails": [
                        {
                            "id": 95,
                            "name": "18-34",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "dbMappingId": 45
                        }
                    ]
                },
                {
                    "id": 112,
                    "name": "18-44",
                    "platformId": 3,
                    "isActive": 1,
                    "platformName": "Meta",
                    "attributeMapping": 94,
                    "mappingDetails": [
                        {
                            "id": 94,
                            "name": "18-44",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "dbMappingId": 46
                        }
                    ]
                },
                {
                    "id": 113,
                    "name": "18-54",
                    "platformId": 3,
                    "isActive": 1,
                    "platformName": "Meta",
                    "attributeMapping": 93,
                    "mappingDetails": [
                        {
                            "id": 93,
                            "name": "18-54",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "dbMappingId": 47
                        }
                    ]
                },
                {
                    "id": 114,
                    "name": "18-64",
                    "platformId": 3,
                    "isActive": 1,
                    "platformName": "Meta",
                    "attributeMapping": 92,
                    "mappingDetails": [
                        {
                            "id": 92,
                            "name": "18-64",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "dbMappingId": 48
                        }
                    ]
                },
                {
                    "id": 115,
                    "name": "25-44",
                    "platformId": 3,
                    "isActive": 1,
                    "platformName": "Meta",
                    "attributeMapping": 90,
                    "mappingDetails": [
                        {
                            "id": 90,
                            "name": "25-44",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "dbMappingId": 49
                        }
                    ]
                },
                {
                    "id": 116,
                    "name": "25-54",
                    "platformId": 3,
                    "isActive": 1,
                    "platformName": "Meta",
                    "attributeMapping": 91,
                    "mappingDetails": [
                        {
                            "id": 91,
                            "name": "25-54",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "dbMappingId": 50
                        }
                    ]
                },
                {
                    "id": 117,
                    "name": "25-64",
                    "platformId": 3,
                    "isActive": 1,
                    "platformName": "Meta",
                    "attributeMapping": 89,
                    "mappingDetails": [
                        {
                            "id": 89,
                            "name": "25-64",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "dbMappingId": 51
                        }
                    ]
                },
                {
                    "id": 118,
                    "name": "35-54",
                    "platformId": 3,
                    "isActive": 1,
                    "platformName": "Meta",
                    "attributeMapping": 88,
                    "mappingDetails": [
                        {
                            "id": 88,
                            "name": "35-54",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "dbMappingId": 52
                        }
                    ]
                },
                {
                    "id": 119,
                    "name": "35-64",
                    "platformId": 3,
                    "isActive": 1,
                    "platformName": "Meta",
                    "attributeMapping": 87,
                    "mappingDetails": [
                        {
                            "id": 87,
                            "name": "35-64",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "dbMappingId": 53
                        }
                    ]
                },
                {
                    "id": 120,
                    "name": "45-64",
                    "platformId": 3,
                    "isActive": 1,
                    "platformName": "Meta",
                    "attributeMapping": 86,
                    "mappingDetails": [
                        {
                            "id": 86,
                            "name": "45-64",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "dbMappingId": 54
                        }
                    ]
                },
                {
                    "id": 4029,
                    "name": "24-65",
                    "platformId": 3,
                    "isActive": 1,
                    "platformName": "Meta",
                    "mappingDetails": []
                },
                {
                    "id": 4030,
                    "name": "18-65",
                    "platformId": 3,
                    "isActive": 1,
                    "platformName": "Meta",
                    "mappingDetails": []
                },
                {
                    "id": 4031,
                    "name": "21-65",
                    "platformId": 3,
                    "isActive": 1,
                    "platformName": "Meta",
                    "mappingDetails": []
                },
                {
                    "id": 4032,
                    "name": "35-65",
                    "platformId": 3,
                    "isActive": 1,
                    "platformName": "Meta",
                    "mappingDetails": []
                },
                {
                    "id": 4033,
                    "name": "25-35",
                    "platformId": 3,
                    "isActive": 1,
                    "platformName": "Meta",
                    "mappingDetails": []
                },
                {
                    "id": 4034,
                    "name": "21-60",
                    "platformId": 3,
                    "isActive": 1,
                    "platformName": "Meta",
                    "mappingDetails": []
                },
                {
                    "id": 4039,
                    "name": "22-37",
                    "platformId": 3,
                    "isActive": 1,
                    "platformName": "Meta",
                    "mappingDetails": []
                }
            ]
        },
        {
            "id": 28,
            "name": "Age_Type",
            "platformId": 5,
            "isActive": 1,
            "platformName": "DV360",
            "displayName": "Age Range",
            "attributeMapping": 25,
            "mappingDetails": [
                {
                    "id": 25,
                    "name": "Age_Type",
                    "platformId": 1,
                    "isActive": 1,
                    "platformName": "Beki",
                    "displayName": "Age Range"
                }
            ],
            "mappedPlatformsValueSet": [],
            "mappedPlatformsIdSet": [],
            "list": [
                {
                    "id": 121,
                    "name": "18-24",
                    "platformId": 5,
                    "isActive": 1,
                    "platformName": "DV360",
                    "attributeMapping": 81,
                    "mappingDetails": [
                        {
                            "id": 81,
                            "name": "18-24",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "dbMappingId": 55
                        }
                    ]
                },
                {
                    "id": 122,
                    "name": "25-34",
                    "platformId": 5,
                    "isActive": 1,
                    "platformName": "DV360",
                    "attributeMapping": 82,
                    "mappingDetails": [
                        {
                            "id": 82,
                            "name": "25-34",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "dbMappingId": 56
                        }
                    ]
                },
                {
                    "id": 123,
                    "name": "35-44",
                    "platformId": 5,
                    "isActive": 1,
                    "platformName": "DV360",
                    "attributeMapping": 83,
                    "mappingDetails": [
                        {
                            "id": 83,
                            "name": "35-44",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "dbMappingId": 57
                        }
                    ]
                },
                {
                    "id": 124,
                    "name": "45-54",
                    "platformId": 5,
                    "isActive": 1,
                    "platformName": "DV360",
                    "attributeMapping": 84,
                    "mappingDetails": [
                        {
                            "id": 84,
                            "name": "45-54",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "dbMappingId": 58
                        }
                    ]
                },
                {
                    "id": 125,
                    "name": "55-64",
                    "platformId": 5,
                    "isActive": 1,
                    "platformName": "DV360",
                    "attributeMapping": 85,
                    "mappingDetails": [
                        {
                            "id": 85,
                            "name": "55-64",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "dbMappingId": 59
                        }
                    ]
                },
                {
                    "id": 126,
                    "name": "18-34",
                    "platformId": 5,
                    "isActive": 1,
                    "platformName": "DV360",
                    "attributeMapping": 95,
                    "mappingDetails": [
                        {
                            "id": 95,
                            "name": "18-34",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "dbMappingId": 60
                        }
                    ]
                },
                {
                    "id": 127,
                    "name": "18-44",
                    "platformId": 5,
                    "isActive": 1,
                    "platformName": "DV360",
                    "attributeMapping": 94,
                    "mappingDetails": [
                        {
                            "id": 94,
                            "name": "18-44",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "dbMappingId": 61
                        }
                    ]
                },
                {
                    "id": 128,
                    "name": "18-54",
                    "platformId": 5,
                    "isActive": 1,
                    "platformName": "DV360",
                    "attributeMapping": 93,
                    "mappingDetails": [
                        {
                            "id": 93,
                            "name": "18-54",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "dbMappingId": 62
                        }
                    ]
                },
                {
                    "id": 129,
                    "name": "18-64",
                    "platformId": 5,
                    "isActive": 1,
                    "platformName": "DV360",
                    "attributeMapping": 92,
                    "mappingDetails": [
                        {
                            "id": 92,
                            "name": "18-64",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "dbMappingId": 63
                        }
                    ]
                },
                {
                    "id": 130,
                    "name": "25-44",
                    "platformId": 5,
                    "isActive": 1,
                    "platformName": "DV360",
                    "attributeMapping": 90,
                    "mappingDetails": [
                        {
                            "id": 90,
                            "name": "25-44",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "dbMappingId": 64
                        }
                    ]
                },
                {
                    "id": 131,
                    "name": "25-54",
                    "platformId": 5,
                    "isActive": 1,
                    "platformName": "DV360",
                    "attributeMapping": 91,
                    "mappingDetails": [
                        {
                            "id": 91,
                            "name": "25-54",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "dbMappingId": 65
                        }
                    ]
                },
                {
                    "id": 132,
                    "name": "25-64",
                    "platformId": 5,
                    "isActive": 1,
                    "platformName": "DV360",
                    "attributeMapping": 89,
                    "mappingDetails": [
                        {
                            "id": 89,
                            "name": "25-64",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "dbMappingId": 66
                        }
                    ]
                },
                {
                    "id": 133,
                    "name": "35-54",
                    "platformId": 5,
                    "isActive": 1,
                    "platformName": "DV360",
                    "attributeMapping": 88,
                    "mappingDetails": [
                        {
                            "id": 88,
                            "name": "35-54",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "dbMappingId": 67
                        }
                    ]
                },
                {
                    "id": 134,
                    "name": "35-64",
                    "platformId": 5,
                    "isActive": 1,
                    "platformName": "DV360",
                    "attributeMapping": 87,
                    "mappingDetails": [
                        {
                            "id": 87,
                            "name": "35-64",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "dbMappingId": 68
                        }
                    ]
                },
                {
                    "id": 135,
                    "name": "45-64",
                    "platformId": 5,
                    "isActive": 1,
                    "platformName": "DV360",
                    "attributeMapping": 86,
                    "mappingDetails": [
                        {
                            "id": 86,
                            "name": "45-64",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "dbMappingId": 69
                        }
                    ]
                }
            ]
        },
        {
            "id": 29,
            "name": "Duration_Type",
            "platformId": 5,
            "isActive": 1,
            "platformName": "DV360",
            "displayName": "Duration Type",
            "attributeMapping": 2,
            "mappingDetails": [
                {
                    "id": 2,
                    "name": "Duration_Type",
                    "platformId": 1,
                    "isActive": 1,
                    "platformName": "Beki",
                    "displayName": "Duration Type"
                }
            ],
            "mappedPlatformsValueSet": [],
            "mappedPlatformsIdSet": [],
            "list": [
                {
                    "id": 138,
                    "name": "PACING_PERIOD_DAILY",
                    "platformId": 5,
                    "isActive": 1,
                    "platformName": "DV360",
                    "displayName": "Daily",
                    "attributeMapping": 5,
                    "mappingDetails": [
                        {
                            "id": 5,
                            "name": "Daily",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Daily",
                            "dbMappingId": 71
                        }
                    ]
                },
                {
                    "id": 140,
                    "name": "PACING_PERIOD_FLIGHT",
                    "platformId": 5,
                    "isActive": 1,
                    "platformName": "DV360",
                    "displayName": "Lifetime",
                    "attributeMapping": 7,
                    "mappingDetails": [
                        {
                            "id": 7,
                            "name": "Lifetime",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Lifetime",
                            "dbMappingId": 561
                        }
                    ]
                }
            ]
        },
        {
            "id": 31,
            "name": "Bidding_Strategy_Display",
            "platformId": 4,
            "isActive": 1,
            "platformName": "Google Ads",
            "displayName": "Bidding Strategy Display",
            "attributeMapping": 65,
            "mappingDetails": [
                {
                    "id": 65,
                    "name": "Bidding_Strategy_Display",
                    "platformId": 1,
                    "isActive": 1,
                    "platformName": "Beki",
                    "displayName": "Bidding_Strategy_Display"
                }
            ],
            "mappedPlatformsValueSet": [],
            "mappedPlatformsIdSet": [],
            "list": [
                {
                    "id": 146,
                    "name": "Maximize click",
                    "platformId": 4,
                    "isActive": 1,
                    "platformName": "Google Ads",
                    "displayName": "Maximize click",
                    "attributeMapping": 1773,
                    "mappingDetails": [
                        {
                            "id": 1773,
                            "name": "Maximize Click",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Maximize Click",
                            "dbMappingId": 555
                        }
                    ]
                },
                {
                    "id": 148,
                    "name": "Manual CPC",
                    "platformId": 4,
                    "isActive": 1,
                    "platformName": "Google Ads",
                    "displayName": "Manual CPC",
                    "attributeMapping": 1775,
                    "mappingDetails": [
                        {
                            "id": 1775,
                            "name": "Manual CPC",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Manual CPC",
                            "dbMappingId": 556
                        }
                    ]
                },
                {
                    "id": 150,
                    "name": "Viewable CPM",
                    "platformId": 4,
                    "isActive": 1,
                    "platformName": "Google Ads",
                    "displayName": "Viewable CPM",
                    "attributeMapping": 1771,
                    "mappingDetails": [
                        {
                            "id": 1771,
                            "name": "CPM",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "CPM",
                            "dbMappingId": 554
                        }
                    ]
                }
            ]
        },
        {
            "id": 32,
            "name": "DISPLAY_SIZES",
            "platformId": 1,
            "isActive": 1,
            "platformName": "Beki",
            "displayName": "Display Sizes",
            "mappingDetails": [
                {
                    "id": 33,
                    "name": "DISPLAY_SIZES",
                    "platformId": 4,
                    "isActive": 1,
                    "platformName": "Google Ads",
                    "displayName": "Display Sizes",
                    "description": "\u003cp\u003eundefined\u003c/p\u003e"
                }
            ],
            "mappedPlatformsValueSet": [
                "Google Ads"
            ],
            "mappedPlatformsIdSet": [
                4
            ],
            "list": [
                {
                    "id": 152,
                    "name": "200X200",
                    "platformId": 1,
                    "isActive": 1,
                    "platformName": "Beki",
                    "mappingDetails": [
                        {
                            "id": 195,
                            "name": "200X200",
                            "platformId": 4,
                            "isActive": 1,
                            "platformName": "Google Ads",
                            "displayName": "200X200",
                            "dbMappingId": 72
                        }
                    ]
                }
            ]
        },
        {
            "id": 33,
            "name": "DISPLAY_SIZES",
            "platformId": 4,
            "isActive": 1,
            "platformName": "Google Ads",
            "displayName": "Display Sizes",
            "description": "\u003cp\u003eundefined\u003c/p\u003e",
            "attributeMapping": 32,
            "mappingDetails": [
                {
                    "id": 32,
                    "name": "DISPLAY_SIZES",
                    "platformId": 1,
                    "isActive": 1,
                    "platformName": "Beki",
                    "displayName": "Display Sizes"
                }
            ],
            "mappedPlatformsValueSet": [],
            "mappedPlatformsIdSet": [],
            "list": [
                {
                    "id": 153,
                    "name": "300X100",
                    "platformId": 4,
                    "isActive": 1,
                    "platformName": "Google Ads",
                    "displayName": "300X100",
                    "mappingDetails": []
                },
                {
                    "id": 155,
                    "name": "750X300",
                    "platformId": 4,
                    "isActive": 1,
                    "platformName": "Google Ads",
                    "displayName": "750X300",
                    "mappingDetails": []
                },
                {
                    "id": 157,
                    "name": "750X200",
                    "platformId": 4,
                    "isActive": 1,
                    "platformName": "Google Ads",
                    "displayName": "750X200",
                    "mappingDetails": []
                },
                {
                    "id": 159,
                    "name": "750X100",
                    "platformId": 4,
                    "isActive": 1,
                    "platformName": "Google Ads",
                    "displayName": "750X100",
                    "mappingDetails": []
                },
                {
                    "id": 161,
                    "name": "950X90",
                    "platformId": 4,
                    "isActive": 1,
                    "platformName": "Google Ads",
                    "displayName": "950X90",
                    "mappingDetails": []
                },
                {
                    "id": 163,
                    "name": "88X31",
                    "platformId": 4,
                    "isActive": 1,
                    "platformName": "Google Ads",
                    "displayName": "88X31",
                    "mappingDetails": []
                },
                {
                    "id": 165,
                    "name": "220X90",
                    "platformId": 4,
                    "isActive": 1,
                    "platformName": "Google Ads",
                    "displayName": "220X90",
                    "mappingDetails": []
                },
                {
                    "id": 167,
                    "name": "300X31",
                    "platformId": 4,
                    "isActive": 1,
                    "platformName": "Google Ads",
                    "displayName": "300X31",
                    "mappingDetails": []
                },
                {
                    "id": 169,
                    "name": "980X90",
                    "platformId": 4,
                    "isActive": 1,
                    "platformName": "Google Ads",
                    "displayName": "980X90",
                    "mappingDetails": []
                },
                {
                    "id": 171,
                    "name": "240X133",
                    "platformId": 4,
                    "isActive": 1,
                    "platformName": "Google Ads",
                    "displayName": "240X133",
                    "mappingDetails": []
                },
                {
                    "id": 173,
                    "name": "200X446",
                    "platformId": 4,
                    "isActive": 1,
                    "platformName": "Google Ads",
                    "displayName": "200X446",
                    "mappingDetails": []
                },
                {
                    "id": 175,
                    "name": "292X30",
                    "platformId": 4,
                    "isActive": 1,
                    "platformName": "Google Ads",
                    "displayName": "292X30",
                    "mappingDetails": []
                },
                {
                    "id": 177,
                    "name": "960X90",
                    "platformId": 4,
                    "isActive": 1,
                    "platformName": "Google Ads",
                    "displayName": "960X90",
                    "mappingDetails": []
                },
                {
                    "id": 179,
                    "name": "970X66",
                    "platformId": 4,
                    "isActive": 1,
                    "platformName": "Google Ads",
                    "displayName": "970X66",
                    "mappingDetails": []
                },
                {
                    "id": 181,
                    "name": "300X57",
                    "platformId": 4,
                    "isActive": 1,
                    "platformName": "Google Ads",
                    "displayName": "300X57",
                    "mappingDetails": []
                },
                {
                    "id": 183,
                    "name": "120X60",
                    "platformId": 4,
                    "isActive": 1,
                    "platformName": "Google Ads",
                    "displayName": "120X60",
                    "mappingDetails": []
                },
                {
                    "id": 185,
                    "name": "320X400",
                    "platformId": 4,
                    "isActive": 1,
                    "platformName": "Google Ads",
                    "displayName": "320X400",
                    "mappingDetails": []
                },
                {
                    "id": 187,
                    "name": "600X314",
                    "platformId": 4,
                    "isActive": 1,
                    "platformName": "Google Ads",
                    "displayName": "600X314",
                    "mappingDetails": []
                },
                {
                    "id": 189,
                    "name": "468X60",
                    "platformId": 4,
                    "isActive": 1,
                    "platformName": "Google Ads",
                    "displayName": "468X60",
                    "mappingDetails": []
                },
                {
                    "id": 191,
                    "name": "728X90",
                    "platformId": 4,
                    "isActive": 1,
                    "platformName": "Google Ads",
                    "displayName": "728X90",
                    "mappingDetails": []
                },
                {
                    "id": 193,
                    "name": "250X250",
                    "platformId": 4,
                    "isActive": 1,
                    "platformName": "Google Ads",
                    "displayName": "250X250",
                    "mappingDetails": []
                },
                {
                    "id": 195,
                    "name": "200X200",
                    "platformId": 4,
                    "isActive": 1,
                    "platformName": "Google Ads",
                    "displayName": "200X200",
                    "attributeMapping": 152,
                    "mappingDetails": [
                        {
                            "id": 152,
                            "name": "200X200",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "dbMappingId": 72
                        }
                    ]
                },
                {
                    "id": 197,
                    "name": "336X280",
                    "platformId": 4,
                    "isActive": 1,
                    "platformName": "Google Ads",
                    "displayName": "336X280",
                    "mappingDetails": []
                },
                {
                    "id": 199,
                    "name": "300X250",
                    "platformId": 4,
                    "isActive": 1,
                    "platformName": "Google Ads",
                    "displayName": "300X250",
                    "mappingDetails": []
                },
                {
                    "id": 201,
                    "name": "120X600",
                    "platformId": 4,
                    "isActive": 1,
                    "platformName": "Google Ads",
                    "displayName": "120X600",
                    "mappingDetails": []
                },
                {
                    "id": 203,
                    "name": "160X600",
                    "platformId": 4,
                    "isActive": 1,
                    "platformName": "Google Ads",
                    "displayName": "160X600",
                    "mappingDetails": []
                },
                {
                    "id": 205,
                    "name": "320X50",
                    "platformId": 4,
                    "isActive": 1,
                    "platformName": "Google Ads",
                    "displayName": "320X50",
                    "mappingDetails": []
                },
                {
                    "id": 207,
                    "name": "320X100",
                    "platformId": 4,
                    "isActive": 1,
                    "platformName": "Google Ads",
                    "displayName": "320X100",
                    "mappingDetails": []
                },
                {
                    "id": 209,
                    "name": "300X50",
                    "platformId": 4,
                    "isActive": 1,
                    "platformName": "Google Ads",
                    "displayName": "300X50",
                    "mappingDetails": []
                },
                {
                    "id": 211,
                    "name": "425X600",
                    "platformId": 4,
                    "isActive": 1,
                    "platformName": "Google Ads",
                    "displayName": "425X600",
                    "mappingDetails": []
                },
                {
                    "id": 213,
                    "name": "300X600",
                    "platformId": 4,
                    "isActive": 1,
                    "platformName": "Google Ads",
                    "displayName": "300X600",
                    "mappingDetails": []
                },
                {
                    "id": 215,
                    "name": "970X90",
                    "platformId": 4,
                    "isActive": 1,
                    "platformName": "Google Ads",
                    "displayName": "970X90",
                    "mappingDetails": []
                },
                {
                    "id": 217,
                    "name": "240X400",
                    "platformId": 4,
                    "isActive": 1,
                    "platformName": "Google Ads",
                    "displayName": "240X400",
                    "mappingDetails": []
                },
                {
                    "id": 219,
                    "name": "980X120",
                    "platformId": 4,
                    "isActive": 1,
                    "platformName": "Google Ads",
                    "displayName": "980X120",
                    "mappingDetails": []
                },
                {
                    "id": 221,
                    "name": "930X180",
                    "platformId": 4,
                    "isActive": 1,
                    "platformName": "Google Ads",
                    "displayName": "930X180",
                    "mappingDetails": []
                },
                {
                    "id": 223,
                    "name": "250X360",
                    "platformId": 4,
                    "isActive": 1,
                    "platformName": "Google Ads",
                    "displayName": "250X360",
                    "mappingDetails": []
                },
                {
                    "id": 225,
                    "name": "580X400",
                    "platformId": 4,
                    "isActive": 1,
                    "platformName": "Google Ads",
                    "displayName": "580X400",
                    "mappingDetails": []
                },
                {
                    "id": 227,
                    "name": "300X1050",
                    "platformId": 4,
                    "isActive": 1,
                    "platformName": "Google Ads",
                    "displayName": "300X1050",
                    "mappingDetails": []
                },
                {
                    "id": 229,
                    "name": "480X320",
                    "platformId": 4,
                    "isActive": 1,
                    "platformName": "Google Ads",
                    "displayName": "480X320",
                    "mappingDetails": []
                },
                {
                    "id": 231,
                    "name": "320X480",
                    "platformId": 4,
                    "isActive": 1,
                    "platformName": "Google Ads",
                    "displayName": "320X480",
                    "mappingDetails": []
                },
                {
                    "id": 233,
                    "name": "768X1024",
                    "platformId": 4,
                    "isActive": 1,
                    "platformName": "Google Ads",
                    "displayName": "768X1024",
                    "mappingDetails": []
                },
                {
                    "id": 235,
                    "name": "414X736",
                    "platformId": 4,
                    "isActive": 1,
                    "platformName": "Google Ads",
                    "displayName": "414X736",
                    "mappingDetails": []
                },
                {
                    "id": 237,
                    "name": "1024X768",
                    "platformId": 4,
                    "isActive": 1,
                    "platformName": "Google Ads",
                    "displayName": "1024X768",
                    "mappingDetails": []
                },
                {
                    "id": 239,
                    "name": "480X32",
                    "platformId": 4,
                    "isActive": 1,
                    "platformName": "Google Ads",
                    "displayName": "480X32",
                    "mappingDetails": []
                },
                {
                    "id": 241,
                    "name": "1024X90",
                    "platformId": 4,
                    "isActive": 1,
                    "platformName": "Google Ads",
                    "displayName": "1024X90",
                    "mappingDetails": []
                },
                {
                    "id": 243,
                    "name": "970X250",
                    "platformId": 4,
                    "isActive": 1,
                    "platformName": "Google Ads",
                    "displayName": "970X250",
                    "mappingDetails": []
                },
                {
                    "id": 245,
                    "name": "375X50",
                    "platformId": 4,
                    "isActive": 1,
                    "platformName": "Google Ads",
                    "displayName": "375X50",
                    "mappingDetails": []
                },
                {
                    "id": 247,
                    "name": "736X414",
                    "platformId": 4,
                    "isActive": 1,
                    "platformName": "Google Ads",
                    "displayName": "736X414",
                    "mappingDetails": []
                },
                {
                    "id": 2975,
                    "name": "600X500",
                    "platformId": 4,
                    "isActive": 1,
                    "platformName": "Google Ads",
                    "displayName": "600X500",
                    "mappingDetails": []
                }
            ]
        },
        {
            "id": 34,
            "name": "DISPLAY_MIME_TYPES",
            "platformId": 1,
            "isActive": 1,
            "platformName": "Beki",
            "displayName": "Display Mime Types",
            "mappingDetails": [
                {
                    "id": 35,
                    "name": "DISPLAY_MIME_TYPES",
                    "platformId": 4,
                    "isActive": 1,
                    "platformName": "Google Ads",
                    "displayName": "Display Mime Types"
                },
                {
                    "id": 36,
                    "name": "DISPLAY_MIME_TYPES",
                    "platformId": 5,
                    "isActive": 1,
                    "platformName": "DV360",
                    "displayName": "Display Mime Types"
                },
                {
                    "id": 89,
                    "name": "DISPLAY_MIME_TYPES",
                    "platformId": 8,
                    "isActive": 1,
                    "platformName": "ViAds",
                    "displayName": "",
                    "description": ""
                }
            ],
            "mappedPlatformsValueSet": [
                "Google Ads",
                "ViAds",
                "DV360"
            ],
            "mappedPlatformsIdSet": [
                4,
                5,
                8
            ],
            "list": [
                {
                    "id": 249,
                    "name": "JPEG",
                    "platformId": 1,
                    "isActive": 1,
                    "platformName": "Beki",
                    "displayName": "Jpeg",
                    "mappingDetails": [
                        {
                            "id": 255,
                            "name": "JPEG",
                            "platformId": 4,
                            "isActive": 1,
                            "platformName": "Google Ads",
                            "displayName": "JPEG",
                            "dbMappingId": 563
                        },
                        {
                            "id": 3003,
                            "name": "JPEG",
                            "platformId": 8,
                            "isActive": 1,
                            "platformName": "ViAds",
                            "displayName": "JPEG",
                            "dbMappingId": 1129
                        }
                    ]
                }
            ]
        },
        {
            "id": 35,
            "name": "DISPLAY_MIME_TYPES",
            "platformId": 4,
            "isActive": 1,
            "platformName": "Google Ads",
            "displayName": "Display Mime Types",
            "attributeMapping": 34,
            "mappingDetails": [
                {
                    "id": 34,
                    "name": "DISPLAY_MIME_TYPES",
                    "platformId": 1,
                    "isActive": 1,
                    "platformName": "Beki",
                    "displayName": "Display Mime Types"
                }
            ],
            "mappedPlatformsValueSet": [],
            "mappedPlatformsIdSet": [],
            "list": [
                {
                    "id": 251,
                    "name": "GIF",
                    "platformId": 4,
                    "isActive": 1,
                    "platformName": "Google Ads",
                    "displayName": "GIF",
                    "mappingDetails": []
                },
                {
                    "id": 253,
                    "name": "PNG",
                    "platformId": 4,
                    "isActive": 1,
                    "platformName": "Google Ads",
                    "displayName": "PNG",
                    "mappingDetails": []
                },
                {
                    "id": 255,
                    "name": "JPEG",
                    "platformId": 4,
                    "isActive": 1,
                    "platformName": "Google Ads",
                    "displayName": "JPEG",
                    "attributeMapping": 249,
                    "mappingDetails": [
                        {
                            "id": 249,
                            "name": "JPEG",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Jpeg",
                            "dbMappingId": 563
                        }
                    ]
                }
            ]
        },
        {
            "id": 36,
            "name": "DISPLAY_MIME_TYPES",
            "platformId": 5,
            "isActive": 1,
            "platformName": "DV360",
            "displayName": "Display Mime Types",
            "attributeMapping": 34,
            "mappingDetails": [
                {
                    "id": 34,
                    "name": "DISPLAY_MIME_TYPES",
                    "platformId": 1,
                    "isActive": 1,
                    "platformName": "Beki",
                    "displayName": "Display Mime Types"
                }
            ],
            "mappedPlatformsValueSet": [],
            "mappedPlatformsIdSet": [],
            "list": [
                {
                    "id": 257,
                    "name": "GIF",
                    "platformId": 5,
                    "isActive": 1,
                    "platformName": "DV360",
                    "displayName": "GIF",
                    "mappingDetails": []
                },
                {
                    "id": 259,
                    "name": "PNG",
                    "platformId": 5,
                    "isActive": 1,
                    "platformName": "DV360",
                    "displayName": "PNG",
                    "mappingDetails": []
                },
                {
                    "id": 261,
                    "name": "JPEG",
                    "platformId": 5,
                    "isActive": 1,
                    "platformName": "DV360",
                    "displayName": "JPEG",
                    "mappingDetails": []
                },
                {
                    "id": 263,
                    "name": "JPG",
                    "platformId": 5,
                    "isActive": 1,
                    "platformName": "DV360",
                    "displayName": "JPG",
                    "mappingDetails": []
                }
            ]
        },
        {
            "id": 37,
            "name": "OnScreen_Position_Facebook_Feeds",
            "platformId": 3,
            "isActive": 1,
            "platformName": "Meta",
            "displayName": "OnScreen Position Facebook Feeds",
            "mappingDetails": [],
            "mappedPlatformsValueSet": [],
            "mappedPlatformsIdSet": [],
            "list": [
                {
                    "id": 265,
                    "name": "feed",
                    "platformId": 3,
                    "isActive": 1,
                    "platformName": "Meta",
                    "displayName": "Facebook Feeds",
                    "mappingDetails": []
                },
                {
                    "id": 267,
                    "name": "marketplace",
                    "platformId": 3,
                    "isActive": 1,
                    "platformName": "Meta",
                    "displayName": "Facebook Marketplace",
                    "mappingDetails": []
                },
                {
                    "id": 269,
                    "name": "video_feeds",
                    "platformId": 3,
                    "isActive": 1,
                    "platformName": "Meta",
                    "displayName": "Facebook Video Feeds",
                    "mappingDetails": []
                },
                {
                    "id": 271,
                    "name": "profile_feed",
                    "platformId": 3,
                    "isActive": 1,
                    "platformName": "Meta",
                    "displayName": "Another Facebook Feeds",
                    "mappingDetails": []
                }
            ]
        },
        {
            "id": 38,
            "name": "OnScreen_Position_Facebook_Stories_And_Reels",
            "platformId": 3,
            "isActive": 1,
            "platformName": "Meta",
            "displayName": "OnScreen Position Facebook Stories And Reels",
            "mappingDetails": [],
            "mappedPlatformsValueSet": [],
            "mappedPlatformsIdSet": [],
            "list": [
                {
                    "id": 273,
                    "name": "story",
                    "platformId": 3,
                    "isActive": 1,
                    "platformName": "Meta",
                    "displayName": "Facebook Stories",
                    "mappingDetails": []
                },
                {
                    "id": 275,
                    "name": "facebook_reels",
                    "platformId": 3,
                    "isActive": 1,
                    "platformName": "Meta",
                    "displayName": "Facebook Reels",
                    "mappingDetails": []
                }
            ]
        },
        {
            "id": 39,
            "name": "OnScreen_Position_Facebook_Search_Results",
            "platformId": 3,
            "isActive": 1,
            "platformName": "Meta",
            "displayName": "OnScreen Position Facebook Search Results",
            "mappingDetails": [],
            "mappedPlatformsValueSet": [],
            "mappedPlatformsIdSet": [],
            "list": [
                {
                    "id": 277,
                    "name": "search",
                    "platformId": 3,
                    "isActive": 1,
                    "platformName": "Meta",
                    "displayName": "Facebook Search Results",
                    "mappingDetails": []
                }
            ]
        },
        {
            "id": 40,
            "name": "OnScreen_Position_DV360_Screen_Position_Display",
            "platformId": 5,
            "isActive": 1,
            "platformName": "DV360",
            "displayName": "OnScreen Position : Display Screen Position",
            "mappingDetails": [],
            "mappedPlatformsValueSet": [],
            "mappedPlatformsIdSet": [],
            "list": [
                {
                    "id": 279,
                    "name": "21",
                    "platformId": 5,
                    "isActive": 1,
                    "platformName": "DV360",
                    "displayName": "Above the fold",
                    "mappingDetails": []
                },
                {
                    "id": 281,
                    "name": "22",
                    "platformId": 5,
                    "isActive": 1,
                    "platformName": "DV360",
                    "displayName": "Below the fold",
                    "mappingDetails": []
                },
                {
                    "id": 283,
                    "name": "23",
                    "platformId": 5,
                    "isActive": 1,
                    "platformName": "DV360",
                    "displayName": "Unknown",
                    "mappingDetails": []
                }
            ]
        },
        {
            "id": 41,
            "name": "OnScreen_Position_DV360_Screen_Position_Video",
            "platformId": 5,
            "isActive": 1,
            "platformName": "DV360",
            "displayName": "OnScreen Position : Video Screen Position",
            "mappingDetails": [],
            "mappedPlatformsValueSet": [],
            "mappedPlatformsIdSet": [],
            "list": [
                {
                    "id": 285,
                    "name": "21",
                    "platformId": 5,
                    "isActive": 1,
                    "platformName": "DV360",
                    "displayName": "Above the fold",
                    "mappingDetails": []
                },
                {
                    "id": 287,
                    "name": "22",
                    "platformId": 5,
                    "isActive": 1,
                    "platformName": "DV360",
                    "displayName": "Below the fold",
                    "mappingDetails": []
                },
                {
                    "id": 289,
                    "name": "23",
                    "platformId": 5,
                    "isActive": 1,
                    "platformName": "DV360",
                    "displayName": "Unknown",
                    "mappingDetails": []
                }
            ]
        },
        {
            "id": 42,
            "name": "OnScreen_Position_DV360_Content_Position_Display",
            "platformId": 5,
            "isActive": 1,
            "platformName": "DV360",
            "displayName": "OnScreen Position : Display Content Position",
            "mappingDetails": [],
            "mappedPlatformsValueSet": [],
            "mappedPlatformsIdSet": [],
            "list": [
                {
                    "id": 291,
                    "name": "CONTENT_OUTSTREAM_POSITION_IN_ARTICLE",
                    "platformId": 5,
                    "isActive": 1,
                    "platformName": "DV360",
                    "displayName": "In article",
                    "mappingDetails": []
                },
                {
                    "id": 293,
                    "name": "CONTENT_OUTSTREAM_POSITION_IN_FEED",
                    "platformId": 5,
                    "isActive": 1,
                    "platformName": "DV360",
                    "displayName": "In feed",
                    "mappingDetails": []
                },
                {
                    "id": 295,
                    "name": "CONTENT_OUTSTREAM_POSITION_INTERSTITIAL",
                    "platformId": 5,
                    "isActive": 1,
                    "platformName": "DV360",
                    "displayName": "Interstetial",
                    "mappingDetails": []
                },
                {
                    "id": 297,
                    "name": "CONTENT_OUTSTREAM_POSITION_IN_BANNER",
                    "platformId": 5,
                    "isActive": 1,
                    "platformName": "DV360",
                    "displayName": "In banner",
                    "mappingDetails": []
                },
                {
                    "id": 299,
                    "name": "CONTENT_OUTSTREAM_POSITION_UNKNOWN",
                    "platformId": 5,
                    "isActive": 1,
                    "platformName": "DV360",
                    "displayName": "Unknown",
                    "mappingDetails": []
                }
            ]
        },
        {
            "id": 43,
            "name": "OnScreen_Position_DV360_Conent_Position_Video_InStream",
            "platformId": 5,
            "isActive": 1,
            "platformName": "DV360",
            "displayName": "OnScreen Position : Video Conent Position InStream",
            "mappingDetails": [],
            "mappedPlatformsValueSet": [],
            "mappedPlatformsIdSet": [],
            "list": [
                {
                    "id": 301,
                    "name": "CONTENT_INSTREAM_POSITION_PRE_ROLL",
                    "platformId": 5,
                    "isActive": 1,
                    "platformName": "DV360",
                    "displayName": "Pre roll",
                    "mappingDetails": []
                },
                {
                    "id": 303,
                    "name": "CONTENT_INSTREAM_POSITION_POST_ROLL",
                    "platformId": 5,
                    "isActive": 1,
                    "platformName": "DV360",
                    "displayName": "Post roll",
                    "mappingDetails": []
                },
                {
                    "id": 305,
                    "name": "CONTENT_INSTREAM_POSITION_MID_ROLL",
                    "platformId": 5,
                    "isActive": 1,
                    "platformName": "DV360",
                    "displayName": "Mid roll",
                    "mappingDetails": []
                }
            ]
        },
        {
            "id": 44,
            "name": "OnScreen_Position_DV360_Conent_Position_Video_OutStream",
            "platformId": 5,
            "isActive": 1,
            "platformName": "DV360",
            "displayName": "OnScreen Position : Video OutStream Conent Position ",
            "mappingDetails": [],
            "mappedPlatformsValueSet": [],
            "mappedPlatformsIdSet": [],
            "list": [
                {
                    "id": 307,
                    "name": "CONTENT_OUTSTREAM_POSITION_IN_ARTICLE",
                    "platformId": 5,
                    "isActive": 1,
                    "platformName": "DV360",
                    "displayName": "In article",
                    "mappingDetails": []
                },
                {
                    "id": 309,
                    "name": "CONTENT_OUTSTREAM_POSITION_IN_FEED",
                    "platformId": 5,
                    "isActive": 1,
                    "platformName": "DV360",
                    "displayName": "In feed",
                    "mappingDetails": []
                },
                {
                    "id": 311,
                    "name": "CONTENT_OUTSTREAM_POSITION_INTERSTITIAL",
                    "platformId": 5,
                    "isActive": 1,
                    "platformName": "DV360",
                    "displayName": "Interstitial",
                    "mappingDetails": []
                },
                {
                    "id": 313,
                    "name": "CONTENT_OUTSTREAM_POSITION_IN_BANNER",
                    "platformId": 5,
                    "isActive": 1,
                    "platformName": "DV360",
                    "displayName": "In banner",
                    "mappingDetails": []
                },
                {
                    "id": 315,
                    "name": "CONTENT_OUTSTREAM_POSITION_UNKNOWN",
                    "platformId": 5,
                    "isActive": 1,
                    "platformName": "DV360",
                    "displayName": "Unknown",
                    "mappingDetails": []
                }
            ]
        },
        {
            "id": 45,
            "name": "Tracker_Event_Image",
            "platformId": 1,
            "isActive": 1,
            "platformName": "Beki",
            "displayName": "Tracker Event : Image",
            "mappingDetails": [
                {
                    "id": 46,
                    "name": "Tracker_Event_Image",
                    "platformId": 5,
                    "isActive": 1,
                    "platformName": "DV360",
                    "displayName": ""
                }
            ],
            "mappedPlatformsValueSet": [
                "DV360"
            ],
            "mappedPlatformsIdSet": [
                5
            ],
            "list": [
                {
                    "id": 317,
                    "name": "Click",
                    "platformId": 1,
                    "isActive": 1,
                    "platformName": "Beki",
                    "displayName": "Click",
                    "mappingDetails": []
                }
            ]
        },
        {
            "id": 46,
            "name": "Tracker_Event_Image",
            "platformId": 5,
            "isActive": 1,
            "platformName": "DV360",
            "displayName": "",
            "attributeMapping": 45,
            "mappingDetails": [
                {
                    "id": 45,
                    "name": "Tracker_Event_Image",
                    "platformId": 1,
                    "isActive": 1,
                    "platformName": "Beki",
                    "displayName": "Tracker Event : Image"
                }
            ],
            "mappedPlatformsValueSet": [],
            "mappedPlatformsIdSet": [],
            "list": [
                {
                    "id": 319,
                    "name": "Impression",
                    "platformId": 5,
                    "isActive": 1,
                    "platformName": "DV360",
                    "displayName": "Impression",
                    "mappingDetails": []
                },
                {
                    "id": 321,
                    "name": "Click",
                    "platformId": 5,
                    "isActive": 1,
                    "platformName": "DV360",
                    "displayName": "Click",
                    "mappingDetails": []
                }
            ]
        },
        {
            "id": 47,
            "name": "Tracker_Event_Video",
            "platformId": 1,
            "isActive": 1,
            "platformName": "Beki",
            "displayName": "Tracker Even : Video",
            "mappingDetails": [
                {
                    "id": 48,
                    "name": "Tracker_Event_Video",
                    "platformId": 5,
                    "isActive": 1,
                    "platformName": "DV360",
                    "displayName": "Tracker Event Video"
                }
            ],
            "mappedPlatformsValueSet": [
                "DV360"
            ],
            "mappedPlatformsIdSet": [
                5
            ],
            "list": [
                {
                    "id": 323,
                    "name": "Start",
                    "platformId": 1,
                    "isActive": 1,
                    "platformName": "Beki",
                    "displayName": "Start",
                    "mappingDetails": []
                }
            ]
        },
        {
            "id": 48,
            "name": "Tracker_Event_Video",
            "platformId": 5,
            "isActive": 1,
            "platformName": "DV360",
            "displayName": "Tracker Event Video",
            "attributeMapping": 47,
            "mappingDetails": [
                {
                    "id": 47,
                    "name": "Tracker_Event_Video",
                    "platformId": 1,
                    "isActive": 1,
                    "platformName": "Beki",
                    "displayName": "Tracker Even : Video"
                }
            ],
            "mappedPlatformsValueSet": [],
            "mappedPlatformsIdSet": [],
            "list": [
                {
                    "id": 325,
                    "name": "THIRD_PARTY_URL_TYPE_IMPRESSION",
                    "platformId": 5,
                    "isActive": 1,
                    "platformName": "DV360",
                    "displayName": "Third Party Url Type : Impression",
                    "mappingDetails": []
                },
                {
                    "id": 327,
                    "name": "THIRD_PARTY_URL_TYPE_CLICK_TRACKING",
                    "platformId": 5,
                    "isActive": 1,
                    "platformName": "DV360",
                    "displayName": "Third Party Url Type :  Click Tracking",
                    "mappingDetails": []
                },
                {
                    "id": 329,
                    "name": "THIRD_PARTY_URL_TYPE_AUDIO_VIDEO_START",
                    "platformId": 5,
                    "isActive": 1,
                    "platformName": "DV360",
                    "displayName": "Third Party URL Type : Audio Video Start",
                    "mappingDetails": []
                },
                {
                    "id": 331,
                    "name": "THIRD_PARTY_URL_TYPE_AUDIO_VIDEO_FIRST_QUARTILE",
                    "platformId": 5,
                    "isActive": 1,
                    "platformName": "DV360",
                    "displayName": "Third Party URL Type : Audio Video First Quartile",
                    "mappingDetails": []
                },
                {
                    "id": 333,
                    "name": "THIRD_PARTY_URL_TYPE_AUDIO_VIDEO_MIDPOINT",
                    "platformId": 5,
                    "isActive": 1,
                    "platformName": "DV360",
                    "displayName": "Third Party URL Type : Audio Video Midpoint",
                    "mappingDetails": []
                },
                {
                    "id": 335,
                    "name": "THIRD_PARTY_URL_TYPE_AUDIO_VIDEO_THIRD_QUARTILE",
                    "platformId": 5,
                    "isActive": 1,
                    "platformName": "DV360",
                    "displayName": "Third Party URL Type : Audio Video Third Quartile",
                    "mappingDetails": []
                },
                {
                    "id": 337,
                    "name": "THIRD_PARTY_URL_TYPE_AUDIO_VIDEO_COMPLETE",
                    "platformId": 5,
                    "isActive": 1,
                    "platformName": "DV360",
                    "displayName": "Third Party URL Type : Audio Video Complete",
                    "mappingDetails": []
                },
                {
                    "id": 339,
                    "name": "THIRD_PARTY_URL_TYPE_AUDIO_VIDEO_REWIND",
                    "platformId": 5,
                    "isActive": 1,
                    "platformName": "DV360",
                    "displayName": "Third Party URL Type : Audio Video Rewind",
                    "mappingDetails": []
                },
                {
                    "id": 341,
                    "name": "THIRD_PARTY_URL_TYPE_AUDIO_VIDEO_SKIP",
                    "platformId": 5,
                    "isActive": 1,
                    "platformName": "DV360",
                    "displayName": "Third Party URL Type : Audio Video Skip",
                    "mappingDetails": []
                }
            ]
        },
        {
            "id": 49,
            "name": "Tracker_Type_Image",
            "platformId": 1,
            "isActive": 1,
            "platformName": "Beki",
            "displayName": "Tracker Type : Image",
            "mappingDetails": [
                {
                    "id": 50,
                    "name": "Tracker_Type_Image",
                    "platformId": 5,
                    "isActive": 1,
                    "platformName": "DV360",
                    "displayName": "Tracker Type : Image"
                }
            ],
            "mappedPlatformsValueSet": [
                "DV360"
            ],
            "mappedPlatformsIdSet": [
                5
            ],
            "list": [
                {
                    "id": 343,
                    "name": "Image_tag",
                    "platformId": 1,
                    "isActive": 1,
                    "platformName": "Beki",
                    "displayName": "Image Tag",
                    "mappingDetails": [
                        {
                            "id": 3033,
                            "name": "Image",
                            "platformId": 8,
                            "isActive": 1,
                            "platformName": "ViAds",
                            "displayName": "Image",
                            "dbMappingId": 945
                        }
                    ]
                }
            ]
        },
        {
            "id": 50,
            "name": "Tracker_Type_Image",
            "platformId": 5,
            "isActive": 1,
            "platformName": "DV360",
            "displayName": "Tracker Type : Image",
            "attributeMapping": 49,
            "mappingDetails": [
                {
                    "id": 49,
                    "name": "Tracker_Type_Image",
                    "platformId": 1,
                    "isActive": 1,
                    "platformName": "Beki",
                    "displayName": "Tracker Type : Image"
                }
            ],
            "mappedPlatformsValueSet": [],
            "mappedPlatformsIdSet": [],
            "list": [
                {
                    "id": 345,
                    "name": "Image Tag",
                    "platformId": 5,
                    "isActive": 1,
                    "platformName": "DV360",
                    "displayName": "Image Tag",
                    "mappingDetails": []
                }
            ]
        },
        {
            "id": 51,
            "name": "Tracker_Type_Video",
            "platformId": 1,
            "isActive": 1,
            "platformName": "Beki",
            "displayName": "Tracker Type : Video",
            "mappingDetails": [
                {
                    "id": 52,
                    "name": "Tracker_Type_Video",
                    "platformId": 5,
                    "isActive": 1,
                    "platformName": "DV360",
                    "displayName": "Tracker Type : Video"
                }
            ],
            "mappedPlatformsValueSet": [
                "DV360"
            ],
            "mappedPlatformsIdSet": [
                5
            ],
            "list": [
                {
                    "id": 347,
                    "name": "URL",
                    "platformId": 1,
                    "isActive": 1,
                    "platformName": "Beki",
                    "displayName": "URL",
                    "mappingDetails": []
                }
            ]
        },
        {
            "id": 52,
            "name": "Tracker_Type_Video",
            "platformId": 5,
            "isActive": 1,
            "platformName": "DV360",
            "displayName": "Tracker Type : Video",
            "attributeMapping": 51,
            "mappingDetails": [
                {
                    "id": 51,
                    "name": "Tracker_Type_Video",
                    "platformId": 1,
                    "isActive": 1,
                    "platformName": "Beki",
                    "displayName": "Tracker Type : Video"
                }
            ],
            "mappedPlatformsValueSet": [],
            "mappedPlatformsIdSet": [],
            "list": [
                {
                    "id": 349,
                    "name": "URL",
                    "platformId": 5,
                    "isActive": 1,
                    "platformName": "DV360",
                    "displayName": "URL",
                    "mappingDetails": []
                }
            ]
        },
        {
            "id": 53,
            "name": "Business_Type",
            "platformId": 1,
            "isActive": 1,
            "platformName": "Beki",
            "displayName": "Business Type",
            "mappingDetails": [],
            "mappedPlatformsValueSet": [],
            "mappedPlatformsIdSet": [],
            "list": [
                {
                    "id": 351,
                    "name": "B2B(Agency)",
                    "platformId": 1,
                    "isActive": 1,
                    "platformName": "Beki",
                    "displayName": "Business to Business : Agency",
                    "mappingDetails": []
                },
                {
                    "id": 353,
                    "name": "B2C(Advertiser)",
                    "platformId": 1,
                    "isActive": 1,
                    "platformName": "Beki",
                    "displayName": "Business to Customer : Advertiser",
                    "mappingDetails": []
                }
            ]
        },
        {
            "id": 54,
            "name": "Objective",
            "platformId": 1,
            "isActive": 1,
            "platformName": "Beki",
            "displayName": "Objective",
            "mappingDetails": [],
            "mappedPlatformsValueSet": [],
            "mappedPlatformsIdSet": [],
            "list": [
                {
                    "id": 355,
                    "name": "Awareness (CPM)",
                    "platformId": 1,
                    "isActive": 1,
                    "platformName": "Beki",
                    "displayName": "Awareness (CPM)",
                    "mappingDetails": []
                },
                {
                    "id": 357,
                    "name": "Traffic (CPC)",
                    "platformId": 1,
                    "isActive": 1,
                    "platformName": "Beki",
                    "displayName": "Traffic (CPC)",
                    "mappingDetails": []
                },
                {
                    "id": 359,
                    "name": "Engagement (CPC)",
                    "platformId": 1,
                    "isActive": 1,
                    "platformName": "Beki",
                    "displayName": "Engagement (CPC)",
                    "mappingDetails": []
                },
                {
                    "id": 361,
                    "name": "Sales (CPA)",
                    "platformId": 1,
                    "isActive": 1,
                    "platformName": "Beki",
                    "displayName": "Sales (CPA)",
                    "mappingDetails": []
                },
                {
                    "id": 363,
                    "name": "Leads (CPL)",
                    "platformId": 1,
                    "isActive": 1,
                    "platformName": "Beki",
                    "displayName": "Leads (CPL)",
                    "mappingDetails": []
                }
            ]
        },
        {
            "id": 55,
            "name": "Onscreen_Type",
            "platformId": 1,
            "isActive": 1,
            "platformName": "Beki",
            "displayName": "Onscreen Type",
            "mappingDetails": [
                {
                    "id": 56,
                    "name": "Onscreen_Type",
                    "platformId": 3,
                    "isActive": 1,
                    "platformName": "Meta",
                    "displayName": "Onscreen Type"
                },
                {
                    "id": 57,
                    "name": "Onscreen_Type",
                    "platformId": 5,
                    "isActive": 1,
                    "platformName": "DV360",
                    "displayName": "Onscreen Type"
                }
            ],
            "mappedPlatformsValueSet": [
                "Meta",
                "DV360"
            ],
            "mappedPlatformsIdSet": [
                3,
                5
            ],
            "list": [
                {
                    "id": 365,
                    "name": "Display",
                    "platformId": 1,
                    "isActive": 1,
                    "platformName": "Beki",
                    "displayName": "Display",
                    "mappingDetails": []
                }
            ]
        },
        {
            "id": 56,
            "name": "Onscreen_Type",
            "platformId": 3,
            "isActive": 1,
            "platformName": "Meta",
            "displayName": "Onscreen Type",
            "attributeMapping": 55,
            "mappingDetails": [
                {
                    "id": 55,
                    "name": "Onscreen_Type",
                    "platformId": 1,
                    "isActive": 1,
                    "platformName": "Beki",
                    "displayName": "Onscreen Type"
                }
            ],
            "mappedPlatformsValueSet": [],
            "mappedPlatformsIdSet": [],
            "list": [
                {
                    "id": 367,
                    "name": "Automatic",
                    "platformId": 3,
                    "isActive": 1,
                    "platformName": "Meta",
                    "displayName": "Automatic",
                    "mappingDetails": []
                },
                {
                    "id": 369,
                    "name": "Manual",
                    "platformId": 3,
                    "isActive": 1,
                    "platformName": "Meta",
                    "displayName": "Manual",
                    "mappingDetails": []
                }
            ]
        },
        {
            "id": 57,
            "name": "Onscreen_Type",
            "platformId": 5,
            "isActive": 1,
            "platformName": "DV360",
            "displayName": "Onscreen Type",
            "attributeMapping": 55,
            "mappingDetails": [
                {
                    "id": 55,
                    "name": "Onscreen_Type",
                    "platformId": 1,
                    "isActive": 1,
                    "platformName": "Beki",
                    "displayName": "Onscreen Type"
                }
            ],
            "mappedPlatformsValueSet": [],
            "mappedPlatformsIdSet": [],
            "list": [
                {
                    "id": 371,
                    "name": "Positon on Screen",
                    "platformId": 5,
                    "isActive": 1,
                    "platformName": "DV360",
                    "displayName": "Positon on Screen",
                    "mappingDetails": []
                },
                {
                    "id": 373,
                    "name": "Position in Content",
                    "platformId": 5,
                    "isActive": 1,
                    "platformName": "DV360",
                    "displayName": "Position in Content",
                    "mappingDetails": []
                }
            ]
        },
        {
            "id": 64,
            "name": "Bidding_Strategy_Search",
            "platformId": 1,
            "isActive": 1,
            "platformName": "Beki",
            "displayName": "Bidding Strategy Search",
            "mappingDetails": [
                {
                    "id": 69,
                    "name": "Bidding_Strategy_Search",
                    "platformId": 4,
                    "isActive": 1,
                    "platformName": "Google Ads",
                    "displayName": "Bidding_Strategy_Search"
                }
            ],
            "mappedPlatformsValueSet": [
                "Google Ads"
            ],
            "mappedPlatformsIdSet": [
                4
            ],
            "list": [
                {
                    "id": 1767,
                    "name": "Maximize Click",
                    "platformId": 1,
                    "isActive": 1,
                    "platformName": "Beki",
                    "displayName": "Maximize Click",
                    "mappingDetails": [
                        {
                            "id": 1795,
                            "name": "Maximize click",
                            "platformId": 4,
                            "isActive": 1,
                            "platformName": "Google Ads",
                            "displayName": "Maximize click",
                            "dbMappingId": 552
                        }
                    ]
                },
                {
                    "id": 1769,
                    "name": "Manual CPC",
                    "platformId": 1,
                    "isActive": 1,
                    "platformName": "Beki",
                    "displayName": "Manual CPC",
                    "mappingDetails": [
                        {
                            "id": 1797,
                            "name": "Manual CPC",
                            "platformId": 4,
                            "isActive": 1,
                            "platformName": "Google Ads",
                            "displayName": "Manual CPC",
                            "dbMappingId": 553
                        }
                    ]
                }
            ]
        },
        {
            "id": 65,
            "name": "Bidding_Strategy_Display",
            "platformId": 1,
            "isActive": 1,
            "platformName": "Beki",
            "displayName": "Bidding_Strategy_Display",
            "mappingDetails": [
                {
                    "id": 67,
                    "name": "Bidding_Strategy_Display",
                    "platformId": 3,
                    "isActive": 1,
                    "platformName": "Meta",
                    "displayName": "Bidding_Strategy_Display"
                },
                {
                    "id": 31,
                    "name": "Bidding_Strategy_Display",
                    "platformId": 4,
                    "isActive": 1,
                    "platformName": "Google Ads",
                    "displayName": "Bidding Strategy Display"
                },
                {
                    "id": 70,
                    "name": "Bidding_Strategy_Display",
                    "platformId": 5,
                    "isActive": 1,
                    "platformName": "DV360",
                    "displayName": "Bidding_Strategy_Display"
                },
                {
                    "id": 101,
                    "name": "Bidding_Strategy_Display",
                    "platformId": 8,
                    "isActive": 1,
                    "platformName": "ViAds",
                    "displayName": "",
                    "description": ""
                }
            ],
            "mappedPlatformsValueSet": [
                "Google Ads",
                "Meta",
                "ViAds",
                "DV360"
            ],
            "mappedPlatformsIdSet": [
                3,
                4,
                5,
                8
            ],
            "list": [
                {
                    "id": 1771,
                    "name": "CPM",
                    "platformId": 1,
                    "isActive": 1,
                    "platformName": "Beki",
                    "displayName": "CPM",
                    "mappingDetails": [
                        {
                            "id": 1785,
                            "name": "IMPRESSIONS",
                            "platformId": 3,
                            "isActive": 1,
                            "platformName": "Meta",
                            "displayName": "CPM",
                            "dbMappingId": 547
                        },
                        {
                            "id": 150,
                            "name": "Viewable CPM",
                            "platformId": 4,
                            "isActive": 1,
                            "platformName": "Google Ads",
                            "displayName": "Viewable CPM",
                            "dbMappingId": 554
                        },
                        {
                            "id": 1799,
                            "name": "CPM",
                            "platformId": 5,
                            "isActive": 1,
                            "platformName": "DV360",
                            "displayName": "CPM",
                            "dbMappingId": 557
                        },
                        {
                            "id": 3621,
                            "name": "89",
                            "platformId": 8,
                            "isActive": 1,
                            "platformName": "ViAds",
                            "displayName": "CPM",
                            "dbMappingId": 940
                        }
                    ]
                },
                {
                    "id": 1773,
                    "name": "Maximize Click",
                    "platformId": 1,
                    "isActive": 1,
                    "platformName": "Beki",
                    "displayName": "Maximize Click",
                    "mappingDetails": [
                        {
                            "id": 1783,
                            "name": "LINK_CLICKS",
                            "platformId": 3,
                            "isActive": 1,
                            "platformName": "Meta",
                            "displayName": "Maximize Click",
                            "dbMappingId": 546
                        },
                        {
                            "id": 146,
                            "name": "Maximize click",
                            "platformId": 4,
                            "isActive": 1,
                            "platformName": "Google Ads",
                            "displayName": "Maximize click",
                            "dbMappingId": 555
                        },
                        {
                            "id": 1801,
                            "name": "Maximize Clicks",
                            "platformId": 5,
                            "isActive": 1,
                            "platformName": "DV360",
                            "displayName": "Maximize Clicks",
                            "dbMappingId": 558
                        }
                    ]
                },
                {
                    "id": 1775,
                    "name": "Manual CPC",
                    "platformId": 1,
                    "isActive": 1,
                    "platformName": "Beki",
                    "displayName": "Manual CPC",
                    "mappingDetails": [
                        {
                            "id": 1787,
                            "name": "LINK_CLICKS",
                            "platformId": 3,
                            "isActive": 1,
                            "platformName": "Meta",
                            "displayName": "Manual CPC",
                            "dbMappingId": 548
                        },
                        {
                            "id": 148,
                            "name": "Manual CPC",
                            "platformId": 4,
                            "isActive": 1,
                            "platformName": "Google Ads",
                            "displayName": "Manual CPC",
                            "dbMappingId": 556
                        },
                        {
                            "id": 3619,
                            "name": "90",
                            "platformId": 8,
                            "isActive": 1,
                            "platformName": "ViAds",
                            "displayName": "CPC",
                            "dbMappingId": 939
                        }
                    ]
                }
            ]
        },
        {
            "id": 66,
            "name": "Bidding_Strategy_Video",
            "platformId": 1,
            "isActive": 1,
            "platformName": "Beki",
            "displayName": "Bidding_Strategy_Video",
            "mappingDetails": [
                {
                    "id": 68,
                    "name": "Bidding_Strategy_Video",
                    "platformId": 3,
                    "isActive": 1,
                    "platformName": "Meta",
                    "displayName": "Bidding_Strategy_Video"
                },
                {
                    "id": 71,
                    "name": "Bidding_Strategy_Video",
                    "platformId": 5,
                    "isActive": 1,
                    "platformName": "DV360",
                    "displayName": "Bidding_Strategy_Video"
                },
                {
                    "id": 100,
                    "name": "Bidding_Strategy_Video",
                    "platformId": 8,
                    "isActive": 1,
                    "platformName": "ViAds",
                    "displayName": "",
                    "description": ""
                },
                {
                    "id": 113,
                    "name": "Bidding_Strategy_Video",
                    "platformId": 4,
                    "isActive": 1,
                    "platformName": "Google Ads",
                    "displayName": "Bidding Strategy Video",
                    "description": ""
                }
            ],
            "mappedPlatformsValueSet": [
                "Google Ads",
                "Meta",
                "ViAds",
                "DV360"
            ],
            "mappedPlatformsIdSet": [
                3,
                4,
                5,
                8
            ],
            "list": [
                {
                    "id": 1777,
                    "name": "Manual CPC",
                    "platformId": 1,
                    "isActive": 1,
                    "platformName": "Beki",
                    "displayName": "Manual CPC",
                    "mappingDetails": [
                        {
                            "id": 1793,
                            "name": "LINK_CLICKS",
                            "platformId": 3,
                            "isActive": 1,
                            "platformName": "Meta",
                            "displayName": "Manual CPC",
                            "dbMappingId": 551
                        },
                        {
                            "id": 3615,
                            "name": "90",
                            "platformId": 8,
                            "isActive": 1,
                            "platformName": "ViAds",
                            "displayName": "CPC",
                            "dbMappingId": 941
                        }
                    ]
                },
                {
                    "id": 1779,
                    "name": "Maximize Click",
                    "platformId": 1,
                    "isActive": 1,
                    "platformName": "Beki",
                    "displayName": "Maximize Click",
                    "mappingDetails": [
                        {
                            "id": 1789,
                            "name": "LINK_CLICKS",
                            "platformId": 3,
                            "isActive": 1,
                            "platformName": "Meta",
                            "displayName": "Maximixe Click",
                            "dbMappingId": 549
                        },
                        {
                            "id": 1805,
                            "name": "Maximize Clicks",
                            "platformId": 5,
                            "isActive": 1,
                            "platformName": "DV360",
                            "displayName": "Maximize Clicks",
                            "dbMappingId": 560
                        },
                        {
                            "id": 4042,
                            "name": "TARGET_SPEND",
                            "platformId": 4,
                            "isActive": 1,
                            "platformName": "Google Ads",
                            "displayName": "Click",
                            "dbMappingId": 1132
                        }
                    ]
                },
                {
                    "id": 1781,
                    "name": "CPM",
                    "platformId": 1,
                    "isActive": 1,
                    "platformName": "Beki",
                    "displayName": "CPM",
                    "mappingDetails": [
                        {
                            "id": 1791,
                            "name": "IMPRESSIONS",
                            "platformId": 3,
                            "isActive": 1,
                            "platformName": "Meta",
                            "displayName": "CPM",
                            "dbMappingId": 550
                        },
                        {
                            "id": 1803,
                            "name": "CPM",
                            "platformId": 5,
                            "isActive": 1,
                            "platformName": "DV360",
                            "displayName": "CPM",
                            "dbMappingId": 559
                        },
                        {
                            "id": 3617,
                            "name": "89",
                            "platformId": 8,
                            "isActive": 1,
                            "platformName": "ViAds",
                            "displayName": "CPM",
                            "dbMappingId": 942
                        }
                    ]
                }
            ]
        },
        {
            "id": 67,
            "name": "Bidding_Strategy_Display",
            "platformId": 3,
            "isActive": 1,
            "platformName": "Meta",
            "displayName": "Bidding_Strategy_Display",
            "attributeMapping": 65,
            "mappingDetails": [
                {
                    "id": 65,
                    "name": "Bidding_Strategy_Display",
                    "platformId": 1,
                    "isActive": 1,
                    "platformName": "Beki",
                    "displayName": "Bidding_Strategy_Display"
                }
            ],
            "mappedPlatformsValueSet": [],
            "mappedPlatformsIdSet": [],
            "list": [
                {
                    "id": 1783,
                    "name": "LINK_CLICKS",
                    "platformId": 3,
                    "isActive": 1,
                    "platformName": "Meta",
                    "displayName": "Maximize Click",
                    "attributeMapping": 1773,
                    "mappingDetails": [
                        {
                            "id": 1773,
                            "name": "Maximize Click",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Maximize Click",
                            "dbMappingId": 546
                        }
                    ]
                },
                {
                    "id": 1785,
                    "name": "IMPRESSIONS",
                    "platformId": 3,
                    "isActive": 1,
                    "platformName": "Meta",
                    "displayName": "CPM",
                    "attributeMapping": 1771,
                    "mappingDetails": [
                        {
                            "id": 1771,
                            "name": "CPM",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "CPM",
                            "dbMappingId": 547
                        }
                    ]
                },
                {
                    "id": 1787,
                    "name": "LINK_CLICKS",
                    "platformId": 3,
                    "isActive": 1,
                    "platformName": "Meta",
                    "displayName": "Manual CPC",
                    "attributeMapping": 1775,
                    "mappingDetails": [
                        {
                            "id": 1775,
                            "name": "Manual CPC",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Manual CPC",
                            "dbMappingId": 548
                        }
                    ]
                }
            ]
        },
        {
            "id": 68,
            "name": "Bidding_Strategy_Video",
            "platformId": 3,
            "isActive": 1,
            "platformName": "Meta",
            "displayName": "Bidding_Strategy_Video",
            "attributeMapping": 66,
            "mappingDetails": [
                {
                    "id": 66,
                    "name": "Bidding_Strategy_Video",
                    "platformId": 1,
                    "isActive": 1,
                    "platformName": "Beki",
                    "displayName": "Bidding_Strategy_Video"
                }
            ],
            "mappedPlatformsValueSet": [],
            "mappedPlatformsIdSet": [],
            "list": [
                {
                    "id": 1789,
                    "name": "LINK_CLICKS",
                    "platformId": 3,
                    "isActive": 1,
                    "platformName": "Meta",
                    "displayName": "Maximixe Click",
                    "attributeMapping": 1779,
                    "mappingDetails": [
                        {
                            "id": 1779,
                            "name": "Maximize Click",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Maximize Click",
                            "dbMappingId": 549
                        }
                    ]
                },
                {
                    "id": 1791,
                    "name": "IMPRESSIONS",
                    "platformId": 3,
                    "isActive": 1,
                    "platformName": "Meta",
                    "displayName": "CPM",
                    "attributeMapping": 1781,
                    "mappingDetails": [
                        {
                            "id": 1781,
                            "name": "CPM",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "CPM",
                            "dbMappingId": 550
                        }
                    ]
                },
                {
                    "id": 1793,
                    "name": "LINK_CLICKS",
                    "platformId": 3,
                    "isActive": 1,
                    "platformName": "Meta",
                    "displayName": "Manual CPC",
                    "attributeMapping": 1777,
                    "mappingDetails": [
                        {
                            "id": 1777,
                            "name": "Manual CPC",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Manual CPC",
                            "dbMappingId": 551
                        }
                    ]
                }
            ]
        },
        {
            "id": 69,
            "name": "Bidding_Strategy_Search",
            "platformId": 4,
            "isActive": 1,
            "platformName": "Google Ads",
            "displayName": "Bidding_Strategy_Search",
            "attributeMapping": 64,
            "mappingDetails": [
                {
                    "id": 64,
                    "name": "Bidding_Strategy_Search",
                    "platformId": 1,
                    "isActive": 1,
                    "platformName": "Beki",
                    "displayName": "Bidding Strategy Search"
                }
            ],
            "mappedPlatformsValueSet": [],
            "mappedPlatformsIdSet": [],
            "list": [
                {
                    "id": 1795,
                    "name": "Maximize click",
                    "platformId": 4,
                    "isActive": 1,
                    "platformName": "Google Ads",
                    "displayName": "Maximize click",
                    "attributeMapping": 1767,
                    "mappingDetails": [
                        {
                            "id": 1767,
                            "name": "Maximize Click",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Maximize Click",
                            "dbMappingId": 552
                        }
                    ]
                },
                {
                    "id": 1797,
                    "name": "Manual CPC",
                    "platformId": 4,
                    "isActive": 1,
                    "platformName": "Google Ads",
                    "displayName": "Manual CPC",
                    "attributeMapping": 1769,
                    "mappingDetails": [
                        {
                            "id": 1769,
                            "name": "Manual CPC",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Manual CPC",
                            "dbMappingId": 553
                        }
                    ]
                }
            ]
        },
        {
            "id": 70,
            "name": "Bidding_Strategy_Display",
            "platformId": 5,
            "isActive": 1,
            "platformName": "DV360",
            "displayName": "Bidding_Strategy_Display",
            "attributeMapping": 65,
            "mappingDetails": [
                {
                    "id": 65,
                    "name": "Bidding_Strategy_Display",
                    "platformId": 1,
                    "isActive": 1,
                    "platformName": "Beki",
                    "displayName": "Bidding_Strategy_Display"
                }
            ],
            "mappedPlatformsValueSet": [],
            "mappedPlatformsIdSet": [],
            "list": [
                {
                    "id": 1799,
                    "name": "CPM",
                    "platformId": 5,
                    "isActive": 1,
                    "platformName": "DV360",
                    "displayName": "CPM",
                    "attributeMapping": 1771,
                    "mappingDetails": [
                        {
                            "id": 1771,
                            "name": "CPM",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "CPM",
                            "dbMappingId": 557
                        }
                    ]
                },
                {
                    "id": 1801,
                    "name": "Maximize Clicks",
                    "platformId": 5,
                    "isActive": 1,
                    "platformName": "DV360",
                    "displayName": "Maximize Clicks",
                    "attributeMapping": 1773,
                    "mappingDetails": [
                        {
                            "id": 1773,
                            "name": "Maximize Click",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Maximize Click",
                            "dbMappingId": 558
                        }
                    ]
                }
            ]
        },
        {
            "id": 71,
            "name": "Bidding_Strategy_Video",
            "platformId": 5,
            "isActive": 1,
            "platformName": "DV360",
            "displayName": "Bidding_Strategy_Video",
            "attributeMapping": 66,
            "mappingDetails": [
                {
                    "id": 66,
                    "name": "Bidding_Strategy_Video",
                    "platformId": 1,
                    "isActive": 1,
                    "platformName": "Beki",
                    "displayName": "Bidding_Strategy_Video"
                }
            ],
            "mappedPlatformsValueSet": [],
            "mappedPlatformsIdSet": [],
            "list": [
                {
                    "id": 1803,
                    "name": "CPM",
                    "platformId": 5,
                    "isActive": 1,
                    "platformName": "DV360",
                    "displayName": "CPM",
                    "attributeMapping": 1781,
                    "mappingDetails": [
                        {
                            "id": 1781,
                            "name": "CPM",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "CPM",
                            "dbMappingId": 559
                        }
                    ]
                },
                {
                    "id": 1805,
                    "name": "Maximize Clicks",
                    "platformId": 5,
                    "isActive": 1,
                    "platformName": "DV360",
                    "displayName": "Maximize Clicks",
                    "attributeMapping": 1779,
                    "mappingDetails": [
                        {
                            "id": 1779,
                            "name": "Maximize Click",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Maximize Click",
                            "dbMappingId": 560
                        }
                    ]
                }
            ]
        },
        {
            "id": 72,
            "name": "TIMEZONE",
            "platformId": 3,
            "isActive": 1,
            "platformName": "Meta",
            "displayName": "Timezone",
            "mappingDetails": [],
            "mappedPlatformsValueSet": [],
            "mappedPlatformsIdSet": [],
            "list": [
                {
                    "id": 1813,
                    "name": "+5:30",
                    "platformId": 3,
                    "isActive": 1,
                    "platformName": "Meta",
                    "displayName": "Asia/Kolkata",
                    "mappingDetails": []
                }
            ]
        },
        {
            "id": 73,
            "name": "TIMEZONE",
            "platformId": 4,
            "isActive": 1,
            "platformName": "Google Ads",
            "displayName": "Timezone",
            "mappingDetails": [],
            "mappedPlatformsValueSet": [],
            "mappedPlatformsIdSet": [],
            "list": [
                {
                    "id": 1815,
                    "name": "+5:30",
                    "platformId": 4,
                    "isActive": 1,
                    "platformName": "Google Ads",
                    "displayName": "Asia/Kolkata",
                    "mappingDetails": []
                },
                {
                    "id": 2980,
                    "name": "-03:00",
                    "platformId": 4,
                    "isActive": 1,
                    "platformName": "Google Ads",
                    "displayName": "America/Sao_Paulo",
                    "mappingDetails": []
                }
            ]
        },
        {
            "id": 74,
            "name": "TIMEZONE",
            "platformId": 5,
            "isActive": 1,
            "platformName": "DV360",
            "displayName": "Timezone",
            "mappingDetails": [],
            "mappedPlatformsValueSet": [],
            "mappedPlatformsIdSet": [],
            "list": [
                {
                    "id": 1817,
                    "name": "+8:00",
                    "platformId": 5,
                    "isActive": 1,
                    "platformName": "DV360",
                    "displayName": "Asia/Hong_Kong",
                    "mappingDetails": []
                }
            ]
        },
        {
            "id": 75,
            "name": "PLAN_DURATION_TYPE",
            "platformId": 1,
            "isActive": 1,
            "platformName": "Beki",
            "displayName": "PLAN_DURATION_TYPE",
            "mappingDetails": [],
            "mappedPlatformsValueSet": [],
            "mappedPlatformsIdSet": [],
            "list": [
                {
                    "id": 1819,
                    "name": "Monthly",
                    "platformId": 1,
                    "isActive": 1,
                    "platformName": "Beki",
                    "mappingDetails": []
                },
                {
                    "id": 1820,
                    "name": "Quarterly",
                    "platformId": 1,
                    "isActive": 1,
                    "platformName": "Beki",
                    "mappingDetails": []
                }
            ]
        },
        {
            "id": 76,
            "name": "Creative Type",
            "platformId": 1,
            "isActive": 1,
            "platformName": "Beki",
            "displayName": "Creative Type",
            "mappingDetails": [],
            "mappedPlatformsValueSet": [],
            "mappedPlatformsIdSet": [],
            "list": [
                {
                    "id": 1821,
                    "name": "Jpeg",
                    "platformId": 1,
                    "isActive": 1,
                    "platformName": "Beki",
                    "mappingDetails": []
                }
            ]
        },
        {
            "id": 77,
            "name": "SCREEN_MODULES",
            "platformId": 1,
            "isActive": 1,
            "platformName": "Beki",
            "displayName": "SCREEN_MODULES",
            "mappingDetails": [],
            "mappedPlatformsValueSet": [],
            "mappedPlatformsIdSet": [],
            "list": [
                {
                    "id": 1822,
                    "name": "Campaign",
                    "platformId": 1,
                    "isActive": 1,
                    "platformName": "Beki",
                    "mappingDetails": []
                },
                {
                    "id": 1823,
                    "name": "Mandate",
                    "platformId": 1,
                    "isActive": 1,
                    "platformName": "Beki",
                    "mappingDetails": []
                },
                {
                    "id": 1824,
                    "name": "Creative",
                    "platformId": 1,
                    "isActive": 1,
                    "platformName": "Beki",
                    "mappingDetails": []
                },
                {
                    "id": 1825,
                    "name": "Connection Mgt",
                    "platformId": 1,
                    "isActive": 1,
                    "platformName": "Beki",
                    "mappingDetails": []
                }
            ]
        },
        {
            "id": 78,
            "name": "RECO_TYPE",
            "platformId": 1,
            "isActive": 1,
            "platformName": "Beki",
            "displayName": "RECO_TYPE",
            "mappingDetails": [],
            "mappedPlatformsValueSet": [],
            "mappedPlatformsIdSet": [],
            "list": [
                {
                    "id": 1826,
                    "name": "Domain Blacklist",
                    "platformId": 1,
                    "isActive": 1,
                    "platformName": "Beki",
                    "mappingDetails": []
                },
                {
                    "id": 1827,
                    "name": "Domain Whitelist",
                    "platformId": 1,
                    "isActive": 1,
                    "platformName": "Beki",
                    "mappingDetails": []
                },
                {
                    "id": 1828,
                    "name": "Optimizer",
                    "platformId": 1,
                    "isActive": 1,
                    "platformName": "Beki",
                    "mappingDetails": []
                },
                {
                    "id": 1829,
                    "name": "Bid Control",
                    "platformId": 1,
                    "isActive": 1,
                    "platformName": "Beki",
                    "mappingDetails": []
                },
                {
                    "id": 1830,
                    "name": "Generative AI",
                    "platformId": 1,
                    "isActive": 1,
                    "platformName": "Beki",
                    "mappingDetails": []
                }
            ]
        },
        {
            "id": 79,
            "name": "Language",
            "platformId": 1,
            "isActive": 1,
            "platformName": "Beki",
            "displayName": "Language",
            "mappingDetails": [
                {
                    "id": 80,
                    "name": "Language",
                    "platformId": 4,
                    "isActive": 1,
                    "platformName": "Google Ads",
                    "displayName": "Language"
                },
                {
                    "id": 81,
                    "name": "Language",
                    "platformId": 3,
                    "isActive": 1,
                    "platformName": "Meta",
                    "displayName": "Language"
                },
                {
                    "id": 82,
                    "name": "Language",
                    "platformId": 2,
                    "isActive": 1,
                    "platformName": "ION",
                    "displayName": "Language"
                },
                {
                    "id": 83,
                    "name": "Language",
                    "platformId": 7,
                    "isActive": 1,
                    "platformName": "TikTok",
                    "displayName": "Language"
                },
                {
                    "id": 102,
                    "name": "Language",
                    "platformId": 8,
                    "isActive": 1,
                    "platformName": "ViAds",
                    "displayName": "Language"
                }
            ],
            "mappedPlatformsValueSet": [
                "Google Ads",
                "Meta",
                "ViAds",
                "ION",
                "TikTok"
            ],
            "mappedPlatformsIdSet": [
                2,
                3,
                4,
                7,
                8
            ],
            "list": [
                {
                    "id": 1831,
                    "name": "Komi",
                    "platformId": 1,
                    "isActive": 1,
                    "platformName": "Beki",
                    "displayName": "Komi",
                    "mappingDetails": [
                        {
                            "id": 1833,
                            "name": "1248",
                            "platformId": 2,
                            "isActive": 1,
                            "platformName": "ION",
                            "displayName": "Komi",
                            "dbMappingId": 564
                        },
                        {
                            "id": 3627,
                            "name": "614",
                            "platformId": 8,
                            "isActive": 1,
                            "platformName": "ViAds",
                            "displayName": "Komi",
                            "dbMappingId": 948
                        }
                    ]
                },
                {
                    "id": 1835,
                    "name": "Lingala",
                    "platformId": 1,
                    "isActive": 1,
                    "platformName": "Beki",
                    "displayName": "Lingala",
                    "mappingDetails": [
                        {
                            "id": 1837,
                            "name": "1257",
                            "platformId": 2,
                            "isActive": 1,
                            "platformName": "ION",
                            "displayName": "Lingala",
                            "dbMappingId": 565
                        },
                        {
                            "id": 3629,
                            "name": "623",
                            "platformId": 8,
                            "isActive": 1,
                            "platformName": "ViAds",
                            "displayName": "Lingala",
                            "dbMappingId": 949
                        }
                    ]
                },
                {
                    "id": 1839,
                    "name": "Bashkir",
                    "platformId": 1,
                    "isActive": 1,
                    "platformName": "Beki",
                    "displayName": "Bashkir",
                    "mappingDetails": [
                        {
                            "id": 1841,
                            "name": "1177",
                            "platformId": 2,
                            "isActive": 1,
                            "platformName": "ION",
                            "displayName": "Bashkir",
                            "dbMappingId": 566
                        },
                        {
                            "id": 3633,
                            "name": "543",
                            "platformId": 8,
                            "isActive": 1,
                            "platformName": "ViAds",
                            "displayName": "Bashkir",
                            "dbMappingId": 951
                        }
                    ]
                },
                {
                    "id": 1843,
                    "name": "Norwegian Nynorsk",
                    "platformId": 1,
                    "isActive": 1,
                    "platformName": "Beki",
                    "displayName": "Norwegian Nynorsk",
                    "mappingDetails": [
                        {
                            "id": 1845,
                            "name": "1279",
                            "platformId": 2,
                            "isActive": 1,
                            "platformName": "ION",
                            "displayName": "Norwegian Nynorsk",
                            "dbMappingId": 567
                        },
                        {
                            "id": 1847,
                            "name": "84",
                            "platformId": 3,
                            "isActive": 1,
                            "platformName": "Meta",
                            "displayName": "Norwegian Nynorsk",
                            "dbMappingId": 568
                        },
                        {
                            "id": 3635,
                            "name": "645",
                            "platformId": 8,
                            "isActive": 1,
                            "platformName": "ViAds",
                            "displayName": "Norwegian Nynorsk",
                            "dbMappingId": 952
                        }
                    ]
                },
                {
                    "id": 1849,
                    "name": "Abkhazian",
                    "platformId": 1,
                    "isActive": 1,
                    "platformName": "Beki",
                    "displayName": "Abkhazian",
                    "mappingDetails": [
                        {
                            "id": 1851,
                            "name": "1162",
                            "platformId": 2,
                            "isActive": 1,
                            "platformName": "ION",
                            "displayName": "Abkhazian",
                            "dbMappingId": 569
                        },
                        {
                            "id": 3637,
                            "name": "528",
                            "platformId": 8,
                            "isActive": 1,
                            "platformName": "ViAds",
                            "displayName": "Abkhazian",
                            "dbMappingId": 953
                        }
                    ]
                },
                {
                    "id": 1853,
                    "name": "Luba-Katanga",
                    "platformId": 1,
                    "isActive": 1,
                    "platformName": "Beki",
                    "displayName": "Luba-Katanga",
                    "mappingDetails": [
                        {
                            "id": 1855,
                            "name": "1259",
                            "platformId": 2,
                            "isActive": 1,
                            "platformName": "ION",
                            "displayName": "Luba-Katanga",
                            "dbMappingId": 570
                        },
                        {
                            "id": 3641,
                            "name": "625",
                            "platformId": 8,
                            "isActive": 1,
                            "platformName": "ViAds",
                            "displayName": "Luba-Katanga",
                            "dbMappingId": 955
                        }
                    ]
                },
                {
                    "id": 1857,
                    "name": "Zulu",
                    "platformId": 1,
                    "isActive": 1,
                    "platformName": "Beki",
                    "displayName": "Zulu",
                    "mappingDetails": [
                        {
                            "id": 1859,
                            "name": "1344",
                            "platformId": 2,
                            "isActive": 1,
                            "platformName": "ION",
                            "displayName": "Zulu",
                            "dbMappingId": 571
                        },
                        {
                            "id": 3643,
                            "name": "710",
                            "platformId": 8,
                            "isActive": 1,
                            "platformName": "ViAds",
                            "displayName": "Zulu",
                            "dbMappingId": 956
                        }
                    ]
                },
                {
                    "id": 1861,
                    "name": "Swedish",
                    "platformId": 1,
                    "isActive": 1,
                    "platformName": "Beki",
                    "displayName": "Swedish",
                    "mappingDetails": [
                        {
                            "id": 1863,
                            "name": "1314",
                            "platformId": 2,
                            "isActive": 1,
                            "platformName": "ION",
                            "displayName": "Swedish",
                            "dbMappingId": 572
                        },
                        {
                            "id": 1865,
                            "name": "18",
                            "platformId": 3,
                            "isActive": 1,
                            "platformName": "Meta",
                            "displayName": "Swedish",
                            "dbMappingId": 573
                        },
                        {
                            "id": 1867,
                            "name": "languageConstants/1015",
                            "platformId": 4,
                            "isActive": 1,
                            "platformName": "Google Ads",
                            "displayName": "Swedish",
                            "dbMappingId": 574
                        },
                        {
                            "id": 1869,
                            "name": "sv",
                            "platformId": 7,
                            "isActive": 1,
                            "platformName": "TikTok",
                            "displayName": "Swedish",
                            "dbMappingId": 575
                        },
                        {
                            "id": 3647,
                            "name": "680",
                            "platformId": 8,
                            "isActive": 1,
                            "platformName": "ViAds",
                            "displayName": "Swedish",
                            "dbMappingId": 958
                        }
                    ]
                },
                {
                    "id": 1871,
                    "name": "Turkish",
                    "platformId": 1,
                    "isActive": 1,
                    "platformName": "Beki",
                    "displayName": "Turkish",
                    "mappingDetails": [
                        {
                            "id": 1873,
                            "name": "1327",
                            "platformId": 2,
                            "isActive": 1,
                            "platformName": "ION",
                            "displayName": "Turkish",
                            "dbMappingId": 576
                        },
                        {
                            "id": 1875,
                            "name": "19",
                            "platformId": 3,
                            "isActive": 1,
                            "platformName": "Meta",
                            "displayName": "Turkish",
                            "dbMappingId": 577
                        },
                        {
                            "id": 1877,
                            "name": "languageConstants/1037",
                            "platformId": 4,
                            "isActive": 1,
                            "platformName": "Google Ads",
                            "displayName": "Turkish",
                            "dbMappingId": 578
                        },
                        {
                            "id": 1879,
                            "name": "tr",
                            "platformId": 7,
                            "isActive": 1,
                            "platformName": "TikTok",
                            "displayName": "Turkish",
                            "dbMappingId": 579
                        },
                        {
                            "id": 3649,
                            "name": "693",
                            "platformId": 8,
                            "isActive": 1,
                            "platformName": "ViAds",
                            "displayName": "Turkish",
                            "dbMappingId": 959
                        }
                    ]
                },
                {
                    "id": 1881,
                    "name": "Kannada",
                    "platformId": 1,
                    "isActive": 1,
                    "platformName": "Beki",
                    "displayName": "Kannada",
                    "mappingDetails": [
                        {
                            "id": 1883,
                            "name": "1240",
                            "platformId": 2,
                            "isActive": 1,
                            "platformName": "ION",
                            "displayName": "Kannada",
                            "dbMappingId": 580
                        },
                        {
                            "id": 1885,
                            "name": "75",
                            "platformId": 3,
                            "isActive": 1,
                            "platformName": "Meta",
                            "displayName": "Kannada",
                            "dbMappingId": 581
                        },
                        {
                            "id": 1887,
                            "name": "languageConstants/1086",
                            "platformId": 4,
                            "isActive": 1,
                            "platformName": "Google Ads",
                            "displayName": "Kannada",
                            "dbMappingId": 582
                        },
                        {
                            "id": 1889,
                            "name": "kn",
                            "platformId": 7,
                            "isActive": 1,
                            "platformName": "TikTok",
                            "displayName": "Kannada",
                            "dbMappingId": 583
                        },
                        {
                            "id": 3653,
                            "name": "606",
                            "platformId": 8,
                            "isActive": 1,
                            "platformName": "ViAds",
                            "displayName": "Kannada",
                            "dbMappingId": 961
                        }
                    ]
                },
                {
                    "id": 1891,
                    "name": "Sango",
                    "platformId": 1,
                    "isActive": 1,
                    "platformName": "Beki",
                    "displayName": "Sango",
                    "mappingDetails": [
                        {
                            "id": 1893,
                            "name": "1299",
                            "platformId": 2,
                            "isActive": 1,
                            "platformName": "ION",
                            "displayName": "Sango",
                            "dbMappingId": 584
                        },
                        {
                            "id": 3659,
                            "name": "665",
                            "platformId": 8,
                            "isActive": 1,
                            "platformName": "ViAds",
                            "displayName": "Sango",
                            "dbMappingId": 964
                        }
                    ]
                },
                {
                    "id": 1895,
                    "name": "Zhuang",
                    "platformId": 1,
                    "isActive": 1,
                    "platformName": "Beki",
                    "displayName": "Zhuang",
                    "mappingDetails": [
                        {
                            "id": 1897,
                            "name": "1343",
                            "platformId": 2,
                            "isActive": 1,
                            "platformName": "ION",
                            "displayName": "Zhuang",
                            "dbMappingId": 585
                        }
                    ]
                },
                {
                    "id": 1899,
                    "name": "French (France)",
                    "platformId": 1,
                    "isActive": 1,
                    "platformName": "Beki",
                    "displayName": "French (France)",
                    "mappingDetails": [
                        {
                            "id": 1901,
                            "name": "9",
                            "platformId": 3,
                            "isActive": 1,
                            "platformName": "Meta",
                            "displayName": "French (France)",
                            "dbMappingId": 586
                        }
                    ]
                },
                {
                    "id": 1903,
                    "name": "Catalan",
                    "platformId": 1,
                    "isActive": 1,
                    "platformName": "Beki",
                    "displayName": "Catalan",
                    "mappingDetails": [
                        {
                            "id": 1905,
                            "name": "1",
                            "platformId": 3,
                            "isActive": 1,
                            "platformName": "Meta",
                            "displayName": "Catalan",
                            "dbMappingId": 587
                        },
                        {
                            "id": 1907,
                            "name": "languageConstants/1038",
                            "platformId": 4,
                            "isActive": 1,
                            "platformName": "Google Ads",
                            "displayName": "Catalan",
                            "dbMappingId": 588
                        }
                    ]
                },
                {
                    "id": 1909,
                    "name": "Church Slavonic, Old Slavonic, Old Church Slavonic",
                    "platformId": 1,
                    "isActive": 1,
                    "platformName": "Beki",
                    "displayName": "Church Slavonic, Old Slavonic, Old Church Slavonic",
                    "mappingDetails": [
                        {
                            "id": 1911,
                            "name": "1191",
                            "platformId": 2,
                            "isActive": 1,
                            "platformName": "ION",
                            "displayName": "Church Slavonic, Old Slavonic, Old Church Slavonic",
                            "dbMappingId": 589
                        },
                        {
                            "id": 3667,
                            "name": "557",
                            "platformId": 8,
                            "isActive": 1,
                            "platformName": "ViAds",
                            "displayName": "Church Slavonic, Old Slavonic, Old Church Slavonic",
                            "dbMappingId": 968
                        }
                    ]
                },
                {
                    "id": 1913,
                    "name": "Portuguese (Portugal)",
                    "platformId": 1,
                    "isActive": 1,
                    "platformName": "Beki",
                    "displayName": "Portuguese (Portugal)",
                    "mappingDetails": [
                        {
                            "id": 1915,
                            "name": "31",
                            "platformId": 3,
                            "isActive": 1,
                            "platformName": "Meta",
                            "displayName": "Portuguese (Portugal)",
                            "dbMappingId": 590
                        }
                    ]
                },
                {
                    "id": 1917,
                    "name": "Gaelic, Scottish Gaelic",
                    "platformId": 1,
                    "isActive": 1,
                    "platformName": "Beki",
                    "displayName": "Gaelic, Scottish Gaelic",
                    "mappingDetails": [
                        {
                            "id": 1919,
                            "name": "1212",
                            "platformId": 2,
                            "isActive": 1,
                            "platformName": "ION",
                            "displayName": "Gaelic, Scottish Gaelic",
                            "dbMappingId": 591
                        },
                        {
                            "id": 3669,
                            "name": "578",
                            "platformId": 8,
                            "isActive": 1,
                            "platformName": "ViAds",
                            "displayName": "Gaelic, Scottish Gaelic",
                            "dbMappingId": 969
                        }
                    ]
                },
                {
                    "id": 1921,
                    "name": "Armenian",
                    "platformId": 1,
                    "isActive": 1,
                    "platformName": "Beki",
                    "displayName": "Armenian",
                    "mappingDetails": [
                        {
                            "id": 1923,
                            "name": "1170",
                            "platformId": 2,
                            "isActive": 1,
                            "platformName": "ION",
                            "displayName": "Armenian",
                            "dbMappingId": 592
                        },
                        {
                            "id": 1925,
                            "name": "68",
                            "platformId": 3,
                            "isActive": 1,
                            "platformName": "Meta",
                            "displayName": "Armenian",
                            "dbMappingId": 593
                        },
                        {
                            "id": 3671,
                            "name": "536",
                            "platformId": 8,
                            "isActive": 1,
                            "platformName": "ViAds",
                            "displayName": "Armenian",
                            "dbMappingId": 970
                        }
                    ]
                },
                {
                    "id": 1927,
                    "name": "Tahitian",
                    "platformId": 1,
                    "isActive": 1,
                    "platformName": "Beki",
                    "displayName": "Tahitian",
                    "mappingDetails": [
                        {
                            "id": 1929,
                            "name": "1316",
                            "platformId": 2,
                            "isActive": 1,
                            "platformName": "ION",
                            "displayName": "Tahitian",
                            "dbMappingId": 594
                        },
                        {
                            "id": 3673,
                            "name": "682",
                            "platformId": 8,
                            "isActive": 1,
                            "platformName": "ViAds",
                            "displayName": "Tahitian",
                            "dbMappingId": 971
                        }
                    ]
                },
                {
                    "id": 1931,
                    "name": "Urdu",
                    "platformId": 1,
                    "isActive": 1,
                    "platformName": "Beki",
                    "displayName": "Urdu",
                    "mappingDetails": [
                        {
                            "id": 1933,
                            "name": "1332",
                            "platformId": 2,
                            "isActive": 1,
                            "platformName": "ION",
                            "displayName": "Urdu",
                            "dbMappingId": 595
                        },
                        {
                            "id": 1935,
                            "name": "90",
                            "platformId": 3,
                            "isActive": 1,
                            "platformName": "Meta",
                            "displayName": "Urdu",
                            "dbMappingId": 596
                        },
                        {
                            "id": 1937,
                            "name": "languageConstants/1041",
                            "platformId": 4,
                            "isActive": 1,
                            "platformName": "Google Ads",
                            "displayName": "Urdu",
                            "dbMappingId": 597
                        },
                        {
                            "id": 3677,
                            "name": "698",
                            "platformId": 8,
                            "isActive": 1,
                            "platformName": "ViAds",
                            "displayName": "Urdu",
                            "dbMappingId": 973
                        }
                    ]
                },
                {
                    "id": 1939,
                    "name": "Romanian",
                    "platformId": 1,
                    "isActive": 1,
                    "platformName": "Beki",
                    "displayName": "Romanian",
                    "mappingDetails": [
                        {
                            "id": 1941,
                            "name": "1293",
                            "platformId": 2,
                            "isActive": 1,
                            "platformName": "ION",
                            "displayName": "Romanian",
                            "dbMappingId": 598
                        },
                        {
                            "id": 1943,
                            "name": "32",
                            "platformId": 3,
                            "isActive": 1,
                            "platformName": "Meta",
                            "displayName": "Romanian",
                            "dbMappingId": 599
                        },
                        {
                            "id": 1945,
                            "name": "languageConstants/1032",
                            "platformId": 4,
                            "isActive": 1,
                            "platformName": "Google Ads",
                            "displayName": "Romanian",
                            "dbMappingId": 600
                        },
                        {
                            "id": 1947,
                            "name": "ro",
                            "platformId": 7,
                            "isActive": 1,
                            "platformName": "TikTok",
                            "displayName": "Romanian",
                            "dbMappingId": 601
                        }
                    ]
                },
                {
                    "id": 1949,
                    "name": "Ganda",
                    "platformId": 1,
                    "isActive": 1,
                    "platformName": "Beki",
                    "displayName": "Ganda",
                    "mappingDetails": [
                        {
                            "id": 1951,
                            "name": "1214",
                            "platformId": 2,
                            "isActive": 1,
                            "platformName": "ION",
                            "displayName": "Ganda",
                            "dbMappingId": 602
                        },
                        {
                            "id": 3679,
                            "name": "580",
                            "platformId": 8,
                            "isActive": 1,
                            "platformName": "ViAds",
                            "displayName": "Ganda",
                            "dbMappingId": 974
                        }
                    ]
                },
                {
                    "id": 1953,
                    "name": "Twi",
                    "platformId": 1,
                    "isActive": 1,
                    "platformName": "Beki",
                    "displayName": "Twi",
                    "mappingDetails": [
                        {
                            "id": 1955,
                            "name": "1329",
                            "platformId": 2,
                            "isActive": 1,
                            "platformName": "ION",
                            "displayName": "Twi",
                            "dbMappingId": 603
                        },
                        {
                            "id": 3681,
                            "name": "695",
                            "platformId": 8,
                            "isActive": 1,
                            "platformName": "ViAds",
                            "displayName": "Twi",
                            "dbMappingId": 975
                        }
                    ]
                },
                {
                    "id": 1957,
                    "name": "Igbo",
                    "platformId": 1,
                    "isActive": 1,
                    "platformName": "Beki",
                    "displayName": "Igbo",
                    "mappingDetails": [
                        {
                            "id": 1959,
                            "name": "1230",
                            "platformId": 2,
                            "isActive": 1,
                            "platformName": "ION",
                            "displayName": "Igbo",
                            "dbMappingId": 604
                        },
                        {
                            "id": 3685,
                            "name": "596",
                            "platformId": 8,
                            "isActive": 1,
                            "platformName": "ViAds",
                            "displayName": "Igbo",
                            "dbMappingId": 977
                        }
                    ]
                },
                {
                    "id": 1961,
                    "name": "Yiddish",
                    "platformId": 1,
                    "isActive": 1,
                    "platformName": "Beki",
                    "displayName": "Yiddish",
                    "mappingDetails": [
                        {
                            "id": 1963,
                            "name": "1341",
                            "platformId": 2,
                            "isActive": 1,
                            "platformName": "ION",
                            "displayName": "Yiddish",
                            "dbMappingId": 605
                        },
                        {
                            "id": 3687,
                            "name": "707",
                            "platformId": 8,
                            "isActive": 1,
                            "platformName": "ViAds",
                            "displayName": "Yiddish",
                            "dbMappingId": 978
                        }
                    ]
                },
                {
                    "id": 1965,
                    "name": "Breton",
                    "platformId": 1,
                    "isActive": 1,
                    "platformName": "Beki",
                    "displayName": "Breton",
                    "mappingDetails": [
                        {
                            "id": 1967,
                            "name": "1183",
                            "platformId": 2,
                            "isActive": 1,
                            "platformName": "ION",
                            "displayName": "Breton",
                            "dbMappingId": 606
                        },
                        {
                            "id": 3691,
                            "name": "549",
                            "platformId": 8,
                            "isActive": 1,
                            "platformName": "ViAds",
                            "displayName": "Breton",
                            "dbMappingId": 980
                        }
                    ]
                },
                {
                    "id": 1969,
                    "name": "Gujarati",
                    "platformId": 1,
                    "isActive": 1,
                    "platformName": "Beki",
                    "displayName": "Gujarati",
                    "mappingDetails": [
                        {
                            "id": 1971,
                            "name": "1220",
                            "platformId": 2,
                            "isActive": 1,
                            "platformName": "ION",
                            "displayName": "Gujarati",
                            "dbMappingId": 607
                        },
                        {
                            "id": 1973,
                            "name": "67",
                            "platformId": 3,
                            "isActive": 1,
                            "platformName": "Meta",
                            "displayName": "Gujarati",
                            "dbMappingId": 608
                        },
                        {
                            "id": 1975,
                            "name": "languageConstants/1072",
                            "platformId": 4,
                            "isActive": 1,
                            "platformName": "Google Ads",
                            "displayName": "Gujarati",
                            "dbMappingId": 609
                        },
                        {
                            "id": 1977,
                            "name": "gu",
                            "platformId": 7,
                            "isActive": 1,
                            "platformName": "TikTok",
                            "displayName": "Gujarati",
                            "dbMappingId": 610
                        },
                        {
                            "id": 3703,
                            "name": "586",
                            "platformId": 8,
                            "isActive": 1,
                            "platformName": "ViAds",
                            "displayName": "Gujarati",
                            "dbMappingId": 986
                        }
                    ]
                },
                {
                    "id": 1979,
                    "name": "Icelandic",
                    "platformId": 1,
                    "isActive": 1,
                    "platformName": "Beki",
                    "displayName": "Icelandic",
                    "mappingDetails": [
                        {
                            "id": 1981,
                            "name": "1228",
                            "platformId": 2,
                            "isActive": 1,
                            "platformName": "ION",
                            "displayName": "Icelandic",
                            "dbMappingId": 611
                        },
                        {
                            "id": 1983,
                            "name": "69",
                            "platformId": 3,
                            "isActive": 1,
                            "platformName": "Meta",
                            "displayName": "Icelandic",
                            "dbMappingId": 612
                        },
                        {
                            "id": 1985,
                            "name": "languageConstants/1026",
                            "platformId": 4,
                            "isActive": 1,
                            "platformName": "Google Ads",
                            "displayName": "Icelandic",
                            "dbMappingId": 613
                        },
                        {
                            "id": 3705,
                            "name": "594",
                            "platformId": 8,
                            "isActive": 1,
                            "platformName": "ViAds",
                            "displayName": "Icelandic",
                            "dbMappingId": 987
                        }
                    ]
                },
                {
                    "id": 1987,
                    "name": "Dzongkha",
                    "platformId": 1,
                    "isActive": 1,
                    "platformName": "Beki",
                    "displayName": "Dzongkha",
                    "mappingDetails": [
                        {
                            "id": 1989,
                            "name": "1201",
                            "platformId": 2,
                            "isActive": 1,
                            "platformName": "ION",
                            "displayName": "Dzongkha",
                            "dbMappingId": 614
                        },
                        {
                            "id": 3717,
                            "name": "567",
                            "platformId": 8,
                            "isActive": 1,
                            "platformName": "ViAds",
                            "displayName": "Dzongkha",
                            "dbMappingId": 993
                        }
                    ]
                },
                {
                    "id": 1991,
                    "name": "Sundanese",
                    "platformId": 1,
                    "isActive": 1,
                    "platformName": "Beki",
                    "displayName": "Sundanese",
                    "mappingDetails": [
                        {
                            "id": 1993,
                            "name": "1311",
                            "platformId": 2,
                            "isActive": 1,
                            "platformName": "ION",
                            "displayName": "Sundanese",
                            "dbMappingId": 615
                        },
                        {
                            "id": 3719,
                            "name": "677",
                            "platformId": 8,
                            "isActive": 1,
                            "platformName": "ViAds",
                            "displayName": "Sundanese",
                            "dbMappingId": 994
                        }
                    ]
                },
                {
                    "id": 1995,
                    "name": "Kurdish",
                    "platformId": 1,
                    "isActive": 1,
                    "platformName": "Beki",
                    "displayName": "Kurdish",
                    "mappingDetails": [
                        {
                            "id": 1997,
                            "name": "1252",
                            "platformId": 2,
                            "isActive": 1,
                            "platformName": "ION",
                            "displayName": "Kurdish",
                            "dbMappingId": 616
                        },
                        {
                            "id": 1999,
                            "name": "76",
                            "platformId": 3,
                            "isActive": 1,
                            "platformName": "Meta",
                            "displayName": "Kurdish",
                            "dbMappingId": 617
                        },
                        {
                            "id": 3733,
                            "name": "618",
                            "platformId": 8,
                            "isActive": 1,
                            "platformName": "ViAds",
                            "displayName": "Kurdish",
                            "dbMappingId": 1001
                        }
                    ]
                },
                {
                    "id": 2001,
                    "name": "French",
                    "platformId": 1,
                    "isActive": 1,
                    "platformName": "Beki",
                    "displayName": "French",
                    "mappingDetails": [
                        {
                            "id": 2003,
                            "name": "1209",
                            "platformId": 2,
                            "isActive": 1,
                            "platformName": "ION",
                            "displayName": "French",
                            "dbMappingId": 618
                        },
                        {
                            "id": 2005,
                            "name": "1003",
                            "platformId": 3,
                            "isActive": 1,
                            "platformName": "Meta",
                            "displayName": "French",
                            "dbMappingId": 619
                        },
                        {
                            "id": 2007,
                            "name": "languageConstants/1002",
                            "platformId": 4,
                            "isActive": 1,
                            "platformName": "Google Ads",
                            "displayName": "French",
                            "dbMappingId": 620
                        },
                        {
                            "id": 2009,
                            "name": "fr",
                            "platformId": 7,
                            "isActive": 1,
                            "platformName": "TikTok",
                            "displayName": "French",
                            "dbMappingId": 621
                        },
                        {
                            "id": 3743,
                            "name": "575",
                            "platformId": 8,
                            "isActive": 1,
                            "platformName": "ViAds",
                            "displayName": "French",
                            "dbMappingId": 1006
                        }
                    ]
                },
                {
                    "id": 2011,
                    "name": "Fulah",
                    "platformId": 1,
                    "isActive": 1,
                    "platformName": "Beki",
                    "displayName": "Fulah",
                    "mappingDetails": [
                        {
                            "id": 2013,
                            "name": "1211",
                            "platformId": 2,
                            "isActive": 1,
                            "platformName": "ION",
                            "displayName": "Fulah",
                            "dbMappingId": 622
                        },
                        {
                            "id": 3745,
                            "name": "577",
                            "platformId": 8,
                            "isActive": 1,
                            "platformName": "ViAds",
                            "displayName": "Fulah",
                            "dbMappingId": 1007
                        }
                    ]
                },
                {
                    "id": 2015,
                    "name": "Indonesian",
                    "platformId": 1,
                    "isActive": 1,
                    "platformName": "Beki",
                    "displayName": "Indonesian",
                    "mappingDetails": [
                        {
                            "id": 2017,
                            "name": "1231",
                            "platformId": 2,
                            "isActive": 1,
                            "platformName": "ION",
                            "displayName": "Indonesian",
                            "dbMappingId": 623
                        },
                        {
                            "id": 2019,
                            "name": "25",
                            "platformId": 3,
                            "isActive": 1,
                            "platformName": "Meta",
                            "displayName": "Indonesian",
                            "dbMappingId": 624
                        },
                        {
                            "id": 2021,
                            "name": "languageConstants/1025",
                            "platformId": 4,
                            "isActive": 1,
                            "platformName": "Google Ads",
                            "displayName": "Indonesian",
                            "dbMappingId": 625
                        },
                        {
                            "id": 2023,
                            "name": "id",
                            "platformId": 7,
                            "isActive": 1,
                            "platformName": "TikTok",
                            "displayName": "Indonesian",
                            "dbMappingId": 626
                        },
                        {
                            "id": 3749,
                            "name": "597",
                            "platformId": 8,
                            "isActive": 1,
                            "platformName": "ViAds",
                            "displayName": "Indonesian",
                            "dbMappingId": 1009
                        }
                    ]
                },
                {
                    "id": 2025,
                    "name": "Sardinian",
                    "platformId": 1,
                    "isActive": 1,
                    "platformName": "Beki",
                    "displayName": "Sardinian",
                    "mappingDetails": [
                        {
                            "id": 2027,
                            "name": "1301",
                            "platformId": 2,
                            "isActive": 1,
                            "platformName": "ION",
                            "displayName": "Sardinian",
                            "dbMappingId": 627
                        },
                        {
                            "id": 3761,
                            "name": "667",
                            "platformId": 8,
                            "isActive": 1,
                            "platformName": "ViAds",
                            "displayName": "Sardinian",
                            "dbMappingId": 1015
                        }
                    ]
                },
                {
                    "id": 2029,
                    "name": "Manx",
                    "platformId": 1,
                    "isActive": 1,
                    "platformName": "Beki",
                    "displayName": "Manx",
                    "mappingDetails": [
                        {
                            "id": 2031,
                            "name": "1266",
                            "platformId": 2,
                            "isActive": 1,
                            "platformName": "ION",
                            "displayName": "Manx",
                            "dbMappingId": 628
                        },
                        {
                            "id": 3763,
                            "name": "632",
                            "platformId": 8,
                            "isActive": 1,
                            "platformName": "ViAds",
                            "displayName": "Manx",
                            "dbMappingId": 1016
                        }
                    ]
                },
                {
                    "id": 2033,
                    "name": "English (US)",
                    "platformId": 1,
                    "isActive": 1,
                    "platformName": "Beki",
                    "displayName": "English (US)",
                    "mappingDetails": [
                        {
                            "id": 2035,
                            "name": "6",
                            "platformId": 3,
                            "isActive": 1,
                            "platformName": "Meta",
                            "displayName": "English (US)",
                            "dbMappingId": 629
                        }
                    ]
                },
                {
                    "id": 2037,
                    "name": "Chinese (Hong Kong SAR)",
                    "platformId": 1,
                    "isActive": 1,
                    "platformName": "Beki",
                    "displayName": "Chinese (Hong Kong SAR)",
                    "mappingDetails": [
                        {
                            "id": 2039,
                            "name": "21",
                            "platformId": 3,
                            "isActive": 1,
                            "platformName": "Meta",
                            "displayName": "Chinese (Hong Kong SAR)",
                            "dbMappingId": 630
                        }
                    ]
                },
                {
                    "id": 2041,
                    "name": "Basque",
                    "platformId": 1,
                    "isActive": 1,
                    "platformName": "Beki",
                    "displayName": "Basque",
                    "mappingDetails": [
                        {
                            "id": 2043,
                            "name": "1178",
                            "platformId": 2,
                            "isActive": 1,
                            "platformName": "ION",
                            "displayName": "Basque",
                            "dbMappingId": 631
                        },
                        {
                            "id": 2045,
                            "name": "59",
                            "platformId": 3,
                            "isActive": 1,
                            "platformName": "Meta",
                            "displayName": "Basque",
                            "dbMappingId": 632
                        },
                        {
                            "id": 3769,
                            "name": "544",
                            "platformId": 8,
                            "isActive": 1,
                            "platformName": "ViAds",
                            "displayName": "Basque",
                            "dbMappingId": 1019
                        }
                    ]
                },
                {
                    "id": 2047,
                    "name": "Fijian",
                    "platformId": 1,
                    "isActive": 1,
                    "platformName": "Beki",
                    "displayName": "Fijian",
                    "mappingDetails": [
                        {
                            "id": 2049,
                            "name": "1207",
                            "platformId": 2,
                            "isActive": 1,
                            "platformName": "ION",
                            "displayName": "Fijian",
                            "dbMappingId": 633
                        },
                        {
                            "id": 3773,
                            "name": "573",
                            "platformId": 8,
                            "isActive": 1,
                            "platformName": "ViAds",
                            "displayName": "Fijian",
                            "dbMappingId": 1021
                        }
                    ]
                },
                {
                    "id": 2051,
                    "name": "Latvian",
                    "platformId": 1,
                    "isActive": 1,
                    "platformName": "Beki",
                    "displayName": "Latvian",
                    "mappingDetails": [
                        {
                            "id": 2053,
                            "name": "1255",
                            "platformId": 2,
                            "isActive": 1,
                            "platformName": "ION",
                            "displayName": "Latvian",
                            "dbMappingId": 634
                        },
                        {
                            "id": 2055,
                            "name": "78",
                            "platformId": 3,
                            "isActive": 1,
                            "platformName": "Meta",
                            "displayName": "Latvian",
                            "dbMappingId": 635
                        },
                        {
                            "id": 2057,
                            "name": "languageConstants/1028",
                            "platformId": 4,
                            "isActive": 1,
                            "platformName": "Google Ads",
                            "displayName": "Latvian",
                            "dbMappingId": 636
                        },
                        {
                            "id": 3777,
                            "name": "621",
                            "platformId": 8,
                            "isActive": 1,
                            "platformName": "ViAds",
                            "displayName": "Latvian",
                            "dbMappingId": 1023
                        }
                    ]
                },
                {
                    "id": 2059,
                    "name": "Tamil",
                    "platformId": 1,
                    "isActive": 1,
                    "platformName": "Beki",
                    "displayName": "Tamil",
                    "mappingDetails": [
                        {
                            "id": 2061,
                            "name": "1318",
                            "platformId": 2,
                            "isActive": 1,
                            "platformName": "ION",
                            "displayName": "Tamil",
                            "dbMappingId": 637
                        },
                        {
                            "id": 2063,
                            "name": "48",
                            "platformId": 3,
                            "isActive": 1,
                            "platformName": "Meta",
                            "displayName": "Tamil",
                            "dbMappingId": 638
                        },
                        {
                            "id": 2065,
                            "name": "languageConstants/1130",
                            "platformId": 4,
                            "isActive": 1,
                            "platformName": "Google Ads",
                            "displayName": "Tamil",
                            "dbMappingId": 639
                        },
                        {
                            "id": 2067,
                            "name": "ta",
                            "platformId": 7,
                            "isActive": 1,
                            "platformName": "TikTok",
                            "displayName": "Tamil",
                            "dbMappingId": 640
                        },
                        {
                            "id": 3791,
                            "name": "684",
                            "platformId": 8,
                            "isActive": 1,
                            "platformName": "ViAds",
                            "displayName": "Tamil",
                            "dbMappingId": 1030
                        }
                    ]
                },
                {
                    "id": 2069,
                    "name": "Volapük",
                    "platformId": 1,
                    "isActive": 1,
                    "platformName": "Beki",
                    "displayName": "Volapük",
                    "mappingDetails": [
                        {
                            "id": 2071,
                            "name": "1336",
                            "platformId": 2,
                            "isActive": 1,
                            "platformName": "ION",
                            "displayName": "Volapük",
                            "dbMappingId": 641
                        },
                        {
                            "id": 3793,
                            "name": "702",
                            "platformId": 8,
                            "isActive": 1,
                            "platformName": "ViAds",
                            "displayName": "Volapük",
                            "dbMappingId": 1031
                        }
                    ]
                },
                {
                    "id": 2073,
                    "name": "Chichewa, Chewa, Nyanja",
                    "platformId": 1,
                    "isActive": 1,
                    "platformName": "Beki",
                    "displayName": "Chichewa, Chewa, Nyanja",
                    "mappingDetails": [
                        {
                            "id": 2075,
                            "name": "1189",
                            "platformId": 2,
                            "isActive": 1,
                            "platformName": "ION",
                            "displayName": "Chichewa, Chewa, Nyanja",
                            "dbMappingId": 642
                        },
                        {
                            "id": 3795,
                            "name": "555",
                            "platformId": 8,
                            "isActive": 1,
                            "platformName": "ViAds",
                            "displayName": "Chichewa, Chewa, Nyanja",
                            "dbMappingId": 1032
                        }
                    ]
                },
                {
                    "id": 2077,
                    "name": "Kuanyama, Kwanyama",
                    "platformId": 1,
                    "isActive": 1,
                    "platformName": "Beki",
                    "displayName": "Kuanyama, Kwanyama",
                    "mappingDetails": [
                        {
                            "id": 2079,
                            "name": "1251",
                            "platformId": 2,
                            "isActive": 1,
                            "platformName": "ION",
                            "displayName": "Kuanyama, Kwanyama",
                            "dbMappingId": 643
                        },
                        {
                            "id": 3799,
                            "name": "617",
                            "platformId": 8,
                            "isActive": 1,
                            "platformName": "ViAds",
                            "displayName": "Kuanyama, Kwanyama",
                            "dbMappingId": 1034
                        }
                    ]
                },
                {
                    "id": 2081,
                    "name": "Marshallese",
                    "platformId": 1,
                    "isActive": 1,
                    "platformName": "Beki",
                    "displayName": "Marshallese",
                    "mappingDetails": [
                        {
                            "id": 2083,
                            "name": "1269",
                            "platformId": 2,
                            "isActive": 1,
                            "platformName": "ION",
                            "displayName": "Marshallese",
                            "dbMappingId": 644
                        },
                        {
                            "id": 3807,
                            "name": "635",
                            "platformId": 8,
                            "isActive": 1,
                            "platformName": "ViAds",
                            "displayName": "Marshallese",
                            "dbMappingId": 1038
                        }
                    ]
                },
                {
                    "id": 2085,
                    "name": "Czech",
                    "platformId": 1,
                    "isActive": 1,
                    "platformName": "Beki",
                    "displayName": "Czech",
                    "mappingDetails": [
                        {
                            "id": 2087,
                            "name": "1197",
                            "platformId": 2,
                            "isActive": 1,
                            "platformName": "ION",
                            "displayName": "Czech",
                            "dbMappingId": 645
                        },
                        {
                            "id": 2089,
                            "name": "2",
                            "platformId": 3,
                            "isActive": 1,
                            "platformName": "Meta",
                            "displayName": "Czech",
                            "dbMappingId": 646
                        },
                        {
                            "id": 2091,
                            "name": "languageConstants/1021",
                            "platformId": 4,
                            "isActive": 1,
                            "platformName": "Google Ads",
                            "displayName": "Czech",
                            "dbMappingId": 647
                        },
                        {
                            "id": 2093,
                            "name": "cs",
                            "platformId": 7,
                            "isActive": 1,
                            "platformName": "TikTok",
                            "displayName": "Czech",
                            "dbMappingId": 648
                        },
                        {
                            "id": 3811,
                            "name": "563",
                            "platformId": 8,
                            "isActive": 1,
                            "platformName": "ViAds",
                            "displayName": "Czech",
                            "dbMappingId": 1040
                        }
                    ]
                },
                {
                    "id": 2095,
                    "name": "Dutch",
                    "platformId": 1,
                    "isActive": 1,
                    "platformName": "Beki",
                    "displayName": "Dutch",
                    "mappingDetails": [
                        {
                            "id": 2097,
                            "name": "1200",
                            "platformId": 2,
                            "isActive": 1,
                            "platformName": "ION",
                            "displayName": "Dutch",
                            "dbMappingId": 649
                        },
                        {
                            "id": 2099,
                            "name": "14",
                            "platformId": 3,
                            "isActive": 1,
                            "platformName": "Meta",
                            "displayName": "Dutch",
                            "dbMappingId": 650
                        },
                        {
                            "id": 2101,
                            "name": "languageConstants/1010",
                            "platformId": 4,
                            "isActive": 1,
                            "platformName": "Google Ads",
                            "displayName": "Dutch",
                            "dbMappingId": 651
                        },
                        {
                            "id": 2103,
                            "name": "nl",
                            "platformId": 7,
                            "isActive": 1,
                            "platformName": "TikTok",
                            "displayName": "Dutch",
                            "dbMappingId": 652
                        }
                    ]
                },
                {
                    "id": 2105,
                    "name": "Sinhala, Sinhalese",
                    "platformId": 1,
                    "isActive": 1,
                    "platformName": "Beki",
                    "displayName": "Sinhala, Sinhalese",
                    "mappingDetails": [
                        {
                            "id": 2107,
                            "name": "1305",
                            "platformId": 2,
                            "isActive": 1,
                            "platformName": "ION",
                            "displayName": "Sinhala, Sinhalese",
                            "dbMappingId": 653
                        },
                        {
                            "id": 2109,
                            "name": "86",
                            "platformId": 3,
                            "isActive": 1,
                            "platformName": "Meta",
                            "displayName": "Sinhala, Sinhalese",
                            "dbMappingId": 654
                        },
                        {
                            "id": 3819,
                            "name": "671",
                            "platformId": 8,
                            "isActive": 1,
                            "platformName": "ViAds",
                            "displayName": "Sinhala, Sinhalese",
                            "dbMappingId": 1044
                        }
                    ]
                },
                {
                    "id": 2111,
                    "name": "Russian",
                    "platformId": 1,
                    "isActive": 1,
                    "platformName": "Beki",
                    "displayName": "Russian",
                    "mappingDetails": [
                        {
                            "id": 2113,
                            "name": "1296",
                            "platformId": 2,
                            "isActive": 1,
                            "platformName": "ION",
                            "displayName": "Russian",
                            "dbMappingId": 655
                        },
                        {
                            "id": 2115,
                            "name": "17",
                            "platformId": 3,
                            "isActive": 1,
                            "platformName": "Meta",
                            "displayName": "Russian",
                            "dbMappingId": 656
                        },
                        {
                            "id": 2117,
                            "name": "languageConstants/1031",
                            "platformId": 4,
                            "isActive": 1,
                            "platformName": "Google Ads",
                            "displayName": "Russian",
                            "dbMappingId": 657
                        },
                        {
                            "id": 2119,
                            "name": "ru",
                            "platformId": 7,
                            "isActive": 1,
                            "platformName": "TikTok",
                            "displayName": "Russian",
                            "dbMappingId": 658
                        },
                        {
                            "id": 3827,
                            "name": "662",
                            "platformId": 8,
                            "isActive": 1,
                            "platformName": "ViAds",
                            "displayName": "Russian",
                            "dbMappingId": 1048
                        }
                    ]
                },
                {
                    "id": 2121,
                    "name": "Bosnian",
                    "platformId": 1,
                    "isActive": 1,
                    "platformName": "Beki",
                    "displayName": "Bosnian",
                    "mappingDetails": [
                        {
                            "id": 2123,
                            "name": "1182",
                            "platformId": 2,
                            "isActive": 1,
                            "platformName": "ION",
                            "displayName": "Bosnian",
                            "dbMappingId": 659
                        },
                        {
                            "id": 2125,
                            "name": "55",
                            "platformId": 3,
                            "isActive": 1,
                            "platformName": "Meta",
                            "displayName": "Bosnian",
                            "dbMappingId": 660
                        },
                        {
                            "id": 3825,
                            "name": "548",
                            "platformId": 8,
                            "isActive": 1,
                            "platformName": "ViAds",
                            "displayName": "Bosnian",
                            "dbMappingId": 1047
                        }
                    ]
                },
                {
                    "id": 2127,
                    "name": "Interlingue, Occidental",
                    "platformId": 1,
                    "isActive": 1,
                    "platformName": "Beki",
                    "displayName": "Interlingue, Occidental",
                    "mappingDetails": [
                        {
                            "id": 2129,
                            "name": "1233",
                            "platformId": 2,
                            "isActive": 1,
                            "platformName": "ION",
                            "displayName": "Interlingue, Occidental",
                            "dbMappingId": 661
                        },
                        {
                            "id": 3841,
                            "name": "599",
                            "platformId": 8,
                            "isActive": 1,
                            "platformName": "ViAds",
                            "displayName": "Interlingue, Occidental",
                            "dbMappingId": 1055
                        }
                    ]
                },
                {
                    "id": 2131,
                    "name": "Rundi",
                    "platformId": 1,
                    "isActive": 1,
                    "platformName": "Beki",
                    "displayName": "Rundi",
                    "mappingDetails": [
                        {
                            "id": 2133,
                            "name": "1295",
                            "platformId": 2,
                            "isActive": 1,
                            "platformName": "ION",
                            "displayName": "Rundi",
                            "dbMappingId": 662
                        },
                        {
                            "id": 3843,
                            "name": "661",
                            "platformId": 8,
                            "isActive": 1,
                            "platformName": "ViAds",
                            "displayName": "Rundi",
                            "dbMappingId": 1056
                        }
                    ]
                },
                {
                    "id": 2135,
                    "name": "Kinyarwanda",
                    "platformId": 1,
                    "isActive": 1,
                    "platformName": "Beki",
                    "displayName": "Kinyarwanda",
                    "mappingDetails": [
                        {
                            "id": 2137,
                            "name": "1246",
                            "platformId": 2,
                            "isActive": 1,
                            "platformName": "ION",
                            "displayName": "Kinyarwanda",
                            "dbMappingId": 663
                        },
                        {
                            "id": 3851,
                            "name": "612",
                            "platformId": 8,
                            "isActive": 1,
                            "platformName": "ViAds",
                            "displayName": "Kinyarwanda",
                            "dbMappingId": 1060
                        }
                    ]
                },
                {
                    "id": 2139,
                    "name": "Bambara",
                    "platformId": 1,
                    "isActive": 1,
                    "platformName": "Beki",
                    "displayName": "Bambara",
                    "mappingDetails": [
                        {
                            "id": 2141,
                            "name": "1176",
                            "platformId": 2,
                            "isActive": 1,
                            "platformName": "ION",
                            "displayName": "Bambara",
                            "dbMappingId": 664
                        },
                        {
                            "id": 3859,
                            "name": "542",
                            "platformId": 8,
                            "isActive": 1,
                            "platformName": "ViAds",
                            "displayName": "Bambara",
                            "dbMappingId": 1064
                        }
                    ]
                },
                {
                    "id": 2143,
                    "name": "Portuguese",
                    "platformId": 1,
                    "isActive": 1,
                    "platformName": "Beki",
                    "displayName": "Portuguese",
                    "mappingDetails": [
                        {
                            "id": 2145,
                            "name": "1290",
                            "platformId": 2,
                            "isActive": 1,
                            "platformName": "ION",
                            "displayName": "Portuguese",
                            "dbMappingId": 665
                        },
                        {
                            "id": 2147,
                            "name": "1005",
                            "platformId": 3,
                            "isActive": 1,
                            "platformName": "Meta",
                            "displayName": "Portuguese",
                            "dbMappingId": 666
                        },
                        {
                            "id": 2149,
                            "name": "languageConstants/1014",
                            "platformId": 4,
                            "isActive": 1,
                            "platformName": "Google Ads",
                            "displayName": "Portuguese",
                            "dbMappingId": 667
                        },
                        {
                            "id": 2151,
                            "name": "pt",
                            "platformId": 7,
                            "isActive": 1,
                            "platformName": "TikTok",
                            "displayName": "Portuguese",
                            "dbMappingId": 668
                        },
                        {
                            "id": 3865,
                            "name": "656",
                            "platformId": 8,
                            "isActive": 1,
                            "platformName": "ViAds",
                            "displayName": "Portuguese",
                            "dbMappingId": 1067
                        }
                    ]
                },
                {
                    "id": 2153,
                    "name": "Ido",
                    "platformId": 1,
                    "isActive": 1,
                    "platformName": "Beki",
                    "displayName": "Ido",
                    "mappingDetails": [
                        {
                            "id": 2155,
                            "name": "1229",
                            "platformId": 2,
                            "isActive": 1,
                            "platformName": "ION",
                            "displayName": "Ido",
                            "dbMappingId": 669
                        },
                        {
                            "id": 3867,
                            "name": "595",
                            "platformId": 8,
                            "isActive": 1,
                            "platformName": "ViAds",
                            "displayName": "Ido",
                            "dbMappingId": 1068
                        }
                    ]
                },
                {
                    "id": 2157,
                    "name": "Hindi",
                    "platformId": 1,
                    "isActive": 1,
                    "platformName": "Beki",
                    "displayName": "Hindi",
                    "mappingDetails": [
                        {
                            "id": 2159,
                            "name": "1225",
                            "platformId": 2,
                            "isActive": 1,
                            "platformName": "ION",
                            "displayName": "Hindi",
                            "dbMappingId": 670
                        },
                        {
                            "id": 2161,
                            "name": "46",
                            "platformId": 3,
                            "isActive": 1,
                            "platformName": "Meta",
                            "displayName": "Hindi",
                            "dbMappingId": 671
                        },
                        {
                            "id": 2163,
                            "name": "languageConstants/1023",
                            "platformId": 4,
                            "isActive": 1,
                            "platformName": "Google Ads",
                            "displayName": "Hindi",
                            "dbMappingId": 672
                        },
                        {
                            "id": 2165,
                            "name": "hi",
                            "platformId": 7,
                            "isActive": 1,
                            "platformName": "TikTok",
                            "displayName": "Hindi",
                            "dbMappingId": 673
                        },
                        {
                            "id": 3869,
                            "name": "591",
                            "platformId": 8,
                            "isActive": 1,
                            "platformName": "ViAds",
                            "displayName": "Hindi",
                            "dbMappingId": 1069
                        }
                    ]
                },
                {
                    "id": 2167,
                    "name": "Norwegian",
                    "platformId": 1,
                    "isActive": 1,
                    "platformName": "Beki",
                    "displayName": "Norwegian",
                    "mappingDetails": [
                        {
                            "id": 2169,
                            "name": "1277",
                            "platformId": 2,
                            "isActive": 1,
                            "platformName": "ION",
                            "displayName": "Norwegian",
                            "dbMappingId": 674
                        },
                        {
                            "id": 2171,
                            "name": "languageConstants/1013",
                            "platformId": 4,
                            "isActive": 1,
                            "platformName": "Google Ads",
                            "displayName": "Norwegian",
                            "dbMappingId": 675
                        },
                        {
                            "id": 3873,
                            "name": "643",
                            "platformId": 8,
                            "isActive": 1,
                            "platformName": "ViAds",
                            "displayName": "Norwegian",
                            "dbMappingId": 1071
                        }
                    ]
                },
                {
                    "id": 2173,
                    "name": "Catalan, Valencian",
                    "platformId": 1,
                    "isActive": 1,
                    "platformName": "Beki",
                    "displayName": "Catalan, Valencian",
                    "mappingDetails": [
                        {
                            "id": 2175,
                            "name": "1186",
                            "platformId": 2,
                            "isActive": 1,
                            "platformName": "ION",
                            "displayName": "Catalan, Valencian",
                            "dbMappingId": 676
                        },
                        {
                            "id": 3883,
                            "name": "552",
                            "platformId": 8,
                            "isActive": 1,
                            "platformName": "ViAds",
                            "displayName": "Catalan, Valencian",
                            "dbMappingId": 1076
                        }
                    ]
                },
                {
                    "id": 2177,
                    "name": "Irish",
                    "platformId": 1,
                    "isActive": 1,
                    "platformName": "Beki",
                    "displayName": "Irish",
                    "mappingDetails": [
                        {
                            "id": 2179,
                            "name": "1236",
                            "platformId": 2,
                            "isActive": 1,
                            "platformName": "ION",
                            "displayName": "Irish",
                            "dbMappingId": 677
                        },
                        {
                            "id": 2181,
                            "name": "64",
                            "platformId": 3,
                            "isActive": 1,
                            "platformName": "Meta",
                            "displayName": "Irish",
                            "dbMappingId": 678
                        },
                        {
                            "id": 3885,
                            "name": "602",
                            "platformId": 8,
                            "isActive": 1,
                            "platformName": "ViAds",
                            "displayName": "Irish",
                            "dbMappingId": 1077
                        }
                    ]
                },
                {
                    "id": 2183,
                    "name": "Guarani",
                    "platformId": 1,
                    "isActive": 1,
                    "platformName": "Beki",
                    "displayName": "Guarani",
                    "mappingDetails": [
                        {
                            "id": 2185,
                            "name": "1219",
                            "platformId": 2,
                            "isActive": 1,
                            "platformName": "ION",
                            "displayName": "Guarani",
                            "dbMappingId": 679
                        },
                        {
                            "id": 2187,
                            "name": "66",
                            "platformId": 3,
                            "isActive": 1,
                            "platformName": "Meta",
                            "displayName": "Guarani",
                            "dbMappingId": 680
                        },
                        {
                            "id": 3887,
                            "name": "585",
                            "platformId": 8,
                            "isActive": 1,
                            "platformName": "ViAds",
                            "displayName": "Guarani",
                            "dbMappingId": 1078
                        }
                    ]
                },
                {
                    "id": 2189,
                    "name": "Chuvash",
                    "platformId": 1,
                    "isActive": 1,
                    "platformName": "Beki",
                    "displayName": "Chuvash",
                    "mappingDetails": [
                        {
                            "id": 2191,
                            "name": "1192",
                            "platformId": 2,
                            "isActive": 1,
                            "platformName": "ION",
                            "displayName": "Chuvash",
                            "dbMappingId": 681
                        },
                        {
                            "id": 3889,
                            "name": "558",
                            "platformId": 8,
                            "isActive": 1,
                            "platformName": "ViAds",
                            "displayName": "Chuvash",
                            "dbMappingId": 1079
                        }
                    ]
                },
                {
                    "id": 2193,
                    "name": "Kazakh",
                    "platformId": 1,
                    "isActive": 1,
                    "platformName": "Beki",
                    "displayName": "Kazakh",
                    "mappingDetails": [
                        {
                            "id": 2195,
                            "name": "1243",
                            "platformId": 2,
                            "isActive": 1,
                            "platformName": "ION",
                            "displayName": "Kazakh",
                            "dbMappingId": 682
                        },
                        {
                            "id": 2197,
                            "name": "73",
                            "platformId": 3,
                            "isActive": 1,
                            "platformName": "Meta",
                            "displayName": "Kazakh",
                            "dbMappingId": 683
                        },
                        {
                            "id": 3891,
                            "name": "609",
                            "platformId": 8,
                            "isActive": 1,
                            "platformName": "ViAds",
                            "displayName": "Kazakh",
                            "dbMappingId": 1080
                        }
                    ]
                },
                {
                    "id": 2199,
                    "name": "Javanese",
                    "platformId": 1,
                    "isActive": 1,
                    "platformName": "Beki",
                    "displayName": "Javanese",
                    "mappingDetails": [
                        {
                            "id": 2201,
                            "name": "1239",
                            "platformId": 2,
                            "isActive": 1,
                            "platformName": "ION",
                            "displayName": "Javanese",
                            "dbMappingId": 684
                        },
                        {
                            "id": 2203,
                            "name": "71",
                            "platformId": 3,
                            "isActive": 1,
                            "platformName": "Meta",
                            "displayName": "Javanese",
                            "dbMappingId": 685
                        },
                        {
                            "id": 3895,
                            "name": "605",
                            "platformId": 8,
                            "isActive": 1,
                            "platformName": "ViAds",
                            "displayName": "Javanese",
                            "dbMappingId": 1082
                        }
                    ]
                },
                {
                    "id": 2205,
                    "name": "Flemish",
                    "platformId": 1,
                    "isActive": 1,
                    "platformName": "Beki",
                    "displayName": "Flemish",
                    "mappingDetails": [
                        {
                            "id": 2207,
                            "name": "83",
                            "platformId": 3,
                            "isActive": 1,
                            "platformName": "Meta",
                            "displayName": "Flemish",
                            "dbMappingId": 686
                        }
                    ]
                },
                {
                    "id": 2209,
                    "name": "Latin",
                    "platformId": 1,
                    "isActive": 1,
                    "platformName": "Beki",
                    "displayName": "Latin",
                    "mappingDetails": [
                        {
                            "id": 2211,
                            "name": "1254",
                            "platformId": 2,
                            "isActive": 1,
                            "platformName": "ION",
                            "displayName": "Latin",
                            "dbMappingId": 687
                        },
                        {
                            "id": 3903,
                            "name": "620",
                            "platformId": 8,
                            "isActive": 1,
                            "platformName": "ViAds",
                            "displayName": "Latin",
                            "dbMappingId": 1086
                        }
                    ]
                },
                {
                    "id": 2213,
                    "name": "Traditional Chinese (Taiwan)",
                    "platformId": 1,
                    "isActive": 1,
                    "platformName": "Beki",
                    "displayName": "Traditional Chinese (Taiwan)",
                    "mappingDetails": [
                        {
                            "id": 2215,
                            "name": "22",
                            "platformId": 3,
                            "isActive": 1,
                            "platformName": "Meta",
                            "displayName": "Traditional Chinese (Taiwan)",
                            "dbMappingId": 688
                        }
                    ]
                },
                {
                    "id": 2217,
                    "name": "Nauru",
                    "platformId": 1,
                    "isActive": 1,
                    "platformName": "Beki",
                    "displayName": "Nauru",
                    "mappingDetails": [
                        {
                            "id": 2219,
                            "name": "1271",
                            "platformId": 2,
                            "isActive": 1,
                            "platformName": "ION",
                            "displayName": "Nauru",
                            "dbMappingId": 689
                        },
                        {
                            "id": 3909,
                            "name": "637",
                            "platformId": 8,
                            "isActive": 1,
                            "platformName": "ViAds",
                            "displayName": "Nauru",
                            "dbMappingId": 1089
                        }
                    ]
                },
                {
                    "id": 2221,
                    "name": "Oriya",
                    "platformId": 1,
                    "isActive": 1,
                    "platformName": "Beki",
                    "displayName": "Oriya",
                    "mappingDetails": [
                        {
                            "id": 2223,
                            "name": "1283",
                            "platformId": 2,
                            "isActive": 1,
                            "platformName": "ION",
                            "displayName": "Oriya",
                            "dbMappingId": 690
                        },
                        {
                            "id": 2225,
                            "name": "or",
                            "platformId": 7,
                            "isActive": 1,
                            "platformName": "TikTok",
                            "displayName": "Oriya",
                            "dbMappingId": 691
                        },
                        {
                            "id": 3913,
                            "name": "649",
                            "platformId": 8,
                            "isActive": 1,
                            "platformName": "ViAds",
                            "displayName": "Oriya",
                            "dbMappingId": 1091
                        }
                    ]
                },
                {
                    "id": 2227,
                    "name": "Italian",
                    "platformId": 1,
                    "isActive": 1,
                    "platformName": "Beki",
                    "displayName": "Italian",
                    "mappingDetails": [
                        {
                            "id": 2229,
                            "name": "1237",
                            "platformId": 2,
                            "isActive": 1,
                            "platformName": "ION",
                            "displayName": "Italian",
                            "dbMappingId": 692
                        },
                        {
                            "id": 2231,
                            "name": "10",
                            "platformId": 3,
                            "isActive": 1,
                            "platformName": "Meta",
                            "displayName": "Italian",
                            "dbMappingId": 693
                        },
                        {
                            "id": 2233,
                            "name": "languageConstants/1004",
                            "platformId": 4,
                            "isActive": 1,
                            "platformName": "Google Ads",
                            "displayName": "Italian",
                            "dbMappingId": 694
                        },
                        {
                            "id": 2235,
                            "name": "it",
                            "platformId": 7,
                            "isActive": 1,
                            "platformName": "TikTok",
                            "displayName": "Italian",
                            "dbMappingId": 695
                        },
                        {
                            "id": 3915,
                            "name": "603",
                            "platformId": 8,
                            "isActive": 1,
                            "platformName": "ViAds",
                            "displayName": "Italian",
                            "dbMappingId": 1092
                        }
                    ]
                },
                {
                    "id": 2237,
                    "name": "Corsican",
                    "platformId": 1,
                    "isActive": 1,
                    "platformName": "Beki",
                    "displayName": "Corsican",
                    "mappingDetails": [
                        {
                            "id": 2239,
                            "name": "1194",
                            "platformId": 2,
                            "isActive": 1,
                            "platformName": "ION",
                            "displayName": "Corsican",
                            "dbMappingId": 696
                        },
                        {
                            "id": 3917,
                            "name": "560",
                            "platformId": 8,
                            "isActive": 1,
                            "platformName": "ViAds",
                            "displayName": "Corsican",
                            "dbMappingId": 1093
                        }
                    ]
                },
                {
                    "id": 2241,
                    "name": "Ojibwa",
                    "platformId": 1,
                    "isActive": 1,
                    "platformName": "Beki",
                    "displayName": "Ojibwa",
                    "mappingDetails": [
                        {
                            "id": 2243,
                            "name": "1282",
                            "platformId": 2,
                            "isActive": 1,
                            "platformName": "ION",
                            "displayName": "Ojibwa",
                            "dbMappingId": 697
                        },
                        {
                            "id": 3927,
                            "name": "648",
                            "platformId": 8,
                            "isActive": 1,
                            "platformName": "ViAds",
                            "displayName": "Ojibwa",
                            "dbMappingId": 1098
                        }
                    ]
                },
                {
                    "id": 2245,
                    "name": "Slovenian",
                    "platformId": 1,
                    "isActive": 1,
                    "platformName": "Beki",
                    "displayName": "Slovenian",
                    "mappingDetails": [
                        {
                            "id": 2247,
                            "name": "1307",
                            "platformId": 2,
                            "isActive": 1,
                            "platformName": "ION",
                            "displayName": "Slovenian",
                            "dbMappingId": 698
                        },
                        {
                            "id": 2249,
                            "name": "34",
                            "platformId": 3,
                            "isActive": 1,
                            "platformName": "Meta",
                            "displayName": "Slovenian",
                            "dbMappingId": 699
                        },
                        {
                            "id": 2251,
                            "name": "languageConstants/1034",
                            "platformId": 4,
                            "isActive": 1,
                            "platformName": "Google Ads",
                            "displayName": "Slovenian",
                            "dbMappingId": 700
                        },
                        {
                            "id": 3929,
                            "name": "673",
                            "platformId": 8,
                            "isActive": 1,
                            "platformName": "ViAds",
                            "displayName": "Slovenian",
                            "dbMappingId": 1099
                        }
                    ]
                },
                {
                    "id": 2253,
                    "name": "Norwegian Bokmål",
                    "platformId": 1,
                    "isActive": 1,
                    "platformName": "Beki",
                    "displayName": "Norwegian Bokmål",
                    "mappingDetails": [
                        {
                            "id": 2255,
                            "name": "1278",
                            "platformId": 2,
                            "isActive": 1,
                            "platformName": "ION",
                            "displayName": "Norwegian Bokmål",
                            "dbMappingId": 701
                        },
                        {
                            "id": 2257,
                            "name": "13",
                            "platformId": 3,
                            "isActive": 1,
                            "platformName": "Meta",
                            "displayName": "Norwegian Bokmål",
                            "dbMappingId": 702
                        },
                        {
                            "id": 3935,
                            "name": "644",
                            "platformId": 8,
                            "isActive": 1,
                            "platformName": "ViAds",
                            "displayName": "Norwegian Bokmål",
                            "dbMappingId": 1102
                        }
                    ]
                },
                {
                    "id": 2259,
                    "name": "Venda",
                    "platformId": 1,
                    "isActive": 1,
                    "platformName": "Beki",
                    "displayName": "Venda",
                    "mappingDetails": [
                        {
                            "id": 2261,
                            "name": "1334",
                            "platformId": 2,
                            "isActive": 1,
                            "platformName": "ION",
                            "displayName": "Venda",
                            "dbMappingId": 703
                        },
                        {
                            "id": 3937,
                            "name": "700",
                            "platformId": 8,
                            "isActive": 1,
                            "platformName": "ViAds",
                            "displayName": "Venda",
                            "dbMappingId": 1103
                        }
                    ]
                },
                {
                    "id": 2263,
                    "name": "Maori",
                    "platformId": 1,
                    "isActive": 1,
                    "platformName": "Beki",
                    "displayName": "Maori",
                    "mappingDetails": [
                        {
                            "id": 2265,
                            "name": "1267",
                            "platformId": 2,
                            "isActive": 1,
                            "platformName": "ION",
                            "displayName": "Maori",
                            "dbMappingId": 704
                        },
                        {
                            "id": 3939,
                            "name": "633",
                            "platformId": 8,
                            "isActive": 1,
                            "platformName": "ViAds",
                            "displayName": "Maori",
                            "dbMappingId": 1104
                        }
                    ]
                },
                {
                    "id": 2267,
                    "name": "Aymara",
                    "platformId": 1,
                    "isActive": 1,
                    "platformName": "Beki",
                    "displayName": "Aymara",
                    "mappingDetails": [
                        {
                            "id": 2269,
                            "name": "1174",
                            "platformId": 2,
                            "isActive": 1,
                            "platformName": "ION",
                            "displayName": "Aymara",
                            "dbMappingId": 705
                        },
                        {
                            "id": 3943,
                            "name": "540",
                            "platformId": 8,
                            "isActive": 1,
                            "platformName": "ViAds",
                            "displayName": "Aymara",
                            "dbMappingId": 1106
                        }
                    ]
                },
                {
                    "id": 2271,
                    "name": "Ossetian, Ossetic",
                    "platformId": 1,
                    "isActive": 1,
                    "platformName": "Beki",
                    "displayName": "Ossetian, Ossetic",
                    "mappingDetails": [
                        {
                            "id": 2273,
                            "name": "1285",
                            "platformId": 2,
                            "isActive": 1,
                            "platformName": "ION",
                            "displayName": "Ossetian, Ossetic",
                            "dbMappingId": 706
                        },
                        {
                            "id": 3949,
                            "name": "651",
                            "platformId": 8,
                            "isActive": 1,
                            "platformName": "ViAds",
                            "displayName": "Ossetian, Ossetic",
                            "dbMappingId": 1109
                        }
                    ]
                },
                {
                    "id": 2275,
                    "name": "Luxembourgish, Letzeburgesch",
                    "platformId": 1,
                    "isActive": 1,
                    "platformName": "Beki",
                    "displayName": "Luxembourgish, Letzeburgesch",
                    "mappingDetails": [
                        {
                            "id": 2277,
                            "name": "1260",
                            "platformId": 2,
                            "isActive": 1,
                            "platformName": "ION",
                            "displayName": "Luxembourgish, Letzeburgesch",
                            "dbMappingId": 707
                        },
                        {
                            "id": 3951,
                            "name": "626",
                            "platformId": 8,
                            "isActive": 1,
                            "platformName": "ViAds",
                            "displayName": "Luxembourgish, Letzeburgesch",
                            "dbMappingId": 1110
                        }
                    ]
                },
                {
                    "id": 2279,
                    "name": "Xhosa",
                    "platformId": 1,
                    "isActive": 1,
                    "platformName": "Beki",
                    "displayName": "Xhosa",
                    "mappingDetails": [
                        {
                            "id": 2281,
                            "name": "1340",
                            "platformId": 2,
                            "isActive": 1,
                            "platformName": "ION",
                            "displayName": "Xhosa",
                            "dbMappingId": 708
                        },
                        {
                            "id": 3955,
                            "name": "706",
                            "platformId": 8,
                            "isActive": 1,
                            "platformName": "ViAds",
                            "displayName": "Xhosa",
                            "dbMappingId": 1112
                        }
                    ]
                },
                {
                    "id": 2283,
                    "name": "Welsh",
                    "platformId": 1,
                    "isActive": 1,
                    "platformName": "Beki",
                    "displayName": "Welsh",
                    "mappingDetails": [
                        {
                            "id": 2285,
                            "name": "1338",
                            "platformId": 2,
                            "isActive": 1,
                            "platformName": "ION",
                            "displayName": "Welsh",
                            "dbMappingId": 709
                        },
                        {
                            "id": 2287,
                            "name": "3",
                            "platformId": 3,
                            "isActive": 1,
                            "platformName": "Meta",
                            "displayName": "Welsh",
                            "dbMappingId": 710
                        },
                        {
                            "id": 3963,
                            "name": "704",
                            "platformId": 8,
                            "isActive": 1,
                            "platformName": "ViAds",
                            "displayName": "Welsh",
                            "dbMappingId": 1116
                        }
                    ]
                },
                {
                    "id": 2289,
                    "name": "Faroese",
                    "platformId": 1,
                    "isActive": 1,
                    "platformName": "Beki",
                    "displayName": "Faroese",
                    "mappingDetails": [
                        {
                            "id": 2291,
                            "name": "1206",
                            "platformId": 2,
                            "isActive": 1,
                            "platformName": "ION",
                            "displayName": "Faroese",
                            "dbMappingId": 711
                        },
                        {
                            "id": 2293,
                            "name": "62",
                            "platformId": 3,
                            "isActive": 1,
                            "platformName": "Meta",
                            "displayName": "Faroese",
                            "dbMappingId": 712
                        },
                        {
                            "id": 3965,
                            "name": "572",
                            "platformId": 8,
                            "isActive": 1,
                            "platformName": "ViAds",
                            "displayName": "Faroese",
                            "dbMappingId": 1117
                        }
                    ]
                },
                {
                    "id": 2295,
                    "name": "Herero",
                    "platformId": 1,
                    "isActive": 1,
                    "platformName": "Beki",
                    "displayName": "Herero",
                    "mappingDetails": [
                        {
                            "id": 2297,
                            "name": "1224",
                            "platformId": 2,
                            "isActive": 1,
                            "platformName": "ION",
                            "displayName": "Herero",
                            "dbMappingId": 713
                        },
                        {
                            "id": 3967,
                            "name": "590",
                            "platformId": 8,
                            "isActive": 1,
                            "platformName": "ViAds",
                            "displayName": "Herero",
                            "dbMappingId": 1118
                        }
                    ]
                },
                {
                    "id": 2299,
                    "name": "Croatian",
                    "platformId": 1,
                    "isActive": 1,
                    "platformName": "Beki",
                    "displayName": "Croatian",
                    "mappingDetails": [
                        {
                            "id": 2301,
                            "name": "1196",
                            "platformId": 2,
                            "isActive": 1,
                            "platformName": "ION",
                            "displayName": "Croatian",
                            "dbMappingId": 714
                        },
                        {
                            "id": 2303,
                            "name": "38",
                            "platformId": 3,
                            "isActive": 1,
                            "platformName": "Meta",
                            "displayName": "Croatian",
                            "dbMappingId": 715
                        },
                        {
                            "id": 2305,
                            "name": "languageConstants/1039",
                            "platformId": 4,
                            "isActive": 1,
                            "platformName": "Google Ads",
                            "displayName": "Croatian",
                            "dbMappingId": 716
                        },
                        {
                            "id": 3971,
                            "name": "562",
                            "platformId": 8,
                            "isActive": 1,
                            "platformName": "ViAds",
                            "displayName": "Croatian",
                            "dbMappingId": 1120
                        }
                    ]
                },
                {
                    "id": 2307,
                    "name": "Uighur",
                    "platformId": 1,
                    "isActive": 1,
                    "platformName": "Beki",
                    "displayName": "Uighur",
                    "mappingDetails": [
                        {
                            "id": 2309,
                            "name": "1330",
                            "platformId": 2,
                            "isActive": 1,
                            "platformName": "ION",
                            "displayName": "Uighur",
                            "dbMappingId": 717
                        }
                    ]
                },
                {
                    "id": 2311,
                    "name": "Danish",
                    "platformId": 1,
                    "isActive": 1,
                    "platformName": "Beki",
                    "displayName": "Danish",
                    "mappingDetails": [
                        {
                            "id": 2313,
                            "name": "1198",
                            "platformId": 2,
                            "isActive": 1,
                            "platformName": "ION",
                            "displayName": "Danish",
                            "dbMappingId": 718
                        },
                        {
                            "id": 2315,
                            "name": "4",
                            "platformId": 3,
                            "isActive": 1,
                            "platformName": "Meta",
                            "displayName": "Danish",
                            "dbMappingId": 719
                        },
                        {
                            "id": 2317,
                            "name": "languageConstants/1009",
                            "platformId": 4,
                            "isActive": 1,
                            "platformName": "Google Ads",
                            "displayName": "Danish",
                            "dbMappingId": 720
                        },
                        {
                            "id": 3979,
                            "name": "564",
                            "platformId": 8,
                            "isActive": 1,
                            "platformName": "ViAds",
                            "displayName": "Danish",
                            "dbMappingId": 1124
                        }
                    ]
                },
                {
                    "id": 2319,
                    "name": "Amharic",
                    "platformId": 1,
                    "isActive": 1,
                    "platformName": "Beki",
                    "displayName": "Amharic",
                    "mappingDetails": [
                        {
                            "id": 2321,
                            "name": "1167",
                            "platformId": 2,
                            "isActive": 1,
                            "platformName": "ION",
                            "displayName": "Amharic",
                            "dbMappingId": 721
                        },
                        {
                            "id": 3983,
                            "name": "533",
                            "platformId": 8,
                            "isActive": 1,
                            "platformName": "ViAds",
                            "displayName": "Amharic",
                            "dbMappingId": 1126
                        }
                    ]
                },
                {
                    "id": 2323,
                    "name": "Greek",
                    "platformId": 1,
                    "isActive": 1,
                    "platformName": "Beki",
                    "displayName": "Greek",
                    "mappingDetails": [
                        {
                            "id": 2325,
                            "name": "1217",
                            "platformId": 2,
                            "isActive": 1,
                            "platformName": "ION",
                            "displayName": "Greek",
                            "dbMappingId": 722
                        },
                        {
                            "id": 2327,
                            "name": "39",
                            "platformId": 3,
                            "isActive": 1,
                            "platformName": "Meta",
                            "displayName": "Greek",
                            "dbMappingId": 723
                        },
                        {
                            "id": 2329,
                            "name": "languageConstants/1022",
                            "platformId": 4,
                            "isActive": 1,
                            "platformName": "Google Ads",
                            "displayName": "Greek",
                            "dbMappingId": 724
                        },
                        {
                            "id": 2331,
                            "name": "el",
                            "platformId": 7,
                            "isActive": 1,
                            "platformName": "TikTok",
                            "displayName": "Greek",
                            "dbMappingId": 725
                        }
                    ]
                },
                {
                    "id": 2333,
                    "name": "Tswana",
                    "platformId": 1,
                    "isActive": 1,
                    "platformName": "Beki",
                    "displayName": "Tswana",
                    "mappingDetails": [
                        {
                            "id": 2335,
                            "name": "1326",
                            "platformId": 2,
                            "isActive": 1,
                            "platformName": "ION",
                            "displayName": "Tswana",
                            "dbMappingId": 726
                        },
                        {
                            "id": 3987,
                            "name": "692",
                            "platformId": 8,
                            "isActive": 1,
                            "platformName": "ViAds",
                            "displayName": "Tswana",
                            "dbMappingId": 1128
                        }
                    ]
                },
                {
                    "id": 2337,
                    "name": "Ndonga",
                    "platformId": 1,
                    "isActive": 1,
                    "platformName": "Beki",
                    "displayName": "Ndonga",
                    "mappingDetails": [
                        {
                            "id": 2339,
                            "name": "1275",
                            "platformId": 2,
                            "isActive": 1,
                            "platformName": "ION",
                            "displayName": "Ndonga",
                            "dbMappingId": 727
                        },
                        {
                            "id": 3623,
                            "name": "641",
                            "platformId": 8,
                            "isActive": 1,
                            "platformName": "ViAds",
                            "displayName": "Ndonga",
                            "dbMappingId": 946
                        }
                    ]
                },
                {
                    "id": 2341,
                    "name": "Southern Sotho",
                    "platformId": 1,
                    "isActive": 1,
                    "platformName": "Beki",
                    "displayName": "Southern Sotho",
                    "mappingDetails": [
                        {
                            "id": 2343,
                            "name": "1309",
                            "platformId": 2,
                            "isActive": 1,
                            "platformName": "ION",
                            "displayName": "Southern Sotho",
                            "dbMappingId": 728
                        },
                        {
                            "id": 3625,
                            "name": "675",
                            "platformId": 8,
                            "isActive": 1,
                            "platformName": "ViAds",
                            "displayName": "Southern Sotho",
                            "dbMappingId": 947
                        }
                    ]
                },
                {
                    "id": 2345,
                    "name": "Hebrew",
                    "platformId": 1,
                    "isActive": 1,
                    "platformName": "Beki",
                    "displayName": "Hebrew",
                    "mappingDetails": [
                        {
                            "id": 2347,
                            "name": "1223",
                            "platformId": 2,
                            "isActive": 1,
                            "platformName": "ION",
                            "displayName": "Hebrew",
                            "dbMappingId": 729
                        },
                        {
                            "id": 2349,
                            "name": "29",
                            "platformId": 3,
                            "isActive": 1,
                            "platformName": "Meta",
                            "displayName": "Hebrew",
                            "dbMappingId": 730
                        },
                        {
                            "id": 2351,
                            "name": "languageConstants/1027",
                            "platformId": 4,
                            "isActive": 1,
                            "platformName": "Google Ads",
                            "displayName": "Hebrew",
                            "dbMappingId": 731
                        },
                        {
                            "id": 2353,
                            "name": "he",
                            "platformId": 7,
                            "isActive": 1,
                            "platformName": "TikTok",
                            "displayName": "Hebrew",
                            "dbMappingId": 732
                        },
                        {
                            "id": 3631,
                            "name": "589",
                            "platformId": 8,
                            "isActive": 1,
                            "platformName": "ViAds",
                            "displayName": "Hebrew",
                            "dbMappingId": 950
                        }
                    ]
                },
                {
                    "id": 2355,
                    "name": "Mongolian",
                    "platformId": 1,
                    "isActive": 1,
                    "platformName": "Beki",
                    "displayName": "Mongolian",
                    "mappingDetails": [
                        {
                            "id": 2357,
                            "name": "1270",
                            "platformId": 2,
                            "isActive": 1,
                            "platformName": "ION",
                            "displayName": "Mongolian",
                            "dbMappingId": 733
                        },
                        {
                            "id": 2359,
                            "name": "80",
                            "platformId": 3,
                            "isActive": 1,
                            "platformName": "Meta",
                            "displayName": "Mongolian",
                            "dbMappingId": 734
                        },
                        {
                            "id": 3639,
                            "name": "636",
                            "platformId": 8,
                            "isActive": 1,
                            "platformName": "ViAds",
                            "displayName": "Mongolian",
                            "dbMappingId": 954
                        }
                    ]
                },
                {
                    "id": 2361,
                    "name": "Shona",
                    "platformId": 1,
                    "isActive": 1,
                    "platformName": "Beki",
                    "displayName": "Shona",
                    "mappingDetails": [
                        {
                            "id": 2363,
                            "name": "1303",
                            "platformId": 2,
                            "isActive": 1,
                            "platformName": "ION",
                            "displayName": "Shona",
                            "dbMappingId": 735
                        },
                        {
                            "id": 3645,
                            "name": "669",
                            "platformId": 8,
                            "isActive": 1,
                            "platformName": "ViAds",
                            "displayName": "Shona",
                            "dbMappingId": 957
                        }
                    ]
                },
                {
                    "id": 2365,
                    "name": "Ukrainian",
                    "platformId": 1,
                    "isActive": 1,
                    "platformName": "Beki",
                    "displayName": "Ukrainian",
                    "mappingDetails": [
                        {
                            "id": 2367,
                            "name": "1331",
                            "platformId": 2,
                            "isActive": 1,
                            "platformName": "ION",
                            "displayName": "Ukrainian",
                            "dbMappingId": 736
                        },
                        {
                            "id": 2369,
                            "name": "52",
                            "platformId": 3,
                            "isActive": 1,
                            "platformName": "Meta",
                            "displayName": "Ukrainian",
                            "dbMappingId": 737
                        },
                        {
                            "id": 2371,
                            "name": "languageConstants/1036",
                            "platformId": 4,
                            "isActive": 1,
                            "platformName": "Google Ads",
                            "displayName": "Ukrainian",
                            "dbMappingId": 738
                        },
                        {
                            "id": 2373,
                            "name": "uk",
                            "platformId": 7,
                            "isActive": 1,
                            "platformName": "TikTok",
                            "displayName": "Ukrainian",
                            "dbMappingId": 739
                        },
                        {
                            "id": 3651,
                            "name": "697",
                            "platformId": 8,
                            "isActive": 1,
                            "platformName": "ViAds",
                            "displayName": "Ukrainian",
                            "dbMappingId": 960
                        }
                    ]
                },
                {
                    "id": 2375,
                    "name": "Limburgan, Limburger, Limburgish",
                    "platformId": 1,
                    "isActive": 1,
                    "platformName": "Beki",
                    "displayName": "Limburgan, Limburger, Limburgish",
                    "mappingDetails": [
                        {
                            "id": 2377,
                            "name": "1256",
                            "platformId": 2,
                            "isActive": 1,
                            "platformName": "ION",
                            "displayName": "Limburgan, Limburger, Limburgish",
                            "dbMappingId": 740
                        },
                        {
                            "id": 3655,
                            "name": "622",
                            "platformId": 8,
                            "isActive": 1,
                            "platformName": "ViAds",
                            "displayName": "Limburgan, Limburger, Limburgish",
                            "dbMappingId": 962
                        }
                    ]
                },
                {
                    "id": 2379,
                    "name": "Northern Sami",
                    "platformId": 1,
                    "isActive": 1,
                    "platformName": "Beki",
                    "displayName": "Northern Sami",
                    "mappingDetails": [
                        {
                            "id": 2381,
                            "name": "1297",
                            "platformId": 2,
                            "isActive": 1,
                            "platformName": "ION",
                            "displayName": "Northern Sami",
                            "dbMappingId": 741
                        },
                        {
                            "id": 3657,
                            "name": "663",
                            "platformId": 8,
                            "isActive": 1,
                            "platformName": "ViAds",
                            "displayName": "Northern Sami",
                            "dbMappingId": 963
                        }
                    ]
                },
                {
                    "id": 2383,
                    "name": "Kikuyu, Gikuyu",
                    "platformId": 1,
                    "isActive": 1,
                    "platformName": "Beki",
                    "displayName": "Kikuyu, Gikuyu",
                    "mappingDetails": [
                        {
                            "id": 2385,
                            "name": "1245",
                            "platformId": 2,
                            "isActive": 1,
                            "platformName": "ION",
                            "displayName": "Kikuyu, Gikuyu",
                            "dbMappingId": 742
                        },
                        {
                            "id": 3661,
                            "name": "611",
                            "platformId": 8,
                            "isActive": 1,
                            "platformName": "ViAds",
                            "displayName": "Kikuyu, Gikuyu",
                            "dbMappingId": 965
                        }
                    ]
                },
                {
                    "id": 2387,
                    "name": "Malay",
                    "platformId": 1,
                    "isActive": 1,
                    "platformName": "Beki",
                    "displayName": "Malay",
                    "mappingDetails": [
                        {
                            "id": 2389,
                            "name": "1263",
                            "platformId": 2,
                            "isActive": 1,
                            "platformName": "ION",
                            "displayName": "Malay",
                            "dbMappingId": 743
                        },
                        {
                            "id": 2391,
                            "name": "41",
                            "platformId": 3,
                            "isActive": 1,
                            "platformName": "Meta",
                            "displayName": "Malay",
                            "dbMappingId": 744
                        },
                        {
                            "id": 2393,
                            "name": "languageConstants/1102",
                            "platformId": 4,
                            "isActive": 1,
                            "platformName": "Google Ads",
                            "displayName": "Malay",
                            "dbMappingId": 745
                        },
                        {
                            "id": 2395,
                            "name": "ms",
                            "platformId": 7,
                            "isActive": 1,
                            "platformName": "TikTok",
                            "displayName": "Malay",
                            "dbMappingId": 746
                        },
                        {
                            "id": 3663,
                            "name": "629",
                            "platformId": 8,
                            "isActive": 1,
                            "platformName": "ViAds",
                            "displayName": "Malay",
                            "dbMappingId": 966
                        }
                    ]
                },
                {
                    "id": 2397,
                    "name": "North Ndebele",
                    "platformId": 1,
                    "isActive": 1,
                    "platformName": "Beki",
                    "displayName": "North Ndebele",
                    "mappingDetails": [
                        {
                            "id": 2399,
                            "name": "1273",
                            "platformId": 2,
                            "isActive": 1,
                            "platformName": "ION",
                            "displayName": "North Ndebele",
                            "dbMappingId": 747
                        },
                        {
                            "id": 3665,
                            "name": "639",
                            "platformId": 8,
                            "isActive": 1,
                            "platformName": "ViAds",
                            "displayName": "North Ndebele",
                            "dbMappingId": 967
                        }
                    ]
                },
                {
                    "id": 2401,
                    "name": "Rajasthani",
                    "platformId": 1,
                    "isActive": 1,
                    "platformName": "Beki",
                    "displayName": "Rajasthani",
                    "mappingDetails": [
                        {
                            "id": 2403,
                            "name": "raj",
                            "platformId": 7,
                            "isActive": 1,
                            "platformName": "TikTok",
                            "displayName": "Rajasthani",
                            "dbMappingId": 748
                        }
                    ]
                },
                {
                    "id": 2405,
                    "name": "Swahili",
                    "platformId": 1,
                    "isActive": 1,
                    "platformName": "Beki",
                    "displayName": "Swahili",
                    "mappingDetails": [
                        {
                            "id": 2407,
                            "name": "1312",
                            "platformId": 2,
                            "isActive": 1,
                            "platformName": "ION",
                            "displayName": "Swahili",
                            "dbMappingId": 749
                        },
                        {
                            "id": 2409,
                            "name": "88",
                            "platformId": 3,
                            "isActive": 1,
                            "platformName": "Meta",
                            "displayName": "Swahili",
                            "dbMappingId": 750
                        },
                        {
                            "id": 3675,
                            "name": "678",
                            "platformId": 8,
                            "isActive": 1,
                            "platformName": "ViAds",
                            "displayName": "Swahili",
                            "dbMappingId": 972
                        }
                    ]
                },
                {
                    "id": 2411,
                    "name": "Afar",
                    "platformId": 1,
                    "isActive": 1,
                    "platformName": "Beki",
                    "displayName": "Afar",
                    "mappingDetails": [
                        {
                            "id": 2413,
                            "name": "1163",
                            "platformId": 2,
                            "isActive": 1,
                            "platformName": "ION",
                            "displayName": "Afar",
                            "dbMappingId": 751
                        },
                        {
                            "id": 3683,
                            "name": "529",
                            "platformId": 8,
                            "isActive": 1,
                            "platformName": "ViAds",
                            "displayName": "Afar",
                            "dbMappingId": 976
                        }
                    ]
                },
                {
                    "id": 2415,
                    "name": "Macedonian",
                    "platformId": 1,
                    "isActive": 1,
                    "platformName": "Beki",
                    "displayName": "Macedonian",
                    "mappingDetails": [
                        {
                            "id": 2417,
                            "name": "1261",
                            "platformId": 2,
                            "isActive": 1,
                            "platformName": "ION",
                            "displayName": "Macedonian",
                            "dbMappingId": 752
                        },
                        {
                            "id": 2419,
                            "name": "79",
                            "platformId": 3,
                            "isActive": 1,
                            "platformName": "Meta",
                            "displayName": "Macedonian",
                            "dbMappingId": 753
                        },
                        {
                            "id": 3689,
                            "name": "627",
                            "platformId": 8,
                            "isActive": 1,
                            "platformName": "ViAds",
                            "displayName": "Macedonian",
                            "dbMappingId": 979
                        }
                    ]
                },
                {
                    "id": 2421,
                    "name": "Japanese",
                    "platformId": 1,
                    "isActive": 1,
                    "platformName": "Beki",
                    "displayName": "Japanese",
                    "mappingDetails": [
                        {
                            "id": 2423,
                            "name": "1238",
                            "platformId": 2,
                            "isActive": 1,
                            "platformName": "ION",
                            "displayName": "Japanese",
                            "dbMappingId": 754
                        },
                        {
                            "id": 2425,
                            "name": "11",
                            "platformId": 3,
                            "isActive": 1,
                            "platformName": "Meta",
                            "displayName": "Japanese",
                            "dbMappingId": 755
                        },
                        {
                            "id": 2427,
                            "name": "languageConstants/1005",
                            "platformId": 4,
                            "isActive": 1,
                            "platformName": "Google Ads",
                            "displayName": "Japanese",
                            "dbMappingId": 756
                        },
                        {
                            "id": 2429,
                            "name": "ja",
                            "platformId": 7,
                            "isActive": 1,
                            "platformName": "TikTok",
                            "displayName": "Japanese",
                            "dbMappingId": 757
                        },
                        {
                            "id": 3693,
                            "name": "604",
                            "platformId": 8,
                            "isActive": 1,
                            "platformName": "ViAds",
                            "displayName": "Japanese",
                            "dbMappingId": 981
                        }
                    ]
                },
                {
                    "id": 2431,
                    "name": "Estonian",
                    "platformId": 1,
                    "isActive": 1,
                    "platformName": "Beki",
                    "displayName": "Estonian",
                    "mappingDetails": [
                        {
                            "id": 2433,
                            "name": "1204",
                            "platformId": 2,
                            "isActive": 1,
                            "platformName": "ION",
                            "displayName": "Estonian",
                            "dbMappingId": 758
                        },
                        {
                            "id": 2435,
                            "name": "58",
                            "platformId": 3,
                            "isActive": 1,
                            "platformName": "Meta",
                            "displayName": "Estonian",
                            "dbMappingId": 759
                        },
                        {
                            "id": 2437,
                            "name": "languageConstants/1043",
                            "platformId": 4,
                            "isActive": 1,
                            "platformName": "Google Ads",
                            "displayName": "Estonian",
                            "dbMappingId": 760
                        },
                        {
                            "id": 3695,
                            "name": "570",
                            "platformId": 8,
                            "isActive": 1,
                            "platformName": "ViAds",
                            "displayName": "Estonian",
                            "dbMappingId": 982
                        }
                    ]
                },
                {
                    "id": 2439,
                    "name": "Sindhi",
                    "platformId": 1,
                    "isActive": 1,
                    "platformName": "Beki",
                    "displayName": "Sindhi",
                    "mappingDetails": [
                        {
                            "id": 2441,
                            "name": "1304",
                            "platformId": 2,
                            "isActive": 1,
                            "platformName": "ION",
                            "displayName": "Sindhi",
                            "dbMappingId": 761
                        },
                        {
                            "id": 3697,
                            "name": "670",
                            "platformId": 8,
                            "isActive": 1,
                            "platformName": "ViAds",
                            "displayName": "Sindhi",
                            "dbMappingId": 983
                        }
                    ]
                },
                {
                    "id": 2443,
                    "name": "Haryanvi",
                    "platformId": 1,
                    "isActive": 1,
                    "platformName": "Beki",
                    "displayName": "Haryanvi",
                    "mappingDetails": [
                        {
                            "id": 2445,
                            "name": "bgc",
                            "platformId": 7,
                            "isActive": 1,
                            "platformName": "TikTok",
                            "displayName": "Haryanvi",
                            "dbMappingId": 762
                        }
                    ]
                },
                {
                    "id": 2447,
                    "name": "Bengali",
                    "platformId": 1,
                    "isActive": 1,
                    "platformName": "Beki",
                    "displayName": "Bengali",
                    "mappingDetails": [
                        {
                            "id": 2449,
                            "name": "1180",
                            "platformId": 2,
                            "isActive": 1,
                            "platformName": "ION",
                            "displayName": "Bengali",
                            "dbMappingId": 763
                        },
                        {
                            "id": 2451,
                            "name": "45",
                            "platformId": 3,
                            "isActive": 1,
                            "platformName": "Meta",
                            "displayName": "Bengali",
                            "dbMappingId": 764
                        },
                        {
                            "id": 2453,
                            "name": "languageConstants/1056",
                            "platformId": 4,
                            "isActive": 1,
                            "platformName": "Google Ads",
                            "displayName": "Bengali",
                            "dbMappingId": 765
                        },
                        {
                            "id": 2455,
                            "name": "bn",
                            "platformId": 7,
                            "isActive": 1,
                            "platformName": "TikTok",
                            "displayName": "Bengali",
                            "dbMappingId": 766
                        },
                        {
                            "id": 3699,
                            "name": "546",
                            "platformId": 8,
                            "isActive": 1,
                            "platformName": "ViAds",
                            "displayName": "Bengali",
                            "dbMappingId": 984
                        }
                    ]
                },
                {
                    "id": 2457,
                    "name": "Kanuri",
                    "platformId": 1,
                    "isActive": 1,
                    "platformName": "Beki",
                    "displayName": "Kanuri",
                    "mappingDetails": [
                        {
                            "id": 2459,
                            "name": "1241",
                            "platformId": 2,
                            "isActive": 1,
                            "platformName": "ION",
                            "displayName": "Kanuri",
                            "dbMappingId": 767
                        },
                        {
                            "id": 3701,
                            "name": "607",
                            "platformId": 8,
                            "isActive": 1,
                            "platformName": "ViAds",
                            "displayName": "Kanuri",
                            "dbMappingId": 985
                        }
                    ]
                },
                {
                    "id": 2461,
                    "name": "Spanish, Castilian",
                    "platformId": 1,
                    "isActive": 1,
                    "platformName": "Beki",
                    "displayName": "Spanish, Castilian",
                    "mappingDetails": [
                        {
                            "id": 2463,
                            "name": "1310",
                            "platformId": 2,
                            "isActive": 1,
                            "platformName": "ION",
                            "displayName": "Spanish, Castilian",
                            "dbMappingId": 768
                        },
                        {
                            "id": 3707,
                            "name": "676",
                            "platformId": 8,
                            "isActive": 1,
                            "platformName": "ViAds",
                            "displayName": "Spanish, Castilian",
                            "dbMappingId": 988
                        }
                    ]
                },
                {
                    "id": 2465,
                    "name": "Tatar",
                    "platformId": 1,
                    "isActive": 1,
                    "platformName": "Beki",
                    "displayName": "Tatar",
                    "mappingDetails": [
                        {
                            "id": 2467,
                            "name": "1319",
                            "platformId": 2,
                            "isActive": 1,
                            "platformName": "ION",
                            "displayName": "Tatar",
                            "dbMappingId": 769
                        },
                        {
                            "id": 3709,
                            "name": "685",
                            "platformId": 8,
                            "isActive": 1,
                            "platformName": "ViAds",
                            "displayName": "Tatar",
                            "dbMappingId": 989
                        }
                    ]
                },
                {
                    "id": 2469,
                    "name": "Chechen",
                    "platformId": 1,
                    "isActive": 1,
                    "platformName": "Beki",
                    "displayName": "Chechen",
                    "mappingDetails": [
                        {
                            "id": 2471,
                            "name": "1188",
                            "platformId": 2,
                            "isActive": 1,
                            "platformName": "ION",
                            "displayName": "Chechen",
                            "dbMappingId": 770
                        },
                        {
                            "id": 3711,
                            "name": "554",
                            "platformId": 8,
                            "isActive": 1,
                            "platformName": "ViAds",
                            "displayName": "Chechen",
                            "dbMappingId": 990
                        }
                    ]
                },
                {
                    "id": 2473,
                    "name": "Haitian, Haitian Creole",
                    "platformId": 1,
                    "isActive": 1,
                    "platformName": "Beki",
                    "displayName": "Haitian, Haitian Creole",
                    "mappingDetails": [
                        {
                            "id": 2475,
                            "name": "1221",
                            "platformId": 2,
                            "isActive": 1,
                            "platformName": "ION",
                            "displayName": "Haitian, Haitian Creole",
                            "dbMappingId": 771
                        },
                        {
                            "id": 3713,
                            "name": "587",
                            "platformId": 8,
                            "isActive": 1,
                            "platformName": "ViAds",
                            "displayName": "Haitian, Haitian Creole",
                            "dbMappingId": 991
                        }
                    ]
                },
                {
                    "id": 2477,
                    "name": "Tibetan",
                    "platformId": 1,
                    "isActive": 1,
                    "platformName": "Beki",
                    "displayName": "Tibetan",
                    "mappingDetails": [
                        {
                            "id": 2479,
                            "name": "1322",
                            "platformId": 2,
                            "isActive": 1,
                            "platformName": "ION",
                            "displayName": "Tibetan",
                            "dbMappingId": 772
                        },
                        {
                            "id": 3721,
                            "name": "688",
                            "platformId": 8,
                            "isActive": 1,
                            "platformName": "ViAds",
                            "displayName": "Tibetan",
                            "dbMappingId": 995
                        }
                    ]
                },
                {
                    "id": 2481,
                    "name": "Uzbek",
                    "platformId": 1,
                    "isActive": 1,
                    "platformName": "Beki",
                    "displayName": "Uzbek",
                    "mappingDetails": [
                        {
                            "id": 2483,
                            "name": "1333",
                            "platformId": 2,
                            "isActive": 1,
                            "platformName": "ION",
                            "displayName": "Uzbek",
                            "dbMappingId": 773
                        },
                        {
                            "id": 2485,
                            "name": "91",
                            "platformId": 3,
                            "isActive": 1,
                            "platformName": "Meta",
                            "displayName": "Uzbek",
                            "dbMappingId": 774
                        },
                        {
                            "id": 3723,
                            "name": "699",
                            "platformId": 8,
                            "isActive": 1,
                            "platformName": "ViAds",
                            "displayName": "Uzbek",
                            "dbMappingId": 996
                        }
                    ]
                },
                {
                    "id": 2487,
                    "name": "Persian",
                    "platformId": 1,
                    "isActive": 1,
                    "platformName": "Beki",
                    "displayName": "Persian",
                    "mappingDetails": [
                        {
                            "id": 2489,
                            "name": "1288",
                            "platformId": 2,
                            "isActive": 1,
                            "platformName": "ION",
                            "displayName": "Persian",
                            "dbMappingId": 775
                        },
                        {
                            "id": 2491,
                            "name": "60",
                            "platformId": 3,
                            "isActive": 1,
                            "platformName": "Meta",
                            "displayName": "Persian",
                            "dbMappingId": 776
                        },
                        {
                            "id": 2493,
                            "name": "languageConstants/1064",
                            "platformId": 4,
                            "isActive": 1,
                            "platformName": "Google Ads",
                            "displayName": "Persian",
                            "dbMappingId": 777
                        },
                        {
                            "id": 3729,
                            "name": "654",
                            "platformId": 8,
                            "isActive": 1,
                            "platformName": "ViAds",
                            "displayName": "Persian",
                            "dbMappingId": 999
                        }
                    ]
                },
                {
                    "id": 2495,
                    "name": "German",
                    "platformId": 1,
                    "isActive": 1,
                    "platformName": "Beki",
                    "displayName": "German",
                    "mappingDetails": [
                        {
                            "id": 2497,
                            "name": "1216",
                            "platformId": 2,
                            "isActive": 1,
                            "platformName": "ION",
                            "displayName": "German",
                            "dbMappingId": 778
                        },
                        {
                            "id": 2499,
                            "name": "5",
                            "platformId": 3,
                            "isActive": 1,
                            "platformName": "Meta",
                            "displayName": "German",
                            "dbMappingId": 779
                        },
                        {
                            "id": 2501,
                            "name": "languageConstants/1001",
                            "platformId": 4,
                            "isActive": 1,
                            "platformName": "Google Ads",
                            "displayName": "German",
                            "dbMappingId": 780
                        },
                        {
                            "id": 2503,
                            "name": "de",
                            "platformId": 7,
                            "isActive": 1,
                            "platformName": "TikTok",
                            "displayName": "German",
                            "dbMappingId": 781
                        },
                        {
                            "id": 3731,
                            "name": "582",
                            "platformId": 8,
                            "isActive": 1,
                            "platformName": "ViAds",
                            "displayName": "German",
                            "dbMappingId": 1000
                        }
                    ]
                },
                {
                    "id": 2505,
                    "name": "Azerbaijani",
                    "platformId": 1,
                    "isActive": 1,
                    "platformName": "Beki",
                    "displayName": "Azerbaijani",
                    "mappingDetails": [
                        {
                            "id": 2507,
                            "name": "1175",
                            "platformId": 2,
                            "isActive": 1,
                            "platformName": "ION",
                            "displayName": "Azerbaijani",
                            "dbMappingId": 782
                        },
                        {
                            "id": 2509,
                            "name": "53",
                            "platformId": 3,
                            "isActive": 1,
                            "platformName": "Meta",
                            "displayName": "Azerbaijani",
                            "dbMappingId": 783
                        },
                        {
                            "id": 3737,
                            "name": "541",
                            "platformId": 8,
                            "isActive": 1,
                            "platformName": "ViAds",
                            "displayName": "Azerbaijani",
                            "dbMappingId": 1003
                        }
                    ]
                },
                {
                    "id": 2511,
                    "name": "Cree",
                    "platformId": 1,
                    "isActive": 1,
                    "platformName": "Beki",
                    "displayName": "Cree",
                    "mappingDetails": [
                        {
                            "id": 2513,
                            "name": "1195",
                            "platformId": 2,
                            "isActive": 1,
                            "platformName": "ION",
                            "displayName": "Cree",
                            "dbMappingId": 784
                        },
                        {
                            "id": 3739,
                            "name": "561",
                            "platformId": 8,
                            "isActive": 1,
                            "platformName": "ViAds",
                            "displayName": "Cree",
                            "dbMappingId": 1004
                        }
                    ]
                },
                {
                    "id": 2515,
                    "name": "Bihari",
                    "platformId": 1,
                    "isActive": 1,
                    "platformName": "Beki",
                    "displayName": "Bihari",
                    "mappingDetails": [
                        {
                            "id": 2517,
                            "name": "bh",
                            "platformId": 7,
                            "isActive": 1,
                            "platformName": "TikTok",
                            "displayName": "Bihari",
                            "dbMappingId": 785
                        }
                    ]
                },
                {
                    "id": 2519,
                    "name": "Telugu",
                    "platformId": 1,
                    "isActive": 1,
                    "platformName": "Beki",
                    "displayName": "Telugu",
                    "mappingDetails": [
                        {
                            "id": 2521,
                            "name": "1320",
                            "platformId": 2,
                            "isActive": 1,
                            "platformName": "ION",
                            "displayName": "Telugu",
                            "dbMappingId": 786
                        },
                        {
                            "id": 2523,
                            "name": "49",
                            "platformId": 3,
                            "isActive": 1,
                            "platformName": "Meta",
                            "displayName": "Telugu",
                            "dbMappingId": 787
                        },
                        {
                            "id": 2525,
                            "name": "languageConstants/1131",
                            "platformId": 4,
                            "isActive": 1,
                            "platformName": "Google Ads",
                            "displayName": "Telugu",
                            "dbMappingId": 788
                        },
                        {
                            "id": 2527,
                            "name": "te",
                            "platformId": 7,
                            "isActive": 1,
                            "platformName": "TikTok",
                            "displayName": "Telugu",
                            "dbMappingId": 789
                        },
                        {
                            "id": 3741,
                            "name": "686",
                            "platformId": 8,
                            "isActive": 1,
                            "platformName": "ViAds",
                            "displayName": "Telugu",
                            "dbMappingId": 1005
                        }
                    ]
                },
                {
                    "id": 2529,
                    "name": "Filipino",
                    "platformId": 1,
                    "isActive": 1,
                    "platformName": "Beki",
                    "displayName": "Filipino",
                    "mappingDetails": [
                        {
                            "id": 2531,
                            "name": "26",
                            "platformId": 3,
                            "isActive": 1,
                            "platformName": "Meta",
                            "displayName": "Filipino",
                            "dbMappingId": 790
                        },
                        {
                            "id": 2533,
                            "name": "languageConstants/1042",
                            "platformId": 4,
                            "isActive": 1,
                            "platformName": "Google Ads",
                            "displayName": "Filipino",
                            "dbMappingId": 791
                        }
                    ]
                },
                {
                    "id": 2535,
                    "name": "English (UK)",
                    "platformId": 1,
                    "isActive": 1,
                    "platformName": "Beki",
                    "displayName": "English (UK)",
                    "mappingDetails": [
                        {
                            "id": 2537,
                            "name": "24",
                            "platformId": 3,
                            "isActive": 1,
                            "platformName": "Meta",
                            "displayName": "English (UK)",
                            "dbMappingId": 792
                        }
                    ]
                },
                {
                    "id": 2539,
                    "name": "Maltese",
                    "platformId": 1,
                    "isActive": 1,
                    "platformName": "Beki",
                    "displayName": "Maltese",
                    "mappingDetails": [
                        {
                            "id": 2541,
                            "name": "1265",
                            "platformId": 2,
                            "isActive": 1,
                            "platformName": "ION",
                            "displayName": "Maltese",
                            "dbMappingId": 793
                        },
                        {
                            "id": 3747,
                            "name": "631",
                            "platformId": 8,
                            "isActive": 1,
                            "platformName": "ViAds",
                            "displayName": "Maltese",
                            "dbMappingId": 1008
                        }
                    ]
                },
                {
                    "id": 2543,
                    "name": "Esperanto",
                    "platformId": 1,
                    "isActive": 1,
                    "platformName": "Beki",
                    "displayName": "Esperanto",
                    "mappingDetails": [
                        {
                            "id": 2545,
                            "name": "1203",
                            "platformId": 2,
                            "isActive": 1,
                            "platformName": "ION",
                            "displayName": "Esperanto",
                            "dbMappingId": 794
                        },
                        {
                            "id": 2547,
                            "name": "57",
                            "platformId": 3,
                            "isActive": 1,
                            "platformName": "Meta",
                            "displayName": "Esperanto",
                            "dbMappingId": 795
                        },
                        {
                            "id": 3751,
                            "name": "569",
                            "platformId": 8,
                            "isActive": 1,
                            "platformName": "ViAds",
                            "displayName": "Esperanto",
                            "dbMappingId": 1010
                        }
                    ]
                },
                {
                    "id": 2549,
                    "name": "Tagalog",
                    "platformId": 1,
                    "isActive": 1,
                    "platformName": "Beki",
                    "displayName": "Tagalog",
                    "mappingDetails": [
                        {
                            "id": 2551,
                            "name": "1315",
                            "platformId": 2,
                            "isActive": 1,
                            "platformName": "ION",
                            "displayName": "Tagalog",
                            "dbMappingId": 796
                        },
                        {
                            "id": 3753,
                            "name": "681",
                            "platformId": 8,
                            "isActive": 1,
                            "platformName": "ViAds",
                            "displayName": "Tagalog",
                            "dbMappingId": 1011
                        }
                    ]
                },
                {
                    "id": 2553,
                    "name": "Turkmen",
                    "platformId": 1,
                    "isActive": 1,
                    "platformName": "Beki",
                    "displayName": "Turkmen",
                    "mappingDetails": [
                        {
                            "id": 2555,
                            "name": "1328",
                            "platformId": 2,
                            "isActive": 1,
                            "platformName": "ION",
                            "displayName": "Turkmen",
                            "dbMappingId": 797
                        },
                        {
                            "id": 3755,
                            "name": "694",
                            "platformId": 8,
                            "isActive": 1,
                            "platformName": "ViAds",
                            "displayName": "Turkmen",
                            "dbMappingId": 1012
                        }
                    ]
                },
                {
                    "id": 2557,
                    "name": "Nepali",
                    "platformId": 1,
                    "isActive": 1,
                    "platformName": "Beki",
                    "displayName": "Nepali",
                    "mappingDetails": [
                        {
                            "id": 2559,
                            "name": "1276",
                            "platformId": 2,
                            "isActive": 1,
                            "platformName": "ION",
                            "displayName": "Nepali",
                            "dbMappingId": 798
                        },
                        {
                            "id": 2561,
                            "name": "82",
                            "platformId": 3,
                            "isActive": 1,
                            "platformName": "Meta",
                            "displayName": "Nepali",
                            "dbMappingId": 799
                        },
                        {
                            "id": 3757,
                            "name": "642",
                            "platformId": 8,
                            "isActive": 1,
                            "platformName": "ViAds",
                            "displayName": "Nepali",
                            "dbMappingId": 1013
                        }
                    ]
                },
                {
                    "id": 2563,
                    "name": "Georgian",
                    "platformId": 1,
                    "isActive": 1,
                    "platformName": "Beki",
                    "displayName": "Georgian",
                    "mappingDetails": [
                        {
                            "id": 2565,
                            "name": "1215",
                            "platformId": 2,
                            "isActive": 1,
                            "platformName": "ION",
                            "displayName": "Georgian",
                            "dbMappingId": 800
                        },
                        {
                            "id": 2567,
                            "name": "72",
                            "platformId": 3,
                            "isActive": 1,
                            "platformName": "Meta",
                            "displayName": "Georgian",
                            "dbMappingId": 801
                        },
                        {
                            "id": 3759,
                            "name": "581",
                            "platformId": 8,
                            "isActive": 1,
                            "platformName": "ViAds",
                            "displayName": "Georgian",
                            "dbMappingId": 1014
                        }
                    ]
                },
                {
                    "id": 2569,
                    "name": "Swati",
                    "platformId": 1,
                    "isActive": 1,
                    "platformName": "Beki",
                    "displayName": "Swati",
                    "mappingDetails": [
                        {
                            "id": 2571,
                            "name": "1313",
                            "platformId": 2,
                            "isActive": 1,
                            "platformName": "ION",
                            "displayName": "Swati",
                            "dbMappingId": 802
                        },
                        {
                            "id": 3765,
                            "name": "679",
                            "platformId": 8,
                            "isActive": 1,
                            "platformName": "ViAds",
                            "displayName": "Swati",
                            "dbMappingId": 1017
                        }
                    ]
                },
                {
                    "id": 2573,
                    "name": "Cebuano",
                    "platformId": 1,
                    "isActive": 1,
                    "platformName": "Beki",
                    "displayName": "Cebuano",
                    "mappingDetails": [
                        {
                            "id": 2575,
                            "name": "56",
                            "platformId": 3,
                            "isActive": 1,
                            "platformName": "Meta",
                            "displayName": "Cebuano",
                            "dbMappingId": 803
                        }
                    ]
                },
                {
                    "id": 2577,
                    "name": "Chamorro",
                    "platformId": 1,
                    "isActive": 1,
                    "platformName": "Beki",
                    "displayName": "Chamorro",
                    "mappingDetails": [
                        {
                            "id": 2579,
                            "name": "1187",
                            "platformId": 2,
                            "isActive": 1,
                            "platformName": "ION",
                            "displayName": "Chamorro",
                            "dbMappingId": 804
                        },
                        {
                            "id": 3767,
                            "name": "553",
                            "platformId": 8,
                            "isActive": 1,
                            "platformName": "ViAds",
                            "displayName": "Chamorro",
                            "dbMappingId": 1018
                        }
                    ]
                },
                {
                    "id": 2581,
                    "name": "Malayalam",
                    "platformId": 1,
                    "isActive": 1,
                    "platformName": "Beki",
                    "displayName": "Malayalam",
                    "mappingDetails": [
                        {
                            "id": 2583,
                            "name": "1264",
                            "platformId": 2,
                            "isActive": 1,
                            "platformName": "ION",
                            "displayName": "Malayalam",
                            "dbMappingId": 805
                        },
                        {
                            "id": 2585,
                            "name": "50",
                            "platformId": 3,
                            "isActive": 1,
                            "platformName": "Meta",
                            "displayName": "Malayalam",
                            "dbMappingId": 806
                        },
                        {
                            "id": 2587,
                            "name": "languageConstants/1098",
                            "platformId": 4,
                            "isActive": 1,
                            "platformName": "Google Ads",
                            "displayName": "Malayalam",
                            "dbMappingId": 807
                        },
                        {
                            "id": 2589,
                            "name": "ml",
                            "platformId": 7,
                            "isActive": 1,
                            "platformName": "TikTok",
                            "displayName": "Malayalam",
                            "dbMappingId": 808
                        },
                        {
                            "id": 3771,
                            "name": "630",
                            "platformId": 8,
                            "isActive": 1,
                            "platformName": "ViAds",
                            "displayName": "Malayalam",
                            "dbMappingId": 1020
                        }
                    ]
                },
                {
                    "id": 2591,
                    "name": "Lithuanian",
                    "platformId": 1,
                    "isActive": 1,
                    "platformName": "Beki",
                    "displayName": "Lithuanian",
                    "mappingDetails": [
                        {
                            "id": 2593,
                            "name": "1258",
                            "platformId": 2,
                            "isActive": 1,
                            "platformName": "ION",
                            "displayName": "Lithuanian",
                            "dbMappingId": 809
                        },
                        {
                            "id": 2595,
                            "name": "40",
                            "platformId": 3,
                            "isActive": 1,
                            "platformName": "Meta",
                            "displayName": "Lithuanian",
                            "dbMappingId": 810
                        },
                        {
                            "id": 2597,
                            "name": "languageConstants/1029",
                            "platformId": 4,
                            "isActive": 1,
                            "platformName": "Google Ads",
                            "displayName": "Lithuanian",
                            "dbMappingId": 811
                        },
                        {
                            "id": 3775,
                            "name": "624",
                            "platformId": 8,
                            "isActive": 1,
                            "platformName": "ViAds",
                            "displayName": "Lithuanian",
                            "dbMappingId": 1022
                        }
                    ]
                },
                {
                    "id": 2599,
                    "name": "Avestan",
                    "platformId": 1,
                    "isActive": 1,
                    "platformName": "Beki",
                    "displayName": "Avestan",
                    "mappingDetails": [
                        {
                            "id": 2601,
                            "name": "1173",
                            "platformId": 2,
                            "isActive": 1,
                            "platformName": "ION",
                            "displayName": "Avestan",
                            "dbMappingId": 812
                        },
                        {
                            "id": 3779,
                            "name": "539",
                            "platformId": 8,
                            "isActive": 1,
                            "platformName": "ViAds",
                            "displayName": "Avestan",
                            "dbMappingId": 1024
                        }
                    ]
                },
                {
                    "id": 2603,
                    "name": "Korean",
                    "platformId": 1,
                    "isActive": 1,
                    "platformName": "Beki",
                    "displayName": "Korean",
                    "mappingDetails": [
                        {
                            "id": 2605,
                            "name": "1250",
                            "platformId": 2,
                            "isActive": 1,
                            "platformName": "ION",
                            "displayName": "Korean",
                            "dbMappingId": 813
                        },
                        {
                            "id": 2607,
                            "name": "12",
                            "platformId": 3,
                            "isActive": 1,
                            "platformName": "Meta",
                            "displayName": "Korean",
                            "dbMappingId": 814
                        },
                        {
                            "id": 2609,
                            "name": "languageConstants/1012",
                            "platformId": 4,
                            "isActive": 1,
                            "platformName": "Google Ads",
                            "displayName": "Korean",
                            "dbMappingId": 815
                        },
                        {
                            "id": 2611,
                            "name": "ko",
                            "platformId": 7,
                            "isActive": 1,
                            "platformName": "TikTok",
                            "displayName": "Korean",
                            "dbMappingId": 816
                        },
                        {
                            "id": 3783,
                            "name": "616",
                            "platformId": 8,
                            "isActive": 1,
                            "platformName": "ViAds",
                            "displayName": "Korean",
                            "dbMappingId": 1026
                        }
                    ]
                },
                {
                    "id": 2613,
                    "name": "Assamese",
                    "platformId": 1,
                    "isActive": 1,
                    "platformName": "Beki",
                    "displayName": "Assamese",
                    "mappingDetails": [
                        {
                            "id": 2615,
                            "name": "1171",
                            "platformId": 2,
                            "isActive": 1,
                            "platformName": "ION",
                            "displayName": "Assamese",
                            "dbMappingId": 817
                        },
                        {
                            "id": 2617,
                            "name": "as",
                            "platformId": 7,
                            "isActive": 1,
                            "platformName": "TikTok",
                            "displayName": "Assamese",
                            "dbMappingId": 818
                        },
                        {
                            "id": 3785,
                            "name": "537",
                            "platformId": 8,
                            "isActive": 1,
                            "platformName": "ViAds",
                            "displayName": "Assamese",
                            "dbMappingId": 1027
                        }
                    ]
                },
                {
                    "id": 2619,
                    "name": "Inuktitut",
                    "platformId": 1,
                    "isActive": 1,
                    "platformName": "Beki",
                    "displayName": "Inuktitut",
                    "mappingDetails": [
                        {
                            "id": 2621,
                            "name": "1234",
                            "platformId": 2,
                            "isActive": 1,
                            "platformName": "ION",
                            "displayName": "Inuktitut",
                            "dbMappingId": 819
                        },
                        {
                            "id": 3787,
                            "name": "600",
                            "platformId": 8,
                            "isActive": 1,
                            "platformName": "ViAds",
                            "displayName": "Inuktitut",
                            "dbMappingId": 1028
                        }
                    ]
                },
                {
                    "id": 2623,
                    "name": "Pali",
                    "platformId": 1,
                    "isActive": 1,
                    "platformName": "Beki",
                    "displayName": "Pali",
                    "mappingDetails": [
                        {
                            "id": 2625,
                            "name": "1286",
                            "platformId": 2,
                            "isActive": 1,
                            "platformName": "ION",
                            "displayName": "Pali",
                            "dbMappingId": 820
                        },
                        {
                            "id": 3789,
                            "name": "652",
                            "platformId": 8,
                            "isActive": 1,
                            "platformName": "ViAds",
                            "displayName": "Pali",
                            "dbMappingId": 1029
                        }
                    ]
                },
                {
                    "id": 2627,
                    "name": "Khmer",
                    "platformId": 1,
                    "isActive": 1,
                    "platformName": "Beki",
                    "displayName": "Khmer",
                    "mappingDetails": [
                        {
                            "id": 2629,
                            "name": "74",
                            "platformId": 3,
                            "isActive": 1,
                            "platformName": "Meta",
                            "displayName": "Khmer",
                            "dbMappingId": 821
                        },
                        {
                            "id": 2631,
                            "name": "km",
                            "platformId": 7,
                            "isActive": 1,
                            "platformName": "TikTok",
                            "displayName": "Khmer",
                            "dbMappingId": 822
                        }
                    ]
                },
                {
                    "id": 2633,
                    "name": "Central Khmer",
                    "platformId": 1,
                    "isActive": 1,
                    "platformName": "Beki",
                    "displayName": "Central Khmer",
                    "mappingDetails": [
                        {
                            "id": 2635,
                            "name": "1244",
                            "platformId": 2,
                            "isActive": 1,
                            "platformName": "ION",
                            "displayName": "Central Khmer",
                            "dbMappingId": 823
                        },
                        {
                            "id": 3797,
                            "name": "610",
                            "platformId": 8,
                            "isActive": 1,
                            "platformName": "ViAds",
                            "displayName": "Central Khmer",
                            "dbMappingId": 1033
                        }
                    ]
                },
                {
                    "id": 2637,
                    "name": "Avaric",
                    "platformId": 1,
                    "isActive": 1,
                    "platformName": "Beki",
                    "displayName": "Avaric",
                    "mappingDetails": [
                        {
                            "id": 2639,
                            "name": "1172",
                            "platformId": 2,
                            "isActive": 1,
                            "platformName": "ION",
                            "displayName": "Avaric",
                            "dbMappingId": 824
                        },
                        {
                            "id": 3801,
                            "name": "538",
                            "platformId": 8,
                            "isActive": 1,
                            "platformName": "ViAds",
                            "displayName": "Avaric",
                            "dbMappingId": 1035
                        }
                    ]
                },
                {
                    "id": 2641,
                    "name": "Kalaallisut, Greenlandic",
                    "platformId": 1,
                    "isActive": 1,
                    "platformName": "Beki",
                    "displayName": "Kalaallisut, Greenlandic",
                    "mappingDetails": [
                        {
                            "id": 2643,
                            "name": "1218",
                            "platformId": 2,
                            "isActive": 1,
                            "platformName": "ION",
                            "displayName": "Kalaallisut, Greenlandic",
                            "dbMappingId": 825
                        },
                        {
                            "id": 3803,
                            "name": "584",
                            "platformId": 8,
                            "isActive": 1,
                            "platformName": "ViAds",
                            "displayName": "Kalaallisut, Greenlandic",
                            "dbMappingId": 1036
                        }
                    ]
                },
                {
                    "id": 2645,
                    "name": "Vietnamese",
                    "platformId": 1,
                    "isActive": 1,
                    "platformName": "Beki",
                    "displayName": "Vietnamese",
                    "mappingDetails": [
                        {
                            "id": 2647,
                            "name": "1335",
                            "platformId": 2,
                            "isActive": 1,
                            "platformName": "ION",
                            "displayName": "Vietnamese",
                            "dbMappingId": 826
                        },
                        {
                            "id": 2649,
                            "name": "27",
                            "platformId": 3,
                            "isActive": 1,
                            "platformName": "Meta",
                            "displayName": "Vietnamese",
                            "dbMappingId": 827
                        },
                        {
                            "id": 2651,
                            "name": "languageConstants/1040",
                            "platformId": 4,
                            "isActive": 1,
                            "platformName": "Google Ads",
                            "displayName": "Vietnamese",
                            "dbMappingId": 828
                        },
                        {
                            "id": 2653,
                            "name": "vi",
                            "platformId": 7,
                            "isActive": 1,
                            "platformName": "TikTok",
                            "displayName": "Vietnamese",
                            "dbMappingId": 829
                        },
                        {
                            "id": 3809,
                            "name": "701",
                            "platformId": 8,
                            "isActive": 1,
                            "platformName": "ViAds",
                            "displayName": "Vietnamese",
                            "dbMappingId": 1039
                        }
                    ]
                },
                {
                    "id": 2655,
                    "name": "Chinese",
                    "platformId": 1,
                    "isActive": 1,
                    "platformName": "Beki",
                    "displayName": "Chinese",
                    "mappingDetails": [
                        {
                            "id": 2657,
                            "name": "1190",
                            "platformId": 2,
                            "isActive": 1,
                            "platformName": "ION",
                            "displayName": "Chinese",
                            "dbMappingId": 830
                        },
                        {
                            "id": 2659,
                            "name": "1004",
                            "platformId": 3,
                            "isActive": 1,
                            "platformName": "Meta",
                            "displayName": "Chinese",
                            "dbMappingId": 831
                        },
                        {
                            "id": 3805,
                            "name": "556",
                            "platformId": 8,
                            "isActive": 1,
                            "platformName": "ViAds",
                            "displayName": "Chinese",
                            "dbMappingId": 1037
                        }
                    ]
                },
                {
                    "id": 2661,
                    "name": "Galician",
                    "platformId": 1,
                    "isActive": 1,
                    "platformName": "Beki",
                    "displayName": "Galician",
                    "mappingDetails": [
                        {
                            "id": 2663,
                            "name": "1213",
                            "platformId": 2,
                            "isActive": 1,
                            "platformName": "ION",
                            "displayName": "Galician",
                            "dbMappingId": 832
                        },
                        {
                            "id": 2665,
                            "name": "65",
                            "platformId": 3,
                            "isActive": 1,
                            "platformName": "Meta",
                            "displayName": "Galician",
                            "dbMappingId": 833
                        },
                        {
                            "id": 3813,
                            "name": "579",
                            "platformId": 8,
                            "isActive": 1,
                            "platformName": "ViAds",
                            "displayName": "Galician",
                            "dbMappingId": 1041
                        }
                    ]
                },
                {
                    "id": 2667,
                    "name": "Lao",
                    "platformId": 1,
                    "isActive": 1,
                    "platformName": "Beki",
                    "displayName": "Lao",
                    "mappingDetails": [
                        {
                            "id": 2669,
                            "name": "1253",
                            "platformId": 2,
                            "isActive": 1,
                            "platformName": "ION",
                            "displayName": "Lao",
                            "dbMappingId": 834
                        },
                        {
                            "id": 3815,
                            "name": "619",
                            "platformId": 8,
                            "isActive": 1,
                            "platformName": "ViAds",
                            "displayName": "Lao",
                            "dbMappingId": 1042
                        }
                    ]
                },
                {
                    "id": 2671,
                    "name": "Somali",
                    "platformId": 1,
                    "isActive": 1,
                    "platformName": "Beki",
                    "displayName": "Somali",
                    "mappingDetails": [
                        {
                            "id": 2673,
                            "name": "1308",
                            "platformId": 2,
                            "isActive": 1,
                            "platformName": "ION",
                            "displayName": "Somali",
                            "dbMappingId": 835
                        },
                        {
                            "id": 3817,
                            "name": "674",
                            "platformId": 8,
                            "isActive": 1,
                            "platformName": "ViAds",
                            "displayName": "Somali",
                            "dbMappingId": 1043
                        }
                    ]
                },
                {
                    "id": 2675,
                    "name": "Sanskrit",
                    "platformId": 1,
                    "isActive": 1,
                    "platformName": "Beki",
                    "displayName": "Sanskrit",
                    "mappingDetails": [
                        {
                            "id": 2677,
                            "name": "1300",
                            "platformId": 2,
                            "isActive": 1,
                            "platformName": "ION",
                            "displayName": "Sanskrit",
                            "dbMappingId": 836
                        },
                        {
                            "id": 3821,
                            "name": "666",
                            "platformId": 8,
                            "isActive": 1,
                            "platformName": "ViAds",
                            "displayName": "Sanskrit",
                            "dbMappingId": 1045
                        }
                    ]
                },
                {
                    "id": 2679,
                    "name": "Slovak",
                    "platformId": 1,
                    "isActive": 1,
                    "platformName": "Beki",
                    "displayName": "Slovak",
                    "mappingDetails": [
                        {
                            "id": 2681,
                            "name": "1306",
                            "platformId": 2,
                            "isActive": 1,
                            "platformName": "ION",
                            "displayName": "Slovak",
                            "dbMappingId": 837
                        },
                        {
                            "id": 2683,
                            "name": "33",
                            "platformId": 3,
                            "isActive": 1,
                            "platformName": "Meta",
                            "displayName": "Slovak",
                            "dbMappingId": 838
                        },
                        {
                            "id": 2685,
                            "name": "languageConstants/1033",
                            "platformId": 4,
                            "isActive": 1,
                            "platformName": "Google Ads",
                            "displayName": "Slovak",
                            "dbMappingId": 839
                        },
                        {
                            "id": 3823,
                            "name": "672",
                            "platformId": 8,
                            "isActive": 1,
                            "platformName": "ViAds",
                            "displayName": "Slovak",
                            "dbMappingId": 1046
                        }
                    ]
                },
                {
                    "id": 2687,
                    "name": "Simplified Chinese (China)",
                    "platformId": 1,
                    "isActive": 1,
                    "platformName": "Beki",
                    "displayName": "Simplified Chinese (China)",
                    "mappingDetails": [
                        {
                            "id": 2689,
                            "name": "20",
                            "platformId": 3,
                            "isActive": 1,
                            "platformName": "Meta",
                            "displayName": "Simplified Chinese (China)",
                            "dbMappingId": 840
                        }
                    ]
                },
                {
                    "id": 2691,
                    "name": "Serbian",
                    "platformId": 1,
                    "isActive": 1,
                    "platformName": "Beki",
                    "displayName": "Serbian",
                    "mappingDetails": [
                        {
                            "id": 2693,
                            "name": "1302",
                            "platformId": 2,
                            "isActive": 1,
                            "platformName": "ION",
                            "displayName": "Serbian",
                            "dbMappingId": 841
                        },
                        {
                            "id": 2695,
                            "name": "42",
                            "platformId": 3,
                            "isActive": 1,
                            "platformName": "Meta",
                            "displayName": "Serbian",
                            "dbMappingId": 842
                        },
                        {
                            "id": 2697,
                            "name": "languageConstants/1035",
                            "platformId": 4,
                            "isActive": 1,
                            "platformName": "Google Ads",
                            "displayName": "Serbian",
                            "dbMappingId": 843
                        },
                        {
                            "id": 3835,
                            "name": "668",
                            "platformId": 8,
                            "isActive": 1,
                            "platformName": "ViAds",
                            "displayName": "Serbian",
                            "dbMappingId": 1052
                        }
                    ]
                },
                {
                    "id": 2699,
                    "name": "Belarusian",
                    "platformId": 1,
                    "isActive": 1,
                    "platformName": "Beki",
                    "displayName": "Belarusian",
                    "mappingDetails": [
                        {
                            "id": 2701,
                            "name": "1179",
                            "platformId": 2,
                            "isActive": 1,
                            "platformName": "ION",
                            "displayName": "Belarusian",
                            "dbMappingId": 844
                        },
                        {
                            "id": 2703,
                            "name": "54",
                            "platformId": 3,
                            "isActive": 1,
                            "platformName": "Meta",
                            "displayName": "Belarusian",
                            "dbMappingId": 845
                        },
                        {
                            "id": 3831,
                            "name": "545",
                            "platformId": 8,
                            "isActive": 1,
                            "platformName": "ViAds",
                            "displayName": "Belarusian",
                            "dbMappingId": 1050
                        }
                    ]
                },
                {
                    "id": 2705,
                    "name": "Kongo",
                    "platformId": 1,
                    "isActive": 1,
                    "platformName": "Beki",
                    "displayName": "Kongo",
                    "mappingDetails": [
                        {
                            "id": 2707,
                            "name": "1249",
                            "platformId": 2,
                            "isActive": 1,
                            "platformName": "ION",
                            "displayName": "Kongo",
                            "dbMappingId": 846
                        },
                        {
                            "id": 3833,
                            "name": "615",
                            "platformId": 8,
                            "isActive": 1,
                            "platformName": "ViAds",
                            "displayName": "Kongo",
                            "dbMappingId": 1051
                        }
                    ]
                },
                {
                    "id": 2709,
                    "name": "Marathi",
                    "platformId": 1,
                    "isActive": 1,
                    "platformName": "Beki",
                    "displayName": "Marathi",
                    "mappingDetails": [
                        {
                            "id": 2711,
                            "name": "1268",
                            "platformId": 2,
                            "isActive": 1,
                            "platformName": "ION",
                            "displayName": "Marathi",
                            "dbMappingId": 847
                        },
                        {
                            "id": 2713,
                            "name": "81",
                            "platformId": 3,
                            "isActive": 1,
                            "platformName": "Meta",
                            "displayName": "Marathi",
                            "dbMappingId": 848
                        },
                        {
                            "id": 2715,
                            "name": "languageConstants/1101",
                            "platformId": 4,
                            "isActive": 1,
                            "platformName": "Google Ads",
                            "displayName": "Marathi",
                            "dbMappingId": 849
                        },
                        {
                            "id": 2717,
                            "name": "mr",
                            "platformId": 7,
                            "isActive": 1,
                            "platformName": "TikTok",
                            "displayName": "Marathi",
                            "dbMappingId": 850
                        },
                        {
                            "id": 3837,
                            "name": "634",
                            "platformId": 8,
                            "isActive": 1,
                            "platformName": "ViAds",
                            "displayName": "Marathi",
                            "dbMappingId": 1053
                        }
                    ]
                },
                {
                    "id": 2719,
                    "name": "Pashto, Pushto",
                    "platformId": 1,
                    "isActive": 1,
                    "platformName": "Beki",
                    "displayName": "Pashto, Pushto",
                    "mappingDetails": [
                        {
                            "id": 2721,
                            "name": "1287",
                            "platformId": 2,
                            "isActive": 1,
                            "platformName": "ION",
                            "displayName": "Pashto, Pushto",
                            "dbMappingId": 851
                        },
                        {
                            "id": 2723,
                            "name": "85",
                            "platformId": 3,
                            "isActive": 1,
                            "platformName": "Meta",
                            "displayName": "Pashto, Pushto",
                            "dbMappingId": 852
                        },
                        {
                            "id": 3839,
                            "name": "653",
                            "platformId": 8,
                            "isActive": 1,
                            "platformName": "ViAds",
                            "displayName": "Pashto, Pushto",
                            "dbMappingId": 1054
                        }
                    ]
                },
                {
                    "id": 2725,
                    "name": "Walloon",
                    "platformId": 1,
                    "isActive": 1,
                    "platformName": "Beki",
                    "displayName": "Walloon",
                    "mappingDetails": [
                        {
                            "id": 2727,
                            "name": "1337",
                            "platformId": 2,
                            "isActive": 1,
                            "platformName": "ION",
                            "displayName": "Walloon",
                            "dbMappingId": 853
                        },
                        {
                            "id": 3845,
                            "name": "703",
                            "platformId": 8,
                            "isActive": 1,
                            "platformName": "ViAds",
                            "displayName": "Walloon",
                            "dbMappingId": 1057
                        }
                    ]
                },
                {
                    "id": 2729,
                    "name": "South Ndebele",
                    "platformId": 1,
                    "isActive": 1,
                    "platformName": "Beki",
                    "displayName": "South Ndebele",
                    "mappingDetails": [
                        {
                            "id": 2731,
                            "name": "1274",
                            "platformId": 2,
                            "isActive": 1,
                            "platformName": "ION",
                            "displayName": "South Ndebele",
                            "dbMappingId": 854
                        },
                        {
                            "id": 3847,
                            "name": "640",
                            "platformId": 8,
                            "isActive": 1,
                            "platformName": "ViAds",
                            "displayName": "South Ndebele",
                            "dbMappingId": 1058
                        }
                    ]
                },
                {
                    "id": 2733,
                    "name": "Samoan",
                    "platformId": 1,
                    "isActive": 1,
                    "platformName": "Beki",
                    "displayName": "Samoan",
                    "mappingDetails": [
                        {
                            "id": 2735,
                            "name": "1298",
                            "platformId": 2,
                            "isActive": 1,
                            "platformName": "ION",
                            "displayName": "Samoan",
                            "dbMappingId": 855
                        },
                        {
                            "id": 3849,
                            "name": "664",
                            "platformId": 8,
                            "isActive": 1,
                            "platformName": "ViAds",
                            "displayName": "Samoan",
                            "dbMappingId": 1059
                        }
                    ]
                },
                {
                    "id": 2737,
                    "name": "Kirghiz, Kyrgyz",
                    "platformId": 1,
                    "isActive": 1,
                    "platformName": "Beki",
                    "displayName": "Kirghiz, Kyrgyz",
                    "mappingDetails": [
                        {
                            "id": 2739,
                            "name": "1247",
                            "platformId": 2,
                            "isActive": 1,
                            "platformName": "ION",
                            "displayName": "Kirghiz, Kyrgyz",
                            "dbMappingId": 856
                        },
                        {
                            "id": 3853,
                            "name": "613",
                            "platformId": 8,
                            "isActive": 1,
                            "platformName": "ViAds",
                            "displayName": "Kirghiz, Kyrgyz",
                            "dbMappingId": 1061
                        }
                    ]
                },
                {
                    "id": 2741,
                    "name": "Tajik",
                    "platformId": 1,
                    "isActive": 1,
                    "platformName": "Beki",
                    "displayName": "Tajik",
                    "mappingDetails": [
                        {
                            "id": 2743,
                            "name": "1317",
                            "platformId": 2,
                            "isActive": 1,
                            "platformName": "ION",
                            "displayName": "Tajik",
                            "dbMappingId": 857
                        },
                        {
                            "id": 2745,
                            "name": "89",
                            "platformId": 3,
                            "isActive": 1,
                            "platformName": "Meta",
                            "displayName": "Tajik",
                            "dbMappingId": 858
                        },
                        {
                            "id": 3855,
                            "name": "683",
                            "platformId": 8,
                            "isActive": 1,
                            "platformName": "ViAds",
                            "displayName": "Tajik",
                            "dbMappingId": 1062
                        }
                    ]
                },
                {
                    "id": 2747,
                    "name": "Arabic",
                    "platformId": 1,
                    "isActive": 1,
                    "platformName": "Beki",
                    "displayName": "Arabic",
                    "mappingDetails": [
                        {
                            "id": 2749,
                            "name": "1168",
                            "platformId": 2,
                            "isActive": 1,
                            "platformName": "ION",
                            "displayName": "Arabic",
                            "dbMappingId": 859
                        },
                        {
                            "id": 2751,
                            "name": "28",
                            "platformId": 3,
                            "isActive": 1,
                            "platformName": "Meta",
                            "displayName": "Arabic",
                            "dbMappingId": 860
                        },
                        {
                            "id": 2753,
                            "name": "languageConstants/1019",
                            "platformId": 4,
                            "isActive": 1,
                            "platformName": "Google Ads",
                            "displayName": "Arabic",
                            "dbMappingId": 861
                        },
                        {
                            "id": 2755,
                            "name": "ar",
                            "platformId": 7,
                            "isActive": 1,
                            "platformName": "TikTok",
                            "displayName": "Arabic",
                            "dbMappingId": 862
                        },
                        {
                            "id": 3857,
                            "name": "534",
                            "platformId": 8,
                            "isActive": 1,
                            "platformName": "ViAds",
                            "displayName": "Arabic",
                            "dbMappingId": 1063
                        }
                    ]
                },
                {
                    "id": 2757,
                    "name": "Cornish",
                    "platformId": 1,
                    "isActive": 1,
                    "platformName": "Beki",
                    "displayName": "Cornish",
                    "mappingDetails": [
                        {
                            "id": 2759,
                            "name": "1193",
                            "platformId": 2,
                            "isActive": 1,
                            "platformName": "ION",
                            "displayName": "Cornish",
                            "dbMappingId": 863
                        },
                        {
                            "id": 3861,
                            "name": "559",
                            "platformId": 8,
                            "isActive": 1,
                            "platformName": "ViAds",
                            "displayName": "Cornish",
                            "dbMappingId": 1065
                        }
                    ]
                },
                {
                    "id": 2761,
                    "name": "Aragonese",
                    "platformId": 1,
                    "isActive": 1,
                    "platformName": "Beki",
                    "displayName": "Aragonese",
                    "mappingDetails": [
                        {
                            "id": 2763,
                            "name": "1169",
                            "platformId": 2,
                            "isActive": 1,
                            "platformName": "ION",
                            "displayName": "Aragonese",
                            "dbMappingId": 864
                        },
                        {
                            "id": 3863,
                            "name": "535",
                            "platformId": 8,
                            "isActive": 1,
                            "platformName": "ViAds",
                            "displayName": "Aragonese",
                            "dbMappingId": 1066
                        }
                    ]
                },
                {
                    "id": 2765,
                    "name": "Spanish",
                    "platformId": 1,
                    "isActive": 1,
                    "platformName": "Beki",
                    "displayName": "Spanish",
                    "mappingDetails": [
                        {
                            "id": 2767,
                            "name": "1002",
                            "platformId": 3,
                            "isActive": 1,
                            "platformName": "Meta",
                            "displayName": "Spanish",
                            "dbMappingId": 865
                        },
                        {
                            "id": 2769,
                            "name": "languageConstants/1003",
                            "platformId": 4,
                            "isActive": 1,
                            "platformName": "Google Ads",
                            "displayName": "Spanish",
                            "dbMappingId": 866
                        },
                        {
                            "id": 2771,
                            "name": "es",
                            "platformId": 7,
                            "isActive": 1,
                            "platformName": "TikTok",
                            "displayName": "Spanish",
                            "dbMappingId": 867
                        }
                    ]
                },
                {
                    "id": 2773,
                    "name": "Thai",
                    "platformId": 1,
                    "isActive": 1,
                    "platformName": "Beki",
                    "displayName": "Thai",
                    "mappingDetails": [
                        {
                            "id": 2775,
                            "name": "1321",
                            "platformId": 2,
                            "isActive": 1,
                            "platformName": "ION",
                            "displayName": "Thai",
                            "dbMappingId": 868
                        },
                        {
                            "id": 2777,
                            "name": "35",
                            "platformId": 3,
                            "isActive": 1,
                            "platformName": "Meta",
                            "displayName": "Thai",
                            "dbMappingId": 869
                        },
                        {
                            "id": 2779,
                            "name": "languageConstants/1044",
                            "platformId": 4,
                            "isActive": 1,
                            "platformName": "Google Ads",
                            "displayName": "Thai",
                            "dbMappingId": 870
                        },
                        {
                            "id": 2781,
                            "name": "th",
                            "platformId": 7,
                            "isActive": 1,
                            "platformName": "TikTok",
                            "displayName": "Thai",
                            "dbMappingId": 871
                        },
                        {
                            "id": 3871,
                            "name": "687",
                            "platformId": 8,
                            "isActive": 1,
                            "platformName": "ViAds",
                            "displayName": "Thai",
                            "dbMappingId": 1070
                        }
                    ]
                },
                {
                    "id": 2783,
                    "name": "Tonga",
                    "platformId": 1,
                    "isActive": 1,
                    "platformName": "Beki",
                    "displayName": "Tonga",
                    "mappingDetails": [
                        {
                            "id": 2785,
                            "name": "1324",
                            "platformId": 2,
                            "isActive": 1,
                            "platformName": "ION",
                            "displayName": "Tonga",
                            "dbMappingId": 872
                        }
                    ]
                },
                {
                    "id": 2787,
                    "name": "Malagasy",
                    "platformId": 1,
                    "isActive": 1,
                    "platformName": "Beki",
                    "displayName": "Malagasy",
                    "mappingDetails": [
                        {
                            "id": 2789,
                            "name": "1262",
                            "platformId": 2,
                            "isActive": 1,
                            "platformName": "ION",
                            "displayName": "Malagasy",
                            "dbMappingId": 873
                        },
                        {
                            "id": 3875,
                            "name": "628",
                            "platformId": 8,
                            "isActive": 1,
                            "platformName": "ViAds",
                            "displayName": "Malagasy",
                            "dbMappingId": 1072
                        }
                    ]
                },
                {
                    "id": 2791,
                    "name": "Tigrinya",
                    "platformId": 1,
                    "isActive": 1,
                    "platformName": "Beki",
                    "displayName": "Tigrinya",
                    "mappingDetails": [
                        {
                            "id": 2793,
                            "name": "1323",
                            "platformId": 2,
                            "isActive": 1,
                            "platformName": "ION",
                            "displayName": "Tigrinya",
                            "dbMappingId": 874
                        },
                        {
                            "id": 3877,
                            "name": "689",
                            "platformId": 8,
                            "isActive": 1,
                            "platformName": "ViAds",
                            "displayName": "Tigrinya",
                            "dbMappingId": 1073
                        }
                    ]
                },
                {
                    "id": 2795,
                    "name": "Romansh",
                    "platformId": 1,
                    "isActive": 1,
                    "platformName": "Beki",
                    "displayName": "Romansh",
                    "mappingDetails": [
                        {
                            "id": 2797,
                            "name": "1294",
                            "platformId": 2,
                            "isActive": 1,
                            "platformName": "ION",
                            "displayName": "Romansh",
                            "dbMappingId": 875
                        },
                        {
                            "id": 3879,
                            "name": "660",
                            "platformId": 8,
                            "isActive": 1,
                            "platformName": "ViAds",
                            "displayName": "Romansh",
                            "dbMappingId": 1074
                        }
                    ]
                },
                {
                    "id": 2799,
                    "name": "Occitan",
                    "platformId": 1,
                    "isActive": 1,
                    "platformName": "Beki",
                    "displayName": "Occitan",
                    "mappingDetails": [
                        {
                            "id": 2801,
                            "name": "1281",
                            "platformId": 2,
                            "isActive": 1,
                            "platformName": "ION",
                            "displayName": "Occitan",
                            "dbMappingId": 876
                        },
                        {
                            "id": 3881,
                            "name": "647",
                            "platformId": 8,
                            "isActive": 1,
                            "platformName": "ViAds",
                            "displayName": "Occitan",
                            "dbMappingId": 1075
                        }
                    ]
                },
                {
                    "id": 2803,
                    "name": "French (Canada)",
                    "platformId": 1,
                    "isActive": 1,
                    "platformName": "Beki",
                    "displayName": "French (Canada)",
                    "mappingDetails": [
                        {
                            "id": 2805,
                            "name": "44",
                            "platformId": 3,
                            "isActive": 1,
                            "platformName": "Meta",
                            "displayName": "French (Canada)",
                            "dbMappingId": 877
                        }
                    ]
                },
                {
                    "id": 2807,
                    "name": "Spanish (Spain)",
                    "platformId": 1,
                    "isActive": 1,
                    "platformName": "Beki",
                    "displayName": "Spanish (Spain)",
                    "mappingDetails": [
                        {
                            "id": 2809,
                            "name": "7",
                            "platformId": 3,
                            "isActive": 1,
                            "platformName": "Meta",
                            "displayName": "Spanish (Spain)",
                            "dbMappingId": 878
                        }
                    ]
                },
                {
                    "id": 2811,
                    "name": "Burmese",
                    "platformId": 1,
                    "isActive": 1,
                    "platformName": "Beki",
                    "displayName": "Burmese",
                    "mappingDetails": [
                        {
                            "id": 2813,
                            "name": "1185",
                            "platformId": 2,
                            "isActive": 1,
                            "platformName": "ION",
                            "displayName": "Burmese",
                            "dbMappingId": 879
                        },
                        {
                            "id": 3893,
                            "name": "551",
                            "platformId": 8,
                            "isActive": 1,
                            "platformName": "ViAds",
                            "displayName": "Burmese",
                            "dbMappingId": 1081
                        }
                    ]
                },
                {
                    "id": 2815,
                    "name": "Wolof",
                    "platformId": 1,
                    "isActive": 1,
                    "platformName": "Beki",
                    "displayName": "Wolof",
                    "mappingDetails": [
                        {
                            "id": 2817,
                            "name": "1339",
                            "platformId": 2,
                            "isActive": 1,
                            "platformName": "ION",
                            "displayName": "Wolof",
                            "dbMappingId": 880
                        },
                        {
                            "id": 3899,
                            "name": "705",
                            "platformId": 8,
                            "isActive": 1,
                            "platformName": "ViAds",
                            "displayName": "Wolof",
                            "dbMappingId": 1084
                        }
                    ]
                },
                {
                    "id": 2819,
                    "name": "Inupiaq",
                    "platformId": 1,
                    "isActive": 1,
                    "platformName": "Beki",
                    "displayName": "Inupiaq",
                    "mappingDetails": [
                        {
                            "id": 2821,
                            "name": "1235",
                            "platformId": 2,
                            "isActive": 1,
                            "platformName": "ION",
                            "displayName": "Inupiaq",
                            "dbMappingId": 881
                        },
                        {
                            "id": 3901,
                            "name": "601",
                            "platformId": 8,
                            "isActive": 1,
                            "platformName": "ViAds",
                            "displayName": "Inupiaq",
                            "dbMappingId": 1085
                        }
                    ]
                },
                {
                    "id": 2823,
                    "name": "Sichuan Yi, Nuosu",
                    "platformId": 1,
                    "isActive": 1,
                    "platformName": "Beki",
                    "displayName": "Sichuan Yi, Nuosu",
                    "mappingDetails": [
                        {
                            "id": 2825,
                            "name": "1280",
                            "platformId": 2,
                            "isActive": 1,
                            "platformName": "ION",
                            "displayName": "Sichuan Yi, Nuosu",
                            "dbMappingId": 882
                        },
                        {
                            "id": 3905,
                            "name": "646",
                            "platformId": 8,
                            "isActive": 1,
                            "platformName": "ViAds",
                            "displayName": "Sichuan Yi, Nuosu",
                            "dbMappingId": 1087
                        }
                    ]
                },
                {
                    "id": 2827,
                    "name": "Bislama",
                    "platformId": 1,
                    "isActive": 1,
                    "platformName": "Beki",
                    "displayName": "Bislama",
                    "mappingDetails": [
                        {
                            "id": 2829,
                            "name": "1181",
                            "platformId": 2,
                            "isActive": 1,
                            "platformName": "ION",
                            "displayName": "Bislama",
                            "dbMappingId": 883
                        },
                        {
                            "id": 3907,
                            "name": "547",
                            "platformId": 8,
                            "isActive": 1,
                            "platformName": "ViAds",
                            "displayName": "Bislama",
                            "dbMappingId": 1088
                        }
                    ]
                },
                {
                    "id": 2831,
                    "name": "Chinese (traditional)",
                    "platformId": 1,
                    "isActive": 1,
                    "platformName": "Beki",
                    "displayName": "Chinese (traditional)",
                    "mappingDetails": [
                        {
                            "id": 2833,
                            "name": "languageConstants/1018",
                            "platformId": 4,
                            "isActive": 1,
                            "platformName": "Google Ads",
                            "displayName": "Chinese (traditional)",
                            "dbMappingId": 884
                        },
                        {
                            "id": 2835,
                            "name": "zh-Hant",
                            "platformId": 7,
                            "isActive": 1,
                            "platformName": "TikTok",
                            "displayName": "Chinese (traditional)",
                            "dbMappingId": 885
                        }
                    ]
                },
                {
                    "id": 2837,
                    "name": "Kashmiri",
                    "platformId": 1,
                    "isActive": 1,
                    "platformName": "Beki",
                    "displayName": "Kashmiri",
                    "mappingDetails": [
                        {
                            "id": 2839,
                            "name": "1242",
                            "platformId": 2,
                            "isActive": 1,
                            "platformName": "ION",
                            "displayName": "Kashmiri",
                            "dbMappingId": 886
                        },
                        {
                            "id": 3911,
                            "name": "608",
                            "platformId": 8,
                            "isActive": 1,
                            "platformName": "ViAds",
                            "displayName": "Kashmiri",
                            "dbMappingId": 1090
                        }
                    ]
                },
                {
                    "id": 2841,
                    "name": "Navajo, Navaho",
                    "platformId": 1,
                    "isActive": 1,
                    "platformName": "Beki",
                    "displayName": "Navajo, Navaho",
                    "mappingDetails": [
                        {
                            "id": 2843,
                            "name": "1272",
                            "platformId": 2,
                            "isActive": 1,
                            "platformName": "ION",
                            "displayName": "Navajo, Navaho",
                            "dbMappingId": 887
                        },
                        {
                            "id": 3919,
                            "name": "638",
                            "platformId": 8,
                            "isActive": 1,
                            "platformName": "ViAds",
                            "displayName": "Navajo, Navaho",
                            "dbMappingId": 1094
                        }
                    ]
                },
                {
                    "id": 2845,
                    "name": "Tsonga",
                    "platformId": 1,
                    "isActive": 1,
                    "platformName": "Beki",
                    "displayName": "Tsonga",
                    "mappingDetails": [
                        {
                            "id": 2847,
                            "name": "1325",
                            "platformId": 2,
                            "isActive": 1,
                            "platformName": "ION",
                            "displayName": "Tsonga",
                            "dbMappingId": 888
                        },
                        {
                            "id": 3921,
                            "name": "691",
                            "platformId": 8,
                            "isActive": 1,
                            "platformName": "ViAds",
                            "displayName": "Tsonga",
                            "dbMappingId": 1095
                        }
                    ]
                },
                {
                    "id": 2849,
                    "name": "Afrikaans",
                    "platformId": 1,
                    "isActive": 1,
                    "platformName": "Beki",
                    "displayName": "Afrikaans",
                    "mappingDetails": [
                        {
                            "id": 2851,
                            "name": "1164",
                            "platformId": 2,
                            "isActive": 1,
                            "platformName": "ION",
                            "displayName": "Afrikaans",
                            "dbMappingId": 889
                        },
                        {
                            "id": 2853,
                            "name": "36",
                            "platformId": 3,
                            "isActive": 1,
                            "platformName": "Meta",
                            "displayName": "Afrikaans",
                            "dbMappingId": 890
                        },
                        {
                            "id": 3923,
                            "name": "530",
                            "platformId": 8,
                            "isActive": 1,
                            "platformName": "ViAds",
                            "displayName": "Afrikaans",
                            "dbMappingId": 1096
                        }
                    ]
                },
                {
                    "id": 2855,
                    "name": "Yoruba",
                    "platformId": 1,
                    "isActive": 1,
                    "platformName": "Beki",
                    "displayName": "Yoruba",
                    "mappingDetails": [
                        {
                            "id": 2857,
                            "name": "1342",
                            "platformId": 2,
                            "isActive": 1,
                            "platformName": "ION",
                            "displayName": "Yoruba",
                            "dbMappingId": 891
                        },
                        {
                            "id": 3925,
                            "name": "708",
                            "platformId": 8,
                            "isActive": 1,
                            "platformName": "ViAds",
                            "displayName": "Yoruba",
                            "dbMappingId": 1097
                        }
                    ]
                },
                {
                    "id": 2859,
                    "name": "Interlingua (International Auxiliary Language Association)",
                    "platformId": 1,
                    "isActive": 1,
                    "platformName": "Beki",
                    "displayName": "Interlingua (International Auxiliary Language Association)",
                    "mappingDetails": [
                        {
                            "id": 2861,
                            "name": "1232",
                            "platformId": 2,
                            "isActive": 1,
                            "platformName": "ION",
                            "displayName": "Interlingua (International Auxiliary Language Association)",
                            "dbMappingId": 892
                        },
                        {
                            "id": 3931,
                            "name": "598",
                            "platformId": 8,
                            "isActive": 1,
                            "platformName": "ViAds",
                            "displayName": "Interlingua (International Auxiliary Language Association)",
                            "dbMappingId": 1100
                        }
                    ]
                },
                {
                    "id": 2863,
                    "name": "Ewe",
                    "platformId": 1,
                    "isActive": 1,
                    "platformName": "Beki",
                    "displayName": "Ewe",
                    "mappingDetails": [
                        {
                            "id": 2865,
                            "name": "1205",
                            "platformId": 2,
                            "isActive": 1,
                            "platformName": "ION",
                            "displayName": "Ewe",
                            "dbMappingId": 893
                        },
                        {
                            "id": 3933,
                            "name": "571",
                            "platformId": 8,
                            "isActive": 1,
                            "platformName": "ViAds",
                            "displayName": "Ewe",
                            "dbMappingId": 1101
                        }
                    ]
                },
                {
                    "id": 2867,
                    "name": "Japanese (Kansai)",
                    "platformId": 1,
                    "isActive": 1,
                    "platformName": "Beki",
                    "displayName": "Japanese (Kansai)",
                    "mappingDetails": [
                        {
                            "id": 2869,
                            "name": "70",
                            "platformId": 3,
                            "isActive": 1,
                            "platformName": "Meta",
                            "displayName": "Japanese (Kansai)",
                            "dbMappingId": 894
                        }
                    ]
                },
                {
                    "id": 2871,
                    "name": "Chinese (simplified)",
                    "platformId": 1,
                    "isActive": 1,
                    "platformName": "Beki",
                    "displayName": "Chinese (simplified)",
                    "mappingDetails": [
                        {
                            "id": 2873,
                            "name": "languageConstants/1017",
                            "platformId": 4,
                            "isActive": 1,
                            "platformName": "Google Ads",
                            "displayName": "Chinese (simplified)",
                            "dbMappingId": 895
                        }
                    ]
                },
                {
                    "id": 2875,
                    "name": "Finnish",
                    "platformId": 1,
                    "isActive": 1,
                    "platformName": "Beki",
                    "displayName": "Finnish",
                    "mappingDetails": [
                        {
                            "id": 2877,
                            "name": "1208",
                            "platformId": 2,
                            "isActive": 1,
                            "platformName": "ION",
                            "displayName": "Finnish",
                            "dbMappingId": 896
                        },
                        {
                            "id": 2879,
                            "name": "8",
                            "platformId": 3,
                            "isActive": 1,
                            "platformName": "Meta",
                            "displayName": "Finnish",
                            "dbMappingId": 897
                        },
                        {
                            "id": 2881,
                            "name": "languageConstants/1011",
                            "platformId": 4,
                            "isActive": 1,
                            "platformName": "Google Ads",
                            "displayName": "Finnish",
                            "dbMappingId": 898
                        },
                        {
                            "id": 2883,
                            "name": "fi",
                            "platformId": 7,
                            "isActive": 1,
                            "platformName": "TikTok",
                            "displayName": "Finnish",
                            "dbMappingId": 899
                        },
                        {
                            "id": 3941,
                            "name": "574",
                            "platformId": 8,
                            "isActive": 1,
                            "platformName": "ViAds",
                            "displayName": "Finnish",
                            "dbMappingId": 1105
                        }
                    ]
                },
                {
                    "id": 2885,
                    "name": "Albanian",
                    "platformId": 1,
                    "isActive": 1,
                    "platformName": "Beki",
                    "displayName": "Albanian",
                    "mappingDetails": [
                        {
                            "id": 2887,
                            "name": "1166",
                            "platformId": 2,
                            "isActive": 1,
                            "platformName": "ION",
                            "displayName": "Albanian",
                            "dbMappingId": 900
                        },
                        {
                            "id": 2889,
                            "name": "87",
                            "platformId": 3,
                            "isActive": 1,
                            "platformName": "Meta",
                            "displayName": "Albanian",
                            "dbMappingId": 901
                        },
                        {
                            "id": 3945,
                            "name": "532",
                            "platformId": 8,
                            "isActive": 1,
                            "platformName": "ViAds",
                            "displayName": "Albanian",
                            "dbMappingId": 1107
                        }
                    ]
                },
                {
                    "id": 2891,
                    "name": "Oromo",
                    "platformId": 1,
                    "isActive": 1,
                    "platformName": "Beki",
                    "displayName": "Oromo",
                    "mappingDetails": [
                        {
                            "id": 2893,
                            "name": "1284",
                            "platformId": 2,
                            "isActive": 1,
                            "platformName": "ION",
                            "displayName": "Oromo",
                            "dbMappingId": 902
                        },
                        {
                            "id": 3947,
                            "name": "650",
                            "platformId": 8,
                            "isActive": 1,
                            "platformName": "ViAds",
                            "displayName": "Oromo",
                            "dbMappingId": 1108
                        }
                    ]
                },
                {
                    "id": 2895,
                    "name": "Polish",
                    "platformId": 1,
                    "isActive": 1,
                    "platformName": "Beki",
                    "displayName": "Polish",
                    "mappingDetails": [
                        {
                            "id": 2897,
                            "name": "1289",
                            "platformId": 2,
                            "isActive": 1,
                            "platformName": "ION",
                            "displayName": "Polish",
                            "dbMappingId": 903
                        },
                        {
                            "id": 2899,
                            "name": "15",
                            "platformId": 3,
                            "isActive": 1,
                            "platformName": "Meta",
                            "displayName": "Polish",
                            "dbMappingId": 904
                        },
                        {
                            "id": 2901,
                            "name": "languageConstants/1030",
                            "platformId": 4,
                            "isActive": 1,
                            "platformName": "Google Ads",
                            "displayName": "Polish",
                            "dbMappingId": 905
                        },
                        {
                            "id": 2903,
                            "name": "pl",
                            "platformId": 7,
                            "isActive": 1,
                            "platformName": "TikTok",
                            "displayName": "Polish",
                            "dbMappingId": 906
                        },
                        {
                            "id": 3953,
                            "name": "655",
                            "platformId": 8,
                            "isActive": 1,
                            "platformName": "ViAds",
                            "displayName": "Polish",
                            "dbMappingId": 1111
                        }
                    ]
                },
                {
                    "id": 2905,
                    "name": "Divehi, Dhivehi, Maldivian",
                    "platformId": 1,
                    "isActive": 1,
                    "platformName": "Beki",
                    "displayName": "Divehi, Dhivehi, Maldivian",
                    "mappingDetails": [
                        {
                            "id": 2907,
                            "name": "1199",
                            "platformId": 2,
                            "isActive": 1,
                            "platformName": "ION",
                            "displayName": "Divehi, Dhivehi, Maldivian",
                            "dbMappingId": 907
                        },
                        {
                            "id": 3957,
                            "name": "565",
                            "platformId": 8,
                            "isActive": 1,
                            "platformName": "ViAds",
                            "displayName": "Divehi, Dhivehi, Maldivian",
                            "dbMappingId": 1113
                        }
                    ]
                },
                {
                    "id": 2909,
                    "name": "Akan",
                    "platformId": 1,
                    "isActive": 1,
                    "platformName": "Beki",
                    "displayName": "Akan",
                    "mappingDetails": [
                        {
                            "id": 2911,
                            "name": "1165",
                            "platformId": 2,
                            "isActive": 1,
                            "platformName": "ION",
                            "displayName": "Akan",
                            "dbMappingId": 908
                        },
                        {
                            "id": 3959,
                            "name": "531",
                            "platformId": 8,
                            "isActive": 1,
                            "platformName": "ViAds",
                            "displayName": "Akan",
                            "dbMappingId": 1114
                        }
                    ]
                },
                {
                    "id": 2913,
                    "name": "Bulgarian",
                    "platformId": 1,
                    "isActive": 1,
                    "platformName": "Beki",
                    "displayName": "Bulgarian",
                    "mappingDetails": [
                        {
                            "id": 2915,
                            "name": "1184",
                            "platformId": 2,
                            "isActive": 1,
                            "platformName": "ION",
                            "displayName": "Bulgarian",
                            "dbMappingId": 909
                        },
                        {
                            "id": 2917,
                            "name": "37",
                            "platformId": 3,
                            "isActive": 1,
                            "platformName": "Meta",
                            "displayName": "Bulgarian",
                            "dbMappingId": 910
                        },
                        {
                            "id": 2919,
                            "name": "languageConstants/1020",
                            "platformId": 4,
                            "isActive": 1,
                            "platformName": "Google Ads",
                            "displayName": "Bulgarian",
                            "dbMappingId": 911
                        },
                        {
                            "id": 3961,
                            "name": "550",
                            "platformId": 8,
                            "isActive": 1,
                            "platformName": "ViAds",
                            "displayName": "Bulgarian",
                            "dbMappingId": 1115
                        }
                    ]
                },
                {
                    "id": 2921,
                    "name": "Hausa",
                    "platformId": 1,
                    "isActive": 1,
                    "platformName": "Beki",
                    "displayName": "Hausa",
                    "mappingDetails": [
                        {
                            "id": 2923,
                            "name": "1222",
                            "platformId": 2,
                            "isActive": 1,
                            "platformName": "ION",
                            "displayName": "Hausa",
                            "dbMappingId": 912
                        },
                        {
                            "id": 3969,
                            "name": "588",
                            "platformId": 8,
                            "isActive": 1,
                            "platformName": "ViAds",
                            "displayName": "Hausa",
                            "dbMappingId": 1119
                        }
                    ]
                },
                {
                    "id": 2925,
                    "name": "Quechua",
                    "platformId": 1,
                    "isActive": 1,
                    "platformName": "Beki",
                    "displayName": "Quechua",
                    "mappingDetails": [
                        {
                            "id": 2927,
                            "name": "1292",
                            "platformId": 2,
                            "isActive": 1,
                            "platformName": "ION",
                            "displayName": "Quechua",
                            "dbMappingId": 913
                        },
                        {
                            "id": 3973,
                            "name": "658",
                            "platformId": 8,
                            "isActive": 1,
                            "platformName": "ViAds",
                            "displayName": "Quechua",
                            "dbMappingId": 1121
                        }
                    ]
                },
                {
                    "id": 2929,
                    "name": "Western Frisian",
                    "platformId": 1,
                    "isActive": 1,
                    "platformName": "Beki",
                    "displayName": "Western Frisian",
                    "mappingDetails": [
                        {
                            "id": 2931,
                            "name": "1210",
                            "platformId": 2,
                            "isActive": 1,
                            "platformName": "ION",
                            "displayName": "Western Frisian",
                            "dbMappingId": 914
                        },
                        {
                            "id": 2933,
                            "name": "63",
                            "platformId": 3,
                            "isActive": 1,
                            "platformName": "Meta",
                            "displayName": "Western Frisian",
                            "dbMappingId": 915
                        },
                        {
                            "id": 3975,
                            "name": "576",
                            "platformId": 8,
                            "isActive": 1,
                            "platformName": "ViAds",
                            "displayName": "Western Frisian",
                            "dbMappingId": 1122
                        }
                    ]
                },
                {
                    "id": 2935,
                    "name": "English",
                    "platformId": 1,
                    "isActive": 1,
                    "platformName": "Beki",
                    "displayName": "English",
                    "mappingDetails": [
                        {
                            "id": 2937,
                            "name": "1202",
                            "platformId": 2,
                            "isActive": 1,
                            "platformName": "ION",
                            "displayName": "English",
                            "dbMappingId": 916
                        },
                        {
                            "id": 2939,
                            "name": "1001",
                            "platformId": 3,
                            "isActive": 1,
                            "platformName": "Meta",
                            "displayName": "English",
                            "dbMappingId": 917
                        },
                        {
                            "id": 2941,
                            "name": "languageConstants/1000",
                            "platformId": 4,
                            "isActive": 1,
                            "platformName": "Google Ads",
                            "displayName": "English",
                            "dbMappingId": 918
                        },
                        {
                            "id": 2943,
                            "name": "en",
                            "platformId": 7,
                            "isActive": 1,
                            "platformName": "TikTok",
                            "displayName": "English",
                            "dbMappingId": 919
                        },
                        {
                            "id": 3977,
                            "name": "568",
                            "platformId": 8,
                            "isActive": 1,
                            "platformName": "ViAds",
                            "displayName": "English",
                            "dbMappingId": 1123
                        }
                    ]
                },
                {
                    "id": 2945,
                    "name": "Hungarian",
                    "platformId": 1,
                    "isActive": 1,
                    "platformName": "Beki",
                    "displayName": "Hungarian",
                    "mappingDetails": [
                        {
                            "id": 2947,
                            "name": "1227",
                            "platformId": 2,
                            "isActive": 1,
                            "platformName": "ION",
                            "displayName": "Hungarian",
                            "dbMappingId": 920
                        },
                        {
                            "id": 2949,
                            "name": "30",
                            "platformId": 3,
                            "isActive": 1,
                            "platformName": "Meta",
                            "displayName": "Hungarian",
                            "dbMappingId": 921
                        },
                        {
                            "id": 2951,
                            "name": "languageConstants/1024",
                            "platformId": 4,
                            "isActive": 1,
                            "platformName": "Google Ads",
                            "displayName": "Hungarian",
                            "dbMappingId": 922
                        },
                        {
                            "id": 2953,
                            "name": "hu",
                            "platformId": 7,
                            "isActive": 1,
                            "platformName": "TikTok",
                            "displayName": "Hungarian",
                            "dbMappingId": 923
                        },
                        {
                            "id": 3981,
                            "name": "593",
                            "platformId": 8,
                            "isActive": 1,
                            "platformName": "ViAds",
                            "displayName": "Hungarian",
                            "dbMappingId": 1125
                        }
                    ]
                },
                {
                    "id": 2955,
                    "name": "Punjabi",
                    "platformId": 1,
                    "isActive": 1,
                    "platformName": "Beki",
                    "displayName": "Punjabi",
                    "mappingDetails": [
                        {
                            "id": 2957,
                            "name": "1291",
                            "platformId": 2,
                            "isActive": 1,
                            "platformName": "ION",
                            "displayName": "Punjabi",
                            "dbMappingId": 924
                        },
                        {
                            "id": 2959,
                            "name": "47",
                            "platformId": 3,
                            "isActive": 1,
                            "platformName": "Meta",
                            "displayName": "Punjabi",
                            "dbMappingId": 925
                        },
                        {
                            "id": 2961,
                            "name": "languageConstants/1110",
                            "platformId": 4,
                            "isActive": 1,
                            "platformName": "Google Ads",
                            "displayName": "Punjabi",
                            "dbMappingId": 926
                        },
                        {
                            "id": 2963,
                            "name": "pa",
                            "platformId": 7,
                            "isActive": 1,
                            "platformName": "TikTok",
                            "displayName": "Punjabi",
                            "dbMappingId": 927
                        }
                    ]
                },
                {
                    "id": 2965,
                    "name": "Hiri Motu",
                    "platformId": 1,
                    "isActive": 1,
                    "platformName": "Beki",
                    "displayName": "Hiri Motu",
                    "mappingDetails": [
                        {
                            "id": 2967,
                            "name": "1226",
                            "platformId": 2,
                            "isActive": 1,
                            "platformName": "ION",
                            "displayName": "Hiri Motu",
                            "dbMappingId": 928
                        },
                        {
                            "id": 3985,
                            "name": "592",
                            "platformId": 8,
                            "isActive": 1,
                            "platformName": "ViAds",
                            "displayName": "Hiri Motu",
                            "dbMappingId": 1127
                        }
                    ]
                },
                {
                    "id": 2969,
                    "name": "Portuguese (Brazil)",
                    "platformId": 1,
                    "isActive": 1,
                    "platformName": "Beki",
                    "displayName": "Portuguese (Brazil)",
                    "mappingDetails": [
                        {
                            "id": 2971,
                            "name": "16",
                            "platformId": 3,
                            "isActive": 1,
                            "platformName": "Meta",
                            "displayName": "Portuguese (Brazil)",
                            "dbMappingId": 929
                        }
                    ]
                }
            ]
        },
        {
            "id": 80,
            "name": "Language",
            "platformId": 4,
            "isActive": 1,
            "platformName": "Google Ads",
            "displayName": "Language",
            "attributeMapping": 79,
            "mappingDetails": [
                {
                    "id": 79,
                    "name": "Language",
                    "platformId": 1,
                    "isActive": 1,
                    "platformName": "Beki",
                    "displayName": "Language"
                }
            ],
            "mappedPlatformsValueSet": [],
            "mappedPlatformsIdSet": [],
            "list": [
                {
                    "id": 1867,
                    "name": "languageConstants/1015",
                    "platformId": 4,
                    "isActive": 1,
                    "platformName": "Google Ads",
                    "displayName": "Swedish",
                    "attributeMapping": 1861,
                    "mappingDetails": [
                        {
                            "id": 1861,
                            "name": "Swedish",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Swedish",
                            "dbMappingId": 574
                        }
                    ]
                },
                {
                    "id": 1877,
                    "name": "languageConstants/1037",
                    "platformId": 4,
                    "isActive": 1,
                    "platformName": "Google Ads",
                    "displayName": "Turkish",
                    "attributeMapping": 1871,
                    "mappingDetails": [
                        {
                            "id": 1871,
                            "name": "Turkish",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Turkish",
                            "dbMappingId": 578
                        }
                    ]
                },
                {
                    "id": 1887,
                    "name": "languageConstants/1086",
                    "platformId": 4,
                    "isActive": 1,
                    "platformName": "Google Ads",
                    "displayName": "Kannada",
                    "attributeMapping": 1881,
                    "mappingDetails": [
                        {
                            "id": 1881,
                            "name": "Kannada",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Kannada",
                            "dbMappingId": 582
                        }
                    ]
                },
                {
                    "id": 1907,
                    "name": "languageConstants/1038",
                    "platformId": 4,
                    "isActive": 1,
                    "platformName": "Google Ads",
                    "displayName": "Catalan",
                    "attributeMapping": 1903,
                    "mappingDetails": [
                        {
                            "id": 1903,
                            "name": "Catalan",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Catalan",
                            "dbMappingId": 588
                        }
                    ]
                },
                {
                    "id": 1937,
                    "name": "languageConstants/1041",
                    "platformId": 4,
                    "isActive": 1,
                    "platformName": "Google Ads",
                    "displayName": "Urdu",
                    "attributeMapping": 1931,
                    "mappingDetails": [
                        {
                            "id": 1931,
                            "name": "Urdu",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Urdu",
                            "dbMappingId": 597
                        }
                    ]
                },
                {
                    "id": 1945,
                    "name": "languageConstants/1032",
                    "platformId": 4,
                    "isActive": 1,
                    "platformName": "Google Ads",
                    "displayName": "Romanian",
                    "attributeMapping": 1939,
                    "mappingDetails": [
                        {
                            "id": 1939,
                            "name": "Romanian",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Romanian",
                            "dbMappingId": 600
                        }
                    ]
                },
                {
                    "id": 1975,
                    "name": "languageConstants/1072",
                    "platformId": 4,
                    "isActive": 1,
                    "platformName": "Google Ads",
                    "displayName": "Gujarati",
                    "attributeMapping": 1969,
                    "mappingDetails": [
                        {
                            "id": 1969,
                            "name": "Gujarati",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Gujarati",
                            "dbMappingId": 609
                        }
                    ]
                },
                {
                    "id": 1985,
                    "name": "languageConstants/1026",
                    "platformId": 4,
                    "isActive": 1,
                    "platformName": "Google Ads",
                    "displayName": "Icelandic",
                    "attributeMapping": 1979,
                    "mappingDetails": [
                        {
                            "id": 1979,
                            "name": "Icelandic",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Icelandic",
                            "dbMappingId": 613
                        }
                    ]
                },
                {
                    "id": 2007,
                    "name": "languageConstants/1002",
                    "platformId": 4,
                    "isActive": 1,
                    "platformName": "Google Ads",
                    "displayName": "French",
                    "attributeMapping": 2001,
                    "mappingDetails": [
                        {
                            "id": 2001,
                            "name": "French",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "French",
                            "dbMappingId": 620
                        }
                    ]
                },
                {
                    "id": 2021,
                    "name": "languageConstants/1025",
                    "platformId": 4,
                    "isActive": 1,
                    "platformName": "Google Ads",
                    "displayName": "Indonesian",
                    "attributeMapping": 2015,
                    "mappingDetails": [
                        {
                            "id": 2015,
                            "name": "Indonesian",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Indonesian",
                            "dbMappingId": 625
                        }
                    ]
                },
                {
                    "id": 2057,
                    "name": "languageConstants/1028",
                    "platformId": 4,
                    "isActive": 1,
                    "platformName": "Google Ads",
                    "displayName": "Latvian",
                    "attributeMapping": 2051,
                    "mappingDetails": [
                        {
                            "id": 2051,
                            "name": "Latvian",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Latvian",
                            "dbMappingId": 636
                        }
                    ]
                },
                {
                    "id": 2065,
                    "name": "languageConstants/1130",
                    "platformId": 4,
                    "isActive": 1,
                    "platformName": "Google Ads",
                    "displayName": "Tamil",
                    "attributeMapping": 2059,
                    "mappingDetails": [
                        {
                            "id": 2059,
                            "name": "Tamil",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Tamil",
                            "dbMappingId": 639
                        }
                    ]
                },
                {
                    "id": 2091,
                    "name": "languageConstants/1021",
                    "platformId": 4,
                    "isActive": 1,
                    "platformName": "Google Ads",
                    "displayName": "Czech",
                    "attributeMapping": 2085,
                    "mappingDetails": [
                        {
                            "id": 2085,
                            "name": "Czech",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Czech",
                            "dbMappingId": 647
                        }
                    ]
                },
                {
                    "id": 2101,
                    "name": "languageConstants/1010",
                    "platformId": 4,
                    "isActive": 1,
                    "platformName": "Google Ads",
                    "displayName": "Dutch",
                    "attributeMapping": 2095,
                    "mappingDetails": [
                        {
                            "id": 2095,
                            "name": "Dutch",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Dutch",
                            "dbMappingId": 651
                        }
                    ]
                },
                {
                    "id": 2117,
                    "name": "languageConstants/1031",
                    "platformId": 4,
                    "isActive": 1,
                    "platformName": "Google Ads",
                    "displayName": "Russian",
                    "attributeMapping": 2111,
                    "mappingDetails": [
                        {
                            "id": 2111,
                            "name": "Russian",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Russian",
                            "dbMappingId": 657
                        }
                    ]
                },
                {
                    "id": 2149,
                    "name": "languageConstants/1014",
                    "platformId": 4,
                    "isActive": 1,
                    "platformName": "Google Ads",
                    "displayName": "Portuguese",
                    "attributeMapping": 2143,
                    "mappingDetails": [
                        {
                            "id": 2143,
                            "name": "Portuguese",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Portuguese",
                            "dbMappingId": 667
                        }
                    ]
                },
                {
                    "id": 2163,
                    "name": "languageConstants/1023",
                    "platformId": 4,
                    "isActive": 1,
                    "platformName": "Google Ads",
                    "displayName": "Hindi",
                    "attributeMapping": 2157,
                    "mappingDetails": [
                        {
                            "id": 2157,
                            "name": "Hindi",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Hindi",
                            "dbMappingId": 672
                        }
                    ]
                },
                {
                    "id": 2171,
                    "name": "languageConstants/1013",
                    "platformId": 4,
                    "isActive": 1,
                    "platformName": "Google Ads",
                    "displayName": "Norwegian",
                    "attributeMapping": 2167,
                    "mappingDetails": [
                        {
                            "id": 2167,
                            "name": "Norwegian",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Norwegian",
                            "dbMappingId": 675
                        }
                    ]
                },
                {
                    "id": 2233,
                    "name": "languageConstants/1004",
                    "platformId": 4,
                    "isActive": 1,
                    "platformName": "Google Ads",
                    "displayName": "Italian",
                    "attributeMapping": 2227,
                    "mappingDetails": [
                        {
                            "id": 2227,
                            "name": "Italian",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Italian",
                            "dbMappingId": 694
                        }
                    ]
                },
                {
                    "id": 2251,
                    "name": "languageConstants/1034",
                    "platformId": 4,
                    "isActive": 1,
                    "platformName": "Google Ads",
                    "displayName": "Slovenian",
                    "attributeMapping": 2245,
                    "mappingDetails": [
                        {
                            "id": 2245,
                            "name": "Slovenian",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Slovenian",
                            "dbMappingId": 700
                        }
                    ]
                },
                {
                    "id": 2305,
                    "name": "languageConstants/1039",
                    "platformId": 4,
                    "isActive": 1,
                    "platformName": "Google Ads",
                    "displayName": "Croatian",
                    "attributeMapping": 2299,
                    "mappingDetails": [
                        {
                            "id": 2299,
                            "name": "Croatian",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Croatian",
                            "dbMappingId": 716
                        }
                    ]
                },
                {
                    "id": 2317,
                    "name": "languageConstants/1009",
                    "platformId": 4,
                    "isActive": 1,
                    "platformName": "Google Ads",
                    "displayName": "Danish",
                    "attributeMapping": 2311,
                    "mappingDetails": [
                        {
                            "id": 2311,
                            "name": "Danish",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Danish",
                            "dbMappingId": 720
                        }
                    ]
                },
                {
                    "id": 2329,
                    "name": "languageConstants/1022",
                    "platformId": 4,
                    "isActive": 1,
                    "platformName": "Google Ads",
                    "displayName": "Greek",
                    "attributeMapping": 2323,
                    "mappingDetails": [
                        {
                            "id": 2323,
                            "name": "Greek",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Greek",
                            "dbMappingId": 724
                        }
                    ]
                },
                {
                    "id": 2351,
                    "name": "languageConstants/1027",
                    "platformId": 4,
                    "isActive": 1,
                    "platformName": "Google Ads",
                    "displayName": "Hebrew",
                    "attributeMapping": 2345,
                    "mappingDetails": [
                        {
                            "id": 2345,
                            "name": "Hebrew",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Hebrew",
                            "dbMappingId": 731
                        }
                    ]
                },
                {
                    "id": 2371,
                    "name": "languageConstants/1036",
                    "platformId": 4,
                    "isActive": 1,
                    "platformName": "Google Ads",
                    "displayName": "Ukrainian",
                    "attributeMapping": 2365,
                    "mappingDetails": [
                        {
                            "id": 2365,
                            "name": "Ukrainian",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Ukrainian",
                            "dbMappingId": 738
                        }
                    ]
                },
                {
                    "id": 2393,
                    "name": "languageConstants/1102",
                    "platformId": 4,
                    "isActive": 1,
                    "platformName": "Google Ads",
                    "displayName": "Malay",
                    "attributeMapping": 2387,
                    "mappingDetails": [
                        {
                            "id": 2387,
                            "name": "Malay",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Malay",
                            "dbMappingId": 745
                        }
                    ]
                },
                {
                    "id": 2427,
                    "name": "languageConstants/1005",
                    "platformId": 4,
                    "isActive": 1,
                    "platformName": "Google Ads",
                    "displayName": "Japanese",
                    "attributeMapping": 2421,
                    "mappingDetails": [
                        {
                            "id": 2421,
                            "name": "Japanese",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Japanese",
                            "dbMappingId": 756
                        }
                    ]
                },
                {
                    "id": 2437,
                    "name": "languageConstants/1043",
                    "platformId": 4,
                    "isActive": 1,
                    "platformName": "Google Ads",
                    "displayName": "Estonian",
                    "attributeMapping": 2431,
                    "mappingDetails": [
                        {
                            "id": 2431,
                            "name": "Estonian",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Estonian",
                            "dbMappingId": 760
                        }
                    ]
                },
                {
                    "id": 2453,
                    "name": "languageConstants/1056",
                    "platformId": 4,
                    "isActive": 1,
                    "platformName": "Google Ads",
                    "displayName": "Bengali",
                    "attributeMapping": 2447,
                    "mappingDetails": [
                        {
                            "id": 2447,
                            "name": "Bengali",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Bengali",
                            "dbMappingId": 765
                        }
                    ]
                },
                {
                    "id": 2493,
                    "name": "languageConstants/1064",
                    "platformId": 4,
                    "isActive": 1,
                    "platformName": "Google Ads",
                    "displayName": "Persian",
                    "attributeMapping": 2487,
                    "mappingDetails": [
                        {
                            "id": 2487,
                            "name": "Persian",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Persian",
                            "dbMappingId": 777
                        }
                    ]
                },
                {
                    "id": 2501,
                    "name": "languageConstants/1001",
                    "platformId": 4,
                    "isActive": 1,
                    "platformName": "Google Ads",
                    "displayName": "German",
                    "attributeMapping": 2495,
                    "mappingDetails": [
                        {
                            "id": 2495,
                            "name": "German",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "German",
                            "dbMappingId": 780
                        }
                    ]
                },
                {
                    "id": 2525,
                    "name": "languageConstants/1131",
                    "platformId": 4,
                    "isActive": 1,
                    "platformName": "Google Ads",
                    "displayName": "Telugu",
                    "attributeMapping": 2519,
                    "mappingDetails": [
                        {
                            "id": 2519,
                            "name": "Telugu",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Telugu",
                            "dbMappingId": 788
                        }
                    ]
                },
                {
                    "id": 2533,
                    "name": "languageConstants/1042",
                    "platformId": 4,
                    "isActive": 1,
                    "platformName": "Google Ads",
                    "displayName": "Filipino",
                    "attributeMapping": 2529,
                    "mappingDetails": [
                        {
                            "id": 2529,
                            "name": "Filipino",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Filipino",
                            "dbMappingId": 791
                        }
                    ]
                },
                {
                    "id": 2587,
                    "name": "languageConstants/1098",
                    "platformId": 4,
                    "isActive": 1,
                    "platformName": "Google Ads",
                    "displayName": "Malayalam",
                    "attributeMapping": 2581,
                    "mappingDetails": [
                        {
                            "id": 2581,
                            "name": "Malayalam",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Malayalam",
                            "dbMappingId": 807
                        }
                    ]
                },
                {
                    "id": 2597,
                    "name": "languageConstants/1029",
                    "platformId": 4,
                    "isActive": 1,
                    "platformName": "Google Ads",
                    "displayName": "Lithuanian",
                    "attributeMapping": 2591,
                    "mappingDetails": [
                        {
                            "id": 2591,
                            "name": "Lithuanian",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Lithuanian",
                            "dbMappingId": 811
                        }
                    ]
                },
                {
                    "id": 2609,
                    "name": "languageConstants/1012",
                    "platformId": 4,
                    "isActive": 1,
                    "platformName": "Google Ads",
                    "displayName": "Korean",
                    "attributeMapping": 2603,
                    "mappingDetails": [
                        {
                            "id": 2603,
                            "name": "Korean",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Korean",
                            "dbMappingId": 815
                        }
                    ]
                },
                {
                    "id": 2651,
                    "name": "languageConstants/1040",
                    "platformId": 4,
                    "isActive": 1,
                    "platformName": "Google Ads",
                    "displayName": "Vietnamese",
                    "attributeMapping": 2645,
                    "mappingDetails": [
                        {
                            "id": 2645,
                            "name": "Vietnamese",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Vietnamese",
                            "dbMappingId": 828
                        }
                    ]
                },
                {
                    "id": 2685,
                    "name": "languageConstants/1033",
                    "platformId": 4,
                    "isActive": 1,
                    "platformName": "Google Ads",
                    "displayName": "Slovak",
                    "attributeMapping": 2679,
                    "mappingDetails": [
                        {
                            "id": 2679,
                            "name": "Slovak",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Slovak",
                            "dbMappingId": 839
                        }
                    ]
                },
                {
                    "id": 2697,
                    "name": "languageConstants/1035",
                    "platformId": 4,
                    "isActive": 1,
                    "platformName": "Google Ads",
                    "displayName": "Serbian",
                    "attributeMapping": 2691,
                    "mappingDetails": [
                        {
                            "id": 2691,
                            "name": "Serbian",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Serbian",
                            "dbMappingId": 843
                        }
                    ]
                },
                {
                    "id": 2715,
                    "name": "languageConstants/1101",
                    "platformId": 4,
                    "isActive": 1,
                    "platformName": "Google Ads",
                    "displayName": "Marathi",
                    "attributeMapping": 2709,
                    "mappingDetails": [
                        {
                            "id": 2709,
                            "name": "Marathi",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Marathi",
                            "dbMappingId": 849
                        }
                    ]
                },
                {
                    "id": 2753,
                    "name": "languageConstants/1019",
                    "platformId": 4,
                    "isActive": 1,
                    "platformName": "Google Ads",
                    "displayName": "Arabic",
                    "attributeMapping": 2747,
                    "mappingDetails": [
                        {
                            "id": 2747,
                            "name": "Arabic",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Arabic",
                            "dbMappingId": 861
                        }
                    ]
                },
                {
                    "id": 2769,
                    "name": "languageConstants/1003",
                    "platformId": 4,
                    "isActive": 1,
                    "platformName": "Google Ads",
                    "displayName": "Spanish",
                    "attributeMapping": 2765,
                    "mappingDetails": [
                        {
                            "id": 2765,
                            "name": "Spanish",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Spanish",
                            "dbMappingId": 866
                        }
                    ]
                },
                {
                    "id": 2779,
                    "name": "languageConstants/1044",
                    "platformId": 4,
                    "isActive": 1,
                    "platformName": "Google Ads",
                    "displayName": "Thai",
                    "attributeMapping": 2773,
                    "mappingDetails": [
                        {
                            "id": 2773,
                            "name": "Thai",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Thai",
                            "dbMappingId": 870
                        }
                    ]
                },
                {
                    "id": 2833,
                    "name": "languageConstants/1018",
                    "platformId": 4,
                    "isActive": 1,
                    "platformName": "Google Ads",
                    "displayName": "Chinese (traditional)",
                    "attributeMapping": 2831,
                    "mappingDetails": [
                        {
                            "id": 2831,
                            "name": "Chinese (traditional)",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Chinese (traditional)",
                            "dbMappingId": 884
                        }
                    ]
                },
                {
                    "id": 2873,
                    "name": "languageConstants/1017",
                    "platformId": 4,
                    "isActive": 1,
                    "platformName": "Google Ads",
                    "displayName": "Chinese (simplified)",
                    "attributeMapping": 2871,
                    "mappingDetails": [
                        {
                            "id": 2871,
                            "name": "Chinese (simplified)",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Chinese (simplified)",
                            "dbMappingId": 895
                        }
                    ]
                },
                {
                    "id": 2881,
                    "name": "languageConstants/1011",
                    "platformId": 4,
                    "isActive": 1,
                    "platformName": "Google Ads",
                    "displayName": "Finnish",
                    "attributeMapping": 2875,
                    "mappingDetails": [
                        {
                            "id": 2875,
                            "name": "Finnish",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Finnish",
                            "dbMappingId": 898
                        }
                    ]
                },
                {
                    "id": 2901,
                    "name": "languageConstants/1030",
                    "platformId": 4,
                    "isActive": 1,
                    "platformName": "Google Ads",
                    "displayName": "Polish",
                    "attributeMapping": 2895,
                    "mappingDetails": [
                        {
                            "id": 2895,
                            "name": "Polish",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Polish",
                            "dbMappingId": 905
                        }
                    ]
                },
                {
                    "id": 2919,
                    "name": "languageConstants/1020",
                    "platformId": 4,
                    "isActive": 1,
                    "platformName": "Google Ads",
                    "displayName": "Bulgarian",
                    "attributeMapping": 2913,
                    "mappingDetails": [
                        {
                            "id": 2913,
                            "name": "Bulgarian",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Bulgarian",
                            "dbMappingId": 911
                        }
                    ]
                },
                {
                    "id": 2941,
                    "name": "languageConstants/1000",
                    "platformId": 4,
                    "isActive": 1,
                    "platformName": "Google Ads",
                    "displayName": "English",
                    "attributeMapping": 2935,
                    "mappingDetails": [
                        {
                            "id": 2935,
                            "name": "English",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "English",
                            "dbMappingId": 918
                        }
                    ]
                },
                {
                    "id": 2951,
                    "name": "languageConstants/1024",
                    "platformId": 4,
                    "isActive": 1,
                    "platformName": "Google Ads",
                    "displayName": "Hungarian",
                    "attributeMapping": 2945,
                    "mappingDetails": [
                        {
                            "id": 2945,
                            "name": "Hungarian",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Hungarian",
                            "dbMappingId": 922
                        }
                    ]
                },
                {
                    "id": 2961,
                    "name": "languageConstants/1110",
                    "platformId": 4,
                    "isActive": 1,
                    "platformName": "Google Ads",
                    "displayName": "Punjabi",
                    "attributeMapping": 2955,
                    "mappingDetails": [
                        {
                            "id": 2955,
                            "name": "Punjabi",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Punjabi",
                            "dbMappingId": 926
                        }
                    ]
                }
            ]
        },
        {
            "id": 81,
            "name": "Language",
            "platformId": 3,
            "isActive": 1,
            "platformName": "Meta",
            "displayName": "Language",
            "attributeMapping": 79,
            "mappingDetails": [
                {
                    "id": 79,
                    "name": "Language",
                    "platformId": 1,
                    "isActive": 1,
                    "platformName": "Beki",
                    "displayName": "Language"
                }
            ],
            "mappedPlatformsValueSet": [],
            "mappedPlatformsIdSet": [],
            "list": [
                {
                    "id": 1847,
                    "name": "84",
                    "platformId": 3,
                    "isActive": 1,
                    "platformName": "Meta",
                    "displayName": "Norwegian Nynorsk",
                    "attributeMapping": 1843,
                    "mappingDetails": [
                        {
                            "id": 1843,
                            "name": "Norwegian Nynorsk",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Norwegian Nynorsk",
                            "dbMappingId": 568
                        }
                    ]
                },
                {
                    "id": 1865,
                    "name": "18",
                    "platformId": 3,
                    "isActive": 1,
                    "platformName": "Meta",
                    "displayName": "Swedish",
                    "attributeMapping": 1861,
                    "mappingDetails": [
                        {
                            "id": 1861,
                            "name": "Swedish",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Swedish",
                            "dbMappingId": 573
                        }
                    ]
                },
                {
                    "id": 1875,
                    "name": "19",
                    "platformId": 3,
                    "isActive": 1,
                    "platformName": "Meta",
                    "displayName": "Turkish",
                    "attributeMapping": 1871,
                    "mappingDetails": [
                        {
                            "id": 1871,
                            "name": "Turkish",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Turkish",
                            "dbMappingId": 577
                        }
                    ]
                },
                {
                    "id": 1885,
                    "name": "75",
                    "platformId": 3,
                    "isActive": 1,
                    "platformName": "Meta",
                    "displayName": "Kannada",
                    "attributeMapping": 1881,
                    "mappingDetails": [
                        {
                            "id": 1881,
                            "name": "Kannada",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Kannada",
                            "dbMappingId": 581
                        }
                    ]
                },
                {
                    "id": 1901,
                    "name": "9",
                    "platformId": 3,
                    "isActive": 1,
                    "platformName": "Meta",
                    "displayName": "French (France)",
                    "attributeMapping": 1899,
                    "mappingDetails": [
                        {
                            "id": 1899,
                            "name": "French (France)",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "French (France)",
                            "dbMappingId": 586
                        }
                    ]
                },
                {
                    "id": 1905,
                    "name": "1",
                    "platformId": 3,
                    "isActive": 1,
                    "platformName": "Meta",
                    "displayName": "Catalan",
                    "attributeMapping": 1903,
                    "mappingDetails": [
                        {
                            "id": 1903,
                            "name": "Catalan",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Catalan",
                            "dbMappingId": 587
                        }
                    ]
                },
                {
                    "id": 1915,
                    "name": "31",
                    "platformId": 3,
                    "isActive": 1,
                    "platformName": "Meta",
                    "displayName": "Portuguese (Portugal)",
                    "attributeMapping": 1913,
                    "mappingDetails": [
                        {
                            "id": 1913,
                            "name": "Portuguese (Portugal)",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Portuguese (Portugal)",
                            "dbMappingId": 590
                        }
                    ]
                },
                {
                    "id": 1925,
                    "name": "68",
                    "platformId": 3,
                    "isActive": 1,
                    "platformName": "Meta",
                    "displayName": "Armenian",
                    "attributeMapping": 1921,
                    "mappingDetails": [
                        {
                            "id": 1921,
                            "name": "Armenian",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Armenian",
                            "dbMappingId": 593
                        }
                    ]
                },
                {
                    "id": 1935,
                    "name": "90",
                    "platformId": 3,
                    "isActive": 1,
                    "platformName": "Meta",
                    "displayName": "Urdu",
                    "attributeMapping": 1931,
                    "mappingDetails": [
                        {
                            "id": 1931,
                            "name": "Urdu",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Urdu",
                            "dbMappingId": 596
                        }
                    ]
                },
                {
                    "id": 1943,
                    "name": "32",
                    "platformId": 3,
                    "isActive": 1,
                    "platformName": "Meta",
                    "displayName": "Romanian",
                    "attributeMapping": 1939,
                    "mappingDetails": [
                        {
                            "id": 1939,
                            "name": "Romanian",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Romanian",
                            "dbMappingId": 599
                        }
                    ]
                },
                {
                    "id": 1973,
                    "name": "67",
                    "platformId": 3,
                    "isActive": 1,
                    "platformName": "Meta",
                    "displayName": "Gujarati",
                    "attributeMapping": 1969,
                    "mappingDetails": [
                        {
                            "id": 1969,
                            "name": "Gujarati",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Gujarati",
                            "dbMappingId": 608
                        }
                    ]
                },
                {
                    "id": 1983,
                    "name": "69",
                    "platformId": 3,
                    "isActive": 1,
                    "platformName": "Meta",
                    "displayName": "Icelandic",
                    "attributeMapping": 1979,
                    "mappingDetails": [
                        {
                            "id": 1979,
                            "name": "Icelandic",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Icelandic",
                            "dbMappingId": 612
                        }
                    ]
                },
                {
                    "id": 1999,
                    "name": "76",
                    "platformId": 3,
                    "isActive": 1,
                    "platformName": "Meta",
                    "displayName": "Kurdish",
                    "attributeMapping": 1995,
                    "mappingDetails": [
                        {
                            "id": 1995,
                            "name": "Kurdish",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Kurdish",
                            "dbMappingId": 617
                        }
                    ]
                },
                {
                    "id": 2005,
                    "name": "1003",
                    "platformId": 3,
                    "isActive": 1,
                    "platformName": "Meta",
                    "displayName": "French",
                    "attributeMapping": 2001,
                    "mappingDetails": [
                        {
                            "id": 2001,
                            "name": "French",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "French",
                            "dbMappingId": 619
                        }
                    ]
                },
                {
                    "id": 2019,
                    "name": "25",
                    "platformId": 3,
                    "isActive": 1,
                    "platformName": "Meta",
                    "displayName": "Indonesian",
                    "attributeMapping": 2015,
                    "mappingDetails": [
                        {
                            "id": 2015,
                            "name": "Indonesian",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Indonesian",
                            "dbMappingId": 624
                        }
                    ]
                },
                {
                    "id": 2035,
                    "name": "6",
                    "platformId": 3,
                    "isActive": 1,
                    "platformName": "Meta",
                    "displayName": "English (US)",
                    "attributeMapping": 2033,
                    "mappingDetails": [
                        {
                            "id": 2033,
                            "name": "English (US)",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "English (US)",
                            "dbMappingId": 629
                        }
                    ]
                },
                {
                    "id": 2039,
                    "name": "21",
                    "platformId": 3,
                    "isActive": 1,
                    "platformName": "Meta",
                    "displayName": "Chinese (Hong Kong SAR)",
                    "attributeMapping": 2037,
                    "mappingDetails": [
                        {
                            "id": 2037,
                            "name": "Chinese (Hong Kong SAR)",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Chinese (Hong Kong SAR)",
                            "dbMappingId": 630
                        }
                    ]
                },
                {
                    "id": 2045,
                    "name": "59",
                    "platformId": 3,
                    "isActive": 1,
                    "platformName": "Meta",
                    "displayName": "Basque",
                    "attributeMapping": 2041,
                    "mappingDetails": [
                        {
                            "id": 2041,
                            "name": "Basque",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Basque",
                            "dbMappingId": 632
                        }
                    ]
                },
                {
                    "id": 2055,
                    "name": "78",
                    "platformId": 3,
                    "isActive": 1,
                    "platformName": "Meta",
                    "displayName": "Latvian",
                    "attributeMapping": 2051,
                    "mappingDetails": [
                        {
                            "id": 2051,
                            "name": "Latvian",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Latvian",
                            "dbMappingId": 635
                        }
                    ]
                },
                {
                    "id": 2063,
                    "name": "48",
                    "platformId": 3,
                    "isActive": 1,
                    "platformName": "Meta",
                    "displayName": "Tamil",
                    "attributeMapping": 2059,
                    "mappingDetails": [
                        {
                            "id": 2059,
                            "name": "Tamil",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Tamil",
                            "dbMappingId": 638
                        }
                    ]
                },
                {
                    "id": 2089,
                    "name": "2",
                    "platformId": 3,
                    "isActive": 1,
                    "platformName": "Meta",
                    "displayName": "Czech",
                    "attributeMapping": 2085,
                    "mappingDetails": [
                        {
                            "id": 2085,
                            "name": "Czech",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Czech",
                            "dbMappingId": 646
                        }
                    ]
                },
                {
                    "id": 2099,
                    "name": "14",
                    "platformId": 3,
                    "isActive": 1,
                    "platformName": "Meta",
                    "displayName": "Dutch",
                    "attributeMapping": 2095,
                    "mappingDetails": [
                        {
                            "id": 2095,
                            "name": "Dutch",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Dutch",
                            "dbMappingId": 650
                        }
                    ]
                },
                {
                    "id": 2109,
                    "name": "86",
                    "platformId": 3,
                    "isActive": 1,
                    "platformName": "Meta",
                    "displayName": "Sinhala, Sinhalese",
                    "attributeMapping": 2105,
                    "mappingDetails": [
                        {
                            "id": 2105,
                            "name": "Sinhala, Sinhalese",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Sinhala, Sinhalese",
                            "dbMappingId": 654
                        }
                    ]
                },
                {
                    "id": 2115,
                    "name": "17",
                    "platformId": 3,
                    "isActive": 1,
                    "platformName": "Meta",
                    "displayName": "Russian",
                    "attributeMapping": 2111,
                    "mappingDetails": [
                        {
                            "id": 2111,
                            "name": "Russian",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Russian",
                            "dbMappingId": 656
                        }
                    ]
                },
                {
                    "id": 2125,
                    "name": "55",
                    "platformId": 3,
                    "isActive": 1,
                    "platformName": "Meta",
                    "displayName": "Bosnian",
                    "attributeMapping": 2121,
                    "mappingDetails": [
                        {
                            "id": 2121,
                            "name": "Bosnian",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Bosnian",
                            "dbMappingId": 660
                        }
                    ]
                },
                {
                    "id": 2147,
                    "name": "1005",
                    "platformId": 3,
                    "isActive": 1,
                    "platformName": "Meta",
                    "displayName": "Portuguese",
                    "attributeMapping": 2143,
                    "mappingDetails": [
                        {
                            "id": 2143,
                            "name": "Portuguese",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Portuguese",
                            "dbMappingId": 666
                        }
                    ]
                },
                {
                    "id": 2161,
                    "name": "46",
                    "platformId": 3,
                    "isActive": 1,
                    "platformName": "Meta",
                    "displayName": "Hindi",
                    "attributeMapping": 2157,
                    "mappingDetails": [
                        {
                            "id": 2157,
                            "name": "Hindi",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Hindi",
                            "dbMappingId": 671
                        }
                    ]
                },
                {
                    "id": 2181,
                    "name": "64",
                    "platformId": 3,
                    "isActive": 1,
                    "platformName": "Meta",
                    "displayName": "Irish",
                    "attributeMapping": 2177,
                    "mappingDetails": [
                        {
                            "id": 2177,
                            "name": "Irish",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Irish",
                            "dbMappingId": 678
                        }
                    ]
                },
                {
                    "id": 2187,
                    "name": "66",
                    "platformId": 3,
                    "isActive": 1,
                    "platformName": "Meta",
                    "displayName": "Guarani",
                    "attributeMapping": 2183,
                    "mappingDetails": [
                        {
                            "id": 2183,
                            "name": "Guarani",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Guarani",
                            "dbMappingId": 680
                        }
                    ]
                },
                {
                    "id": 2197,
                    "name": "73",
                    "platformId": 3,
                    "isActive": 1,
                    "platformName": "Meta",
                    "displayName": "Kazakh",
                    "attributeMapping": 2193,
                    "mappingDetails": [
                        {
                            "id": 2193,
                            "name": "Kazakh",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Kazakh",
                            "dbMappingId": 683
                        }
                    ]
                },
                {
                    "id": 2203,
                    "name": "71",
                    "platformId": 3,
                    "isActive": 1,
                    "platformName": "Meta",
                    "displayName": "Javanese",
                    "attributeMapping": 2199,
                    "mappingDetails": [
                        {
                            "id": 2199,
                            "name": "Javanese",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Javanese",
                            "dbMappingId": 685
                        }
                    ]
                },
                {
                    "id": 2207,
                    "name": "83",
                    "platformId": 3,
                    "isActive": 1,
                    "platformName": "Meta",
                    "displayName": "Flemish",
                    "attributeMapping": 2205,
                    "mappingDetails": [
                        {
                            "id": 2205,
                            "name": "Flemish",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Flemish",
                            "dbMappingId": 686
                        }
                    ]
                },
                {
                    "id": 2215,
                    "name": "22",
                    "platformId": 3,
                    "isActive": 1,
                    "platformName": "Meta",
                    "displayName": "Traditional Chinese (Taiwan)",
                    "attributeMapping": 2213,
                    "mappingDetails": [
                        {
                            "id": 2213,
                            "name": "Traditional Chinese (Taiwan)",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Traditional Chinese (Taiwan)",
                            "dbMappingId": 688
                        }
                    ]
                },
                {
                    "id": 2231,
                    "name": "10",
                    "platformId": 3,
                    "isActive": 1,
                    "platformName": "Meta",
                    "displayName": "Italian",
                    "attributeMapping": 2227,
                    "mappingDetails": [
                        {
                            "id": 2227,
                            "name": "Italian",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Italian",
                            "dbMappingId": 693
                        }
                    ]
                },
                {
                    "id": 2249,
                    "name": "34",
                    "platformId": 3,
                    "isActive": 1,
                    "platformName": "Meta",
                    "displayName": "Slovenian",
                    "attributeMapping": 2245,
                    "mappingDetails": [
                        {
                            "id": 2245,
                            "name": "Slovenian",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Slovenian",
                            "dbMappingId": 699
                        }
                    ]
                },
                {
                    "id": 2257,
                    "name": "13",
                    "platformId": 3,
                    "isActive": 1,
                    "platformName": "Meta",
                    "displayName": "Norwegian Bokmål",
                    "attributeMapping": 2253,
                    "mappingDetails": [
                        {
                            "id": 2253,
                            "name": "Norwegian Bokmål",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Norwegian Bokmål",
                            "dbMappingId": 702
                        }
                    ]
                },
                {
                    "id": 2287,
                    "name": "3",
                    "platformId": 3,
                    "isActive": 1,
                    "platformName": "Meta",
                    "displayName": "Welsh",
                    "attributeMapping": 2283,
                    "mappingDetails": [
                        {
                            "id": 2283,
                            "name": "Welsh",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Welsh",
                            "dbMappingId": 710
                        }
                    ]
                },
                {
                    "id": 2293,
                    "name": "62",
                    "platformId": 3,
                    "isActive": 1,
                    "platformName": "Meta",
                    "displayName": "Faroese",
                    "attributeMapping": 2289,
                    "mappingDetails": [
                        {
                            "id": 2289,
                            "name": "Faroese",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Faroese",
                            "dbMappingId": 712
                        }
                    ]
                },
                {
                    "id": 2303,
                    "name": "38",
                    "platformId": 3,
                    "isActive": 1,
                    "platformName": "Meta",
                    "displayName": "Croatian",
                    "attributeMapping": 2299,
                    "mappingDetails": [
                        {
                            "id": 2299,
                            "name": "Croatian",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Croatian",
                            "dbMappingId": 715
                        }
                    ]
                },
                {
                    "id": 2315,
                    "name": "4",
                    "platformId": 3,
                    "isActive": 1,
                    "platformName": "Meta",
                    "displayName": "Danish",
                    "attributeMapping": 2311,
                    "mappingDetails": [
                        {
                            "id": 2311,
                            "name": "Danish",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Danish",
                            "dbMappingId": 719
                        }
                    ]
                },
                {
                    "id": 2327,
                    "name": "39",
                    "platformId": 3,
                    "isActive": 1,
                    "platformName": "Meta",
                    "displayName": "Greek",
                    "attributeMapping": 2323,
                    "mappingDetails": [
                        {
                            "id": 2323,
                            "name": "Greek",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Greek",
                            "dbMappingId": 723
                        }
                    ]
                },
                {
                    "id": 2349,
                    "name": "29",
                    "platformId": 3,
                    "isActive": 1,
                    "platformName": "Meta",
                    "displayName": "Hebrew",
                    "attributeMapping": 2345,
                    "mappingDetails": [
                        {
                            "id": 2345,
                            "name": "Hebrew",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Hebrew",
                            "dbMappingId": 730
                        }
                    ]
                },
                {
                    "id": 2359,
                    "name": "80",
                    "platformId": 3,
                    "isActive": 1,
                    "platformName": "Meta",
                    "displayName": "Mongolian",
                    "attributeMapping": 2355,
                    "mappingDetails": [
                        {
                            "id": 2355,
                            "name": "Mongolian",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Mongolian",
                            "dbMappingId": 734
                        }
                    ]
                },
                {
                    "id": 2369,
                    "name": "52",
                    "platformId": 3,
                    "isActive": 1,
                    "platformName": "Meta",
                    "displayName": "Ukrainian",
                    "attributeMapping": 2365,
                    "mappingDetails": [
                        {
                            "id": 2365,
                            "name": "Ukrainian",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Ukrainian",
                            "dbMappingId": 737
                        }
                    ]
                },
                {
                    "id": 2391,
                    "name": "41",
                    "platformId": 3,
                    "isActive": 1,
                    "platformName": "Meta",
                    "displayName": "Malay",
                    "attributeMapping": 2387,
                    "mappingDetails": [
                        {
                            "id": 2387,
                            "name": "Malay",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Malay",
                            "dbMappingId": 744
                        }
                    ]
                },
                {
                    "id": 2409,
                    "name": "88",
                    "platformId": 3,
                    "isActive": 1,
                    "platformName": "Meta",
                    "displayName": "Swahili",
                    "attributeMapping": 2405,
                    "mappingDetails": [
                        {
                            "id": 2405,
                            "name": "Swahili",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Swahili",
                            "dbMappingId": 750
                        }
                    ]
                },
                {
                    "id": 2419,
                    "name": "79",
                    "platformId": 3,
                    "isActive": 1,
                    "platformName": "Meta",
                    "displayName": "Macedonian",
                    "attributeMapping": 2415,
                    "mappingDetails": [
                        {
                            "id": 2415,
                            "name": "Macedonian",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Macedonian",
                            "dbMappingId": 753
                        }
                    ]
                },
                {
                    "id": 2425,
                    "name": "11",
                    "platformId": 3,
                    "isActive": 1,
                    "platformName": "Meta",
                    "displayName": "Japanese",
                    "attributeMapping": 2421,
                    "mappingDetails": [
                        {
                            "id": 2421,
                            "name": "Japanese",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Japanese",
                            "dbMappingId": 755
                        }
                    ]
                },
                {
                    "id": 2435,
                    "name": "58",
                    "platformId": 3,
                    "isActive": 1,
                    "platformName": "Meta",
                    "displayName": "Estonian",
                    "attributeMapping": 2431,
                    "mappingDetails": [
                        {
                            "id": 2431,
                            "name": "Estonian",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Estonian",
                            "dbMappingId": 759
                        }
                    ]
                },
                {
                    "id": 2451,
                    "name": "45",
                    "platformId": 3,
                    "isActive": 1,
                    "platformName": "Meta",
                    "displayName": "Bengali",
                    "attributeMapping": 2447,
                    "mappingDetails": [
                        {
                            "id": 2447,
                            "name": "Bengali",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Bengali",
                            "dbMappingId": 764
                        }
                    ]
                },
                {
                    "id": 2485,
                    "name": "91",
                    "platformId": 3,
                    "isActive": 1,
                    "platformName": "Meta",
                    "displayName": "Uzbek",
                    "attributeMapping": 2481,
                    "mappingDetails": [
                        {
                            "id": 2481,
                            "name": "Uzbek",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Uzbek",
                            "dbMappingId": 774
                        }
                    ]
                },
                {
                    "id": 2491,
                    "name": "60",
                    "platformId": 3,
                    "isActive": 1,
                    "platformName": "Meta",
                    "displayName": "Persian",
                    "attributeMapping": 2487,
                    "mappingDetails": [
                        {
                            "id": 2487,
                            "name": "Persian",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Persian",
                            "dbMappingId": 776
                        }
                    ]
                },
                {
                    "id": 2499,
                    "name": "5",
                    "platformId": 3,
                    "isActive": 1,
                    "platformName": "Meta",
                    "displayName": "German",
                    "attributeMapping": 2495,
                    "mappingDetails": [
                        {
                            "id": 2495,
                            "name": "German",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "German",
                            "dbMappingId": 779
                        }
                    ]
                },
                {
                    "id": 2509,
                    "name": "53",
                    "platformId": 3,
                    "isActive": 1,
                    "platformName": "Meta",
                    "displayName": "Azerbaijani",
                    "attributeMapping": 2505,
                    "mappingDetails": [
                        {
                            "id": 2505,
                            "name": "Azerbaijani",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Azerbaijani",
                            "dbMappingId": 783
                        }
                    ]
                },
                {
                    "id": 2523,
                    "name": "49",
                    "platformId": 3,
                    "isActive": 1,
                    "platformName": "Meta",
                    "displayName": "Telugu",
                    "attributeMapping": 2519,
                    "mappingDetails": [
                        {
                            "id": 2519,
                            "name": "Telugu",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Telugu",
                            "dbMappingId": 787
                        }
                    ]
                },
                {
                    "id": 2531,
                    "name": "26",
                    "platformId": 3,
                    "isActive": 1,
                    "platformName": "Meta",
                    "displayName": "Filipino",
                    "attributeMapping": 2529,
                    "mappingDetails": [
                        {
                            "id": 2529,
                            "name": "Filipino",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Filipino",
                            "dbMappingId": 790
                        }
                    ]
                },
                {
                    "id": 2537,
                    "name": "24",
                    "platformId": 3,
                    "isActive": 1,
                    "platformName": "Meta",
                    "displayName": "English (UK)",
                    "attributeMapping": 2535,
                    "mappingDetails": [
                        {
                            "id": 2535,
                            "name": "English (UK)",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "English (UK)",
                            "dbMappingId": 792
                        }
                    ]
                },
                {
                    "id": 2547,
                    "name": "57",
                    "platformId": 3,
                    "isActive": 1,
                    "platformName": "Meta",
                    "displayName": "Esperanto",
                    "attributeMapping": 2543,
                    "mappingDetails": [
                        {
                            "id": 2543,
                            "name": "Esperanto",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Esperanto",
                            "dbMappingId": 795
                        }
                    ]
                },
                {
                    "id": 2561,
                    "name": "82",
                    "platformId": 3,
                    "isActive": 1,
                    "platformName": "Meta",
                    "displayName": "Nepali",
                    "attributeMapping": 2557,
                    "mappingDetails": [
                        {
                            "id": 2557,
                            "name": "Nepali",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Nepali",
                            "dbMappingId": 799
                        }
                    ]
                },
                {
                    "id": 2567,
                    "name": "72",
                    "platformId": 3,
                    "isActive": 1,
                    "platformName": "Meta",
                    "displayName": "Georgian",
                    "attributeMapping": 2563,
                    "mappingDetails": [
                        {
                            "id": 2563,
                            "name": "Georgian",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Georgian",
                            "dbMappingId": 801
                        }
                    ]
                },
                {
                    "id": 2575,
                    "name": "56",
                    "platformId": 3,
                    "isActive": 1,
                    "platformName": "Meta",
                    "displayName": "Cebuano",
                    "attributeMapping": 2573,
                    "mappingDetails": [
                        {
                            "id": 2573,
                            "name": "Cebuano",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Cebuano",
                            "dbMappingId": 803
                        }
                    ]
                },
                {
                    "id": 2585,
                    "name": "50",
                    "platformId": 3,
                    "isActive": 1,
                    "platformName": "Meta",
                    "displayName": "Malayalam",
                    "attributeMapping": 2581,
                    "mappingDetails": [
                        {
                            "id": 2581,
                            "name": "Malayalam",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Malayalam",
                            "dbMappingId": 806
                        }
                    ]
                },
                {
                    "id": 2595,
                    "name": "40",
                    "platformId": 3,
                    "isActive": 1,
                    "platformName": "Meta",
                    "displayName": "Lithuanian",
                    "attributeMapping": 2591,
                    "mappingDetails": [
                        {
                            "id": 2591,
                            "name": "Lithuanian",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Lithuanian",
                            "dbMappingId": 810
                        }
                    ]
                },
                {
                    "id": 2607,
                    "name": "12",
                    "platformId": 3,
                    "isActive": 1,
                    "platformName": "Meta",
                    "displayName": "Korean",
                    "attributeMapping": 2603,
                    "mappingDetails": [
                        {
                            "id": 2603,
                            "name": "Korean",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Korean",
                            "dbMappingId": 814
                        }
                    ]
                },
                {
                    "id": 2629,
                    "name": "74",
                    "platformId": 3,
                    "isActive": 1,
                    "platformName": "Meta",
                    "displayName": "Khmer",
                    "attributeMapping": 2627,
                    "mappingDetails": [
                        {
                            "id": 2627,
                            "name": "Khmer",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Khmer",
                            "dbMappingId": 821
                        }
                    ]
                },
                {
                    "id": 2649,
                    "name": "27",
                    "platformId": 3,
                    "isActive": 1,
                    "platformName": "Meta",
                    "displayName": "Vietnamese",
                    "attributeMapping": 2645,
                    "mappingDetails": [
                        {
                            "id": 2645,
                            "name": "Vietnamese",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Vietnamese",
                            "dbMappingId": 827
                        }
                    ]
                },
                {
                    "id": 2659,
                    "name": "1004",
                    "platformId": 3,
                    "isActive": 1,
                    "platformName": "Meta",
                    "displayName": "Chinese",
                    "attributeMapping": 2655,
                    "mappingDetails": [
                        {
                            "id": 2655,
                            "name": "Chinese",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Chinese",
                            "dbMappingId": 831
                        }
                    ]
                },
                {
                    "id": 2665,
                    "name": "65",
                    "platformId": 3,
                    "isActive": 1,
                    "platformName": "Meta",
                    "displayName": "Galician",
                    "attributeMapping": 2661,
                    "mappingDetails": [
                        {
                            "id": 2661,
                            "name": "Galician",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Galician",
                            "dbMappingId": 833
                        }
                    ]
                },
                {
                    "id": 2683,
                    "name": "33",
                    "platformId": 3,
                    "isActive": 1,
                    "platformName": "Meta",
                    "displayName": "Slovak",
                    "attributeMapping": 2679,
                    "mappingDetails": [
                        {
                            "id": 2679,
                            "name": "Slovak",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Slovak",
                            "dbMappingId": 838
                        }
                    ]
                },
                {
                    "id": 2689,
                    "name": "20",
                    "platformId": 3,
                    "isActive": 1,
                    "platformName": "Meta",
                    "displayName": "Simplified Chinese (China)",
                    "attributeMapping": 2687,
                    "mappingDetails": [
                        {
                            "id": 2687,
                            "name": "Simplified Chinese (China)",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Simplified Chinese (China)",
                            "dbMappingId": 840
                        }
                    ]
                },
                {
                    "id": 2695,
                    "name": "42",
                    "platformId": 3,
                    "isActive": 1,
                    "platformName": "Meta",
                    "displayName": "Serbian",
                    "attributeMapping": 2691,
                    "mappingDetails": [
                        {
                            "id": 2691,
                            "name": "Serbian",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Serbian",
                            "dbMappingId": 842
                        }
                    ]
                },
                {
                    "id": 2703,
                    "name": "54",
                    "platformId": 3,
                    "isActive": 1,
                    "platformName": "Meta",
                    "displayName": "Belarusian",
                    "attributeMapping": 2699,
                    "mappingDetails": [
                        {
                            "id": 2699,
                            "name": "Belarusian",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Belarusian",
                            "dbMappingId": 845
                        }
                    ]
                },
                {
                    "id": 2713,
                    "name": "81",
                    "platformId": 3,
                    "isActive": 1,
                    "platformName": "Meta",
                    "displayName": "Marathi",
                    "attributeMapping": 2709,
                    "mappingDetails": [
                        {
                            "id": 2709,
                            "name": "Marathi",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Marathi",
                            "dbMappingId": 848
                        }
                    ]
                },
                {
                    "id": 2723,
                    "name": "85",
                    "platformId": 3,
                    "isActive": 1,
                    "platformName": "Meta",
                    "displayName": "Pashto, Pushto",
                    "attributeMapping": 2719,
                    "mappingDetails": [
                        {
                            "id": 2719,
                            "name": "Pashto, Pushto",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Pashto, Pushto",
                            "dbMappingId": 852
                        }
                    ]
                },
                {
                    "id": 2745,
                    "name": "89",
                    "platformId": 3,
                    "isActive": 1,
                    "platformName": "Meta",
                    "displayName": "Tajik",
                    "attributeMapping": 2741,
                    "mappingDetails": [
                        {
                            "id": 2741,
                            "name": "Tajik",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Tajik",
                            "dbMappingId": 858
                        }
                    ]
                },
                {
                    "id": 2751,
                    "name": "28",
                    "platformId": 3,
                    "isActive": 1,
                    "platformName": "Meta",
                    "displayName": "Arabic",
                    "attributeMapping": 2747,
                    "mappingDetails": [
                        {
                            "id": 2747,
                            "name": "Arabic",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Arabic",
                            "dbMappingId": 860
                        }
                    ]
                },
                {
                    "id": 2767,
                    "name": "1002",
                    "platformId": 3,
                    "isActive": 1,
                    "platformName": "Meta",
                    "displayName": "Spanish",
                    "attributeMapping": 2765,
                    "mappingDetails": [
                        {
                            "id": 2765,
                            "name": "Spanish",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Spanish",
                            "dbMappingId": 865
                        }
                    ]
                },
                {
                    "id": 2777,
                    "name": "35",
                    "platformId": 3,
                    "isActive": 1,
                    "platformName": "Meta",
                    "displayName": "Thai",
                    "attributeMapping": 2773,
                    "mappingDetails": [
                        {
                            "id": 2773,
                            "name": "Thai",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Thai",
                            "dbMappingId": 869
                        }
                    ]
                },
                {
                    "id": 2805,
                    "name": "44",
                    "platformId": 3,
                    "isActive": 1,
                    "platformName": "Meta",
                    "displayName": "French (Canada)",
                    "attributeMapping": 2803,
                    "mappingDetails": [
                        {
                            "id": 2803,
                            "name": "French (Canada)",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "French (Canada)",
                            "dbMappingId": 877
                        }
                    ]
                },
                {
                    "id": 2809,
                    "name": "7",
                    "platformId": 3,
                    "isActive": 1,
                    "platformName": "Meta",
                    "displayName": "Spanish (Spain)",
                    "attributeMapping": 2807,
                    "mappingDetails": [
                        {
                            "id": 2807,
                            "name": "Spanish (Spain)",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Spanish (Spain)",
                            "dbMappingId": 878
                        }
                    ]
                },
                {
                    "id": 2853,
                    "name": "36",
                    "platformId": 3,
                    "isActive": 1,
                    "platformName": "Meta",
                    "displayName": "Afrikaans",
                    "attributeMapping": 2849,
                    "mappingDetails": [
                        {
                            "id": 2849,
                            "name": "Afrikaans",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Afrikaans",
                            "dbMappingId": 890
                        }
                    ]
                },
                {
                    "id": 2869,
                    "name": "70",
                    "platformId": 3,
                    "isActive": 1,
                    "platformName": "Meta",
                    "displayName": "Japanese (Kansai)",
                    "attributeMapping": 2867,
                    "mappingDetails": [
                        {
                            "id": 2867,
                            "name": "Japanese (Kansai)",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Japanese (Kansai)",
                            "dbMappingId": 894
                        }
                    ]
                },
                {
                    "id": 2879,
                    "name": "8",
                    "platformId": 3,
                    "isActive": 1,
                    "platformName": "Meta",
                    "displayName": "Finnish",
                    "attributeMapping": 2875,
                    "mappingDetails": [
                        {
                            "id": 2875,
                            "name": "Finnish",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Finnish",
                            "dbMappingId": 897
                        }
                    ]
                },
                {
                    "id": 2889,
                    "name": "87",
                    "platformId": 3,
                    "isActive": 1,
                    "platformName": "Meta",
                    "displayName": "Albanian",
                    "attributeMapping": 2885,
                    "mappingDetails": [
                        {
                            "id": 2885,
                            "name": "Albanian",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Albanian",
                            "dbMappingId": 901
                        }
                    ]
                },
                {
                    "id": 2899,
                    "name": "15",
                    "platformId": 3,
                    "isActive": 1,
                    "platformName": "Meta",
                    "displayName": "Polish",
                    "attributeMapping": 2895,
                    "mappingDetails": [
                        {
                            "id": 2895,
                            "name": "Polish",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Polish",
                            "dbMappingId": 904
                        }
                    ]
                },
                {
                    "id": 2917,
                    "name": "37",
                    "platformId": 3,
                    "isActive": 1,
                    "platformName": "Meta",
                    "displayName": "Bulgarian",
                    "attributeMapping": 2913,
                    "mappingDetails": [
                        {
                            "id": 2913,
                            "name": "Bulgarian",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Bulgarian",
                            "dbMappingId": 910
                        }
                    ]
                },
                {
                    "id": 2933,
                    "name": "63",
                    "platformId": 3,
                    "isActive": 1,
                    "platformName": "Meta",
                    "displayName": "Western Frisian",
                    "attributeMapping": 2929,
                    "mappingDetails": [
                        {
                            "id": 2929,
                            "name": "Western Frisian",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Western Frisian",
                            "dbMappingId": 915
                        }
                    ]
                },
                {
                    "id": 2939,
                    "name": "1001",
                    "platformId": 3,
                    "isActive": 1,
                    "platformName": "Meta",
                    "displayName": "English",
                    "attributeMapping": 2935,
                    "mappingDetails": [
                        {
                            "id": 2935,
                            "name": "English",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "English",
                            "dbMappingId": 917
                        }
                    ]
                },
                {
                    "id": 2949,
                    "name": "30",
                    "platformId": 3,
                    "isActive": 1,
                    "platformName": "Meta",
                    "displayName": "Hungarian",
                    "attributeMapping": 2945,
                    "mappingDetails": [
                        {
                            "id": 2945,
                            "name": "Hungarian",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Hungarian",
                            "dbMappingId": 921
                        }
                    ]
                },
                {
                    "id": 2959,
                    "name": "47",
                    "platformId": 3,
                    "isActive": 1,
                    "platformName": "Meta",
                    "displayName": "Punjabi",
                    "attributeMapping": 2955,
                    "mappingDetails": [
                        {
                            "id": 2955,
                            "name": "Punjabi",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Punjabi",
                            "dbMappingId": 925
                        }
                    ]
                },
                {
                    "id": 2971,
                    "name": "16",
                    "platformId": 3,
                    "isActive": 1,
                    "platformName": "Meta",
                    "displayName": "Portuguese (Brazil)",
                    "attributeMapping": 2969,
                    "mappingDetails": [
                        {
                            "id": 2969,
                            "name": "Portuguese (Brazil)",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Portuguese (Brazil)",
                            "dbMappingId": 929
                        }
                    ]
                }
            ]
        },
        {
            "id": 82,
            "name": "Language",
            "platformId": 2,
            "isActive": 1,
            "platformName": "ION",
            "displayName": "Language",
            "attributeMapping": 79,
            "mappingDetails": [
                {
                    "id": 79,
                    "name": "Language",
                    "platformId": 1,
                    "isActive": 1,
                    "platformName": "Beki",
                    "displayName": "Language"
                }
            ],
            "mappedPlatformsValueSet": [],
            "mappedPlatformsIdSet": [],
            "list": [
                {
                    "id": 1833,
                    "name": "1248",
                    "platformId": 2,
                    "isActive": 1,
                    "platformName": "ION",
                    "displayName": "Komi",
                    "attributeMapping": 1831,
                    "mappingDetails": [
                        {
                            "id": 1831,
                            "name": "Komi",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Komi",
                            "dbMappingId": 564
                        }
                    ]
                },
                {
                    "id": 1837,
                    "name": "1257",
                    "platformId": 2,
                    "isActive": 1,
                    "platformName": "ION",
                    "displayName": "Lingala",
                    "attributeMapping": 1835,
                    "mappingDetails": [
                        {
                            "id": 1835,
                            "name": "Lingala",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Lingala",
                            "dbMappingId": 565
                        }
                    ]
                },
                {
                    "id": 1841,
                    "name": "1177",
                    "platformId": 2,
                    "isActive": 1,
                    "platformName": "ION",
                    "displayName": "Bashkir",
                    "attributeMapping": 1839,
                    "mappingDetails": [
                        {
                            "id": 1839,
                            "name": "Bashkir",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Bashkir",
                            "dbMappingId": 566
                        }
                    ]
                },
                {
                    "id": 1845,
                    "name": "1279",
                    "platformId": 2,
                    "isActive": 1,
                    "platformName": "ION",
                    "displayName": "Norwegian Nynorsk",
                    "attributeMapping": 1843,
                    "mappingDetails": [
                        {
                            "id": 1843,
                            "name": "Norwegian Nynorsk",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Norwegian Nynorsk",
                            "dbMappingId": 567
                        }
                    ]
                },
                {
                    "id": 1851,
                    "name": "1162",
                    "platformId": 2,
                    "isActive": 1,
                    "platformName": "ION",
                    "displayName": "Abkhazian",
                    "attributeMapping": 1849,
                    "mappingDetails": [
                        {
                            "id": 1849,
                            "name": "Abkhazian",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Abkhazian",
                            "dbMappingId": 569
                        }
                    ]
                },
                {
                    "id": 1855,
                    "name": "1259",
                    "platformId": 2,
                    "isActive": 1,
                    "platformName": "ION",
                    "displayName": "Luba-Katanga",
                    "attributeMapping": 1853,
                    "mappingDetails": [
                        {
                            "id": 1853,
                            "name": "Luba-Katanga",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Luba-Katanga",
                            "dbMappingId": 570
                        }
                    ]
                },
                {
                    "id": 1859,
                    "name": "1344",
                    "platformId": 2,
                    "isActive": 1,
                    "platformName": "ION",
                    "displayName": "Zulu",
                    "attributeMapping": 1857,
                    "mappingDetails": [
                        {
                            "id": 1857,
                            "name": "Zulu",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Zulu",
                            "dbMappingId": 571
                        }
                    ]
                },
                {
                    "id": 1863,
                    "name": "1314",
                    "platformId": 2,
                    "isActive": 1,
                    "platformName": "ION",
                    "displayName": "Swedish",
                    "attributeMapping": 1861,
                    "mappingDetails": [
                        {
                            "id": 1861,
                            "name": "Swedish",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Swedish",
                            "dbMappingId": 572
                        }
                    ]
                },
                {
                    "id": 1873,
                    "name": "1327",
                    "platformId": 2,
                    "isActive": 1,
                    "platformName": "ION",
                    "displayName": "Turkish",
                    "attributeMapping": 1871,
                    "mappingDetails": [
                        {
                            "id": 1871,
                            "name": "Turkish",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Turkish",
                            "dbMappingId": 576
                        }
                    ]
                },
                {
                    "id": 1883,
                    "name": "1240",
                    "platformId": 2,
                    "isActive": 1,
                    "platformName": "ION",
                    "displayName": "Kannada",
                    "attributeMapping": 1881,
                    "mappingDetails": [
                        {
                            "id": 1881,
                            "name": "Kannada",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Kannada",
                            "dbMappingId": 580
                        }
                    ]
                },
                {
                    "id": 1893,
                    "name": "1299",
                    "platformId": 2,
                    "isActive": 1,
                    "platformName": "ION",
                    "displayName": "Sango",
                    "attributeMapping": 1891,
                    "mappingDetails": [
                        {
                            "id": 1891,
                            "name": "Sango",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Sango",
                            "dbMappingId": 584
                        }
                    ]
                },
                {
                    "id": 1897,
                    "name": "1343",
                    "platformId": 2,
                    "isActive": 1,
                    "platformName": "ION",
                    "displayName": "Zhuang",
                    "attributeMapping": 1895,
                    "mappingDetails": [
                        {
                            "id": 1895,
                            "name": "Zhuang",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Zhuang",
                            "dbMappingId": 585
                        }
                    ]
                },
                {
                    "id": 1911,
                    "name": "1191",
                    "platformId": 2,
                    "isActive": 1,
                    "platformName": "ION",
                    "displayName": "Church Slavonic, Old Slavonic, Old Church Slavonic",
                    "attributeMapping": 1909,
                    "mappingDetails": [
                        {
                            "id": 1909,
                            "name": "Church Slavonic, Old Slavonic, Old Church Slavonic",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Church Slavonic, Old Slavonic, Old Church Slavonic",
                            "dbMappingId": 589
                        }
                    ]
                },
                {
                    "id": 1919,
                    "name": "1212",
                    "platformId": 2,
                    "isActive": 1,
                    "platformName": "ION",
                    "displayName": "Gaelic, Scottish Gaelic",
                    "attributeMapping": 1917,
                    "mappingDetails": [
                        {
                            "id": 1917,
                            "name": "Gaelic, Scottish Gaelic",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Gaelic, Scottish Gaelic",
                            "dbMappingId": 591
                        }
                    ]
                },
                {
                    "id": 1923,
                    "name": "1170",
                    "platformId": 2,
                    "isActive": 1,
                    "platformName": "ION",
                    "displayName": "Armenian",
                    "attributeMapping": 1921,
                    "mappingDetails": [
                        {
                            "id": 1921,
                            "name": "Armenian",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Armenian",
                            "dbMappingId": 592
                        }
                    ]
                },
                {
                    "id": 1929,
                    "name": "1316",
                    "platformId": 2,
                    "isActive": 1,
                    "platformName": "ION",
                    "displayName": "Tahitian",
                    "attributeMapping": 1927,
                    "mappingDetails": [
                        {
                            "id": 1927,
                            "name": "Tahitian",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Tahitian",
                            "dbMappingId": 594
                        }
                    ]
                },
                {
                    "id": 1933,
                    "name": "1332",
                    "platformId": 2,
                    "isActive": 1,
                    "platformName": "ION",
                    "displayName": "Urdu",
                    "attributeMapping": 1931,
                    "mappingDetails": [
                        {
                            "id": 1931,
                            "name": "Urdu",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Urdu",
                            "dbMappingId": 595
                        }
                    ]
                },
                {
                    "id": 1941,
                    "name": "1293",
                    "platformId": 2,
                    "isActive": 1,
                    "platformName": "ION",
                    "displayName": "Romanian",
                    "attributeMapping": 1939,
                    "mappingDetails": [
                        {
                            "id": 1939,
                            "name": "Romanian",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Romanian",
                            "dbMappingId": 598
                        }
                    ]
                },
                {
                    "id": 1951,
                    "name": "1214",
                    "platformId": 2,
                    "isActive": 1,
                    "platformName": "ION",
                    "displayName": "Ganda",
                    "attributeMapping": 1949,
                    "mappingDetails": [
                        {
                            "id": 1949,
                            "name": "Ganda",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Ganda",
                            "dbMappingId": 602
                        }
                    ]
                },
                {
                    "id": 1955,
                    "name": "1329",
                    "platformId": 2,
                    "isActive": 1,
                    "platformName": "ION",
                    "displayName": "Twi",
                    "attributeMapping": 1953,
                    "mappingDetails": [
                        {
                            "id": 1953,
                            "name": "Twi",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Twi",
                            "dbMappingId": 603
                        }
                    ]
                },
                {
                    "id": 1959,
                    "name": "1230",
                    "platformId": 2,
                    "isActive": 1,
                    "platformName": "ION",
                    "displayName": "Igbo",
                    "attributeMapping": 1957,
                    "mappingDetails": [
                        {
                            "id": 1957,
                            "name": "Igbo",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Igbo",
                            "dbMappingId": 604
                        }
                    ]
                },
                {
                    "id": 1963,
                    "name": "1341",
                    "platformId": 2,
                    "isActive": 1,
                    "platformName": "ION",
                    "displayName": "Yiddish",
                    "attributeMapping": 1961,
                    "mappingDetails": [
                        {
                            "id": 1961,
                            "name": "Yiddish",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Yiddish",
                            "dbMappingId": 605
                        }
                    ]
                },
                {
                    "id": 1967,
                    "name": "1183",
                    "platformId": 2,
                    "isActive": 1,
                    "platformName": "ION",
                    "displayName": "Breton",
                    "attributeMapping": 1965,
                    "mappingDetails": [
                        {
                            "id": 1965,
                            "name": "Breton",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Breton",
                            "dbMappingId": 606
                        }
                    ]
                },
                {
                    "id": 1971,
                    "name": "1220",
                    "platformId": 2,
                    "isActive": 1,
                    "platformName": "ION",
                    "displayName": "Gujarati",
                    "attributeMapping": 1969,
                    "mappingDetails": [
                        {
                            "id": 1969,
                            "name": "Gujarati",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Gujarati",
                            "dbMappingId": 607
                        }
                    ]
                },
                {
                    "id": 1981,
                    "name": "1228",
                    "platformId": 2,
                    "isActive": 1,
                    "platformName": "ION",
                    "displayName": "Icelandic",
                    "attributeMapping": 1979,
                    "mappingDetails": [
                        {
                            "id": 1979,
                            "name": "Icelandic",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Icelandic",
                            "dbMappingId": 611
                        }
                    ]
                },
                {
                    "id": 1989,
                    "name": "1201",
                    "platformId": 2,
                    "isActive": 1,
                    "platformName": "ION",
                    "displayName": "Dzongkha",
                    "attributeMapping": 1987,
                    "mappingDetails": [
                        {
                            "id": 1987,
                            "name": "Dzongkha",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Dzongkha",
                            "dbMappingId": 614
                        }
                    ]
                },
                {
                    "id": 1993,
                    "name": "1311",
                    "platformId": 2,
                    "isActive": 1,
                    "platformName": "ION",
                    "displayName": "Sundanese",
                    "attributeMapping": 1991,
                    "mappingDetails": [
                        {
                            "id": 1991,
                            "name": "Sundanese",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Sundanese",
                            "dbMappingId": 615
                        }
                    ]
                },
                {
                    "id": 1997,
                    "name": "1252",
                    "platformId": 2,
                    "isActive": 1,
                    "platformName": "ION",
                    "displayName": "Kurdish",
                    "attributeMapping": 1995,
                    "mappingDetails": [
                        {
                            "id": 1995,
                            "name": "Kurdish",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Kurdish",
                            "dbMappingId": 616
                        }
                    ]
                },
                {
                    "id": 2003,
                    "name": "1209",
                    "platformId": 2,
                    "isActive": 1,
                    "platformName": "ION",
                    "displayName": "French",
                    "attributeMapping": 2001,
                    "mappingDetails": [
                        {
                            "id": 2001,
                            "name": "French",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "French",
                            "dbMappingId": 618
                        }
                    ]
                },
                {
                    "id": 2013,
                    "name": "1211",
                    "platformId": 2,
                    "isActive": 1,
                    "platformName": "ION",
                    "displayName": "Fulah",
                    "attributeMapping": 2011,
                    "mappingDetails": [
                        {
                            "id": 2011,
                            "name": "Fulah",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Fulah",
                            "dbMappingId": 622
                        }
                    ]
                },
                {
                    "id": 2017,
                    "name": "1231",
                    "platformId": 2,
                    "isActive": 1,
                    "platformName": "ION",
                    "displayName": "Indonesian",
                    "attributeMapping": 2015,
                    "mappingDetails": [
                        {
                            "id": 2015,
                            "name": "Indonesian",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Indonesian",
                            "dbMappingId": 623
                        }
                    ]
                },
                {
                    "id": 2027,
                    "name": "1301",
                    "platformId": 2,
                    "isActive": 1,
                    "platformName": "ION",
                    "displayName": "Sardinian",
                    "attributeMapping": 2025,
                    "mappingDetails": [
                        {
                            "id": 2025,
                            "name": "Sardinian",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Sardinian",
                            "dbMappingId": 627
                        }
                    ]
                },
                {
                    "id": 2031,
                    "name": "1266",
                    "platformId": 2,
                    "isActive": 1,
                    "platformName": "ION",
                    "displayName": "Manx",
                    "attributeMapping": 2029,
                    "mappingDetails": [
                        {
                            "id": 2029,
                            "name": "Manx",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Manx",
                            "dbMappingId": 628
                        }
                    ]
                },
                {
                    "id": 2043,
                    "name": "1178",
                    "platformId": 2,
                    "isActive": 1,
                    "platformName": "ION",
                    "displayName": "Basque",
                    "attributeMapping": 2041,
                    "mappingDetails": [
                        {
                            "id": 2041,
                            "name": "Basque",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Basque",
                            "dbMappingId": 631
                        }
                    ]
                },
                {
                    "id": 2049,
                    "name": "1207",
                    "platformId": 2,
                    "isActive": 1,
                    "platformName": "ION",
                    "displayName": "Fijian",
                    "attributeMapping": 2047,
                    "mappingDetails": [
                        {
                            "id": 2047,
                            "name": "Fijian",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Fijian",
                            "dbMappingId": 633
                        }
                    ]
                },
                {
                    "id": 2053,
                    "name": "1255",
                    "platformId": 2,
                    "isActive": 1,
                    "platformName": "ION",
                    "displayName": "Latvian",
                    "attributeMapping": 2051,
                    "mappingDetails": [
                        {
                            "id": 2051,
                            "name": "Latvian",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Latvian",
                            "dbMappingId": 634
                        }
                    ]
                },
                {
                    "id": 2061,
                    "name": "1318",
                    "platformId": 2,
                    "isActive": 1,
                    "platformName": "ION",
                    "displayName": "Tamil",
                    "attributeMapping": 2059,
                    "mappingDetails": [
                        {
                            "id": 2059,
                            "name": "Tamil",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Tamil",
                            "dbMappingId": 637
                        }
                    ]
                },
                {
                    "id": 2071,
                    "name": "1336",
                    "platformId": 2,
                    "isActive": 1,
                    "platformName": "ION",
                    "displayName": "Volapük",
                    "attributeMapping": 2069,
                    "mappingDetails": [
                        {
                            "id": 2069,
                            "name": "Volapük",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Volapük",
                            "dbMappingId": 641
                        }
                    ]
                },
                {
                    "id": 2075,
                    "name": "1189",
                    "platformId": 2,
                    "isActive": 1,
                    "platformName": "ION",
                    "displayName": "Chichewa, Chewa, Nyanja",
                    "attributeMapping": 2073,
                    "mappingDetails": [
                        {
                            "id": 2073,
                            "name": "Chichewa, Chewa, Nyanja",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Chichewa, Chewa, Nyanja",
                            "dbMappingId": 642
                        }
                    ]
                },
                {
                    "id": 2079,
                    "name": "1251",
                    "platformId": 2,
                    "isActive": 1,
                    "platformName": "ION",
                    "displayName": "Kuanyama, Kwanyama",
                    "attributeMapping": 2077,
                    "mappingDetails": [
                        {
                            "id": 2077,
                            "name": "Kuanyama, Kwanyama",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Kuanyama, Kwanyama",
                            "dbMappingId": 643
                        }
                    ]
                },
                {
                    "id": 2083,
                    "name": "1269",
                    "platformId": 2,
                    "isActive": 1,
                    "platformName": "ION",
                    "displayName": "Marshallese",
                    "attributeMapping": 2081,
                    "mappingDetails": [
                        {
                            "id": 2081,
                            "name": "Marshallese",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Marshallese",
                            "dbMappingId": 644
                        }
                    ]
                },
                {
                    "id": 2087,
                    "name": "1197",
                    "platformId": 2,
                    "isActive": 1,
                    "platformName": "ION",
                    "displayName": "Czech",
                    "attributeMapping": 2085,
                    "mappingDetails": [
                        {
                            "id": 2085,
                            "name": "Czech",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Czech",
                            "dbMappingId": 645
                        }
                    ]
                },
                {
                    "id": 2097,
                    "name": "1200",
                    "platformId": 2,
                    "isActive": 1,
                    "platformName": "ION",
                    "displayName": "Dutch",
                    "attributeMapping": 2095,
                    "mappingDetails": [
                        {
                            "id": 2095,
                            "name": "Dutch",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Dutch",
                            "dbMappingId": 649
                        }
                    ]
                },
                {
                    "id": 2107,
                    "name": "1305",
                    "platformId": 2,
                    "isActive": 1,
                    "platformName": "ION",
                    "displayName": "Sinhala, Sinhalese",
                    "attributeMapping": 2105,
                    "mappingDetails": [
                        {
                            "id": 2105,
                            "name": "Sinhala, Sinhalese",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Sinhala, Sinhalese",
                            "dbMappingId": 653
                        }
                    ]
                },
                {
                    "id": 2113,
                    "name": "1296",
                    "platformId": 2,
                    "isActive": 1,
                    "platformName": "ION",
                    "displayName": "Russian",
                    "attributeMapping": 2111,
                    "mappingDetails": [
                        {
                            "id": 2111,
                            "name": "Russian",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Russian",
                            "dbMappingId": 655
                        }
                    ]
                },
                {
                    "id": 2123,
                    "name": "1182",
                    "platformId": 2,
                    "isActive": 1,
                    "platformName": "ION",
                    "displayName": "Bosnian",
                    "attributeMapping": 2121,
                    "mappingDetails": [
                        {
                            "id": 2121,
                            "name": "Bosnian",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Bosnian",
                            "dbMappingId": 659
                        }
                    ]
                },
                {
                    "id": 2129,
                    "name": "1233",
                    "platformId": 2,
                    "isActive": 1,
                    "platformName": "ION",
                    "displayName": "Interlingue, Occidental",
                    "attributeMapping": 2127,
                    "mappingDetails": [
                        {
                            "id": 2127,
                            "name": "Interlingue, Occidental",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Interlingue, Occidental",
                            "dbMappingId": 661
                        }
                    ]
                },
                {
                    "id": 2133,
                    "name": "1295",
                    "platformId": 2,
                    "isActive": 1,
                    "platformName": "ION",
                    "displayName": "Rundi",
                    "attributeMapping": 2131,
                    "mappingDetails": [
                        {
                            "id": 2131,
                            "name": "Rundi",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Rundi",
                            "dbMappingId": 662
                        }
                    ]
                },
                {
                    "id": 2137,
                    "name": "1246",
                    "platformId": 2,
                    "isActive": 1,
                    "platformName": "ION",
                    "displayName": "Kinyarwanda",
                    "attributeMapping": 2135,
                    "mappingDetails": [
                        {
                            "id": 2135,
                            "name": "Kinyarwanda",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Kinyarwanda",
                            "dbMappingId": 663
                        }
                    ]
                },
                {
                    "id": 2141,
                    "name": "1176",
                    "platformId": 2,
                    "isActive": 1,
                    "platformName": "ION",
                    "displayName": "Bambara",
                    "attributeMapping": 2139,
                    "mappingDetails": [
                        {
                            "id": 2139,
                            "name": "Bambara",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Bambara",
                            "dbMappingId": 664
                        }
                    ]
                },
                {
                    "id": 2145,
                    "name": "1290",
                    "platformId": 2,
                    "isActive": 1,
                    "platformName": "ION",
                    "displayName": "Portuguese",
                    "attributeMapping": 2143,
                    "mappingDetails": [
                        {
                            "id": 2143,
                            "name": "Portuguese",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Portuguese",
                            "dbMappingId": 665
                        }
                    ]
                },
                {
                    "id": 2155,
                    "name": "1229",
                    "platformId": 2,
                    "isActive": 1,
                    "platformName": "ION",
                    "displayName": "Ido",
                    "attributeMapping": 2153,
                    "mappingDetails": [
                        {
                            "id": 2153,
                            "name": "Ido",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Ido",
                            "dbMappingId": 669
                        }
                    ]
                },
                {
                    "id": 2159,
                    "name": "1225",
                    "platformId": 2,
                    "isActive": 1,
                    "platformName": "ION",
                    "displayName": "Hindi",
                    "attributeMapping": 2157,
                    "mappingDetails": [
                        {
                            "id": 2157,
                            "name": "Hindi",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Hindi",
                            "dbMappingId": 670
                        }
                    ]
                },
                {
                    "id": 2169,
                    "name": "1277",
                    "platformId": 2,
                    "isActive": 1,
                    "platformName": "ION",
                    "displayName": "Norwegian",
                    "attributeMapping": 2167,
                    "mappingDetails": [
                        {
                            "id": 2167,
                            "name": "Norwegian",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Norwegian",
                            "dbMappingId": 674
                        }
                    ]
                },
                {
                    "id": 2175,
                    "name": "1186",
                    "platformId": 2,
                    "isActive": 1,
                    "platformName": "ION",
                    "displayName": "Catalan, Valencian",
                    "attributeMapping": 2173,
                    "mappingDetails": [
                        {
                            "id": 2173,
                            "name": "Catalan, Valencian",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Catalan, Valencian",
                            "dbMappingId": 676
                        }
                    ]
                },
                {
                    "id": 2179,
                    "name": "1236",
                    "platformId": 2,
                    "isActive": 1,
                    "platformName": "ION",
                    "displayName": "Irish",
                    "attributeMapping": 2177,
                    "mappingDetails": [
                        {
                            "id": 2177,
                            "name": "Irish",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Irish",
                            "dbMappingId": 677
                        }
                    ]
                },
                {
                    "id": 2185,
                    "name": "1219",
                    "platformId": 2,
                    "isActive": 1,
                    "platformName": "ION",
                    "displayName": "Guarani",
                    "attributeMapping": 2183,
                    "mappingDetails": [
                        {
                            "id": 2183,
                            "name": "Guarani",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Guarani",
                            "dbMappingId": 679
                        }
                    ]
                },
                {
                    "id": 2191,
                    "name": "1192",
                    "platformId": 2,
                    "isActive": 1,
                    "platformName": "ION",
                    "displayName": "Chuvash",
                    "attributeMapping": 2189,
                    "mappingDetails": [
                        {
                            "id": 2189,
                            "name": "Chuvash",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Chuvash",
                            "dbMappingId": 681
                        }
                    ]
                },
                {
                    "id": 2195,
                    "name": "1243",
                    "platformId": 2,
                    "isActive": 1,
                    "platformName": "ION",
                    "displayName": "Kazakh",
                    "attributeMapping": 2193,
                    "mappingDetails": [
                        {
                            "id": 2193,
                            "name": "Kazakh",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Kazakh",
                            "dbMappingId": 682
                        }
                    ]
                },
                {
                    "id": 2201,
                    "name": "1239",
                    "platformId": 2,
                    "isActive": 1,
                    "platformName": "ION",
                    "displayName": "Javanese",
                    "attributeMapping": 2199,
                    "mappingDetails": [
                        {
                            "id": 2199,
                            "name": "Javanese",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Javanese",
                            "dbMappingId": 684
                        }
                    ]
                },
                {
                    "id": 2211,
                    "name": "1254",
                    "platformId": 2,
                    "isActive": 1,
                    "platformName": "ION",
                    "displayName": "Latin",
                    "attributeMapping": 2209,
                    "mappingDetails": [
                        {
                            "id": 2209,
                            "name": "Latin",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Latin",
                            "dbMappingId": 687
                        }
                    ]
                },
                {
                    "id": 2219,
                    "name": "1271",
                    "platformId": 2,
                    "isActive": 1,
                    "platformName": "ION",
                    "displayName": "Nauru",
                    "attributeMapping": 2217,
                    "mappingDetails": [
                        {
                            "id": 2217,
                            "name": "Nauru",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Nauru",
                            "dbMappingId": 689
                        }
                    ]
                },
                {
                    "id": 2223,
                    "name": "1283",
                    "platformId": 2,
                    "isActive": 1,
                    "platformName": "ION",
                    "displayName": "Oriya",
                    "attributeMapping": 2221,
                    "mappingDetails": [
                        {
                            "id": 2221,
                            "name": "Oriya",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Oriya",
                            "dbMappingId": 690
                        }
                    ]
                },
                {
                    "id": 2229,
                    "name": "1237",
                    "platformId": 2,
                    "isActive": 1,
                    "platformName": "ION",
                    "displayName": "Italian",
                    "attributeMapping": 2227,
                    "mappingDetails": [
                        {
                            "id": 2227,
                            "name": "Italian",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Italian",
                            "dbMappingId": 692
                        }
                    ]
                },
                {
                    "id": 2239,
                    "name": "1194",
                    "platformId": 2,
                    "isActive": 1,
                    "platformName": "ION",
                    "displayName": "Corsican",
                    "attributeMapping": 2237,
                    "mappingDetails": [
                        {
                            "id": 2237,
                            "name": "Corsican",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Corsican",
                            "dbMappingId": 696
                        }
                    ]
                },
                {
                    "id": 2243,
                    "name": "1282",
                    "platformId": 2,
                    "isActive": 1,
                    "platformName": "ION",
                    "displayName": "Ojibwa",
                    "attributeMapping": 2241,
                    "mappingDetails": [
                        {
                            "id": 2241,
                            "name": "Ojibwa",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Ojibwa",
                            "dbMappingId": 697
                        }
                    ]
                },
                {
                    "id": 2247,
                    "name": "1307",
                    "platformId": 2,
                    "isActive": 1,
                    "platformName": "ION",
                    "displayName": "Slovenian",
                    "attributeMapping": 2245,
                    "mappingDetails": [
                        {
                            "id": 2245,
                            "name": "Slovenian",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Slovenian",
                            "dbMappingId": 698
                        }
                    ]
                },
                {
                    "id": 2255,
                    "name": "1278",
                    "platformId": 2,
                    "isActive": 1,
                    "platformName": "ION",
                    "displayName": "Norwegian Bokmål",
                    "attributeMapping": 2253,
                    "mappingDetails": [
                        {
                            "id": 2253,
                            "name": "Norwegian Bokmål",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Norwegian Bokmål",
                            "dbMappingId": 701
                        }
                    ]
                },
                {
                    "id": 2261,
                    "name": "1334",
                    "platformId": 2,
                    "isActive": 1,
                    "platformName": "ION",
                    "displayName": "Venda",
                    "attributeMapping": 2259,
                    "mappingDetails": [
                        {
                            "id": 2259,
                            "name": "Venda",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Venda",
                            "dbMappingId": 703
                        }
                    ]
                },
                {
                    "id": 2265,
                    "name": "1267",
                    "platformId": 2,
                    "isActive": 1,
                    "platformName": "ION",
                    "displayName": "Maori",
                    "attributeMapping": 2263,
                    "mappingDetails": [
                        {
                            "id": 2263,
                            "name": "Maori",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Maori",
                            "dbMappingId": 704
                        }
                    ]
                },
                {
                    "id": 2269,
                    "name": "1174",
                    "platformId": 2,
                    "isActive": 1,
                    "platformName": "ION",
                    "displayName": "Aymara",
                    "attributeMapping": 2267,
                    "mappingDetails": [
                        {
                            "id": 2267,
                            "name": "Aymara",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Aymara",
                            "dbMappingId": 705
                        }
                    ]
                },
                {
                    "id": 2273,
                    "name": "1285",
                    "platformId": 2,
                    "isActive": 1,
                    "platformName": "ION",
                    "displayName": "Ossetian, Ossetic",
                    "attributeMapping": 2271,
                    "mappingDetails": [
                        {
                            "id": 2271,
                            "name": "Ossetian, Ossetic",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Ossetian, Ossetic",
                            "dbMappingId": 706
                        }
                    ]
                },
                {
                    "id": 2277,
                    "name": "1260",
                    "platformId": 2,
                    "isActive": 1,
                    "platformName": "ION",
                    "displayName": "Luxembourgish, Letzeburgesch",
                    "attributeMapping": 2275,
                    "mappingDetails": [
                        {
                            "id": 2275,
                            "name": "Luxembourgish, Letzeburgesch",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Luxembourgish, Letzeburgesch",
                            "dbMappingId": 707
                        }
                    ]
                },
                {
                    "id": 2281,
                    "name": "1340",
                    "platformId": 2,
                    "isActive": 1,
                    "platformName": "ION",
                    "displayName": "Xhosa",
                    "attributeMapping": 2279,
                    "mappingDetails": [
                        {
                            "id": 2279,
                            "name": "Xhosa",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Xhosa",
                            "dbMappingId": 708
                        }
                    ]
                },
                {
                    "id": 2285,
                    "name": "1338",
                    "platformId": 2,
                    "isActive": 1,
                    "platformName": "ION",
                    "displayName": "Welsh",
                    "attributeMapping": 2283,
                    "mappingDetails": [
                        {
                            "id": 2283,
                            "name": "Welsh",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Welsh",
                            "dbMappingId": 709
                        }
                    ]
                },
                {
                    "id": 2291,
                    "name": "1206",
                    "platformId": 2,
                    "isActive": 1,
                    "platformName": "ION",
                    "displayName": "Faroese",
                    "attributeMapping": 2289,
                    "mappingDetails": [
                        {
                            "id": 2289,
                            "name": "Faroese",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Faroese",
                            "dbMappingId": 711
                        }
                    ]
                },
                {
                    "id": 2297,
                    "name": "1224",
                    "platformId": 2,
                    "isActive": 1,
                    "platformName": "ION",
                    "displayName": "Herero",
                    "attributeMapping": 2295,
                    "mappingDetails": [
                        {
                            "id": 2295,
                            "name": "Herero",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Herero",
                            "dbMappingId": 713
                        }
                    ]
                },
                {
                    "id": 2301,
                    "name": "1196",
                    "platformId": 2,
                    "isActive": 1,
                    "platformName": "ION",
                    "displayName": "Croatian",
                    "attributeMapping": 2299,
                    "mappingDetails": [
                        {
                            "id": 2299,
                            "name": "Croatian",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Croatian",
                            "dbMappingId": 714
                        }
                    ]
                },
                {
                    "id": 2309,
                    "name": "1330",
                    "platformId": 2,
                    "isActive": 1,
                    "platformName": "ION",
                    "displayName": "Uighur",
                    "attributeMapping": 2307,
                    "mappingDetails": [
                        {
                            "id": 2307,
                            "name": "Uighur",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Uighur",
                            "dbMappingId": 717
                        }
                    ]
                },
                {
                    "id": 2313,
                    "name": "1198",
                    "platformId": 2,
                    "isActive": 1,
                    "platformName": "ION",
                    "displayName": "Danish",
                    "attributeMapping": 2311,
                    "mappingDetails": [
                        {
                            "id": 2311,
                            "name": "Danish",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Danish",
                            "dbMappingId": 718
                        }
                    ]
                },
                {
                    "id": 2321,
                    "name": "1167",
                    "platformId": 2,
                    "isActive": 1,
                    "platformName": "ION",
                    "displayName": "Amharic",
                    "attributeMapping": 2319,
                    "mappingDetails": [
                        {
                            "id": 2319,
                            "name": "Amharic",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Amharic",
                            "dbMappingId": 721
                        }
                    ]
                },
                {
                    "id": 2325,
                    "name": "1217",
                    "platformId": 2,
                    "isActive": 1,
                    "platformName": "ION",
                    "displayName": "Greek",
                    "attributeMapping": 2323,
                    "mappingDetails": [
                        {
                            "id": 2323,
                            "name": "Greek",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Greek",
                            "dbMappingId": 722
                        }
                    ]
                },
                {
                    "id": 2335,
                    "name": "1326",
                    "platformId": 2,
                    "isActive": 1,
                    "platformName": "ION",
                    "displayName": "Tswana",
                    "attributeMapping": 2333,
                    "mappingDetails": [
                        {
                            "id": 2333,
                            "name": "Tswana",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Tswana",
                            "dbMappingId": 726
                        }
                    ]
                },
                {
                    "id": 2339,
                    "name": "1275",
                    "platformId": 2,
                    "isActive": 1,
                    "platformName": "ION",
                    "displayName": "Ndonga",
                    "attributeMapping": 2337,
                    "mappingDetails": [
                        {
                            "id": 2337,
                            "name": "Ndonga",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Ndonga",
                            "dbMappingId": 727
                        }
                    ]
                },
                {
                    "id": 2343,
                    "name": "1309",
                    "platformId": 2,
                    "isActive": 1,
                    "platformName": "ION",
                    "displayName": "Southern Sotho",
                    "attributeMapping": 2341,
                    "mappingDetails": [
                        {
                            "id": 2341,
                            "name": "Southern Sotho",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Southern Sotho",
                            "dbMappingId": 728
                        }
                    ]
                },
                {
                    "id": 2347,
                    "name": "1223",
                    "platformId": 2,
                    "isActive": 1,
                    "platformName": "ION",
                    "displayName": "Hebrew",
                    "attributeMapping": 2345,
                    "mappingDetails": [
                        {
                            "id": 2345,
                            "name": "Hebrew",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Hebrew",
                            "dbMappingId": 729
                        }
                    ]
                },
                {
                    "id": 2357,
                    "name": "1270",
                    "platformId": 2,
                    "isActive": 1,
                    "platformName": "ION",
                    "displayName": "Mongolian",
                    "attributeMapping": 2355,
                    "mappingDetails": [
                        {
                            "id": 2355,
                            "name": "Mongolian",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Mongolian",
                            "dbMappingId": 733
                        }
                    ]
                },
                {
                    "id": 2363,
                    "name": "1303",
                    "platformId": 2,
                    "isActive": 1,
                    "platformName": "ION",
                    "displayName": "Shona",
                    "attributeMapping": 2361,
                    "mappingDetails": [
                        {
                            "id": 2361,
                            "name": "Shona",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Shona",
                            "dbMappingId": 735
                        }
                    ]
                },
                {
                    "id": 2367,
                    "name": "1331",
                    "platformId": 2,
                    "isActive": 1,
                    "platformName": "ION",
                    "displayName": "Ukrainian",
                    "attributeMapping": 2365,
                    "mappingDetails": [
                        {
                            "id": 2365,
                            "name": "Ukrainian",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Ukrainian",
                            "dbMappingId": 736
                        }
                    ]
                },
                {
                    "id": 2377,
                    "name": "1256",
                    "platformId": 2,
                    "isActive": 1,
                    "platformName": "ION",
                    "displayName": "Limburgan, Limburger, Limburgish",
                    "attributeMapping": 2375,
                    "mappingDetails": [
                        {
                            "id": 2375,
                            "name": "Limburgan, Limburger, Limburgish",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Limburgan, Limburger, Limburgish",
                            "dbMappingId": 740
                        }
                    ]
                },
                {
                    "id": 2381,
                    "name": "1297",
                    "platformId": 2,
                    "isActive": 1,
                    "platformName": "ION",
                    "displayName": "Northern Sami",
                    "attributeMapping": 2379,
                    "mappingDetails": [
                        {
                            "id": 2379,
                            "name": "Northern Sami",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Northern Sami",
                            "dbMappingId": 741
                        }
                    ]
                },
                {
                    "id": 2385,
                    "name": "1245",
                    "platformId": 2,
                    "isActive": 1,
                    "platformName": "ION",
                    "displayName": "Kikuyu, Gikuyu",
                    "attributeMapping": 2383,
                    "mappingDetails": [
                        {
                            "id": 2383,
                            "name": "Kikuyu, Gikuyu",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Kikuyu, Gikuyu",
                            "dbMappingId": 742
                        }
                    ]
                },
                {
                    "id": 2389,
                    "name": "1263",
                    "platformId": 2,
                    "isActive": 1,
                    "platformName": "ION",
                    "displayName": "Malay",
                    "attributeMapping": 2387,
                    "mappingDetails": [
                        {
                            "id": 2387,
                            "name": "Malay",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Malay",
                            "dbMappingId": 743
                        }
                    ]
                },
                {
                    "id": 2399,
                    "name": "1273",
                    "platformId": 2,
                    "isActive": 1,
                    "platformName": "ION",
                    "displayName": "North Ndebele",
                    "attributeMapping": 2397,
                    "mappingDetails": [
                        {
                            "id": 2397,
                            "name": "North Ndebele",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "North Ndebele",
                            "dbMappingId": 747
                        }
                    ]
                },
                {
                    "id": 2407,
                    "name": "1312",
                    "platformId": 2,
                    "isActive": 1,
                    "platformName": "ION",
                    "displayName": "Swahili",
                    "attributeMapping": 2405,
                    "mappingDetails": [
                        {
                            "id": 2405,
                            "name": "Swahili",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Swahili",
                            "dbMappingId": 749
                        }
                    ]
                },
                {
                    "id": 2413,
                    "name": "1163",
                    "platformId": 2,
                    "isActive": 1,
                    "platformName": "ION",
                    "displayName": "Afar",
                    "attributeMapping": 2411,
                    "mappingDetails": [
                        {
                            "id": 2411,
                            "name": "Afar",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Afar",
                            "dbMappingId": 751
                        }
                    ]
                },
                {
                    "id": 2417,
                    "name": "1261",
                    "platformId": 2,
                    "isActive": 1,
                    "platformName": "ION",
                    "displayName": "Macedonian",
                    "attributeMapping": 2415,
                    "mappingDetails": [
                        {
                            "id": 2415,
                            "name": "Macedonian",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Macedonian",
                            "dbMappingId": 752
                        }
                    ]
                },
                {
                    "id": 2423,
                    "name": "1238",
                    "platformId": 2,
                    "isActive": 1,
                    "platformName": "ION",
                    "displayName": "Japanese",
                    "attributeMapping": 2421,
                    "mappingDetails": [
                        {
                            "id": 2421,
                            "name": "Japanese",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Japanese",
                            "dbMappingId": 754
                        }
                    ]
                },
                {
                    "id": 2433,
                    "name": "1204",
                    "platformId": 2,
                    "isActive": 1,
                    "platformName": "ION",
                    "displayName": "Estonian",
                    "attributeMapping": 2431,
                    "mappingDetails": [
                        {
                            "id": 2431,
                            "name": "Estonian",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Estonian",
                            "dbMappingId": 758
                        }
                    ]
                },
                {
                    "id": 2441,
                    "name": "1304",
                    "platformId": 2,
                    "isActive": 1,
                    "platformName": "ION",
                    "displayName": "Sindhi",
                    "attributeMapping": 2439,
                    "mappingDetails": [
                        {
                            "id": 2439,
                            "name": "Sindhi",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Sindhi",
                            "dbMappingId": 761
                        }
                    ]
                },
                {
                    "id": 2449,
                    "name": "1180",
                    "platformId": 2,
                    "isActive": 1,
                    "platformName": "ION",
                    "displayName": "Bengali",
                    "attributeMapping": 2447,
                    "mappingDetails": [
                        {
                            "id": 2447,
                            "name": "Bengali",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Bengali",
                            "dbMappingId": 763
                        }
                    ]
                },
                {
                    "id": 2459,
                    "name": "1241",
                    "platformId": 2,
                    "isActive": 1,
                    "platformName": "ION",
                    "displayName": "Kanuri",
                    "attributeMapping": 2457,
                    "mappingDetails": [
                        {
                            "id": 2457,
                            "name": "Kanuri",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Kanuri",
                            "dbMappingId": 767
                        }
                    ]
                },
                {
                    "id": 2463,
                    "name": "1310",
                    "platformId": 2,
                    "isActive": 1,
                    "platformName": "ION",
                    "displayName": "Spanish, Castilian",
                    "attributeMapping": 2461,
                    "mappingDetails": [
                        {
                            "id": 2461,
                            "name": "Spanish, Castilian",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Spanish, Castilian",
                            "dbMappingId": 768
                        }
                    ]
                },
                {
                    "id": 2467,
                    "name": "1319",
                    "platformId": 2,
                    "isActive": 1,
                    "platformName": "ION",
                    "displayName": "Tatar",
                    "attributeMapping": 2465,
                    "mappingDetails": [
                        {
                            "id": 2465,
                            "name": "Tatar",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Tatar",
                            "dbMappingId": 769
                        }
                    ]
                },
                {
                    "id": 2471,
                    "name": "1188",
                    "platformId": 2,
                    "isActive": 1,
                    "platformName": "ION",
                    "displayName": "Chechen",
                    "attributeMapping": 2469,
                    "mappingDetails": [
                        {
                            "id": 2469,
                            "name": "Chechen",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Chechen",
                            "dbMappingId": 770
                        }
                    ]
                },
                {
                    "id": 2475,
                    "name": "1221",
                    "platformId": 2,
                    "isActive": 1,
                    "platformName": "ION",
                    "displayName": "Haitian, Haitian Creole",
                    "attributeMapping": 2473,
                    "mappingDetails": [
                        {
                            "id": 2473,
                            "name": "Haitian, Haitian Creole",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Haitian, Haitian Creole",
                            "dbMappingId": 771
                        }
                    ]
                },
                {
                    "id": 2479,
                    "name": "1322",
                    "platformId": 2,
                    "isActive": 1,
                    "platformName": "ION",
                    "displayName": "Tibetan",
                    "attributeMapping": 2477,
                    "mappingDetails": [
                        {
                            "id": 2477,
                            "name": "Tibetan",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Tibetan",
                            "dbMappingId": 772
                        }
                    ]
                },
                {
                    "id": 2483,
                    "name": "1333",
                    "platformId": 2,
                    "isActive": 1,
                    "platformName": "ION",
                    "displayName": "Uzbek",
                    "attributeMapping": 2481,
                    "mappingDetails": [
                        {
                            "id": 2481,
                            "name": "Uzbek",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Uzbek",
                            "dbMappingId": 773
                        }
                    ]
                },
                {
                    "id": 2489,
                    "name": "1288",
                    "platformId": 2,
                    "isActive": 1,
                    "platformName": "ION",
                    "displayName": "Persian",
                    "attributeMapping": 2487,
                    "mappingDetails": [
                        {
                            "id": 2487,
                            "name": "Persian",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Persian",
                            "dbMappingId": 775
                        }
                    ]
                },
                {
                    "id": 2497,
                    "name": "1216",
                    "platformId": 2,
                    "isActive": 1,
                    "platformName": "ION",
                    "displayName": "German",
                    "attributeMapping": 2495,
                    "mappingDetails": [
                        {
                            "id": 2495,
                            "name": "German",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "German",
                            "dbMappingId": 778
                        }
                    ]
                },
                {
                    "id": 2507,
                    "name": "1175",
                    "platformId": 2,
                    "isActive": 1,
                    "platformName": "ION",
                    "displayName": "Azerbaijani",
                    "attributeMapping": 2505,
                    "mappingDetails": [
                        {
                            "id": 2505,
                            "name": "Azerbaijani",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Azerbaijani",
                            "dbMappingId": 782
                        }
                    ]
                },
                {
                    "id": 2513,
                    "name": "1195",
                    "platformId": 2,
                    "isActive": 1,
                    "platformName": "ION",
                    "displayName": "Cree",
                    "attributeMapping": 2511,
                    "mappingDetails": [
                        {
                            "id": 2511,
                            "name": "Cree",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Cree",
                            "dbMappingId": 784
                        }
                    ]
                },
                {
                    "id": 2521,
                    "name": "1320",
                    "platformId": 2,
                    "isActive": 1,
                    "platformName": "ION",
                    "displayName": "Telugu",
                    "attributeMapping": 2519,
                    "mappingDetails": [
                        {
                            "id": 2519,
                            "name": "Telugu",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Telugu",
                            "dbMappingId": 786
                        }
                    ]
                },
                {
                    "id": 2541,
                    "name": "1265",
                    "platformId": 2,
                    "isActive": 1,
                    "platformName": "ION",
                    "displayName": "Maltese",
                    "attributeMapping": 2539,
                    "mappingDetails": [
                        {
                            "id": 2539,
                            "name": "Maltese",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Maltese",
                            "dbMappingId": 793
                        }
                    ]
                },
                {
                    "id": 2545,
                    "name": "1203",
                    "platformId": 2,
                    "isActive": 1,
                    "platformName": "ION",
                    "displayName": "Esperanto",
                    "attributeMapping": 2543,
                    "mappingDetails": [
                        {
                            "id": 2543,
                            "name": "Esperanto",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Esperanto",
                            "dbMappingId": 794
                        }
                    ]
                },
                {
                    "id": 2551,
                    "name": "1315",
                    "platformId": 2,
                    "isActive": 1,
                    "platformName": "ION",
                    "displayName": "Tagalog",
                    "attributeMapping": 2549,
                    "mappingDetails": [
                        {
                            "id": 2549,
                            "name": "Tagalog",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Tagalog",
                            "dbMappingId": 796
                        }
                    ]
                },
                {
                    "id": 2555,
                    "name": "1328",
                    "platformId": 2,
                    "isActive": 1,
                    "platformName": "ION",
                    "displayName": "Turkmen",
                    "attributeMapping": 2553,
                    "mappingDetails": [
                        {
                            "id": 2553,
                            "name": "Turkmen",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Turkmen",
                            "dbMappingId": 797
                        }
                    ]
                },
                {
                    "id": 2559,
                    "name": "1276",
                    "platformId": 2,
                    "isActive": 1,
                    "platformName": "ION",
                    "displayName": "Nepali",
                    "attributeMapping": 2557,
                    "mappingDetails": [
                        {
                            "id": 2557,
                            "name": "Nepali",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Nepali",
                            "dbMappingId": 798
                        }
                    ]
                },
                {
                    "id": 2565,
                    "name": "1215",
                    "platformId": 2,
                    "isActive": 1,
                    "platformName": "ION",
                    "displayName": "Georgian",
                    "attributeMapping": 2563,
                    "mappingDetails": [
                        {
                            "id": 2563,
                            "name": "Georgian",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Georgian",
                            "dbMappingId": 800
                        }
                    ]
                },
                {
                    "id": 2571,
                    "name": "1313",
                    "platformId": 2,
                    "isActive": 1,
                    "platformName": "ION",
                    "displayName": "Swati",
                    "attributeMapping": 2569,
                    "mappingDetails": [
                        {
                            "id": 2569,
                            "name": "Swati",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Swati",
                            "dbMappingId": 802
                        }
                    ]
                },
                {
                    "id": 2579,
                    "name": "1187",
                    "platformId": 2,
                    "isActive": 1,
                    "platformName": "ION",
                    "displayName": "Chamorro",
                    "attributeMapping": 2577,
                    "mappingDetails": [
                        {
                            "id": 2577,
                            "name": "Chamorro",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Chamorro",
                            "dbMappingId": 804
                        }
                    ]
                },
                {
                    "id": 2583,
                    "name": "1264",
                    "platformId": 2,
                    "isActive": 1,
                    "platformName": "ION",
                    "displayName": "Malayalam",
                    "attributeMapping": 2581,
                    "mappingDetails": [
                        {
                            "id": 2581,
                            "name": "Malayalam",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Malayalam",
                            "dbMappingId": 805
                        }
                    ]
                },
                {
                    "id": 2593,
                    "name": "1258",
                    "platformId": 2,
                    "isActive": 1,
                    "platformName": "ION",
                    "displayName": "Lithuanian",
                    "attributeMapping": 2591,
                    "mappingDetails": [
                        {
                            "id": 2591,
                            "name": "Lithuanian",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Lithuanian",
                            "dbMappingId": 809
                        }
                    ]
                },
                {
                    "id": 2601,
                    "name": "1173",
                    "platformId": 2,
                    "isActive": 1,
                    "platformName": "ION",
                    "displayName": "Avestan",
                    "attributeMapping": 2599,
                    "mappingDetails": [
                        {
                            "id": 2599,
                            "name": "Avestan",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Avestan",
                            "dbMappingId": 812
                        }
                    ]
                },
                {
                    "id": 2605,
                    "name": "1250",
                    "platformId": 2,
                    "isActive": 1,
                    "platformName": "ION",
                    "displayName": "Korean",
                    "attributeMapping": 2603,
                    "mappingDetails": [
                        {
                            "id": 2603,
                            "name": "Korean",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Korean",
                            "dbMappingId": 813
                        }
                    ]
                },
                {
                    "id": 2615,
                    "name": "1171",
                    "platformId": 2,
                    "isActive": 1,
                    "platformName": "ION",
                    "displayName": "Assamese",
                    "attributeMapping": 2613,
                    "mappingDetails": [
                        {
                            "id": 2613,
                            "name": "Assamese",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Assamese",
                            "dbMappingId": 817
                        }
                    ]
                },
                {
                    "id": 2621,
                    "name": "1234",
                    "platformId": 2,
                    "isActive": 1,
                    "platformName": "ION",
                    "displayName": "Inuktitut",
                    "attributeMapping": 2619,
                    "mappingDetails": [
                        {
                            "id": 2619,
                            "name": "Inuktitut",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Inuktitut",
                            "dbMappingId": 819
                        }
                    ]
                },
                {
                    "id": 2625,
                    "name": "1286",
                    "platformId": 2,
                    "isActive": 1,
                    "platformName": "ION",
                    "displayName": "Pali",
                    "attributeMapping": 2623,
                    "mappingDetails": [
                        {
                            "id": 2623,
                            "name": "Pali",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Pali",
                            "dbMappingId": 820
                        }
                    ]
                },
                {
                    "id": 2635,
                    "name": "1244",
                    "platformId": 2,
                    "isActive": 1,
                    "platformName": "ION",
                    "displayName": "Central Khmer",
                    "attributeMapping": 2633,
                    "mappingDetails": [
                        {
                            "id": 2633,
                            "name": "Central Khmer",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Central Khmer",
                            "dbMappingId": 823
                        }
                    ]
                },
                {
                    "id": 2639,
                    "name": "1172",
                    "platformId": 2,
                    "isActive": 1,
                    "platformName": "ION",
                    "displayName": "Avaric",
                    "attributeMapping": 2637,
                    "mappingDetails": [
                        {
                            "id": 2637,
                            "name": "Avaric",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Avaric",
                            "dbMappingId": 824
                        }
                    ]
                },
                {
                    "id": 2643,
                    "name": "1218",
                    "platformId": 2,
                    "isActive": 1,
                    "platformName": "ION",
                    "displayName": "Kalaallisut, Greenlandic",
                    "attributeMapping": 2641,
                    "mappingDetails": [
                        {
                            "id": 2641,
                            "name": "Kalaallisut, Greenlandic",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Kalaallisut, Greenlandic",
                            "dbMappingId": 825
                        }
                    ]
                },
                {
                    "id": 2647,
                    "name": "1335",
                    "platformId": 2,
                    "isActive": 1,
                    "platformName": "ION",
                    "displayName": "Vietnamese",
                    "attributeMapping": 2645,
                    "mappingDetails": [
                        {
                            "id": 2645,
                            "name": "Vietnamese",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Vietnamese",
                            "dbMappingId": 826
                        }
                    ]
                },
                {
                    "id": 2657,
                    "name": "1190",
                    "platformId": 2,
                    "isActive": 1,
                    "platformName": "ION",
                    "displayName": "Chinese",
                    "attributeMapping": 2655,
                    "mappingDetails": [
                        {
                            "id": 2655,
                            "name": "Chinese",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Chinese",
                            "dbMappingId": 830
                        }
                    ]
                },
                {
                    "id": 2663,
                    "name": "1213",
                    "platformId": 2,
                    "isActive": 1,
                    "platformName": "ION",
                    "displayName": "Galician",
                    "attributeMapping": 2661,
                    "mappingDetails": [
                        {
                            "id": 2661,
                            "name": "Galician",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Galician",
                            "dbMappingId": 832
                        }
                    ]
                },
                {
                    "id": 2669,
                    "name": "1253",
                    "platformId": 2,
                    "isActive": 1,
                    "platformName": "ION",
                    "displayName": "Lao",
                    "attributeMapping": 2667,
                    "mappingDetails": [
                        {
                            "id": 2667,
                            "name": "Lao",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Lao",
                            "dbMappingId": 834
                        }
                    ]
                },
                {
                    "id": 2673,
                    "name": "1308",
                    "platformId": 2,
                    "isActive": 1,
                    "platformName": "ION",
                    "displayName": "Somali",
                    "attributeMapping": 2671,
                    "mappingDetails": [
                        {
                            "id": 2671,
                            "name": "Somali",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Somali",
                            "dbMappingId": 835
                        }
                    ]
                },
                {
                    "id": 2677,
                    "name": "1300",
                    "platformId": 2,
                    "isActive": 1,
                    "platformName": "ION",
                    "displayName": "Sanskrit",
                    "attributeMapping": 2675,
                    "mappingDetails": [
                        {
                            "id": 2675,
                            "name": "Sanskrit",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Sanskrit",
                            "dbMappingId": 836
                        }
                    ]
                },
                {
                    "id": 2681,
                    "name": "1306",
                    "platformId": 2,
                    "isActive": 1,
                    "platformName": "ION",
                    "displayName": "Slovak",
                    "attributeMapping": 2679,
                    "mappingDetails": [
                        {
                            "id": 2679,
                            "name": "Slovak",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Slovak",
                            "dbMappingId": 837
                        }
                    ]
                },
                {
                    "id": 2693,
                    "name": "1302",
                    "platformId": 2,
                    "isActive": 1,
                    "platformName": "ION",
                    "displayName": "Serbian",
                    "attributeMapping": 2691,
                    "mappingDetails": [
                        {
                            "id": 2691,
                            "name": "Serbian",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Serbian",
                            "dbMappingId": 841
                        }
                    ]
                },
                {
                    "id": 2701,
                    "name": "1179",
                    "platformId": 2,
                    "isActive": 1,
                    "platformName": "ION",
                    "displayName": "Belarusian",
                    "attributeMapping": 2699,
                    "mappingDetails": [
                        {
                            "id": 2699,
                            "name": "Belarusian",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Belarusian",
                            "dbMappingId": 844
                        }
                    ]
                },
                {
                    "id": 2707,
                    "name": "1249",
                    "platformId": 2,
                    "isActive": 1,
                    "platformName": "ION",
                    "displayName": "Kongo",
                    "attributeMapping": 2705,
                    "mappingDetails": [
                        {
                            "id": 2705,
                            "name": "Kongo",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Kongo",
                            "dbMappingId": 846
                        }
                    ]
                },
                {
                    "id": 2711,
                    "name": "1268",
                    "platformId": 2,
                    "isActive": 1,
                    "platformName": "ION",
                    "displayName": "Marathi",
                    "attributeMapping": 2709,
                    "mappingDetails": [
                        {
                            "id": 2709,
                            "name": "Marathi",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Marathi",
                            "dbMappingId": 847
                        }
                    ]
                },
                {
                    "id": 2721,
                    "name": "1287",
                    "platformId": 2,
                    "isActive": 1,
                    "platformName": "ION",
                    "displayName": "Pashto, Pushto",
                    "attributeMapping": 2719,
                    "mappingDetails": [
                        {
                            "id": 2719,
                            "name": "Pashto, Pushto",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Pashto, Pushto",
                            "dbMappingId": 851
                        }
                    ]
                },
                {
                    "id": 2727,
                    "name": "1337",
                    "platformId": 2,
                    "isActive": 1,
                    "platformName": "ION",
                    "displayName": "Walloon",
                    "attributeMapping": 2725,
                    "mappingDetails": [
                        {
                            "id": 2725,
                            "name": "Walloon",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Walloon",
                            "dbMappingId": 853
                        }
                    ]
                },
                {
                    "id": 2731,
                    "name": "1274",
                    "platformId": 2,
                    "isActive": 1,
                    "platformName": "ION",
                    "displayName": "South Ndebele",
                    "attributeMapping": 2729,
                    "mappingDetails": [
                        {
                            "id": 2729,
                            "name": "South Ndebele",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "South Ndebele",
                            "dbMappingId": 854
                        }
                    ]
                },
                {
                    "id": 2735,
                    "name": "1298",
                    "platformId": 2,
                    "isActive": 1,
                    "platformName": "ION",
                    "displayName": "Samoan",
                    "attributeMapping": 2733,
                    "mappingDetails": [
                        {
                            "id": 2733,
                            "name": "Samoan",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Samoan",
                            "dbMappingId": 855
                        }
                    ]
                },
                {
                    "id": 2739,
                    "name": "1247",
                    "platformId": 2,
                    "isActive": 1,
                    "platformName": "ION",
                    "displayName": "Kirghiz, Kyrgyz",
                    "attributeMapping": 2737,
                    "mappingDetails": [
                        {
                            "id": 2737,
                            "name": "Kirghiz, Kyrgyz",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Kirghiz, Kyrgyz",
                            "dbMappingId": 856
                        }
                    ]
                },
                {
                    "id": 2743,
                    "name": "1317",
                    "platformId": 2,
                    "isActive": 1,
                    "platformName": "ION",
                    "displayName": "Tajik",
                    "attributeMapping": 2741,
                    "mappingDetails": [
                        {
                            "id": 2741,
                            "name": "Tajik",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Tajik",
                            "dbMappingId": 857
                        }
                    ]
                },
                {
                    "id": 2749,
                    "name": "1168",
                    "platformId": 2,
                    "isActive": 1,
                    "platformName": "ION",
                    "displayName": "Arabic",
                    "attributeMapping": 2747,
                    "mappingDetails": [
                        {
                            "id": 2747,
                            "name": "Arabic",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Arabic",
                            "dbMappingId": 859
                        }
                    ]
                },
                {
                    "id": 2759,
                    "name": "1193",
                    "platformId": 2,
                    "isActive": 1,
                    "platformName": "ION",
                    "displayName": "Cornish",
                    "attributeMapping": 2757,
                    "mappingDetails": [
                        {
                            "id": 2757,
                            "name": "Cornish",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Cornish",
                            "dbMappingId": 863
                        }
                    ]
                },
                {
                    "id": 2763,
                    "name": "1169",
                    "platformId": 2,
                    "isActive": 1,
                    "platformName": "ION",
                    "displayName": "Aragonese",
                    "attributeMapping": 2761,
                    "mappingDetails": [
                        {
                            "id": 2761,
                            "name": "Aragonese",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Aragonese",
                            "dbMappingId": 864
                        }
                    ]
                },
                {
                    "id": 2775,
                    "name": "1321",
                    "platformId": 2,
                    "isActive": 1,
                    "platformName": "ION",
                    "displayName": "Thai",
                    "attributeMapping": 2773,
                    "mappingDetails": [
                        {
                            "id": 2773,
                            "name": "Thai",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Thai",
                            "dbMappingId": 868
                        }
                    ]
                },
                {
                    "id": 2785,
                    "name": "1324",
                    "platformId": 2,
                    "isActive": 1,
                    "platformName": "ION",
                    "displayName": "Tonga",
                    "attributeMapping": 2783,
                    "mappingDetails": [
                        {
                            "id": 2783,
                            "name": "Tonga",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Tonga",
                            "dbMappingId": 872
                        }
                    ]
                },
                {
                    "id": 2789,
                    "name": "1262",
                    "platformId": 2,
                    "isActive": 1,
                    "platformName": "ION",
                    "displayName": "Malagasy",
                    "attributeMapping": 2787,
                    "mappingDetails": [
                        {
                            "id": 2787,
                            "name": "Malagasy",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Malagasy",
                            "dbMappingId": 873
                        }
                    ]
                },
                {
                    "id": 2793,
                    "name": "1323",
                    "platformId": 2,
                    "isActive": 1,
                    "platformName": "ION",
                    "displayName": "Tigrinya",
                    "attributeMapping": 2791,
                    "mappingDetails": [
                        {
                            "id": 2791,
                            "name": "Tigrinya",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Tigrinya",
                            "dbMappingId": 874
                        }
                    ]
                },
                {
                    "id": 2797,
                    "name": "1294",
                    "platformId": 2,
                    "isActive": 1,
                    "platformName": "ION",
                    "displayName": "Romansh",
                    "attributeMapping": 2795,
                    "mappingDetails": [
                        {
                            "id": 2795,
                            "name": "Romansh",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Romansh",
                            "dbMappingId": 875
                        }
                    ]
                },
                {
                    "id": 2801,
                    "name": "1281",
                    "platformId": 2,
                    "isActive": 1,
                    "platformName": "ION",
                    "displayName": "Occitan",
                    "attributeMapping": 2799,
                    "mappingDetails": [
                        {
                            "id": 2799,
                            "name": "Occitan",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Occitan",
                            "dbMappingId": 876
                        }
                    ]
                },
                {
                    "id": 2813,
                    "name": "1185",
                    "platformId": 2,
                    "isActive": 1,
                    "platformName": "ION",
                    "displayName": "Burmese",
                    "attributeMapping": 2811,
                    "mappingDetails": [
                        {
                            "id": 2811,
                            "name": "Burmese",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Burmese",
                            "dbMappingId": 879
                        }
                    ]
                },
                {
                    "id": 2817,
                    "name": "1339",
                    "platformId": 2,
                    "isActive": 1,
                    "platformName": "ION",
                    "displayName": "Wolof",
                    "attributeMapping": 2815,
                    "mappingDetails": [
                        {
                            "id": 2815,
                            "name": "Wolof",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Wolof",
                            "dbMappingId": 880
                        }
                    ]
                },
                {
                    "id": 2821,
                    "name": "1235",
                    "platformId": 2,
                    "isActive": 1,
                    "platformName": "ION",
                    "displayName": "Inupiaq",
                    "attributeMapping": 2819,
                    "mappingDetails": [
                        {
                            "id": 2819,
                            "name": "Inupiaq",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Inupiaq",
                            "dbMappingId": 881
                        }
                    ]
                },
                {
                    "id": 2825,
                    "name": "1280",
                    "platformId": 2,
                    "isActive": 1,
                    "platformName": "ION",
                    "displayName": "Sichuan Yi, Nuosu",
                    "attributeMapping": 2823,
                    "mappingDetails": [
                        {
                            "id": 2823,
                            "name": "Sichuan Yi, Nuosu",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Sichuan Yi, Nuosu",
                            "dbMappingId": 882
                        }
                    ]
                },
                {
                    "id": 2829,
                    "name": "1181",
                    "platformId": 2,
                    "isActive": 1,
                    "platformName": "ION",
                    "displayName": "Bislama",
                    "attributeMapping": 2827,
                    "mappingDetails": [
                        {
                            "id": 2827,
                            "name": "Bislama",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Bislama",
                            "dbMappingId": 883
                        }
                    ]
                },
                {
                    "id": 2839,
                    "name": "1242",
                    "platformId": 2,
                    "isActive": 1,
                    "platformName": "ION",
                    "displayName": "Kashmiri",
                    "attributeMapping": 2837,
                    "mappingDetails": [
                        {
                            "id": 2837,
                            "name": "Kashmiri",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Kashmiri",
                            "dbMappingId": 886
                        }
                    ]
                },
                {
                    "id": 2843,
                    "name": "1272",
                    "platformId": 2,
                    "isActive": 1,
                    "platformName": "ION",
                    "displayName": "Navajo, Navaho",
                    "attributeMapping": 2841,
                    "mappingDetails": [
                        {
                            "id": 2841,
                            "name": "Navajo, Navaho",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Navajo, Navaho",
                            "dbMappingId": 887
                        }
                    ]
                },
                {
                    "id": 2847,
                    "name": "1325",
                    "platformId": 2,
                    "isActive": 1,
                    "platformName": "ION",
                    "displayName": "Tsonga",
                    "attributeMapping": 2845,
                    "mappingDetails": [
                        {
                            "id": 2845,
                            "name": "Tsonga",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Tsonga",
                            "dbMappingId": 888
                        }
                    ]
                },
                {
                    "id": 2851,
                    "name": "1164",
                    "platformId": 2,
                    "isActive": 1,
                    "platformName": "ION",
                    "displayName": "Afrikaans",
                    "attributeMapping": 2849,
                    "mappingDetails": [
                        {
                            "id": 2849,
                            "name": "Afrikaans",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Afrikaans",
                            "dbMappingId": 889
                        }
                    ]
                },
                {
                    "id": 2857,
                    "name": "1342",
                    "platformId": 2,
                    "isActive": 1,
                    "platformName": "ION",
                    "displayName": "Yoruba",
                    "attributeMapping": 2855,
                    "mappingDetails": [
                        {
                            "id": 2855,
                            "name": "Yoruba",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Yoruba",
                            "dbMappingId": 891
                        }
                    ]
                },
                {
                    "id": 2861,
                    "name": "1232",
                    "platformId": 2,
                    "isActive": 1,
                    "platformName": "ION",
                    "displayName": "Interlingua (International Auxiliary Language Association)",
                    "attributeMapping": 2859,
                    "mappingDetails": [
                        {
                            "id": 2859,
                            "name": "Interlingua (International Auxiliary Language Association)",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Interlingua (International Auxiliary Language Association)",
                            "dbMappingId": 892
                        }
                    ]
                },
                {
                    "id": 2865,
                    "name": "1205",
                    "platformId": 2,
                    "isActive": 1,
                    "platformName": "ION",
                    "displayName": "Ewe",
                    "attributeMapping": 2863,
                    "mappingDetails": [
                        {
                            "id": 2863,
                            "name": "Ewe",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Ewe",
                            "dbMappingId": 893
                        }
                    ]
                },
                {
                    "id": 2877,
                    "name": "1208",
                    "platformId": 2,
                    "isActive": 1,
                    "platformName": "ION",
                    "displayName": "Finnish",
                    "attributeMapping": 2875,
                    "mappingDetails": [
                        {
                            "id": 2875,
                            "name": "Finnish",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Finnish",
                            "dbMappingId": 896
                        }
                    ]
                },
                {
                    "id": 2887,
                    "name": "1166",
                    "platformId": 2,
                    "isActive": 1,
                    "platformName": "ION",
                    "displayName": "Albanian",
                    "attributeMapping": 2885,
                    "mappingDetails": [
                        {
                            "id": 2885,
                            "name": "Albanian",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Albanian",
                            "dbMappingId": 900
                        }
                    ]
                },
                {
                    "id": 2893,
                    "name": "1284",
                    "platformId": 2,
                    "isActive": 1,
                    "platformName": "ION",
                    "displayName": "Oromo",
                    "attributeMapping": 2891,
                    "mappingDetails": [
                        {
                            "id": 2891,
                            "name": "Oromo",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Oromo",
                            "dbMappingId": 902
                        }
                    ]
                },
                {
                    "id": 2897,
                    "name": "1289",
                    "platformId": 2,
                    "isActive": 1,
                    "platformName": "ION",
                    "displayName": "Polish",
                    "attributeMapping": 2895,
                    "mappingDetails": [
                        {
                            "id": 2895,
                            "name": "Polish",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Polish",
                            "dbMappingId": 903
                        }
                    ]
                },
                {
                    "id": 2907,
                    "name": "1199",
                    "platformId": 2,
                    "isActive": 1,
                    "platformName": "ION",
                    "displayName": "Divehi, Dhivehi, Maldivian",
                    "attributeMapping": 2905,
                    "mappingDetails": [
                        {
                            "id": 2905,
                            "name": "Divehi, Dhivehi, Maldivian",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Divehi, Dhivehi, Maldivian",
                            "dbMappingId": 907
                        }
                    ]
                },
                {
                    "id": 2911,
                    "name": "1165",
                    "platformId": 2,
                    "isActive": 1,
                    "platformName": "ION",
                    "displayName": "Akan",
                    "attributeMapping": 2909,
                    "mappingDetails": [
                        {
                            "id": 2909,
                            "name": "Akan",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Akan",
                            "dbMappingId": 908
                        }
                    ]
                },
                {
                    "id": 2915,
                    "name": "1184",
                    "platformId": 2,
                    "isActive": 1,
                    "platformName": "ION",
                    "displayName": "Bulgarian",
                    "attributeMapping": 2913,
                    "mappingDetails": [
                        {
                            "id": 2913,
                            "name": "Bulgarian",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Bulgarian",
                            "dbMappingId": 909
                        }
                    ]
                },
                {
                    "id": 2923,
                    "name": "1222",
                    "platformId": 2,
                    "isActive": 1,
                    "platformName": "ION",
                    "displayName": "Hausa",
                    "attributeMapping": 2921,
                    "mappingDetails": [
                        {
                            "id": 2921,
                            "name": "Hausa",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Hausa",
                            "dbMappingId": 912
                        }
                    ]
                },
                {
                    "id": 2927,
                    "name": "1292",
                    "platformId": 2,
                    "isActive": 1,
                    "platformName": "ION",
                    "displayName": "Quechua",
                    "attributeMapping": 2925,
                    "mappingDetails": [
                        {
                            "id": 2925,
                            "name": "Quechua",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Quechua",
                            "dbMappingId": 913
                        }
                    ]
                },
                {
                    "id": 2931,
                    "name": "1210",
                    "platformId": 2,
                    "isActive": 1,
                    "platformName": "ION",
                    "displayName": "Western Frisian",
                    "attributeMapping": 2929,
                    "mappingDetails": [
                        {
                            "id": 2929,
                            "name": "Western Frisian",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Western Frisian",
                            "dbMappingId": 914
                        }
                    ]
                },
                {
                    "id": 2937,
                    "name": "1202",
                    "platformId": 2,
                    "isActive": 1,
                    "platformName": "ION",
                    "displayName": "English",
                    "attributeMapping": 2935,
                    "mappingDetails": [
                        {
                            "id": 2935,
                            "name": "English",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "English",
                            "dbMappingId": 916
                        }
                    ]
                },
                {
                    "id": 2947,
                    "name": "1227",
                    "platformId": 2,
                    "isActive": 1,
                    "platformName": "ION",
                    "displayName": "Hungarian",
                    "attributeMapping": 2945,
                    "mappingDetails": [
                        {
                            "id": 2945,
                            "name": "Hungarian",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Hungarian",
                            "dbMappingId": 920
                        }
                    ]
                },
                {
                    "id": 2957,
                    "name": "1291",
                    "platformId": 2,
                    "isActive": 1,
                    "platformName": "ION",
                    "displayName": "Punjabi",
                    "attributeMapping": 2955,
                    "mappingDetails": [
                        {
                            "id": 2955,
                            "name": "Punjabi",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Punjabi",
                            "dbMappingId": 924
                        }
                    ]
                },
                {
                    "id": 2967,
                    "name": "1226",
                    "platformId": 2,
                    "isActive": 1,
                    "platformName": "ION",
                    "displayName": "Hiri Motu",
                    "attributeMapping": 2965,
                    "mappingDetails": [
                        {
                            "id": 2965,
                            "name": "Hiri Motu",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Hiri Motu",
                            "dbMappingId": 928
                        }
                    ]
                }
            ]
        },
        {
            "id": 83,
            "name": "Language",
            "platformId": 7,
            "isActive": 1,
            "platformName": "TikTok",
            "displayName": "Language",
            "attributeMapping": 79,
            "mappingDetails": [
                {
                    "id": 79,
                    "name": "Language",
                    "platformId": 1,
                    "isActive": 1,
                    "platformName": "Beki",
                    "displayName": "Language"
                }
            ],
            "mappedPlatformsValueSet": [],
            "mappedPlatformsIdSet": [],
            "list": [
                {
                    "id": 1869,
                    "name": "sv",
                    "platformId": 7,
                    "isActive": 1,
                    "platformName": "TikTok",
                    "displayName": "Swedish",
                    "attributeMapping": 1861,
                    "mappingDetails": [
                        {
                            "id": 1861,
                            "name": "Swedish",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Swedish",
                            "dbMappingId": 575
                        }
                    ]
                },
                {
                    "id": 1879,
                    "name": "tr",
                    "platformId": 7,
                    "isActive": 1,
                    "platformName": "TikTok",
                    "displayName": "Turkish",
                    "attributeMapping": 1871,
                    "mappingDetails": [
                        {
                            "id": 1871,
                            "name": "Turkish",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Turkish",
                            "dbMappingId": 579
                        }
                    ]
                },
                {
                    "id": 1889,
                    "name": "kn",
                    "platformId": 7,
                    "isActive": 1,
                    "platformName": "TikTok",
                    "displayName": "Kannada",
                    "attributeMapping": 1881,
                    "mappingDetails": [
                        {
                            "id": 1881,
                            "name": "Kannada",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Kannada",
                            "dbMappingId": 583
                        }
                    ]
                },
                {
                    "id": 1947,
                    "name": "ro",
                    "platformId": 7,
                    "isActive": 1,
                    "platformName": "TikTok",
                    "displayName": "Romanian",
                    "attributeMapping": 1939,
                    "mappingDetails": [
                        {
                            "id": 1939,
                            "name": "Romanian",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Romanian",
                            "dbMappingId": 601
                        }
                    ]
                },
                {
                    "id": 1977,
                    "name": "gu",
                    "platformId": 7,
                    "isActive": 1,
                    "platformName": "TikTok",
                    "displayName": "Gujarati",
                    "attributeMapping": 1969,
                    "mappingDetails": [
                        {
                            "id": 1969,
                            "name": "Gujarati",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Gujarati",
                            "dbMappingId": 610
                        }
                    ]
                },
                {
                    "id": 2009,
                    "name": "fr",
                    "platformId": 7,
                    "isActive": 1,
                    "platformName": "TikTok",
                    "displayName": "French",
                    "attributeMapping": 2001,
                    "mappingDetails": [
                        {
                            "id": 2001,
                            "name": "French",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "French",
                            "dbMappingId": 621
                        }
                    ]
                },
                {
                    "id": 2023,
                    "name": "id",
                    "platformId": 7,
                    "isActive": 1,
                    "platformName": "TikTok",
                    "displayName": "Indonesian",
                    "attributeMapping": 2015,
                    "mappingDetails": [
                        {
                            "id": 2015,
                            "name": "Indonesian",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Indonesian",
                            "dbMappingId": 626
                        }
                    ]
                },
                {
                    "id": 2067,
                    "name": "ta",
                    "platformId": 7,
                    "isActive": 1,
                    "platformName": "TikTok",
                    "displayName": "Tamil",
                    "attributeMapping": 2059,
                    "mappingDetails": [
                        {
                            "id": 2059,
                            "name": "Tamil",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Tamil",
                            "dbMappingId": 640
                        }
                    ]
                },
                {
                    "id": 2093,
                    "name": "cs",
                    "platformId": 7,
                    "isActive": 1,
                    "platformName": "TikTok",
                    "displayName": "Czech",
                    "attributeMapping": 2085,
                    "mappingDetails": [
                        {
                            "id": 2085,
                            "name": "Czech",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Czech",
                            "dbMappingId": 648
                        }
                    ]
                },
                {
                    "id": 2103,
                    "name": "nl",
                    "platformId": 7,
                    "isActive": 1,
                    "platformName": "TikTok",
                    "displayName": "Dutch",
                    "attributeMapping": 2095,
                    "mappingDetails": [
                        {
                            "id": 2095,
                            "name": "Dutch",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Dutch",
                            "dbMappingId": 652
                        }
                    ]
                },
                {
                    "id": 2119,
                    "name": "ru",
                    "platformId": 7,
                    "isActive": 1,
                    "platformName": "TikTok",
                    "displayName": "Russian",
                    "attributeMapping": 2111,
                    "mappingDetails": [
                        {
                            "id": 2111,
                            "name": "Russian",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Russian",
                            "dbMappingId": 658
                        }
                    ]
                },
                {
                    "id": 2151,
                    "name": "pt",
                    "platformId": 7,
                    "isActive": 1,
                    "platformName": "TikTok",
                    "displayName": "Portuguese",
                    "attributeMapping": 2143,
                    "mappingDetails": [
                        {
                            "id": 2143,
                            "name": "Portuguese",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Portuguese",
                            "dbMappingId": 668
                        }
                    ]
                },
                {
                    "id": 2165,
                    "name": "hi",
                    "platformId": 7,
                    "isActive": 1,
                    "platformName": "TikTok",
                    "displayName": "Hindi",
                    "attributeMapping": 2157,
                    "mappingDetails": [
                        {
                            "id": 2157,
                            "name": "Hindi",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Hindi",
                            "dbMappingId": 673
                        }
                    ]
                },
                {
                    "id": 2225,
                    "name": "or",
                    "platformId": 7,
                    "isActive": 1,
                    "platformName": "TikTok",
                    "displayName": "Oriya",
                    "attributeMapping": 2221,
                    "mappingDetails": [
                        {
                            "id": 2221,
                            "name": "Oriya",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Oriya",
                            "dbMappingId": 691
                        }
                    ]
                },
                {
                    "id": 2235,
                    "name": "it",
                    "platformId": 7,
                    "isActive": 1,
                    "platformName": "TikTok",
                    "displayName": "Italian",
                    "attributeMapping": 2227,
                    "mappingDetails": [
                        {
                            "id": 2227,
                            "name": "Italian",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Italian",
                            "dbMappingId": 695
                        }
                    ]
                },
                {
                    "id": 2331,
                    "name": "el",
                    "platformId": 7,
                    "isActive": 1,
                    "platformName": "TikTok",
                    "displayName": "Greek",
                    "attributeMapping": 2323,
                    "mappingDetails": [
                        {
                            "id": 2323,
                            "name": "Greek",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Greek",
                            "dbMappingId": 725
                        }
                    ]
                },
                {
                    "id": 2353,
                    "name": "he",
                    "platformId": 7,
                    "isActive": 1,
                    "platformName": "TikTok",
                    "displayName": "Hebrew",
                    "attributeMapping": 2345,
                    "mappingDetails": [
                        {
                            "id": 2345,
                            "name": "Hebrew",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Hebrew",
                            "dbMappingId": 732
                        }
                    ]
                },
                {
                    "id": 2373,
                    "name": "uk",
                    "platformId": 7,
                    "isActive": 1,
                    "platformName": "TikTok",
                    "displayName": "Ukrainian",
                    "attributeMapping": 2365,
                    "mappingDetails": [
                        {
                            "id": 2365,
                            "name": "Ukrainian",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Ukrainian",
                            "dbMappingId": 739
                        }
                    ]
                },
                {
                    "id": 2395,
                    "name": "ms",
                    "platformId": 7,
                    "isActive": 1,
                    "platformName": "TikTok",
                    "displayName": "Malay",
                    "attributeMapping": 2387,
                    "mappingDetails": [
                        {
                            "id": 2387,
                            "name": "Malay",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Malay",
                            "dbMappingId": 746
                        }
                    ]
                },
                {
                    "id": 2403,
                    "name": "raj",
                    "platformId": 7,
                    "isActive": 1,
                    "platformName": "TikTok",
                    "displayName": "Rajasthani",
                    "attributeMapping": 2401,
                    "mappingDetails": [
                        {
                            "id": 2401,
                            "name": "Rajasthani",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Rajasthani",
                            "dbMappingId": 748
                        }
                    ]
                },
                {
                    "id": 2429,
                    "name": "ja",
                    "platformId": 7,
                    "isActive": 1,
                    "platformName": "TikTok",
                    "displayName": "Japanese",
                    "attributeMapping": 2421,
                    "mappingDetails": [
                        {
                            "id": 2421,
                            "name": "Japanese",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Japanese",
                            "dbMappingId": 757
                        }
                    ]
                },
                {
                    "id": 2445,
                    "name": "bgc",
                    "platformId": 7,
                    "isActive": 1,
                    "platformName": "TikTok",
                    "displayName": "Haryanvi",
                    "attributeMapping": 2443,
                    "mappingDetails": [
                        {
                            "id": 2443,
                            "name": "Haryanvi",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Haryanvi",
                            "dbMappingId": 762
                        }
                    ]
                },
                {
                    "id": 2455,
                    "name": "bn",
                    "platformId": 7,
                    "isActive": 1,
                    "platformName": "TikTok",
                    "displayName": "Bengali",
                    "attributeMapping": 2447,
                    "mappingDetails": [
                        {
                            "id": 2447,
                            "name": "Bengali",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Bengali",
                            "dbMappingId": 766
                        }
                    ]
                },
                {
                    "id": 2503,
                    "name": "de",
                    "platformId": 7,
                    "isActive": 1,
                    "platformName": "TikTok",
                    "displayName": "German",
                    "attributeMapping": 2495,
                    "mappingDetails": [
                        {
                            "id": 2495,
                            "name": "German",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "German",
                            "dbMappingId": 781
                        }
                    ]
                },
                {
                    "id": 2517,
                    "name": "bh",
                    "platformId": 7,
                    "isActive": 1,
                    "platformName": "TikTok",
                    "displayName": "Bihari",
                    "attributeMapping": 2515,
                    "mappingDetails": [
                        {
                            "id": 2515,
                            "name": "Bihari",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Bihari",
                            "dbMappingId": 785
                        }
                    ]
                },
                {
                    "id": 2527,
                    "name": "te",
                    "platformId": 7,
                    "isActive": 1,
                    "platformName": "TikTok",
                    "displayName": "Telugu",
                    "attributeMapping": 2519,
                    "mappingDetails": [
                        {
                            "id": 2519,
                            "name": "Telugu",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Telugu",
                            "dbMappingId": 789
                        }
                    ]
                },
                {
                    "id": 2589,
                    "name": "ml",
                    "platformId": 7,
                    "isActive": 1,
                    "platformName": "TikTok",
                    "displayName": "Malayalam",
                    "attributeMapping": 2581,
                    "mappingDetails": [
                        {
                            "id": 2581,
                            "name": "Malayalam",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Malayalam",
                            "dbMappingId": 808
                        }
                    ]
                },
                {
                    "id": 2611,
                    "name": "ko",
                    "platformId": 7,
                    "isActive": 1,
                    "platformName": "TikTok",
                    "displayName": "Korean",
                    "attributeMapping": 2603,
                    "mappingDetails": [
                        {
                            "id": 2603,
                            "name": "Korean",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Korean",
                            "dbMappingId": 816
                        }
                    ]
                },
                {
                    "id": 2617,
                    "name": "as",
                    "platformId": 7,
                    "isActive": 1,
                    "platformName": "TikTok",
                    "displayName": "Assamese",
                    "attributeMapping": 2613,
                    "mappingDetails": [
                        {
                            "id": 2613,
                            "name": "Assamese",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Assamese",
                            "dbMappingId": 818
                        }
                    ]
                },
                {
                    "id": 2631,
                    "name": "km",
                    "platformId": 7,
                    "isActive": 1,
                    "platformName": "TikTok",
                    "displayName": "Khmer",
                    "attributeMapping": 2627,
                    "mappingDetails": [
                        {
                            "id": 2627,
                            "name": "Khmer",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Khmer",
                            "dbMappingId": 822
                        }
                    ]
                },
                {
                    "id": 2653,
                    "name": "vi",
                    "platformId": 7,
                    "isActive": 1,
                    "platformName": "TikTok",
                    "displayName": "Vietnamese",
                    "attributeMapping": 2645,
                    "mappingDetails": [
                        {
                            "id": 2645,
                            "name": "Vietnamese",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Vietnamese",
                            "dbMappingId": 829
                        }
                    ]
                },
                {
                    "id": 2717,
                    "name": "mr",
                    "platformId": 7,
                    "isActive": 1,
                    "platformName": "TikTok",
                    "displayName": "Marathi",
                    "attributeMapping": 2709,
                    "mappingDetails": [
                        {
                            "id": 2709,
                            "name": "Marathi",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Marathi",
                            "dbMappingId": 850
                        }
                    ]
                },
                {
                    "id": 2755,
                    "name": "ar",
                    "platformId": 7,
                    "isActive": 1,
                    "platformName": "TikTok",
                    "displayName": "Arabic",
                    "attributeMapping": 2747,
                    "mappingDetails": [
                        {
                            "id": 2747,
                            "name": "Arabic",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Arabic",
                            "dbMappingId": 862
                        }
                    ]
                },
                {
                    "id": 2771,
                    "name": "es",
                    "platformId": 7,
                    "isActive": 1,
                    "platformName": "TikTok",
                    "displayName": "Spanish",
                    "attributeMapping": 2765,
                    "mappingDetails": [
                        {
                            "id": 2765,
                            "name": "Spanish",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Spanish",
                            "dbMappingId": 867
                        }
                    ]
                },
                {
                    "id": 2781,
                    "name": "th",
                    "platformId": 7,
                    "isActive": 1,
                    "platformName": "TikTok",
                    "displayName": "Thai",
                    "attributeMapping": 2773,
                    "mappingDetails": [
                        {
                            "id": 2773,
                            "name": "Thai",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Thai",
                            "dbMappingId": 871
                        }
                    ]
                },
                {
                    "id": 2835,
                    "name": "zh-Hant",
                    "platformId": 7,
                    "isActive": 1,
                    "platformName": "TikTok",
                    "displayName": "Chinese (traditional)",
                    "attributeMapping": 2831,
                    "mappingDetails": [
                        {
                            "id": 2831,
                            "name": "Chinese (traditional)",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Chinese (traditional)",
                            "dbMappingId": 885
                        }
                    ]
                },
                {
                    "id": 2883,
                    "name": "fi",
                    "platformId": 7,
                    "isActive": 1,
                    "platformName": "TikTok",
                    "displayName": "Finnish",
                    "attributeMapping": 2875,
                    "mappingDetails": [
                        {
                            "id": 2875,
                            "name": "Finnish",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Finnish",
                            "dbMappingId": 899
                        }
                    ]
                },
                {
                    "id": 2903,
                    "name": "pl",
                    "platformId": 7,
                    "isActive": 1,
                    "platformName": "TikTok",
                    "displayName": "Polish",
                    "attributeMapping": 2895,
                    "mappingDetails": [
                        {
                            "id": 2895,
                            "name": "Polish",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Polish",
                            "dbMappingId": 906
                        }
                    ]
                },
                {
                    "id": 2943,
                    "name": "en",
                    "platformId": 7,
                    "isActive": 1,
                    "platformName": "TikTok",
                    "displayName": "English",
                    "attributeMapping": 2935,
                    "mappingDetails": [
                        {
                            "id": 2935,
                            "name": "English",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "English",
                            "dbMappingId": 919
                        }
                    ]
                },
                {
                    "id": 2953,
                    "name": "hu",
                    "platformId": 7,
                    "isActive": 1,
                    "platformName": "TikTok",
                    "displayName": "Hungarian",
                    "attributeMapping": 2945,
                    "mappingDetails": [
                        {
                            "id": 2945,
                            "name": "Hungarian",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Hungarian",
                            "dbMappingId": 923
                        }
                    ]
                },
                {
                    "id": 2963,
                    "name": "pa",
                    "platformId": 7,
                    "isActive": 1,
                    "platformName": "TikTok",
                    "displayName": "Punjabi",
                    "attributeMapping": 2955,
                    "mappingDetails": [
                        {
                            "id": 2955,
                            "name": "Punjabi",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Punjabi",
                            "dbMappingId": 927
                        }
                    ]
                }
            ]
        },
        {
            "id": 84,
            "name": "Media_Type",
            "platformId": 8,
            "isActive": 1,
            "platformName": "ViAds",
            "displayName": "",
            "description": "",
            "attributeMapping": 3,
            "mappingDetails": [
                {
                    "id": 3,
                    "name": "Media_Type",
                    "platformId": 1,
                    "isActive": 1,
                    "platformName": "Beki",
                    "displayName": "Media Type"
                }
            ],
            "mappedPlatformsValueSet": [],
            "mappedPlatformsIdSet": [],
            "list": [
                {
                    "id": 2981,
                    "name": "7",
                    "platformId": 8,
                    "isActive": 1,
                    "platformName": "ViAds",
                    "displayName": "Display",
                    "attributeMapping": 13,
                    "mappingDetails": [
                        {
                            "id": 13,
                            "name": "Display",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "dbMappingId": 931
                        }
                    ]
                },
                {
                    "id": 2983,
                    "name": "9",
                    "platformId": 8,
                    "isActive": 1,
                    "platformName": "ViAds",
                    "displayName": "Video",
                    "attributeMapping": 15,
                    "mappingDetails": [
                        {
                            "id": 15,
                            "name": "Video",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "dbMappingId": 932
                        }
                    ]
                }
            ]
        },
        {
            "id": 85,
            "name": "Duration_Type",
            "platformId": 8,
            "isActive": 1,
            "platformName": "ViAds",
            "displayName": "",
            "description": "",
            "attributeMapping": 2,
            "mappingDetails": [
                {
                    "id": 2,
                    "name": "Duration_Type",
                    "platformId": 1,
                    "isActive": 1,
                    "platformName": "Beki",
                    "displayName": "Duration Type"
                }
            ],
            "mappedPlatformsValueSet": [],
            "mappedPlatformsIdSet": [],
            "list": [
                {
                    "id": 2985,
                    "name": "1",
                    "platformId": 8,
                    "isActive": 1,
                    "platformName": "ViAds",
                    "displayName": "Daily",
                    "attributeMapping": 5,
                    "mappingDetails": [
                        {
                            "id": 5,
                            "name": "Daily",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Daily",
                            "dbMappingId": 933
                        }
                    ]
                },
                {
                    "id": 2987,
                    "name": "0",
                    "platformId": 8,
                    "isActive": 1,
                    "platformName": "ViAds",
                    "displayName": "Hourly",
                    "attributeMapping": 9,
                    "mappingDetails": [
                        {
                            "id": 9,
                            "name": "Hourly",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Hourly",
                            "dbMappingId": 934
                        }
                    ]
                }
            ]
        },
        {
            "id": 86,
            "name": "Device_Type",
            "platformId": 8,
            "isActive": 1,
            "platformName": "ViAds",
            "displayName": "",
            "description": "",
            "attributeMapping": 17,
            "mappingDetails": [
                {
                    "id": 17,
                    "name": "Device_Type",
                    "platformId": 1,
                    "isActive": 1,
                    "platformName": "Beki",
                    "displayName": "Device Type",
                    "description": ""
                }
            ],
            "mappedPlatformsValueSet": [],
            "mappedPlatformsIdSet": [],
            "list": [
                {
                    "id": 2989,
                    "name": "85",
                    "platformId": 8,
                    "isActive": 1,
                    "platformName": "ViAds",
                    "displayName": "Mobile",
                    "attributeMapping": 41,
                    "mappingDetails": [
                        {
                            "id": 41,
                            "name": "Mobile",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Mobile",
                            "dbMappingId": 935
                        }
                    ]
                },
                {
                    "id": 2991,
                    "name": "84",
                    "platformId": 8,
                    "isActive": 1,
                    "platformName": "ViAds",
                    "displayName": "Desktop",
                    "attributeMapping": 42,
                    "mappingDetails": [
                        {
                            "id": 42,
                            "name": "Desktop",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "dbMappingId": 936
                        }
                    ]
                },
                {
                    "id": 2993,
                    "name": "86",
                    "platformId": 8,
                    "isActive": 1,
                    "platformName": "ViAds",
                    "displayName": "CTV",
                    "mappingDetails": []
                }
            ]
        },
        {
            "id": 87,
            "name": "Pacing_Type",
            "platformId": 8,
            "isActive": 1,
            "platformName": "ViAds",
            "displayName": "",
            "description": "",
            "attributeMapping": 1,
            "mappingDetails": [
                {
                    "id": 1,
                    "name": "Pacing_Type",
                    "platformId": 1,
                    "isActive": 1,
                    "platformName": "Beki",
                    "displayName": "Pacing Type",
                    "description": ""
                }
            ],
            "mappedPlatformsValueSet": [],
            "mappedPlatformsIdSet": [],
            "list": [
                {
                    "id": 2995,
                    "name": "0",
                    "platformId": 8,
                    "isActive": 1,
                    "platformName": "ViAds",
                    "displayName": "ASAP",
                    "attributeMapping": 3,
                    "mappingDetails": [
                        {
                            "id": 3,
                            "name": "ASAP",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Asap",
                            "dbMappingId": 937
                        }
                    ]
                },
                {
                    "id": 2997,
                    "name": "1",
                    "platformId": 8,
                    "isActive": 1,
                    "platformName": "ViAds",
                    "displayName": "Even",
                    "attributeMapping": 1,
                    "mappingDetails": [
                        {
                            "id": 1,
                            "name": "Even",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Even",
                            "dbMappingId": 938
                        }
                    ]
                }
            ]
        },
        {
            "id": 88,
            "name": "VIDEO_MIME_TYPES",
            "platformId": 8,
            "isActive": 1,
            "platformName": "ViAds",
            "mappingDetails": [],
            "mappedPlatformsValueSet": [],
            "mappedPlatformsIdSet": [],
            "list": [
                {
                    "id": 2999,
                    "name": "video/mp4",
                    "platformId": 8,
                    "isActive": 1,
                    "platformName": "ViAds",
                    "displayName": "video/mp4",
                    "mappingDetails": []
                }
            ]
        },
        {
            "id": 89,
            "name": "DISPLAY_MIME_TYPES",
            "platformId": 8,
            "isActive": 1,
            "platformName": "ViAds",
            "displayName": "",
            "description": "",
            "attributeMapping": 34,
            "mappingDetails": [
                {
                    "id": 34,
                    "name": "DISPLAY_MIME_TYPES",
                    "platformId": 1,
                    "isActive": 1,
                    "platformName": "Beki",
                    "displayName": "Display Mime Types"
                }
            ],
            "mappedPlatformsValueSet": [],
            "mappedPlatformsIdSet": [],
            "list": [
                {
                    "id": 3001,
                    "name": "JPG",
                    "platformId": 8,
                    "isActive": 1,
                    "platformName": "ViAds",
                    "displayName": "JPG",
                    "mappingDetails": []
                },
                {
                    "id": 3003,
                    "name": "JPEG",
                    "platformId": 8,
                    "isActive": 1,
                    "platformName": "ViAds",
                    "displayName": "JPEG",
                    "attributeMapping": 249,
                    "mappingDetails": [
                        {
                            "id": 249,
                            "name": "JPEG",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Jpeg",
                            "dbMappingId": 1129
                        }
                    ]
                },
                {
                    "id": 3005,
                    "name": "PNG",
                    "platformId": 8,
                    "isActive": 1,
                    "platformName": "ViAds",
                    "displayName": "PNG",
                    "mappingDetails": []
                },
                {
                    "id": 3007,
                    "name": "GIF",
                    "platformId": 8,
                    "isActive": 1,
                    "platformName": "ViAds",
                    "displayName": "GIF",
                    "mappingDetails": []
                }
            ]
        },
        {
            "id": 90,
            "name": "Tracker_Event_Image",
            "platformId": 8,
            "isActive": 1,
            "platformName": "ViAds",
            "mappingDetails": [],
            "mappedPlatformsValueSet": [],
            "mappedPlatformsIdSet": [],
            "list": [
                {
                    "id": 3009,
                    "name": "impression",
                    "platformId": 8,
                    "isActive": 1,
                    "platformName": "ViAds",
                    "displayName": "impression",
                    "mappingDetails": []
                },
                {
                    "id": 3011,
                    "name": "click",
                    "platformId": 8,
                    "isActive": 1,
                    "platformName": "ViAds",
                    "displayName": "click",
                    "mappingDetails": []
                }
            ]
        },
        {
            "id": 91,
            "name": "Tracker_Event_Video",
            "platformId": 8,
            "isActive": 1,
            "platformName": "ViAds",
            "mappingDetails": [],
            "mappedPlatformsValueSet": [],
            "mappedPlatformsIdSet": [],
            "list": [
                {
                    "id": 3013,
                    "name": "start",
                    "platformId": 8,
                    "isActive": 1,
                    "platformName": "ViAds",
                    "displayName": "start",
                    "mappingDetails": []
                },
                {
                    "id": 3015,
                    "name": "firstQuartile",
                    "platformId": 8,
                    "isActive": 1,
                    "platformName": "ViAds",
                    "displayName": "firstQuartile",
                    "mappingDetails": []
                },
                {
                    "id": 3017,
                    "name": "midpoint",
                    "platformId": 8,
                    "isActive": 1,
                    "platformName": "ViAds",
                    "displayName": "midpoint",
                    "mappingDetails": []
                },
                {
                    "id": 3019,
                    "name": "thirdQuartile",
                    "platformId": 8,
                    "isActive": 1,
                    "platformName": "ViAds",
                    "displayName": "thirdQuartile",
                    "mappingDetails": []
                },
                {
                    "id": 3021,
                    "name": "complete",
                    "platformId": 8,
                    "isActive": 1,
                    "platformName": "ViAds",
                    "displayName": "complete",
                    "mappingDetails": []
                },
                {
                    "id": 3023,
                    "name": "rewind",
                    "platformId": 8,
                    "isActive": 1,
                    "platformName": "ViAds",
                    "displayName": "rewind",
                    "mappingDetails": []
                },
                {
                    "id": 3025,
                    "name": "skip",
                    "platformId": 8,
                    "isActive": 1,
                    "platformName": "ViAds",
                    "displayName": "skip",
                    "mappingDetails": []
                },
                {
                    "id": 3027,
                    "name": "impression",
                    "platformId": 8,
                    "isActive": 1,
                    "platformName": "ViAds",
                    "displayName": "impression",
                    "mappingDetails": []
                },
                {
                    "id": 3029,
                    "name": "click",
                    "platformId": 8,
                    "isActive": 1,
                    "platformName": "ViAds",
                    "displayName": "click",
                    "mappingDetails": []
                }
            ]
        },
        {
            "id": 92,
            "name": "Tracker_Type_Video",
            "platformId": 8,
            "isActive": 1,
            "platformName": "ViAds",
            "mappingDetails": [],
            "mappedPlatformsValueSet": [],
            "mappedPlatformsIdSet": [],
            "list": [
                {
                    "id": 3031,
                    "name": "Image",
                    "platformId": 8,
                    "isActive": 1,
                    "platformName": "ViAds",
                    "displayName": "Image",
                    "mappingDetails": []
                }
            ]
        },
        {
            "id": 93,
            "name": "Tracker_Type_Image",
            "platformId": 8,
            "isActive": 1,
            "platformName": "ViAds",
            "displayName": "",
            "description": "",
            "mappingDetails": [],
            "mappedPlatformsValueSet": [],
            "mappedPlatformsIdSet": [],
            "list": [
                {
                    "id": 3033,
                    "name": "Image",
                    "platformId": 8,
                    "isActive": 1,
                    "platformName": "ViAds",
                    "displayName": "Image",
                    "attributeMapping": 343,
                    "mappingDetails": [
                        {
                            "id": 343,
                            "name": "Image_tag",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Image Tag",
                            "dbMappingId": 945
                        }
                    ]
                }
            ]
        },
        {
            "id": 94,
            "name": "OnScreen_Position_VIADS_Screen_Position_Display",
            "platformId": 8,
            "isActive": 1,
            "platformName": "ViAds",
            "mappingDetails": [],
            "mappedPlatformsValueSet": [],
            "mappedPlatformsIdSet": [],
            "list": [
                {
                    "id": 3035,
                    "name": "93",
                    "platformId": 8,
                    "isActive": 1,
                    "platformName": "ViAds",
                    "displayName": "0-Unknown",
                    "mappingDetails": []
                },
                {
                    "id": 3037,
                    "name": "94",
                    "platformId": 8,
                    "isActive": 1,
                    "platformName": "ViAds",
                    "displayName": "1-Above the fold",
                    "mappingDetails": []
                },
                {
                    "id": 3039,
                    "name": "95",
                    "platformId": 8,
                    "isActive": 1,
                    "platformName": "ViAds",
                    "displayName": "2-DEPRECATED",
                    "mappingDetails": []
                },
                {
                    "id": 3041,
                    "name": "96",
                    "platformId": 8,
                    "isActive": 1,
                    "platformName": "ViAds",
                    "displayName": "3-Below the Fold",
                    "mappingDetails": []
                },
                {
                    "id": 3043,
                    "name": "97",
                    "platformId": 8,
                    "isActive": 1,
                    "platformName": "ViAds",
                    "displayName": "4-Header",
                    "mappingDetails": []
                },
                {
                    "id": 3045,
                    "name": "98",
                    "platformId": 8,
                    "isActive": 1,
                    "platformName": "ViAds",
                    "displayName": "5-Footer",
                    "mappingDetails": []
                },
                {
                    "id": 3047,
                    "name": "99",
                    "platformId": 8,
                    "isActive": 1,
                    "platformName": "ViAds",
                    "displayName": "6-Sidebar",
                    "mappingDetails": []
                },
                {
                    "id": 3049,
                    "name": "100",
                    "platformId": 8,
                    "isActive": 1,
                    "platformName": "ViAds",
                    "displayName": "7-Full Screen",
                    "mappingDetails": []
                }
            ]
        },
        {
            "id": 95,
            "name": "OnScreen_Position_VIADS_Screen_Position_Video",
            "platformId": 8,
            "isActive": 1,
            "platformName": "ViAds",
            "mappingDetails": [],
            "mappedPlatformsValueSet": [],
            "mappedPlatformsIdSet": [],
            "list": [
                {
                    "id": 3051,
                    "name": "0",
                    "platformId": 8,
                    "isActive": 1,
                    "platformName": "ViAds",
                    "displayName": "Pre-Roll",
                    "mappingDetails": []
                },
                {
                    "id": 3053,
                    "name": "-1",
                    "platformId": 8,
                    "isActive": 1,
                    "platformName": "ViAds",
                    "displayName": "Mid-roll",
                    "mappingDetails": []
                },
                {
                    "id": 3055,
                    "name": "-2",
                    "platformId": 8,
                    "isActive": 1,
                    "platformName": "ViAds",
                    "displayName": "Post-Roll",
                    "mappingDetails": []
                }
            ]
        },
        {
            "id": 96,
            "name": "Bidding_Strategy",
            "platformId": 8,
            "isActive": 1,
            "platformName": "ViAds",
            "displayName": "",
            "description": "",
            "attributeMapping": 13,
            "mappingDetails": [
                {
                    "id": 13,
                    "name": "Bidding_Strategy",
                    "platformId": 1,
                    "isActive": 1,
                    "platformName": "Beki",
                    "displayName": "Bidding Strategy"
                }
            ],
            "mappedPlatformsValueSet": [],
            "mappedPlatformsIdSet": [],
            "list": [
                {
                    "id": 3057,
                    "name": "90",
                    "platformId": 8,
                    "isActive": 1,
                    "platformName": "ViAds",
                    "displayName": "CPC",
                    "attributeMapping": 1763,
                    "mappingDetails": [
                        {
                            "id": 1763,
                            "name": "Manual CPC",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Manual CPC",
                            "dbMappingId": 943
                        }
                    ]
                },
                {
                    "id": 3059,
                    "name": "89",
                    "platformId": 8,
                    "isActive": 1,
                    "platformName": "ViAds",
                    "displayName": "CPM",
                    "attributeMapping": 36,
                    "mappingDetails": [
                        {
                            "id": 36,
                            "name": "CPM",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "CPM",
                            "dbMappingId": 944
                        }
                    ]
                }
            ]
        },
        {
            "id": 97,
            "name": "DISPLAY_SIZES",
            "platformId": 8,
            "isActive": 1,
            "platformName": "ViAds",
            "mappingDetails": [],
            "mappedPlatformsValueSet": [],
            "mappedPlatformsIdSet": [],
            "list": [
                {
                    "id": 3061,
                    "name": "468X60",
                    "platformId": 8,
                    "isActive": 1,
                    "platformName": "ViAds",
                    "displayName": "468X60",
                    "mappingDetails": []
                },
                {
                    "id": 3063,
                    "name": "336X280",
                    "platformId": 8,
                    "isActive": 1,
                    "platformName": "ViAds",
                    "displayName": "336X280",
                    "mappingDetails": []
                },
                {
                    "id": 3065,
                    "name": "320X50",
                    "platformId": 8,
                    "isActive": 1,
                    "platformName": "ViAds",
                    "displayName": "320X50",
                    "mappingDetails": []
                },
                {
                    "id": 3067,
                    "name": "300X600",
                    "platformId": 8,
                    "isActive": 1,
                    "platformName": "ViAds",
                    "displayName": "300X600",
                    "mappingDetails": []
                },
                {
                    "id": 3069,
                    "name": "300X250",
                    "platformId": 8,
                    "isActive": 1,
                    "platformName": "ViAds",
                    "displayName": "300X250",
                    "mappingDetails": []
                },
                {
                    "id": 3071,
                    "name": "100X100",
                    "platformId": 8,
                    "isActive": 1,
                    "platformName": "ViAds",
                    "displayName": "100X100",
                    "mappingDetails": []
                },
                {
                    "id": 3073,
                    "name": "250X250",
                    "platformId": 8,
                    "isActive": 1,
                    "platformName": "ViAds",
                    "displayName": "250X250",
                    "mappingDetails": []
                },
                {
                    "id": 3075,
                    "name": "240X400",
                    "platformId": 8,
                    "isActive": 1,
                    "platformName": "ViAds",
                    "displayName": "240X400",
                    "mappingDetails": []
                },
                {
                    "id": 3077,
                    "name": "234X60",
                    "platformId": 8,
                    "isActive": 1,
                    "platformName": "ViAds",
                    "displayName": "234X60",
                    "mappingDetails": []
                },
                {
                    "id": 3079,
                    "name": "200X200",
                    "platformId": 8,
                    "isActive": 1,
                    "platformName": "ViAds",
                    "displayName": "200X200",
                    "mappingDetails": []
                },
                {
                    "id": 3081,
                    "name": "180X150",
                    "platformId": 8,
                    "isActive": 1,
                    "platformName": "ViAds",
                    "displayName": "180X150",
                    "mappingDetails": []
                },
                {
                    "id": 3083,
                    "name": "160X600",
                    "platformId": 8,
                    "isActive": 1,
                    "platformName": "ViAds",
                    "displayName": "160X600",
                    "mappingDetails": []
                },
                {
                    "id": 3085,
                    "name": "125X125",
                    "platformId": 8,
                    "isActive": 1,
                    "platformName": "ViAds",
                    "displayName": "125X125",
                    "mappingDetails": []
                },
                {
                    "id": 3087,
                    "name": "120X600",
                    "platformId": 8,
                    "isActive": 1,
                    "platformName": "ViAds",
                    "displayName": "120X600",
                    "mappingDetails": []
                },
                {
                    "id": 3089,
                    "name": "120X90",
                    "platformId": 8,
                    "isActive": 1,
                    "platformName": "ViAds",
                    "displayName": "120X90",
                    "mappingDetails": []
                },
                {
                    "id": 3091,
                    "name": "120X60",
                    "platformId": 8,
                    "isActive": 1,
                    "platformName": "ViAds",
                    "displayName": "120X60",
                    "mappingDetails": []
                },
                {
                    "id": 3093,
                    "name": "88X31",
                    "platformId": 8,
                    "isActive": 1,
                    "platformName": "ViAds",
                    "displayName": "88X31",
                    "mappingDetails": []
                },
                {
                    "id": 3095,
                    "name": "320X250",
                    "platformId": 8,
                    "isActive": 1,
                    "platformName": "ViAds",
                    "displayName": "320X250",
                    "mappingDetails": []
                },
                {
                    "id": 3097,
                    "name": "300X350",
                    "platformId": 8,
                    "isActive": 1,
                    "platformName": "ViAds",
                    "displayName": "300X350",
                    "mappingDetails": []
                },
                {
                    "id": 3099,
                    "name": "1920X1080",
                    "platformId": 8,
                    "isActive": 1,
                    "platformName": "ViAds",
                    "displayName": "1920X1080",
                    "mappingDetails": []
                },
                {
                    "id": 3101,
                    "name": "728X90",
                    "platformId": 8,
                    "isActive": 1,
                    "platformName": "ViAds",
                    "displayName": "728X90",
                    "mappingDetails": []
                },
                {
                    "id": 3103,
                    "name": "390X390",
                    "platformId": 8,
                    "isActive": 1,
                    "platformName": "ViAds",
                    "displayName": "390X390",
                    "mappingDetails": []
                },
                {
                    "id": 3105,
                    "name": "320X100",
                    "platformId": 8,
                    "isActive": 1,
                    "platformName": "ViAds",
                    "displayName": "320X100",
                    "mappingDetails": []
                },
                {
                    "id": 3107,
                    "name": "970X115",
                    "platformId": 8,
                    "isActive": 1,
                    "platformName": "ViAds",
                    "displayName": "970X115",
                    "mappingDetails": []
                },
                {
                    "id": 3109,
                    "name": "1280X719",
                    "platformId": 8,
                    "isActive": 1,
                    "platformName": "ViAds",
                    "displayName": "1280X719",
                    "mappingDetails": []
                },
                {
                    "id": 3111,
                    "name": "300X300",
                    "platformId": 8,
                    "isActive": 1,
                    "platformName": "ViAds",
                    "displayName": "300X300",
                    "mappingDetails": []
                },
                {
                    "id": 3113,
                    "name": "320X480",
                    "platformId": 8,
                    "isActive": 1,
                    "platformName": "ViAds",
                    "displayName": "320X480",
                    "mappingDetails": []
                },
                {
                    "id": 3115,
                    "name": "640X480",
                    "platformId": 8,
                    "isActive": 1,
                    "platformName": "ViAds",
                    "displayName": "640X480",
                    "mappingDetails": []
                },
                {
                    "id": 3117,
                    "name": "640X360",
                    "platformId": 8,
                    "isActive": 1,
                    "platformName": "ViAds",
                    "displayName": "640X360",
                    "mappingDetails": []
                },
                {
                    "id": 3119,
                    "name": "320X280",
                    "platformId": 8,
                    "isActive": 1,
                    "platformName": "ViAds",
                    "displayName": "320X280",
                    "mappingDetails": []
                },
                {
                    "id": 3121,
                    "name": "1024X768",
                    "platformId": 8,
                    "isActive": 1,
                    "platformName": "ViAds",
                    "displayName": "1024X768",
                    "mappingDetails": []
                },
                {
                    "id": 3123,
                    "name": "768X1024",
                    "platformId": 8,
                    "isActive": 1,
                    "platformName": "ViAds",
                    "displayName": "768X1024",
                    "mappingDetails": []
                },
                {
                    "id": 3125,
                    "name": "640X960",
                    "platformId": 8,
                    "isActive": 1,
                    "platformName": "ViAds",
                    "displayName": "640X960",
                    "mappingDetails": []
                },
                {
                    "id": 3127,
                    "name": "300X400",
                    "platformId": 8,
                    "isActive": 1,
                    "platformName": "ViAds",
                    "displayName": "300X400",
                    "mappingDetails": []
                },
                {
                    "id": 3129,
                    "name": "320X180",
                    "platformId": 8,
                    "isActive": 1,
                    "platformName": "ViAds",
                    "displayName": "320X180",
                    "mappingDetails": []
                },
                {
                    "id": 3131,
                    "name": "1000X80",
                    "platformId": 8,
                    "isActive": 1,
                    "platformName": "ViAds",
                    "displayName": "1000X80",
                    "mappingDetails": []
                },
                {
                    "id": 3133,
                    "name": "45X45",
                    "platformId": 8,
                    "isActive": 1,
                    "platformName": "ViAds",
                    "displayName": "45X45",
                    "mappingDetails": []
                },
                {
                    "id": 3135,
                    "name": "305X345",
                    "platformId": 8,
                    "isActive": 1,
                    "platformName": "ViAds",
                    "displayName": "305X345",
                    "mappingDetails": []
                },
                {
                    "id": 3137,
                    "name": "990X550",
                    "platformId": 8,
                    "isActive": 1,
                    "platformName": "ViAds",
                    "displayName": "990X550",
                    "mappingDetails": []
                },
                {
                    "id": 3139,
                    "name": "1100X600",
                    "platformId": 8,
                    "isActive": 1,
                    "platformName": "ViAds",
                    "displayName": "1100X600",
                    "mappingDetails": []
                },
                {
                    "id": 3141,
                    "name": "970X90",
                    "platformId": 8,
                    "isActive": 1,
                    "platformName": "ViAds",
                    "displayName": "970X90",
                    "mappingDetails": []
                },
                {
                    "id": 3143,
                    "name": "970X250",
                    "platformId": 8,
                    "isActive": 1,
                    "platformName": "ViAds",
                    "displayName": "970X250",
                    "mappingDetails": []
                },
                {
                    "id": 3145,
                    "name": "500X500",
                    "platformId": 8,
                    "isActive": 1,
                    "platformName": "ViAds",
                    "displayName": "500X500",
                    "mappingDetails": []
                },
                {
                    "id": 3147,
                    "name": "201X268",
                    "platformId": 8,
                    "isActive": 1,
                    "platformName": "ViAds",
                    "displayName": "201X268",
                    "mappingDetails": []
                },
                {
                    "id": 3149,
                    "name": "402X536",
                    "platformId": 8,
                    "isActive": 1,
                    "platformName": "ViAds",
                    "displayName": "402X536",
                    "mappingDetails": []
                },
                {
                    "id": 3151,
                    "name": "725X300",
                    "platformId": 8,
                    "isActive": 1,
                    "platformName": "ViAds",
                    "displayName": "725X300",
                    "mappingDetails": []
                },
                {
                    "id": 3153,
                    "name": "480X320",
                    "platformId": 8,
                    "isActive": 1,
                    "platformName": "ViAds",
                    "displayName": "480X320",
                    "mappingDetails": []
                },
                {
                    "id": 3155,
                    "name": "300X50",
                    "platformId": 8,
                    "isActive": 1,
                    "platformName": "ViAds",
                    "displayName": "300X50",
                    "mappingDetails": []
                },
                {
                    "id": 3157,
                    "name": "273X300",
                    "platformId": 8,
                    "isActive": 1,
                    "platformName": "ViAds",
                    "displayName": "273X300",
                    "mappingDetails": []
                },
                {
                    "id": 3159,
                    "name": "900X600",
                    "platformId": 8,
                    "isActive": 1,
                    "platformName": "ViAds",
                    "displayName": "900X600",
                    "mappingDetails": []
                },
                {
                    "id": 3161,
                    "name": "275X183",
                    "platformId": 8,
                    "isActive": 1,
                    "platformName": "ViAds",
                    "displayName": "275X183",
                    "mappingDetails": []
                },
                {
                    "id": 3163,
                    "name": "400X400",
                    "platformId": 8,
                    "isActive": 1,
                    "platformName": "ViAds",
                    "displayName": "400X400",
                    "mappingDetails": []
                },
                {
                    "id": 3165,
                    "name": "150X150",
                    "platformId": 8,
                    "isActive": 1,
                    "platformName": "ViAds",
                    "displayName": "150X150",
                    "mappingDetails": []
                },
                {
                    "id": 3167,
                    "name": "15X10",
                    "platformId": 8,
                    "isActive": 1,
                    "platformName": "ViAds",
                    "displayName": "15X10",
                    "mappingDetails": []
                },
                {
                    "id": 3169,
                    "name": "1300X160",
                    "platformId": 8,
                    "isActive": 1,
                    "platformName": "ViAds",
                    "displayName": "1300X160",
                    "mappingDetails": []
                },
                {
                    "id": 3171,
                    "name": "800X600",
                    "platformId": 8,
                    "isActive": 1,
                    "platformName": "ViAds",
                    "displayName": "800X600",
                    "mappingDetails": []
                },
                {
                    "id": 3173,
                    "name": "300X170",
                    "platformId": 8,
                    "isActive": 1,
                    "platformName": "ViAds",
                    "displayName": "300X170",
                    "mappingDetails": []
                },
                {
                    "id": 3175,
                    "name": "250X40",
                    "platformId": 8,
                    "isActive": 1,
                    "platformName": "ViAds",
                    "displayName": "250X40",
                    "mappingDetails": []
                },
                {
                    "id": 3177,
                    "name": "300X240",
                    "platformId": 8,
                    "isActive": 1,
                    "platformName": "ViAds",
                    "displayName": "300X240",
                    "mappingDetails": []
                },
                {
                    "id": 3179,
                    "name": "300X302",
                    "platformId": 8,
                    "isActive": 1,
                    "platformName": "ViAds",
                    "displayName": "300X302",
                    "mappingDetails": []
                }
            ]
        },
        {
            "id": 98,
            "name": "VIDEO_SIZES",
            "platformId": 8,
            "isActive": 1,
            "platformName": "ViAds",
            "mappingDetails": [],
            "mappedPlatformsValueSet": [],
            "mappedPlatformsIdSet": [],
            "list": [
                {
                    "id": 3181,
                    "name": "300X250",
                    "platformId": 8,
                    "isActive": 1,
                    "platformName": "ViAds",
                    "displayName": "300X250",
                    "mappingDetails": []
                },
                {
                    "id": 3183,
                    "name": "300X224",
                    "platformId": 8,
                    "isActive": 1,
                    "platformName": "ViAds",
                    "displayName": "300X224",
                    "mappingDetails": []
                },
                {
                    "id": 3185,
                    "name": "350X200",
                    "platformId": 8,
                    "isActive": 1,
                    "platformName": "ViAds",
                    "displayName": "350X200",
                    "mappingDetails": []
                },
                {
                    "id": 3187,
                    "name": "400X200",
                    "platformId": 8,
                    "isActive": 1,
                    "platformName": "ViAds",
                    "displayName": "400X200",
                    "mappingDetails": []
                },
                {
                    "id": 3189,
                    "name": "300X200",
                    "platformId": 8,
                    "isActive": 1,
                    "platformName": "ViAds",
                    "displayName": "300X200",
                    "mappingDetails": []
                },
                {
                    "id": 3191,
                    "name": "250X250",
                    "platformId": 8,
                    "isActive": 1,
                    "platformName": "ViAds",
                    "displayName": "250X250",
                    "mappingDetails": []
                },
                {
                    "id": 3193,
                    "name": "336X280",
                    "platformId": 8,
                    "isActive": 1,
                    "platformName": "ViAds",
                    "displayName": "336X280",
                    "mappingDetails": []
                },
                {
                    "id": 3195,
                    "name": "350X196",
                    "platformId": 8,
                    "isActive": 1,
                    "platformName": "ViAds",
                    "displayName": "350X196",
                    "mappingDetails": []
                },
                {
                    "id": 3197,
                    "name": "300X168",
                    "platformId": 8,
                    "isActive": 1,
                    "platformName": "ViAds",
                    "displayName": "300X168",
                    "mappingDetails": []
                },
                {
                    "id": 3199,
                    "name": "320X250",
                    "platformId": 8,
                    "isActive": 1,
                    "platformName": "ViAds",
                    "displayName": "320X250",
                    "mappingDetails": []
                },
                {
                    "id": 3201,
                    "name": "640X480",
                    "platformId": 8,
                    "isActive": 1,
                    "platformName": "ViAds",
                    "displayName": "640X480",
                    "mappingDetails": []
                },
                {
                    "id": 3203,
                    "name": "400X300",
                    "platformId": 8,
                    "isActive": 1,
                    "platformName": "ViAds",
                    "displayName": "400X300",
                    "mappingDetails": []
                },
                {
                    "id": 3205,
                    "name": "1280X720",
                    "platformId": 8,
                    "isActive": 1,
                    "platformName": "ViAds",
                    "displayName": "1280X720",
                    "mappingDetails": []
                },
                {
                    "id": 3207,
                    "name": "1440X1080",
                    "platformId": 8,
                    "isActive": 1,
                    "platformName": "ViAds",
                    "displayName": "1440X1080",
                    "mappingDetails": []
                },
                {
                    "id": 3209,
                    "name": "1920X1080",
                    "platformId": 8,
                    "isActive": 1,
                    "platformName": "ViAds",
                    "displayName": "1920X1080",
                    "mappingDetails": []
                },
                {
                    "id": 3211,
                    "name": "600X500",
                    "platformId": 8,
                    "isActive": 1,
                    "platformName": "ViAds",
                    "displayName": "600X500",
                    "mappingDetails": []
                },
                {
                    "id": 3213,
                    "name": "640X360",
                    "platformId": 8,
                    "isActive": 1,
                    "platformName": "ViAds",
                    "displayName": "640X360",
                    "mappingDetails": []
                },
                {
                    "id": 3215,
                    "name": "338X190",
                    "platformId": 8,
                    "isActive": 1,
                    "platformName": "ViAds",
                    "displayName": "338X190",
                    "mappingDetails": []
                },
                {
                    "id": 3217,
                    "name": "640X362",
                    "platformId": 8,
                    "isActive": 1,
                    "platformName": "ViAds",
                    "displayName": "640X362",
                    "mappingDetails": []
                },
                {
                    "id": 3219,
                    "name": "320X240",
                    "platformId": 8,
                    "isActive": 1,
                    "platformName": "ViAds",
                    "displayName": "320X240",
                    "mappingDetails": []
                },
                {
                    "id": 3221,
                    "name": "320X480",
                    "platformId": 8,
                    "isActive": 1,
                    "platformName": "ViAds",
                    "displayName": "320X480",
                    "mappingDetails": []
                },
                {
                    "id": 3223,
                    "name": "320X50",
                    "platformId": 8,
                    "isActive": 1,
                    "platformName": "ViAds",
                    "displayName": "320X50",
                    "mappingDetails": []
                },
                {
                    "id": 3225,
                    "name": "480X320",
                    "platformId": 8,
                    "isActive": 1,
                    "platformName": "ViAds",
                    "displayName": "480X320",
                    "mappingDetails": []
                },
                {
                    "id": 3227,
                    "name": "720X576",
                    "platformId": 8,
                    "isActive": 1,
                    "platformName": "ViAds",
                    "displayName": "720X576",
                    "mappingDetails": []
                },
                {
                    "id": 3229,
                    "name": "1080X1920",
                    "platformId": 8,
                    "isActive": 1,
                    "platformName": "ViAds",
                    "displayName": "1080X1920",
                    "mappingDetails": []
                },
                {
                    "id": 3231,
                    "name": "360X640",
                    "platformId": 8,
                    "isActive": 1,
                    "platformName": "ViAds",
                    "displayName": "360X640",
                    "mappingDetails": []
                },
                {
                    "id": 3233,
                    "name": "1024X768",
                    "platformId": 8,
                    "isActive": 1,
                    "platformName": "ViAds",
                    "displayName": "1024X768",
                    "mappingDetails": []
                },
                {
                    "id": 3235,
                    "name": "1X1",
                    "platformId": 8,
                    "isActive": 1,
                    "platformName": "ViAds",
                    "displayName": "1X1",
                    "mappingDetails": []
                },
                {
                    "id": 3237,
                    "name": "300X600",
                    "platformId": 8,
                    "isActive": 1,
                    "platformName": "ViAds",
                    "displayName": "300X600",
                    "mappingDetails": []
                },
                {
                    "id": 3239,
                    "name": "300X50",
                    "platformId": 8,
                    "isActive": 1,
                    "platformName": "ViAds",
                    "displayName": "300X50",
                    "mappingDetails": []
                },
                {
                    "id": 3241,
                    "name": "300X240",
                    "platformId": 8,
                    "isActive": 1,
                    "platformName": "ViAds",
                    "displayName": "300X240",
                    "mappingDetails": []
                },
                {
                    "id": 3243,
                    "name": "123X123",
                    "platformId": 8,
                    "isActive": 1,
                    "platformName": "ViAds",
                    "displayName": "123X123",
                    "mappingDetails": []
                },
                {
                    "id": 3245,
                    "name": "850X480",
                    "platformId": 8,
                    "isActive": 1,
                    "platformName": "ViAds",
                    "displayName": "850X480",
                    "mappingDetails": []
                },
                {
                    "id": 3247,
                    "name": "960X400",
                    "platformId": 8,
                    "isActive": 1,
                    "platformName": "ViAds",
                    "displayName": "960X400",
                    "mappingDetails": []
                }
            ]
        },
        {
            "id": 100,
            "name": "Bidding_Strategy_Video",
            "platformId": 8,
            "isActive": 1,
            "platformName": "ViAds",
            "displayName": "",
            "description": "",
            "attributeMapping": 66,
            "mappingDetails": [
                {
                    "id": 66,
                    "name": "Bidding_Strategy_Video",
                    "platformId": 1,
                    "isActive": 1,
                    "platformName": "Beki",
                    "displayName": "Bidding_Strategy_Video"
                }
            ],
            "mappedPlatformsValueSet": [],
            "mappedPlatformsIdSet": [],
            "list": [
                {
                    "id": 3615,
                    "name": "90",
                    "platformId": 8,
                    "isActive": 1,
                    "platformName": "ViAds",
                    "displayName": "CPC",
                    "attributeMapping": 1777,
                    "mappingDetails": [
                        {
                            "id": 1777,
                            "name": "Manual CPC",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Manual CPC",
                            "dbMappingId": 941
                        }
                    ]
                },
                {
                    "id": 3617,
                    "name": "89",
                    "platformId": 8,
                    "isActive": 1,
                    "platformName": "ViAds",
                    "displayName": "CPM",
                    "attributeMapping": 1781,
                    "mappingDetails": [
                        {
                            "id": 1781,
                            "name": "CPM",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "CPM",
                            "dbMappingId": 942
                        }
                    ]
                }
            ]
        },
        {
            "id": 101,
            "name": "Bidding_Strategy_Display",
            "platformId": 8,
            "isActive": 1,
            "platformName": "ViAds",
            "displayName": "",
            "description": "",
            "attributeMapping": 65,
            "mappingDetails": [
                {
                    "id": 65,
                    "name": "Bidding_Strategy_Display",
                    "platformId": 1,
                    "isActive": 1,
                    "platformName": "Beki",
                    "displayName": "Bidding_Strategy_Display"
                }
            ],
            "mappedPlatformsValueSet": [],
            "mappedPlatformsIdSet": [],
            "list": [
                {
                    "id": 3619,
                    "name": "90",
                    "platformId": 8,
                    "isActive": 1,
                    "platformName": "ViAds",
                    "displayName": "CPC",
                    "attributeMapping": 1775,
                    "mappingDetails": [
                        {
                            "id": 1775,
                            "name": "Manual CPC",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Manual CPC",
                            "dbMappingId": 939
                        }
                    ]
                },
                {
                    "id": 3621,
                    "name": "89",
                    "platformId": 8,
                    "isActive": 1,
                    "platformName": "ViAds",
                    "displayName": "CPM",
                    "attributeMapping": 1771,
                    "mappingDetails": [
                        {
                            "id": 1771,
                            "name": "CPM",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "CPM",
                            "dbMappingId": 940
                        }
                    ]
                }
            ]
        },
        {
            "id": 102,
            "name": "Language",
            "platformId": 8,
            "isActive": 1,
            "platformName": "ViAds",
            "displayName": "Language",
            "attributeMapping": 79,
            "mappingDetails": [
                {
                    "id": 79,
                    "name": "Language",
                    "platformId": 1,
                    "isActive": 1,
                    "platformName": "Beki",
                    "displayName": "Language"
                }
            ],
            "mappedPlatformsValueSet": [],
            "mappedPlatformsIdSet": [],
            "list": [
                {
                    "id": 3623,
                    "name": "641",
                    "platformId": 8,
                    "isActive": 1,
                    "platformName": "ViAds",
                    "displayName": "Ndonga",
                    "attributeMapping": 2337,
                    "mappingDetails": [
                        {
                            "id": 2337,
                            "name": "Ndonga",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Ndonga",
                            "dbMappingId": 946
                        }
                    ]
                },
                {
                    "id": 3625,
                    "name": "675",
                    "platformId": 8,
                    "isActive": 1,
                    "platformName": "ViAds",
                    "displayName": "Southern Sotho",
                    "attributeMapping": 2341,
                    "mappingDetails": [
                        {
                            "id": 2341,
                            "name": "Southern Sotho",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Southern Sotho",
                            "dbMappingId": 947
                        }
                    ]
                },
                {
                    "id": 3627,
                    "name": "614",
                    "platformId": 8,
                    "isActive": 1,
                    "platformName": "ViAds",
                    "displayName": "Komi",
                    "attributeMapping": 1831,
                    "mappingDetails": [
                        {
                            "id": 1831,
                            "name": "Komi",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Komi",
                            "dbMappingId": 948
                        }
                    ]
                },
                {
                    "id": 3629,
                    "name": "623",
                    "platformId": 8,
                    "isActive": 1,
                    "platformName": "ViAds",
                    "displayName": "Lingala",
                    "attributeMapping": 1835,
                    "mappingDetails": [
                        {
                            "id": 1835,
                            "name": "Lingala",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Lingala",
                            "dbMappingId": 949
                        }
                    ]
                },
                {
                    "id": 3631,
                    "name": "589",
                    "platformId": 8,
                    "isActive": 1,
                    "platformName": "ViAds",
                    "displayName": "Hebrew",
                    "attributeMapping": 2345,
                    "mappingDetails": [
                        {
                            "id": 2345,
                            "name": "Hebrew",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Hebrew",
                            "dbMappingId": 950
                        }
                    ]
                },
                {
                    "id": 3633,
                    "name": "543",
                    "platformId": 8,
                    "isActive": 1,
                    "platformName": "ViAds",
                    "displayName": "Bashkir",
                    "attributeMapping": 1839,
                    "mappingDetails": [
                        {
                            "id": 1839,
                            "name": "Bashkir",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Bashkir",
                            "dbMappingId": 951
                        }
                    ]
                },
                {
                    "id": 3635,
                    "name": "645",
                    "platformId": 8,
                    "isActive": 1,
                    "platformName": "ViAds",
                    "displayName": "Norwegian Nynorsk",
                    "attributeMapping": 1843,
                    "mappingDetails": [
                        {
                            "id": 1843,
                            "name": "Norwegian Nynorsk",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Norwegian Nynorsk",
                            "dbMappingId": 952
                        }
                    ]
                },
                {
                    "id": 3637,
                    "name": "528",
                    "platformId": 8,
                    "isActive": 1,
                    "platformName": "ViAds",
                    "displayName": "Abkhazian",
                    "attributeMapping": 1849,
                    "mappingDetails": [
                        {
                            "id": 1849,
                            "name": "Abkhazian",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Abkhazian",
                            "dbMappingId": 953
                        }
                    ]
                },
                {
                    "id": 3639,
                    "name": "636",
                    "platformId": 8,
                    "isActive": 1,
                    "platformName": "ViAds",
                    "displayName": "Mongolian",
                    "attributeMapping": 2355,
                    "mappingDetails": [
                        {
                            "id": 2355,
                            "name": "Mongolian",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Mongolian",
                            "dbMappingId": 954
                        }
                    ]
                },
                {
                    "id": 3641,
                    "name": "625",
                    "platformId": 8,
                    "isActive": 1,
                    "platformName": "ViAds",
                    "displayName": "Luba-Katanga",
                    "attributeMapping": 1853,
                    "mappingDetails": [
                        {
                            "id": 1853,
                            "name": "Luba-Katanga",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Luba-Katanga",
                            "dbMappingId": 955
                        }
                    ]
                },
                {
                    "id": 3643,
                    "name": "710",
                    "platformId": 8,
                    "isActive": 1,
                    "platformName": "ViAds",
                    "displayName": "Zulu",
                    "attributeMapping": 1857,
                    "mappingDetails": [
                        {
                            "id": 1857,
                            "name": "Zulu",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Zulu",
                            "dbMappingId": 956
                        }
                    ]
                },
                {
                    "id": 3645,
                    "name": "669",
                    "platformId": 8,
                    "isActive": 1,
                    "platformName": "ViAds",
                    "displayName": "Shona",
                    "attributeMapping": 2361,
                    "mappingDetails": [
                        {
                            "id": 2361,
                            "name": "Shona",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Shona",
                            "dbMappingId": 957
                        }
                    ]
                },
                {
                    "id": 3647,
                    "name": "680",
                    "platformId": 8,
                    "isActive": 1,
                    "platformName": "ViAds",
                    "displayName": "Swedish",
                    "attributeMapping": 1861,
                    "mappingDetails": [
                        {
                            "id": 1861,
                            "name": "Swedish",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Swedish",
                            "dbMappingId": 958
                        }
                    ]
                },
                {
                    "id": 3649,
                    "name": "693",
                    "platformId": 8,
                    "isActive": 1,
                    "platformName": "ViAds",
                    "displayName": "Turkish",
                    "attributeMapping": 1871,
                    "mappingDetails": [
                        {
                            "id": 1871,
                            "name": "Turkish",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Turkish",
                            "dbMappingId": 959
                        }
                    ]
                },
                {
                    "id": 3651,
                    "name": "697",
                    "platformId": 8,
                    "isActive": 1,
                    "platformName": "ViAds",
                    "displayName": "Ukrainian",
                    "attributeMapping": 2365,
                    "mappingDetails": [
                        {
                            "id": 2365,
                            "name": "Ukrainian",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Ukrainian",
                            "dbMappingId": 960
                        }
                    ]
                },
                {
                    "id": 3653,
                    "name": "606",
                    "platformId": 8,
                    "isActive": 1,
                    "platformName": "ViAds",
                    "displayName": "Kannada",
                    "attributeMapping": 1881,
                    "mappingDetails": [
                        {
                            "id": 1881,
                            "name": "Kannada",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Kannada",
                            "dbMappingId": 961
                        }
                    ]
                },
                {
                    "id": 3655,
                    "name": "622",
                    "platformId": 8,
                    "isActive": 1,
                    "platformName": "ViAds",
                    "displayName": "Limburgan, Limburger, Limburgish",
                    "attributeMapping": 2375,
                    "mappingDetails": [
                        {
                            "id": 2375,
                            "name": "Limburgan, Limburger, Limburgish",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Limburgan, Limburger, Limburgish",
                            "dbMappingId": 962
                        }
                    ]
                },
                {
                    "id": 3657,
                    "name": "663",
                    "platformId": 8,
                    "isActive": 1,
                    "platformName": "ViAds",
                    "displayName": "Northern Sami",
                    "attributeMapping": 2379,
                    "mappingDetails": [
                        {
                            "id": 2379,
                            "name": "Northern Sami",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Northern Sami",
                            "dbMappingId": 963
                        }
                    ]
                },
                {
                    "id": 3659,
                    "name": "665",
                    "platformId": 8,
                    "isActive": 1,
                    "platformName": "ViAds",
                    "displayName": "Sango",
                    "attributeMapping": 1891,
                    "mappingDetails": [
                        {
                            "id": 1891,
                            "name": "Sango",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Sango",
                            "dbMappingId": 964
                        }
                    ]
                },
                {
                    "id": 3661,
                    "name": "611",
                    "platformId": 8,
                    "isActive": 1,
                    "platformName": "ViAds",
                    "displayName": "Kikuyu, Gikuyu",
                    "attributeMapping": 2383,
                    "mappingDetails": [
                        {
                            "id": 2383,
                            "name": "Kikuyu, Gikuyu",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Kikuyu, Gikuyu",
                            "dbMappingId": 965
                        }
                    ]
                },
                {
                    "id": 3663,
                    "name": "629",
                    "platformId": 8,
                    "isActive": 1,
                    "platformName": "ViAds",
                    "displayName": "Malay",
                    "attributeMapping": 2387,
                    "mappingDetails": [
                        {
                            "id": 2387,
                            "name": "Malay",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Malay",
                            "dbMappingId": 966
                        }
                    ]
                },
                {
                    "id": 3665,
                    "name": "639",
                    "platformId": 8,
                    "isActive": 1,
                    "platformName": "ViAds",
                    "displayName": "North Ndebele",
                    "attributeMapping": 2397,
                    "mappingDetails": [
                        {
                            "id": 2397,
                            "name": "North Ndebele",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "North Ndebele",
                            "dbMappingId": 967
                        }
                    ]
                },
                {
                    "id": 3667,
                    "name": "557",
                    "platformId": 8,
                    "isActive": 1,
                    "platformName": "ViAds",
                    "displayName": "Church Slavonic, Old Slavonic, Old Church Slavonic",
                    "attributeMapping": 1909,
                    "mappingDetails": [
                        {
                            "id": 1909,
                            "name": "Church Slavonic, Old Slavonic, Old Church Slavonic",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Church Slavonic, Old Slavonic, Old Church Slavonic",
                            "dbMappingId": 968
                        }
                    ]
                },
                {
                    "id": 3669,
                    "name": "578",
                    "platformId": 8,
                    "isActive": 1,
                    "platformName": "ViAds",
                    "displayName": "Gaelic, Scottish Gaelic",
                    "attributeMapping": 1917,
                    "mappingDetails": [
                        {
                            "id": 1917,
                            "name": "Gaelic, Scottish Gaelic",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Gaelic, Scottish Gaelic",
                            "dbMappingId": 969
                        }
                    ]
                },
                {
                    "id": 3671,
                    "name": "536",
                    "platformId": 8,
                    "isActive": 1,
                    "platformName": "ViAds",
                    "displayName": "Armenian",
                    "attributeMapping": 1921,
                    "mappingDetails": [
                        {
                            "id": 1921,
                            "name": "Armenian",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Armenian",
                            "dbMappingId": 970
                        }
                    ]
                },
                {
                    "id": 3673,
                    "name": "682",
                    "platformId": 8,
                    "isActive": 1,
                    "platformName": "ViAds",
                    "displayName": "Tahitian",
                    "attributeMapping": 1927,
                    "mappingDetails": [
                        {
                            "id": 1927,
                            "name": "Tahitian",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Tahitian",
                            "dbMappingId": 971
                        }
                    ]
                },
                {
                    "id": 3675,
                    "name": "678",
                    "platformId": 8,
                    "isActive": 1,
                    "platformName": "ViAds",
                    "displayName": "Swahili",
                    "attributeMapping": 2405,
                    "mappingDetails": [
                        {
                            "id": 2405,
                            "name": "Swahili",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Swahili",
                            "dbMappingId": 972
                        }
                    ]
                },
                {
                    "id": 3677,
                    "name": "698",
                    "platformId": 8,
                    "isActive": 1,
                    "platformName": "ViAds",
                    "displayName": "Urdu",
                    "attributeMapping": 1931,
                    "mappingDetails": [
                        {
                            "id": 1931,
                            "name": "Urdu",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Urdu",
                            "dbMappingId": 973
                        }
                    ]
                },
                {
                    "id": 3679,
                    "name": "580",
                    "platformId": 8,
                    "isActive": 1,
                    "platformName": "ViAds",
                    "displayName": "Ganda",
                    "attributeMapping": 1949,
                    "mappingDetails": [
                        {
                            "id": 1949,
                            "name": "Ganda",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Ganda",
                            "dbMappingId": 974
                        }
                    ]
                },
                {
                    "id": 3681,
                    "name": "695",
                    "platformId": 8,
                    "isActive": 1,
                    "platformName": "ViAds",
                    "displayName": "Twi",
                    "attributeMapping": 1953,
                    "mappingDetails": [
                        {
                            "id": 1953,
                            "name": "Twi",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Twi",
                            "dbMappingId": 975
                        }
                    ]
                },
                {
                    "id": 3683,
                    "name": "529",
                    "platformId": 8,
                    "isActive": 1,
                    "platformName": "ViAds",
                    "displayName": "Afar",
                    "attributeMapping": 2411,
                    "mappingDetails": [
                        {
                            "id": 2411,
                            "name": "Afar",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Afar",
                            "dbMappingId": 976
                        }
                    ]
                },
                {
                    "id": 3685,
                    "name": "596",
                    "platformId": 8,
                    "isActive": 1,
                    "platformName": "ViAds",
                    "displayName": "Igbo",
                    "attributeMapping": 1957,
                    "mappingDetails": [
                        {
                            "id": 1957,
                            "name": "Igbo",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Igbo",
                            "dbMappingId": 977
                        }
                    ]
                },
                {
                    "id": 3687,
                    "name": "707",
                    "platformId": 8,
                    "isActive": 1,
                    "platformName": "ViAds",
                    "displayName": "Yiddish",
                    "attributeMapping": 1961,
                    "mappingDetails": [
                        {
                            "id": 1961,
                            "name": "Yiddish",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Yiddish",
                            "dbMappingId": 978
                        }
                    ]
                },
                {
                    "id": 3689,
                    "name": "627",
                    "platformId": 8,
                    "isActive": 1,
                    "platformName": "ViAds",
                    "displayName": "Macedonian",
                    "attributeMapping": 2415,
                    "mappingDetails": [
                        {
                            "id": 2415,
                            "name": "Macedonian",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Macedonian",
                            "dbMappingId": 979
                        }
                    ]
                },
                {
                    "id": 3691,
                    "name": "549",
                    "platformId": 8,
                    "isActive": 1,
                    "platformName": "ViAds",
                    "displayName": "Breton",
                    "attributeMapping": 1965,
                    "mappingDetails": [
                        {
                            "id": 1965,
                            "name": "Breton",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Breton",
                            "dbMappingId": 980
                        }
                    ]
                },
                {
                    "id": 3693,
                    "name": "604",
                    "platformId": 8,
                    "isActive": 1,
                    "platformName": "ViAds",
                    "displayName": "Japanese",
                    "attributeMapping": 2421,
                    "mappingDetails": [
                        {
                            "id": 2421,
                            "name": "Japanese",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Japanese",
                            "dbMappingId": 981
                        }
                    ]
                },
                {
                    "id": 3695,
                    "name": "570",
                    "platformId": 8,
                    "isActive": 1,
                    "platformName": "ViAds",
                    "displayName": "Estonian",
                    "attributeMapping": 2431,
                    "mappingDetails": [
                        {
                            "id": 2431,
                            "name": "Estonian",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Estonian",
                            "dbMappingId": 982
                        }
                    ]
                },
                {
                    "id": 3697,
                    "name": "670",
                    "platformId": 8,
                    "isActive": 1,
                    "platformName": "ViAds",
                    "displayName": "Sindhi",
                    "attributeMapping": 2439,
                    "mappingDetails": [
                        {
                            "id": 2439,
                            "name": "Sindhi",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Sindhi",
                            "dbMappingId": 983
                        }
                    ]
                },
                {
                    "id": 3699,
                    "name": "546",
                    "platformId": 8,
                    "isActive": 1,
                    "platformName": "ViAds",
                    "displayName": "Bengali",
                    "attributeMapping": 2447,
                    "mappingDetails": [
                        {
                            "id": 2447,
                            "name": "Bengali",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Bengali",
                            "dbMappingId": 984
                        }
                    ]
                },
                {
                    "id": 3701,
                    "name": "607",
                    "platformId": 8,
                    "isActive": 1,
                    "platformName": "ViAds",
                    "displayName": "Kanuri",
                    "attributeMapping": 2457,
                    "mappingDetails": [
                        {
                            "id": 2457,
                            "name": "Kanuri",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Kanuri",
                            "dbMappingId": 985
                        }
                    ]
                },
                {
                    "id": 3703,
                    "name": "586",
                    "platformId": 8,
                    "isActive": 1,
                    "platformName": "ViAds",
                    "displayName": "Gujarati",
                    "attributeMapping": 1969,
                    "mappingDetails": [
                        {
                            "id": 1969,
                            "name": "Gujarati",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Gujarati",
                            "dbMappingId": 986
                        }
                    ]
                },
                {
                    "id": 3705,
                    "name": "594",
                    "platformId": 8,
                    "isActive": 1,
                    "platformName": "ViAds",
                    "displayName": "Icelandic",
                    "attributeMapping": 1979,
                    "mappingDetails": [
                        {
                            "id": 1979,
                            "name": "Icelandic",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Icelandic",
                            "dbMappingId": 987
                        }
                    ]
                },
                {
                    "id": 3707,
                    "name": "676",
                    "platformId": 8,
                    "isActive": 1,
                    "platformName": "ViAds",
                    "displayName": "Spanish, Castilian",
                    "attributeMapping": 2461,
                    "mappingDetails": [
                        {
                            "id": 2461,
                            "name": "Spanish, Castilian",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Spanish, Castilian",
                            "dbMappingId": 988
                        }
                    ]
                },
                {
                    "id": 3709,
                    "name": "685",
                    "platformId": 8,
                    "isActive": 1,
                    "platformName": "ViAds",
                    "displayName": "Tatar",
                    "attributeMapping": 2465,
                    "mappingDetails": [
                        {
                            "id": 2465,
                            "name": "Tatar",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Tatar",
                            "dbMappingId": 989
                        }
                    ]
                },
                {
                    "id": 3711,
                    "name": "554",
                    "platformId": 8,
                    "isActive": 1,
                    "platformName": "ViAds",
                    "displayName": "Chechen",
                    "attributeMapping": 2469,
                    "mappingDetails": [
                        {
                            "id": 2469,
                            "name": "Chechen",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Chechen",
                            "dbMappingId": 990
                        }
                    ]
                },
                {
                    "id": 3713,
                    "name": "587",
                    "platformId": 8,
                    "isActive": 1,
                    "platformName": "ViAds",
                    "displayName": "Haitian, Haitian Creole",
                    "attributeMapping": 2473,
                    "mappingDetails": [
                        {
                            "id": 2473,
                            "name": "Haitian, Haitian Creole",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Haitian, Haitian Creole",
                            "dbMappingId": 991
                        }
                    ]
                },
                {
                    "id": 3715,
                    "name": "690",
                    "platformId": 8,
                    "isActive": 1,
                    "platformName": "ViAds",
                    "displayName": "Tonga (Tonga Islands)",
                    "mappingDetails": []
                },
                {
                    "id": 3717,
                    "name": "567",
                    "platformId": 8,
                    "isActive": 1,
                    "platformName": "ViAds",
                    "displayName": "Dzongkha",
                    "attributeMapping": 1987,
                    "mappingDetails": [
                        {
                            "id": 1987,
                            "name": "Dzongkha",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Dzongkha",
                            "dbMappingId": 993
                        }
                    ]
                },
                {
                    "id": 3719,
                    "name": "677",
                    "platformId": 8,
                    "isActive": 1,
                    "platformName": "ViAds",
                    "displayName": "Sundanese",
                    "attributeMapping": 1991,
                    "mappingDetails": [
                        {
                            "id": 1991,
                            "name": "Sundanese",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Sundanese",
                            "dbMappingId": 994
                        }
                    ]
                },
                {
                    "id": 3721,
                    "name": "688",
                    "platformId": 8,
                    "isActive": 1,
                    "platformName": "ViAds",
                    "displayName": "Tibetan",
                    "attributeMapping": 2477,
                    "mappingDetails": [
                        {
                            "id": 2477,
                            "name": "Tibetan",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Tibetan",
                            "dbMappingId": 995
                        }
                    ]
                },
                {
                    "id": 3723,
                    "name": "699",
                    "platformId": 8,
                    "isActive": 1,
                    "platformName": "ViAds",
                    "displayName": "Uzbek",
                    "attributeMapping": 2481,
                    "mappingDetails": [
                        {
                            "id": 2481,
                            "name": "Uzbek",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Uzbek",
                            "dbMappingId": 996
                        }
                    ]
                },
                {
                    "id": 3725,
                    "name": "696",
                    "platformId": 8,
                    "isActive": 1,
                    "platformName": "ViAds",
                    "displayName": "Uighur, Uyghur",
                    "mappingDetails": []
                },
                {
                    "id": 3727,
                    "name": "566",
                    "platformId": 8,
                    "isActive": 1,
                    "platformName": "ViAds",
                    "displayName": "Dutch, Flemish",
                    "mappingDetails": []
                },
                {
                    "id": 3729,
                    "name": "654",
                    "platformId": 8,
                    "isActive": 1,
                    "platformName": "ViAds",
                    "displayName": "Persian",
                    "attributeMapping": 2487,
                    "mappingDetails": [
                        {
                            "id": 2487,
                            "name": "Persian",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Persian",
                            "dbMappingId": 999
                        }
                    ]
                },
                {
                    "id": 3731,
                    "name": "582",
                    "platformId": 8,
                    "isActive": 1,
                    "platformName": "ViAds",
                    "displayName": "German",
                    "attributeMapping": 2495,
                    "mappingDetails": [
                        {
                            "id": 2495,
                            "name": "German",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "German",
                            "dbMappingId": 1000
                        }
                    ]
                },
                {
                    "id": 3733,
                    "name": "618",
                    "platformId": 8,
                    "isActive": 1,
                    "platformName": "ViAds",
                    "displayName": "Kurdish",
                    "attributeMapping": 1995,
                    "mappingDetails": [
                        {
                            "id": 1995,
                            "name": "Kurdish",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Kurdish",
                            "dbMappingId": 1001
                        }
                    ]
                },
                {
                    "id": 3735,
                    "name": "659",
                    "platformId": 8,
                    "isActive": 1,
                    "platformName": "ViAds",
                    "displayName": "Romanian, Moldavian, Moldovan",
                    "mappingDetails": []
                },
                {
                    "id": 3737,
                    "name": "541",
                    "platformId": 8,
                    "isActive": 1,
                    "platformName": "ViAds",
                    "displayName": "Azerbaijani",
                    "attributeMapping": 2505,
                    "mappingDetails": [
                        {
                            "id": 2505,
                            "name": "Azerbaijani",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Azerbaijani",
                            "dbMappingId": 1003
                        }
                    ]
                },
                {
                    "id": 3739,
                    "name": "561",
                    "platformId": 8,
                    "isActive": 1,
                    "platformName": "ViAds",
                    "displayName": "Cree",
                    "attributeMapping": 2511,
                    "mappingDetails": [
                        {
                            "id": 2511,
                            "name": "Cree",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Cree",
                            "dbMappingId": 1004
                        }
                    ]
                },
                {
                    "id": 3741,
                    "name": "686",
                    "platformId": 8,
                    "isActive": 1,
                    "platformName": "ViAds",
                    "displayName": "Telugu",
                    "attributeMapping": 2519,
                    "mappingDetails": [
                        {
                            "id": 2519,
                            "name": "Telugu",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Telugu",
                            "dbMappingId": 1005
                        }
                    ]
                },
                {
                    "id": 3743,
                    "name": "575",
                    "platformId": 8,
                    "isActive": 1,
                    "platformName": "ViAds",
                    "displayName": "French",
                    "attributeMapping": 2001,
                    "mappingDetails": [
                        {
                            "id": 2001,
                            "name": "French",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "French",
                            "dbMappingId": 1006
                        }
                    ]
                },
                {
                    "id": 3745,
                    "name": "577",
                    "platformId": 8,
                    "isActive": 1,
                    "platformName": "ViAds",
                    "displayName": "Fulah",
                    "attributeMapping": 2011,
                    "mappingDetails": [
                        {
                            "id": 2011,
                            "name": "Fulah",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Fulah",
                            "dbMappingId": 1007
                        }
                    ]
                },
                {
                    "id": 3747,
                    "name": "631",
                    "platformId": 8,
                    "isActive": 1,
                    "platformName": "ViAds",
                    "displayName": "Maltese",
                    "attributeMapping": 2539,
                    "mappingDetails": [
                        {
                            "id": 2539,
                            "name": "Maltese",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Maltese",
                            "dbMappingId": 1008
                        }
                    ]
                },
                {
                    "id": 3749,
                    "name": "597",
                    "platformId": 8,
                    "isActive": 1,
                    "platformName": "ViAds",
                    "displayName": "Indonesian",
                    "attributeMapping": 2015,
                    "mappingDetails": [
                        {
                            "id": 2015,
                            "name": "Indonesian",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Indonesian",
                            "dbMappingId": 1009
                        }
                    ]
                },
                {
                    "id": 3751,
                    "name": "569",
                    "platformId": 8,
                    "isActive": 1,
                    "platformName": "ViAds",
                    "displayName": "Esperanto",
                    "attributeMapping": 2543,
                    "mappingDetails": [
                        {
                            "id": 2543,
                            "name": "Esperanto",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Esperanto",
                            "dbMappingId": 1010
                        }
                    ]
                },
                {
                    "id": 3753,
                    "name": "681",
                    "platformId": 8,
                    "isActive": 1,
                    "platformName": "ViAds",
                    "displayName": "Tagalog",
                    "attributeMapping": 2549,
                    "mappingDetails": [
                        {
                            "id": 2549,
                            "name": "Tagalog",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Tagalog",
                            "dbMappingId": 1011
                        }
                    ]
                },
                {
                    "id": 3755,
                    "name": "694",
                    "platformId": 8,
                    "isActive": 1,
                    "platformName": "ViAds",
                    "displayName": "Turkmen",
                    "attributeMapping": 2553,
                    "mappingDetails": [
                        {
                            "id": 2553,
                            "name": "Turkmen",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Turkmen",
                            "dbMappingId": 1012
                        }
                    ]
                },
                {
                    "id": 3757,
                    "name": "642",
                    "platformId": 8,
                    "isActive": 1,
                    "platformName": "ViAds",
                    "displayName": "Nepali",
                    "attributeMapping": 2557,
                    "mappingDetails": [
                        {
                            "id": 2557,
                            "name": "Nepali",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Nepali",
                            "dbMappingId": 1013
                        }
                    ]
                },
                {
                    "id": 3759,
                    "name": "581",
                    "platformId": 8,
                    "isActive": 1,
                    "platformName": "ViAds",
                    "displayName": "Georgian",
                    "attributeMapping": 2563,
                    "mappingDetails": [
                        {
                            "id": 2563,
                            "name": "Georgian",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Georgian",
                            "dbMappingId": 1014
                        }
                    ]
                },
                {
                    "id": 3761,
                    "name": "667",
                    "platformId": 8,
                    "isActive": 1,
                    "platformName": "ViAds",
                    "displayName": "Sardinian",
                    "attributeMapping": 2025,
                    "mappingDetails": [
                        {
                            "id": 2025,
                            "name": "Sardinian",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Sardinian",
                            "dbMappingId": 1015
                        }
                    ]
                },
                {
                    "id": 3763,
                    "name": "632",
                    "platformId": 8,
                    "isActive": 1,
                    "platformName": "ViAds",
                    "displayName": "Manx",
                    "attributeMapping": 2029,
                    "mappingDetails": [
                        {
                            "id": 2029,
                            "name": "Manx",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Manx",
                            "dbMappingId": 1016
                        }
                    ]
                },
                {
                    "id": 3765,
                    "name": "679",
                    "platformId": 8,
                    "isActive": 1,
                    "platformName": "ViAds",
                    "displayName": "Swati",
                    "attributeMapping": 2569,
                    "mappingDetails": [
                        {
                            "id": 2569,
                            "name": "Swati",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Swati",
                            "dbMappingId": 1017
                        }
                    ]
                },
                {
                    "id": 3767,
                    "name": "553",
                    "platformId": 8,
                    "isActive": 1,
                    "platformName": "ViAds",
                    "displayName": "Chamorro",
                    "attributeMapping": 2577,
                    "mappingDetails": [
                        {
                            "id": 2577,
                            "name": "Chamorro",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Chamorro",
                            "dbMappingId": 1018
                        }
                    ]
                },
                {
                    "id": 3769,
                    "name": "544",
                    "platformId": 8,
                    "isActive": 1,
                    "platformName": "ViAds",
                    "displayName": "Basque",
                    "attributeMapping": 2041,
                    "mappingDetails": [
                        {
                            "id": 2041,
                            "name": "Basque",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Basque",
                            "dbMappingId": 1019
                        }
                    ]
                },
                {
                    "id": 3771,
                    "name": "630",
                    "platformId": 8,
                    "isActive": 1,
                    "platformName": "ViAds",
                    "displayName": "Malayalam",
                    "attributeMapping": 2581,
                    "mappingDetails": [
                        {
                            "id": 2581,
                            "name": "Malayalam",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Malayalam",
                            "dbMappingId": 1020
                        }
                    ]
                },
                {
                    "id": 3773,
                    "name": "573",
                    "platformId": 8,
                    "isActive": 1,
                    "platformName": "ViAds",
                    "displayName": "Fijian",
                    "attributeMapping": 2047,
                    "mappingDetails": [
                        {
                            "id": 2047,
                            "name": "Fijian",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Fijian",
                            "dbMappingId": 1021
                        }
                    ]
                },
                {
                    "id": 3775,
                    "name": "624",
                    "platformId": 8,
                    "isActive": 1,
                    "platformName": "ViAds",
                    "displayName": "Lithuanian",
                    "attributeMapping": 2591,
                    "mappingDetails": [
                        {
                            "id": 2591,
                            "name": "Lithuanian",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Lithuanian",
                            "dbMappingId": 1022
                        }
                    ]
                },
                {
                    "id": 3777,
                    "name": "621",
                    "platformId": 8,
                    "isActive": 1,
                    "platformName": "ViAds",
                    "displayName": "Latvian",
                    "attributeMapping": 2051,
                    "mappingDetails": [
                        {
                            "id": 2051,
                            "name": "Latvian",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Latvian",
                            "dbMappingId": 1023
                        }
                    ]
                },
                {
                    "id": 3779,
                    "name": "539",
                    "platformId": 8,
                    "isActive": 1,
                    "platformName": "ViAds",
                    "displayName": "Avestan",
                    "attributeMapping": 2599,
                    "mappingDetails": [
                        {
                            "id": 2599,
                            "name": "Avestan",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Avestan",
                            "dbMappingId": 1024
                        }
                    ]
                },
                {
                    "id": 3781,
                    "name": "583",
                    "platformId": 8,
                    "isActive": 1,
                    "platformName": "ViAds",
                    "displayName": "Greek, Modern (1453–)",
                    "mappingDetails": []
                },
                {
                    "id": 3783,
                    "name": "616",
                    "platformId": 8,
                    "isActive": 1,
                    "platformName": "ViAds",
                    "displayName": "Korean",
                    "attributeMapping": 2603,
                    "mappingDetails": [
                        {
                            "id": 2603,
                            "name": "Korean",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Korean",
                            "dbMappingId": 1026
                        }
                    ]
                },
                {
                    "id": 3785,
                    "name": "537",
                    "platformId": 8,
                    "isActive": 1,
                    "platformName": "ViAds",
                    "displayName": "Assamese",
                    "attributeMapping": 2613,
                    "mappingDetails": [
                        {
                            "id": 2613,
                            "name": "Assamese",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Assamese",
                            "dbMappingId": 1027
                        }
                    ]
                },
                {
                    "id": 3787,
                    "name": "600",
                    "platformId": 8,
                    "isActive": 1,
                    "platformName": "ViAds",
                    "displayName": "Inuktitut",
                    "attributeMapping": 2619,
                    "mappingDetails": [
                        {
                            "id": 2619,
                            "name": "Inuktitut",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Inuktitut",
                            "dbMappingId": 1028
                        }
                    ]
                },
                {
                    "id": 3789,
                    "name": "652",
                    "platformId": 8,
                    "isActive": 1,
                    "platformName": "ViAds",
                    "displayName": "Pali",
                    "attributeMapping": 2623,
                    "mappingDetails": [
                        {
                            "id": 2623,
                            "name": "Pali",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Pali",
                            "dbMappingId": 1029
                        }
                    ]
                },
                {
                    "id": 3791,
                    "name": "684",
                    "platformId": 8,
                    "isActive": 1,
                    "platformName": "ViAds",
                    "displayName": "Tamil",
                    "attributeMapping": 2059,
                    "mappingDetails": [
                        {
                            "id": 2059,
                            "name": "Tamil",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Tamil",
                            "dbMappingId": 1030
                        }
                    ]
                },
                {
                    "id": 3793,
                    "name": "702",
                    "platformId": 8,
                    "isActive": 1,
                    "platformName": "ViAds",
                    "displayName": "Volapük",
                    "attributeMapping": 2069,
                    "mappingDetails": [
                        {
                            "id": 2069,
                            "name": "Volapük",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Volapük",
                            "dbMappingId": 1031
                        }
                    ]
                },
                {
                    "id": 3795,
                    "name": "555",
                    "platformId": 8,
                    "isActive": 1,
                    "platformName": "ViAds",
                    "displayName": "Chichewa, Chewa, Nyanja",
                    "attributeMapping": 2073,
                    "mappingDetails": [
                        {
                            "id": 2073,
                            "name": "Chichewa, Chewa, Nyanja",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Chichewa, Chewa, Nyanja",
                            "dbMappingId": 1032
                        }
                    ]
                },
                {
                    "id": 3797,
                    "name": "610",
                    "platformId": 8,
                    "isActive": 1,
                    "platformName": "ViAds",
                    "displayName": "Central Khmer",
                    "attributeMapping": 2633,
                    "mappingDetails": [
                        {
                            "id": 2633,
                            "name": "Central Khmer",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Central Khmer",
                            "dbMappingId": 1033
                        }
                    ]
                },
                {
                    "id": 3799,
                    "name": "617",
                    "platformId": 8,
                    "isActive": 1,
                    "platformName": "ViAds",
                    "displayName": "Kuanyama, Kwanyama",
                    "attributeMapping": 2077,
                    "mappingDetails": [
                        {
                            "id": 2077,
                            "name": "Kuanyama, Kwanyama",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Kuanyama, Kwanyama",
                            "dbMappingId": 1034
                        }
                    ]
                },
                {
                    "id": 3801,
                    "name": "538",
                    "platformId": 8,
                    "isActive": 1,
                    "platformName": "ViAds",
                    "displayName": "Avaric",
                    "attributeMapping": 2637,
                    "mappingDetails": [
                        {
                            "id": 2637,
                            "name": "Avaric",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Avaric",
                            "dbMappingId": 1035
                        }
                    ]
                },
                {
                    "id": 3803,
                    "name": "584",
                    "platformId": 8,
                    "isActive": 1,
                    "platformName": "ViAds",
                    "displayName": "Kalaallisut, Greenlandic",
                    "attributeMapping": 2641,
                    "mappingDetails": [
                        {
                            "id": 2641,
                            "name": "Kalaallisut, Greenlandic",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Kalaallisut, Greenlandic",
                            "dbMappingId": 1036
                        }
                    ]
                },
                {
                    "id": 3805,
                    "name": "556",
                    "platformId": 8,
                    "isActive": 1,
                    "platformName": "ViAds",
                    "displayName": "Chinese",
                    "attributeMapping": 2655,
                    "mappingDetails": [
                        {
                            "id": 2655,
                            "name": "Chinese",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Chinese",
                            "dbMappingId": 1037
                        }
                    ]
                },
                {
                    "id": 3807,
                    "name": "635",
                    "platformId": 8,
                    "isActive": 1,
                    "platformName": "ViAds",
                    "displayName": "Marshallese",
                    "attributeMapping": 2081,
                    "mappingDetails": [
                        {
                            "id": 2081,
                            "name": "Marshallese",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Marshallese",
                            "dbMappingId": 1038
                        }
                    ]
                },
                {
                    "id": 3809,
                    "name": "701",
                    "platformId": 8,
                    "isActive": 1,
                    "platformName": "ViAds",
                    "displayName": "Vietnamese",
                    "attributeMapping": 2645,
                    "mappingDetails": [
                        {
                            "id": 2645,
                            "name": "Vietnamese",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Vietnamese",
                            "dbMappingId": 1039
                        }
                    ]
                },
                {
                    "id": 3811,
                    "name": "563",
                    "platformId": 8,
                    "isActive": 1,
                    "platformName": "ViAds",
                    "displayName": "Czech",
                    "attributeMapping": 2085,
                    "mappingDetails": [
                        {
                            "id": 2085,
                            "name": "Czech",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Czech",
                            "dbMappingId": 1040
                        }
                    ]
                },
                {
                    "id": 3813,
                    "name": "579",
                    "platformId": 8,
                    "isActive": 1,
                    "platformName": "ViAds",
                    "displayName": "Galician",
                    "attributeMapping": 2661,
                    "mappingDetails": [
                        {
                            "id": 2661,
                            "name": "Galician",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Galician",
                            "dbMappingId": 1041
                        }
                    ]
                },
                {
                    "id": 3815,
                    "name": "619",
                    "platformId": 8,
                    "isActive": 1,
                    "platformName": "ViAds",
                    "displayName": "Lao",
                    "attributeMapping": 2667,
                    "mappingDetails": [
                        {
                            "id": 2667,
                            "name": "Lao",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Lao",
                            "dbMappingId": 1042
                        }
                    ]
                },
                {
                    "id": 3817,
                    "name": "674",
                    "platformId": 8,
                    "isActive": 1,
                    "platformName": "ViAds",
                    "displayName": "Somali",
                    "attributeMapping": 2671,
                    "mappingDetails": [
                        {
                            "id": 2671,
                            "name": "Somali",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Somali",
                            "dbMappingId": 1043
                        }
                    ]
                },
                {
                    "id": 3819,
                    "name": "671",
                    "platformId": 8,
                    "isActive": 1,
                    "platformName": "ViAds",
                    "displayName": "Sinhala, Sinhalese",
                    "attributeMapping": 2105,
                    "mappingDetails": [
                        {
                            "id": 2105,
                            "name": "Sinhala, Sinhalese",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Sinhala, Sinhalese",
                            "dbMappingId": 1044
                        }
                    ]
                },
                {
                    "id": 3821,
                    "name": "666",
                    "platformId": 8,
                    "isActive": 1,
                    "platformName": "ViAds",
                    "displayName": "Sanskrit",
                    "attributeMapping": 2675,
                    "mappingDetails": [
                        {
                            "id": 2675,
                            "name": "Sanskrit",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Sanskrit",
                            "dbMappingId": 1045
                        }
                    ]
                },
                {
                    "id": 3823,
                    "name": "672",
                    "platformId": 8,
                    "isActive": 1,
                    "platformName": "ViAds",
                    "displayName": "Slovak",
                    "attributeMapping": 2679,
                    "mappingDetails": [
                        {
                            "id": 2679,
                            "name": "Slovak",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Slovak",
                            "dbMappingId": 1046
                        }
                    ]
                },
                {
                    "id": 3825,
                    "name": "548",
                    "platformId": 8,
                    "isActive": 1,
                    "platformName": "ViAds",
                    "displayName": "Bosnian",
                    "attributeMapping": 2121,
                    "mappingDetails": [
                        {
                            "id": 2121,
                            "name": "Bosnian",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Bosnian",
                            "dbMappingId": 1047
                        }
                    ]
                },
                {
                    "id": 3827,
                    "name": "662",
                    "platformId": 8,
                    "isActive": 1,
                    "platformName": "ViAds",
                    "displayName": "Russian",
                    "attributeMapping": 2111,
                    "mappingDetails": [
                        {
                            "id": 2111,
                            "name": "Russian",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Russian",
                            "dbMappingId": 1048
                        }
                    ]
                },
                {
                    "id": 3829,
                    "name": "657",
                    "platformId": 8,
                    "isActive": 1,
                    "platformName": "ViAds",
                    "displayName": "Punjabi, Panjabi",
                    "mappingDetails": []
                },
                {
                    "id": 3831,
                    "name": "545",
                    "platformId": 8,
                    "isActive": 1,
                    "platformName": "ViAds",
                    "displayName": "Belarusian",
                    "attributeMapping": 2699,
                    "mappingDetails": [
                        {
                            "id": 2699,
                            "name": "Belarusian",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Belarusian",
                            "dbMappingId": 1050
                        }
                    ]
                },
                {
                    "id": 3833,
                    "name": "615",
                    "platformId": 8,
                    "isActive": 1,
                    "platformName": "ViAds",
                    "displayName": "Kongo",
                    "attributeMapping": 2705,
                    "mappingDetails": [
                        {
                            "id": 2705,
                            "name": "Kongo",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Kongo",
                            "dbMappingId": 1051
                        }
                    ]
                },
                {
                    "id": 3835,
                    "name": "668",
                    "platformId": 8,
                    "isActive": 1,
                    "platformName": "ViAds",
                    "displayName": "Serbian",
                    "attributeMapping": 2691,
                    "mappingDetails": [
                        {
                            "id": 2691,
                            "name": "Serbian",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Serbian",
                            "dbMappingId": 1052
                        }
                    ]
                },
                {
                    "id": 3837,
                    "name": "634",
                    "platformId": 8,
                    "isActive": 1,
                    "platformName": "ViAds",
                    "displayName": "Marathi",
                    "attributeMapping": 2709,
                    "mappingDetails": [
                        {
                            "id": 2709,
                            "name": "Marathi",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Marathi",
                            "dbMappingId": 1053
                        }
                    ]
                },
                {
                    "id": 3839,
                    "name": "653",
                    "platformId": 8,
                    "isActive": 1,
                    "platformName": "ViAds",
                    "displayName": "Pashto, Pushto",
                    "attributeMapping": 2719,
                    "mappingDetails": [
                        {
                            "id": 2719,
                            "name": "Pashto, Pushto",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Pashto, Pushto",
                            "dbMappingId": 1054
                        }
                    ]
                },
                {
                    "id": 3841,
                    "name": "599",
                    "platformId": 8,
                    "isActive": 1,
                    "platformName": "ViAds",
                    "displayName": "Interlingue, Occidental",
                    "attributeMapping": 2127,
                    "mappingDetails": [
                        {
                            "id": 2127,
                            "name": "Interlingue, Occidental",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Interlingue, Occidental",
                            "dbMappingId": 1055
                        }
                    ]
                },
                {
                    "id": 3843,
                    "name": "661",
                    "platformId": 8,
                    "isActive": 1,
                    "platformName": "ViAds",
                    "displayName": "Rundi",
                    "attributeMapping": 2131,
                    "mappingDetails": [
                        {
                            "id": 2131,
                            "name": "Rundi",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Rundi",
                            "dbMappingId": 1056
                        }
                    ]
                },
                {
                    "id": 3845,
                    "name": "703",
                    "platformId": 8,
                    "isActive": 1,
                    "platformName": "ViAds",
                    "displayName": "Walloon",
                    "attributeMapping": 2725,
                    "mappingDetails": [
                        {
                            "id": 2725,
                            "name": "Walloon",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Walloon",
                            "dbMappingId": 1057
                        }
                    ]
                },
                {
                    "id": 3847,
                    "name": "640",
                    "platformId": 8,
                    "isActive": 1,
                    "platformName": "ViAds",
                    "displayName": "South Ndebele",
                    "attributeMapping": 2729,
                    "mappingDetails": [
                        {
                            "id": 2729,
                            "name": "South Ndebele",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "South Ndebele",
                            "dbMappingId": 1058
                        }
                    ]
                },
                {
                    "id": 3849,
                    "name": "664",
                    "platformId": 8,
                    "isActive": 1,
                    "platformName": "ViAds",
                    "displayName": "Samoan",
                    "attributeMapping": 2733,
                    "mappingDetails": [
                        {
                            "id": 2733,
                            "name": "Samoan",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Samoan",
                            "dbMappingId": 1059
                        }
                    ]
                },
                {
                    "id": 3851,
                    "name": "612",
                    "platformId": 8,
                    "isActive": 1,
                    "platformName": "ViAds",
                    "displayName": "Kinyarwanda",
                    "attributeMapping": 2135,
                    "mappingDetails": [
                        {
                            "id": 2135,
                            "name": "Kinyarwanda",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Kinyarwanda",
                            "dbMappingId": 1060
                        }
                    ]
                },
                {
                    "id": 3853,
                    "name": "613",
                    "platformId": 8,
                    "isActive": 1,
                    "platformName": "ViAds",
                    "displayName": "Kirghiz, Kyrgyz",
                    "attributeMapping": 2737,
                    "mappingDetails": [
                        {
                            "id": 2737,
                            "name": "Kirghiz, Kyrgyz",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Kirghiz, Kyrgyz",
                            "dbMappingId": 1061
                        }
                    ]
                },
                {
                    "id": 3855,
                    "name": "683",
                    "platformId": 8,
                    "isActive": 1,
                    "platformName": "ViAds",
                    "displayName": "Tajik",
                    "attributeMapping": 2741,
                    "mappingDetails": [
                        {
                            "id": 2741,
                            "name": "Tajik",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Tajik",
                            "dbMappingId": 1062
                        }
                    ]
                },
                {
                    "id": 3857,
                    "name": "534",
                    "platformId": 8,
                    "isActive": 1,
                    "platformName": "ViAds",
                    "displayName": "Arabic",
                    "attributeMapping": 2747,
                    "mappingDetails": [
                        {
                            "id": 2747,
                            "name": "Arabic",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Arabic",
                            "dbMappingId": 1063
                        }
                    ]
                },
                {
                    "id": 3859,
                    "name": "542",
                    "platformId": 8,
                    "isActive": 1,
                    "platformName": "ViAds",
                    "displayName": "Bambara",
                    "attributeMapping": 2139,
                    "mappingDetails": [
                        {
                            "id": 2139,
                            "name": "Bambara",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Bambara",
                            "dbMappingId": 1064
                        }
                    ]
                },
                {
                    "id": 3861,
                    "name": "559",
                    "platformId": 8,
                    "isActive": 1,
                    "platformName": "ViAds",
                    "displayName": "Cornish",
                    "attributeMapping": 2757,
                    "mappingDetails": [
                        {
                            "id": 2757,
                            "name": "Cornish",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Cornish",
                            "dbMappingId": 1065
                        }
                    ]
                },
                {
                    "id": 3863,
                    "name": "535",
                    "platformId": 8,
                    "isActive": 1,
                    "platformName": "ViAds",
                    "displayName": "Aragonese",
                    "attributeMapping": 2761,
                    "mappingDetails": [
                        {
                            "id": 2761,
                            "name": "Aragonese",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Aragonese",
                            "dbMappingId": 1066
                        }
                    ]
                },
                {
                    "id": 3865,
                    "name": "656",
                    "platformId": 8,
                    "isActive": 1,
                    "platformName": "ViAds",
                    "displayName": "Portuguese",
                    "attributeMapping": 2143,
                    "mappingDetails": [
                        {
                            "id": 2143,
                            "name": "Portuguese",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Portuguese",
                            "dbMappingId": 1067
                        }
                    ]
                },
                {
                    "id": 3867,
                    "name": "595",
                    "platformId": 8,
                    "isActive": 1,
                    "platformName": "ViAds",
                    "displayName": "Ido",
                    "attributeMapping": 2153,
                    "mappingDetails": [
                        {
                            "id": 2153,
                            "name": "Ido",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Ido",
                            "dbMappingId": 1068
                        }
                    ]
                },
                {
                    "id": 3869,
                    "name": "591",
                    "platformId": 8,
                    "isActive": 1,
                    "platformName": "ViAds",
                    "displayName": "Hindi",
                    "attributeMapping": 2157,
                    "mappingDetails": [
                        {
                            "id": 2157,
                            "name": "Hindi",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Hindi",
                            "dbMappingId": 1069
                        }
                    ]
                },
                {
                    "id": 3871,
                    "name": "687",
                    "platformId": 8,
                    "isActive": 1,
                    "platformName": "ViAds",
                    "displayName": "Thai",
                    "attributeMapping": 2773,
                    "mappingDetails": [
                        {
                            "id": 2773,
                            "name": "Thai",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Thai",
                            "dbMappingId": 1070
                        }
                    ]
                },
                {
                    "id": 3873,
                    "name": "643",
                    "platformId": 8,
                    "isActive": 1,
                    "platformName": "ViAds",
                    "displayName": "Norwegian",
                    "attributeMapping": 2167,
                    "mappingDetails": [
                        {
                            "id": 2167,
                            "name": "Norwegian",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Norwegian",
                            "dbMappingId": 1071
                        }
                    ]
                },
                {
                    "id": 3875,
                    "name": "628",
                    "platformId": 8,
                    "isActive": 1,
                    "platformName": "ViAds",
                    "displayName": "Malagasy",
                    "attributeMapping": 2787,
                    "mappingDetails": [
                        {
                            "id": 2787,
                            "name": "Malagasy",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Malagasy",
                            "dbMappingId": 1072
                        }
                    ]
                },
                {
                    "id": 3877,
                    "name": "689",
                    "platformId": 8,
                    "isActive": 1,
                    "platformName": "ViAds",
                    "displayName": "Tigrinya",
                    "attributeMapping": 2791,
                    "mappingDetails": [
                        {
                            "id": 2791,
                            "name": "Tigrinya",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Tigrinya",
                            "dbMappingId": 1073
                        }
                    ]
                },
                {
                    "id": 3879,
                    "name": "660",
                    "platformId": 8,
                    "isActive": 1,
                    "platformName": "ViAds",
                    "displayName": "Romansh",
                    "attributeMapping": 2795,
                    "mappingDetails": [
                        {
                            "id": 2795,
                            "name": "Romansh",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Romansh",
                            "dbMappingId": 1074
                        }
                    ]
                },
                {
                    "id": 3881,
                    "name": "647",
                    "platformId": 8,
                    "isActive": 1,
                    "platformName": "ViAds",
                    "displayName": "Occitan",
                    "attributeMapping": 2799,
                    "mappingDetails": [
                        {
                            "id": 2799,
                            "name": "Occitan",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Occitan",
                            "dbMappingId": 1075
                        }
                    ]
                },
                {
                    "id": 3883,
                    "name": "552",
                    "platformId": 8,
                    "isActive": 1,
                    "platformName": "ViAds",
                    "displayName": "Catalan, Valencian",
                    "attributeMapping": 2173,
                    "mappingDetails": [
                        {
                            "id": 2173,
                            "name": "Catalan, Valencian",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Catalan, Valencian",
                            "dbMappingId": 1076
                        }
                    ]
                },
                {
                    "id": 3885,
                    "name": "602",
                    "platformId": 8,
                    "isActive": 1,
                    "platformName": "ViAds",
                    "displayName": "Irish",
                    "attributeMapping": 2177,
                    "mappingDetails": [
                        {
                            "id": 2177,
                            "name": "Irish",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Irish",
                            "dbMappingId": 1077
                        }
                    ]
                },
                {
                    "id": 3887,
                    "name": "585",
                    "platformId": 8,
                    "isActive": 1,
                    "platformName": "ViAds",
                    "displayName": "Guarani",
                    "attributeMapping": 2183,
                    "mappingDetails": [
                        {
                            "id": 2183,
                            "name": "Guarani",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Guarani",
                            "dbMappingId": 1078
                        }
                    ]
                },
                {
                    "id": 3889,
                    "name": "558",
                    "platformId": 8,
                    "isActive": 1,
                    "platformName": "ViAds",
                    "displayName": "Chuvash",
                    "attributeMapping": 2189,
                    "mappingDetails": [
                        {
                            "id": 2189,
                            "name": "Chuvash",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Chuvash",
                            "dbMappingId": 1079
                        }
                    ]
                },
                {
                    "id": 3891,
                    "name": "609",
                    "platformId": 8,
                    "isActive": 1,
                    "platformName": "ViAds",
                    "displayName": "Kazakh",
                    "attributeMapping": 2193,
                    "mappingDetails": [
                        {
                            "id": 2193,
                            "name": "Kazakh",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Kazakh",
                            "dbMappingId": 1080
                        }
                    ]
                },
                {
                    "id": 3893,
                    "name": "551",
                    "platformId": 8,
                    "isActive": 1,
                    "platformName": "ViAds",
                    "displayName": "Burmese",
                    "attributeMapping": 2811,
                    "mappingDetails": [
                        {
                            "id": 2811,
                            "name": "Burmese",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Burmese",
                            "dbMappingId": 1081
                        }
                    ]
                },
                {
                    "id": 3895,
                    "name": "605",
                    "platformId": 8,
                    "isActive": 1,
                    "platformName": "ViAds",
                    "displayName": "Javanese",
                    "attributeMapping": 2199,
                    "mappingDetails": [
                        {
                            "id": 2199,
                            "name": "Javanese",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Javanese",
                            "dbMappingId": 1082
                        }
                    ]
                },
                {
                    "id": 3897,
                    "name": "709",
                    "platformId": 8,
                    "isActive": 1,
                    "platformName": "ViAds",
                    "displayName": "Zhuang, Chuang",
                    "mappingDetails": []
                },
                {
                    "id": 3899,
                    "name": "705",
                    "platformId": 8,
                    "isActive": 1,
                    "platformName": "ViAds",
                    "displayName": "Wolof",
                    "attributeMapping": 2815,
                    "mappingDetails": [
                        {
                            "id": 2815,
                            "name": "Wolof",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Wolof",
                            "dbMappingId": 1084
                        }
                    ]
                },
                {
                    "id": 3901,
                    "name": "601",
                    "platformId": 8,
                    "isActive": 1,
                    "platformName": "ViAds",
                    "displayName": "Inupiaq",
                    "attributeMapping": 2819,
                    "mappingDetails": [
                        {
                            "id": 2819,
                            "name": "Inupiaq",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Inupiaq",
                            "dbMappingId": 1085
                        }
                    ]
                },
                {
                    "id": 3903,
                    "name": "620",
                    "platformId": 8,
                    "isActive": 1,
                    "platformName": "ViAds",
                    "displayName": "Latin",
                    "attributeMapping": 2209,
                    "mappingDetails": [
                        {
                            "id": 2209,
                            "name": "Latin",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Latin",
                            "dbMappingId": 1086
                        }
                    ]
                },
                {
                    "id": 3905,
                    "name": "646",
                    "platformId": 8,
                    "isActive": 1,
                    "platformName": "ViAds",
                    "displayName": "Sichuan Yi, Nuosu",
                    "attributeMapping": 2823,
                    "mappingDetails": [
                        {
                            "id": 2823,
                            "name": "Sichuan Yi, Nuosu",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Sichuan Yi, Nuosu",
                            "dbMappingId": 1087
                        }
                    ]
                },
                {
                    "id": 3907,
                    "name": "547",
                    "platformId": 8,
                    "isActive": 1,
                    "platformName": "ViAds",
                    "displayName": "Bislama",
                    "attributeMapping": 2827,
                    "mappingDetails": [
                        {
                            "id": 2827,
                            "name": "Bislama",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Bislama",
                            "dbMappingId": 1088
                        }
                    ]
                },
                {
                    "id": 3909,
                    "name": "637",
                    "platformId": 8,
                    "isActive": 1,
                    "platformName": "ViAds",
                    "displayName": "Nauru",
                    "attributeMapping": 2217,
                    "mappingDetails": [
                        {
                            "id": 2217,
                            "name": "Nauru",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Nauru",
                            "dbMappingId": 1089
                        }
                    ]
                },
                {
                    "id": 3911,
                    "name": "608",
                    "platformId": 8,
                    "isActive": 1,
                    "platformName": "ViAds",
                    "displayName": "Kashmiri",
                    "attributeMapping": 2837,
                    "mappingDetails": [
                        {
                            "id": 2837,
                            "name": "Kashmiri",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Kashmiri",
                            "dbMappingId": 1090
                        }
                    ]
                },
                {
                    "id": 3913,
                    "name": "649",
                    "platformId": 8,
                    "isActive": 1,
                    "platformName": "ViAds",
                    "displayName": "Oriya",
                    "attributeMapping": 2221,
                    "mappingDetails": [
                        {
                            "id": 2221,
                            "name": "Oriya",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Oriya",
                            "dbMappingId": 1091
                        }
                    ]
                },
                {
                    "id": 3915,
                    "name": "603",
                    "platformId": 8,
                    "isActive": 1,
                    "platformName": "ViAds",
                    "displayName": "Italian",
                    "attributeMapping": 2227,
                    "mappingDetails": [
                        {
                            "id": 2227,
                            "name": "Italian",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Italian",
                            "dbMappingId": 1092
                        }
                    ]
                },
                {
                    "id": 3917,
                    "name": "560",
                    "platformId": 8,
                    "isActive": 1,
                    "platformName": "ViAds",
                    "displayName": "Corsican",
                    "attributeMapping": 2237,
                    "mappingDetails": [
                        {
                            "id": 2237,
                            "name": "Corsican",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Corsican",
                            "dbMappingId": 1093
                        }
                    ]
                },
                {
                    "id": 3919,
                    "name": "638",
                    "platformId": 8,
                    "isActive": 1,
                    "platformName": "ViAds",
                    "displayName": "Navajo, Navaho",
                    "attributeMapping": 2841,
                    "mappingDetails": [
                        {
                            "id": 2841,
                            "name": "Navajo, Navaho",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Navajo, Navaho",
                            "dbMappingId": 1094
                        }
                    ]
                },
                {
                    "id": 3921,
                    "name": "691",
                    "platformId": 8,
                    "isActive": 1,
                    "platformName": "ViAds",
                    "displayName": "Tsonga",
                    "attributeMapping": 2845,
                    "mappingDetails": [
                        {
                            "id": 2845,
                            "name": "Tsonga",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Tsonga",
                            "dbMappingId": 1095
                        }
                    ]
                },
                {
                    "id": 3923,
                    "name": "530",
                    "platformId": 8,
                    "isActive": 1,
                    "platformName": "ViAds",
                    "displayName": "Afrikaans",
                    "attributeMapping": 2849,
                    "mappingDetails": [
                        {
                            "id": 2849,
                            "name": "Afrikaans",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Afrikaans",
                            "dbMappingId": 1096
                        }
                    ]
                },
                {
                    "id": 3925,
                    "name": "708",
                    "platformId": 8,
                    "isActive": 1,
                    "platformName": "ViAds",
                    "displayName": "Yoruba",
                    "attributeMapping": 2855,
                    "mappingDetails": [
                        {
                            "id": 2855,
                            "name": "Yoruba",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Yoruba",
                            "dbMappingId": 1097
                        }
                    ]
                },
                {
                    "id": 3927,
                    "name": "648",
                    "platformId": 8,
                    "isActive": 1,
                    "platformName": "ViAds",
                    "displayName": "Ojibwa",
                    "attributeMapping": 2241,
                    "mappingDetails": [
                        {
                            "id": 2241,
                            "name": "Ojibwa",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Ojibwa",
                            "dbMappingId": 1098
                        }
                    ]
                },
                {
                    "id": 3929,
                    "name": "673",
                    "platformId": 8,
                    "isActive": 1,
                    "platformName": "ViAds",
                    "displayName": "Slovenian",
                    "attributeMapping": 2245,
                    "mappingDetails": [
                        {
                            "id": 2245,
                            "name": "Slovenian",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Slovenian",
                            "dbMappingId": 1099
                        }
                    ]
                },
                {
                    "id": 3931,
                    "name": "598",
                    "platformId": 8,
                    "isActive": 1,
                    "platformName": "ViAds",
                    "displayName": "Interlingua (International Auxiliary Language Association)",
                    "attributeMapping": 2859,
                    "mappingDetails": [
                        {
                            "id": 2859,
                            "name": "Interlingua (International Auxiliary Language Association)",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Interlingua (International Auxiliary Language Association)",
                            "dbMappingId": 1100
                        }
                    ]
                },
                {
                    "id": 3933,
                    "name": "571",
                    "platformId": 8,
                    "isActive": 1,
                    "platformName": "ViAds",
                    "displayName": "Ewe",
                    "attributeMapping": 2863,
                    "mappingDetails": [
                        {
                            "id": 2863,
                            "name": "Ewe",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Ewe",
                            "dbMappingId": 1101
                        }
                    ]
                },
                {
                    "id": 3935,
                    "name": "644",
                    "platformId": 8,
                    "isActive": 1,
                    "platformName": "ViAds",
                    "displayName": "Norwegian Bokmål",
                    "attributeMapping": 2253,
                    "mappingDetails": [
                        {
                            "id": 2253,
                            "name": "Norwegian Bokmål",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Norwegian Bokmål",
                            "dbMappingId": 1102
                        }
                    ]
                },
                {
                    "id": 3937,
                    "name": "700",
                    "platformId": 8,
                    "isActive": 1,
                    "platformName": "ViAds",
                    "displayName": "Venda",
                    "attributeMapping": 2259,
                    "mappingDetails": [
                        {
                            "id": 2259,
                            "name": "Venda",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Venda",
                            "dbMappingId": 1103
                        }
                    ]
                },
                {
                    "id": 3939,
                    "name": "633",
                    "platformId": 8,
                    "isActive": 1,
                    "platformName": "ViAds",
                    "displayName": "Maori",
                    "attributeMapping": 2263,
                    "mappingDetails": [
                        {
                            "id": 2263,
                            "name": "Maori",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Maori",
                            "dbMappingId": 1104
                        }
                    ]
                },
                {
                    "id": 3941,
                    "name": "574",
                    "platformId": 8,
                    "isActive": 1,
                    "platformName": "ViAds",
                    "displayName": "Finnish",
                    "attributeMapping": 2875,
                    "mappingDetails": [
                        {
                            "id": 2875,
                            "name": "Finnish",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Finnish",
                            "dbMappingId": 1105
                        }
                    ]
                },
                {
                    "id": 3943,
                    "name": "540",
                    "platformId": 8,
                    "isActive": 1,
                    "platformName": "ViAds",
                    "displayName": "Aymara",
                    "attributeMapping": 2267,
                    "mappingDetails": [
                        {
                            "id": 2267,
                            "name": "Aymara",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Aymara",
                            "dbMappingId": 1106
                        }
                    ]
                },
                {
                    "id": 3945,
                    "name": "532",
                    "platformId": 8,
                    "isActive": 1,
                    "platformName": "ViAds",
                    "displayName": "Albanian",
                    "attributeMapping": 2885,
                    "mappingDetails": [
                        {
                            "id": 2885,
                            "name": "Albanian",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Albanian",
                            "dbMappingId": 1107
                        }
                    ]
                },
                {
                    "id": 3947,
                    "name": "650",
                    "platformId": 8,
                    "isActive": 1,
                    "platformName": "ViAds",
                    "displayName": "Oromo",
                    "attributeMapping": 2891,
                    "mappingDetails": [
                        {
                            "id": 2891,
                            "name": "Oromo",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Oromo",
                            "dbMappingId": 1108
                        }
                    ]
                },
                {
                    "id": 3949,
                    "name": "651",
                    "platformId": 8,
                    "isActive": 1,
                    "platformName": "ViAds",
                    "displayName": "Ossetian, Ossetic",
                    "attributeMapping": 2271,
                    "mappingDetails": [
                        {
                            "id": 2271,
                            "name": "Ossetian, Ossetic",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Ossetian, Ossetic",
                            "dbMappingId": 1109
                        }
                    ]
                },
                {
                    "id": 3951,
                    "name": "626",
                    "platformId": 8,
                    "isActive": 1,
                    "platformName": "ViAds",
                    "displayName": "Luxembourgish, Letzeburgesch",
                    "attributeMapping": 2275,
                    "mappingDetails": [
                        {
                            "id": 2275,
                            "name": "Luxembourgish, Letzeburgesch",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Luxembourgish, Letzeburgesch",
                            "dbMappingId": 1110
                        }
                    ]
                },
                {
                    "id": 3953,
                    "name": "655",
                    "platformId": 8,
                    "isActive": 1,
                    "platformName": "ViAds",
                    "displayName": "Polish",
                    "attributeMapping": 2895,
                    "mappingDetails": [
                        {
                            "id": 2895,
                            "name": "Polish",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Polish",
                            "dbMappingId": 1111
                        }
                    ]
                },
                {
                    "id": 3955,
                    "name": "706",
                    "platformId": 8,
                    "isActive": 1,
                    "platformName": "ViAds",
                    "displayName": "Xhosa",
                    "attributeMapping": 2279,
                    "mappingDetails": [
                        {
                            "id": 2279,
                            "name": "Xhosa",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Xhosa",
                            "dbMappingId": 1112
                        }
                    ]
                },
                {
                    "id": 3957,
                    "name": "565",
                    "platformId": 8,
                    "isActive": 1,
                    "platformName": "ViAds",
                    "displayName": "Divehi, Dhivehi, Maldivian",
                    "attributeMapping": 2905,
                    "mappingDetails": [
                        {
                            "id": 2905,
                            "name": "Divehi, Dhivehi, Maldivian",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Divehi, Dhivehi, Maldivian",
                            "dbMappingId": 1113
                        }
                    ]
                },
                {
                    "id": 3959,
                    "name": "531",
                    "platformId": 8,
                    "isActive": 1,
                    "platformName": "ViAds",
                    "displayName": "Akan",
                    "attributeMapping": 2909,
                    "mappingDetails": [
                        {
                            "id": 2909,
                            "name": "Akan",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Akan",
                            "dbMappingId": 1114
                        }
                    ]
                },
                {
                    "id": 3961,
                    "name": "550",
                    "platformId": 8,
                    "isActive": 1,
                    "platformName": "ViAds",
                    "displayName": "Bulgarian",
                    "attributeMapping": 2913,
                    "mappingDetails": [
                        {
                            "id": 2913,
                            "name": "Bulgarian",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Bulgarian",
                            "dbMappingId": 1115
                        }
                    ]
                },
                {
                    "id": 3963,
                    "name": "704",
                    "platformId": 8,
                    "isActive": 1,
                    "platformName": "ViAds",
                    "displayName": "Welsh",
                    "attributeMapping": 2283,
                    "mappingDetails": [
                        {
                            "id": 2283,
                            "name": "Welsh",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Welsh",
                            "dbMappingId": 1116
                        }
                    ]
                },
                {
                    "id": 3965,
                    "name": "572",
                    "platformId": 8,
                    "isActive": 1,
                    "platformName": "ViAds",
                    "displayName": "Faroese",
                    "attributeMapping": 2289,
                    "mappingDetails": [
                        {
                            "id": 2289,
                            "name": "Faroese",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Faroese",
                            "dbMappingId": 1117
                        }
                    ]
                },
                {
                    "id": 3967,
                    "name": "590",
                    "platformId": 8,
                    "isActive": 1,
                    "platformName": "ViAds",
                    "displayName": "Herero",
                    "attributeMapping": 2295,
                    "mappingDetails": [
                        {
                            "id": 2295,
                            "name": "Herero",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Herero",
                            "dbMappingId": 1118
                        }
                    ]
                },
                {
                    "id": 3969,
                    "name": "588",
                    "platformId": 8,
                    "isActive": 1,
                    "platformName": "ViAds",
                    "displayName": "Hausa",
                    "attributeMapping": 2921,
                    "mappingDetails": [
                        {
                            "id": 2921,
                            "name": "Hausa",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Hausa",
                            "dbMappingId": 1119
                        }
                    ]
                },
                {
                    "id": 3971,
                    "name": "562",
                    "platformId": 8,
                    "isActive": 1,
                    "platformName": "ViAds",
                    "displayName": "Croatian",
                    "attributeMapping": 2299,
                    "mappingDetails": [
                        {
                            "id": 2299,
                            "name": "Croatian",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Croatian",
                            "dbMappingId": 1120
                        }
                    ]
                },
                {
                    "id": 3973,
                    "name": "658",
                    "platformId": 8,
                    "isActive": 1,
                    "platformName": "ViAds",
                    "displayName": "Quechua",
                    "attributeMapping": 2925,
                    "mappingDetails": [
                        {
                            "id": 2925,
                            "name": "Quechua",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Quechua",
                            "dbMappingId": 1121
                        }
                    ]
                },
                {
                    "id": 3975,
                    "name": "576",
                    "platformId": 8,
                    "isActive": 1,
                    "platformName": "ViAds",
                    "displayName": "Western Frisian",
                    "attributeMapping": 2929,
                    "mappingDetails": [
                        {
                            "id": 2929,
                            "name": "Western Frisian",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Western Frisian",
                            "dbMappingId": 1122
                        }
                    ]
                },
                {
                    "id": 3977,
                    "name": "568",
                    "platformId": 8,
                    "isActive": 1,
                    "platformName": "ViAds",
                    "displayName": "English",
                    "attributeMapping": 2935,
                    "mappingDetails": [
                        {
                            "id": 2935,
                            "name": "English",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "English",
                            "dbMappingId": 1123
                        }
                    ]
                },
                {
                    "id": 3979,
                    "name": "564",
                    "platformId": 8,
                    "isActive": 1,
                    "platformName": "ViAds",
                    "displayName": "Danish",
                    "attributeMapping": 2311,
                    "mappingDetails": [
                        {
                            "id": 2311,
                            "name": "Danish",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Danish",
                            "dbMappingId": 1124
                        }
                    ]
                },
                {
                    "id": 3981,
                    "name": "593",
                    "platformId": 8,
                    "isActive": 1,
                    "platformName": "ViAds",
                    "displayName": "Hungarian",
                    "attributeMapping": 2945,
                    "mappingDetails": [
                        {
                            "id": 2945,
                            "name": "Hungarian",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Hungarian",
                            "dbMappingId": 1125
                        }
                    ]
                },
                {
                    "id": 3983,
                    "name": "533",
                    "platformId": 8,
                    "isActive": 1,
                    "platformName": "ViAds",
                    "displayName": "Amharic",
                    "attributeMapping": 2319,
                    "mappingDetails": [
                        {
                            "id": 2319,
                            "name": "Amharic",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Amharic",
                            "dbMappingId": 1126
                        }
                    ]
                },
                {
                    "id": 3985,
                    "name": "592",
                    "platformId": 8,
                    "isActive": 1,
                    "platformName": "ViAds",
                    "displayName": "Hiri Motu",
                    "attributeMapping": 2965,
                    "mappingDetails": [
                        {
                            "id": 2965,
                            "name": "Hiri Motu",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Hiri Motu",
                            "dbMappingId": 1127
                        }
                    ]
                },
                {
                    "id": 3987,
                    "name": "692",
                    "platformId": 8,
                    "isActive": 1,
                    "platformName": "ViAds",
                    "displayName": "Tswana",
                    "attributeMapping": 2333,
                    "mappingDetails": [
                        {
                            "id": 2333,
                            "name": "Tswana",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Tswana",
                            "dbMappingId": 1128
                        }
                    ]
                }
            ]
        },
        {
            "id": 103,
            "name": "Pacing_Type",
            "platformId": 7,
            "isActive": 1,
            "platformName": "TikTok",
            "displayName": "",
            "description": "",
            "attributeMapping": 1,
            "mappingDetails": [
                {
                    "id": 1,
                    "name": "Pacing_Type",
                    "platformId": 1,
                    "isActive": 1,
                    "platformName": "Beki",
                    "displayName": "Pacing Type",
                    "description": ""
                }
            ],
            "mappedPlatformsValueSet": [],
            "mappedPlatformsIdSet": [],
            "list": []
        },
        {
            "id": 104,
            "name": "OnScreen_Position_Instagram_Stories_And_Reels",
            "platformId": 3,
            "isActive": 1,
            "platformName": "Meta",
            "displayName": "OnScreen Position Facebook Stories And Reels",
            "description": "",
            "mappingDetails": [],
            "mappedPlatformsValueSet": [],
            "mappedPlatformsIdSet": [],
            "list": [
                {
                    "id": 3991,
                    "name": "story",
                    "platformId": 3,
                    "isActive": 1,
                    "platformName": "Meta",
                    "displayName": "Instagram Stories",
                    "mappingDetails": []
                },
                {
                    "id": 3993,
                    "name": "reels",
                    "platformId": 3,
                    "isActive": 1,
                    "platformName": "Meta",
                    "displayName": "Instagram Reels",
                    "mappingDetails": []
                },
                {
                    "id": 3995,
                    "name": "profile_reels",
                    "platformId": 3,
                    "isActive": 1,
                    "platformName": "Meta",
                    "displayName": "Instargram profile reels",
                    "mappingDetails": []
                }
            ]
        },
        {
            "id": 105,
            "name": "OnScreen_Position_Instagram_Feeds",
            "platformId": 3,
            "isActive": 1,
            "platformName": "Meta",
            "displayName": "OnScreen_Position_Instagram_Feeds",
            "description": "",
            "mappingDetails": [],
            "mappedPlatformsValueSet": [],
            "mappedPlatformsIdSet": [],
            "list": [
                {
                    "id": 3997,
                    "name": "stream",
                    "platformId": 3,
                    "isActive": 1,
                    "platformName": "Meta",
                    "displayName": "Instagram Feed",
                    "mappingDetails": []
                },
                {
                    "id": 3999,
                    "name": "profile_feed",
                    "platformId": 3,
                    "isActive": 1,
                    "platformName": "Meta",
                    "displayName": "Instagram profile feed",
                    "mappingDetails": []
                },
                {
                    "id": 4001,
                    "name": "explore",
                    "platformId": 3,
                    "isActive": 1,
                    "platformName": "Meta",
                    "displayName": "Instagram Explore",
                    "mappingDetails": []
                },
                {
                    "id": 4003,
                    "name": "explore_home",
                    "platformId": 3,
                    "isActive": 1,
                    "platformName": "Meta",
                    "displayName": "Instagram Explore Home",
                    "mappingDetails": []
                }
            ]
        },
        {
            "id": 106,
            "name": "OnScreen_Position_Instagram_Search_Results",
            "platformId": 3,
            "isActive": 1,
            "platformName": "Meta",
            "displayName": "OnScreen Position Instagram Search Results",
            "description": "",
            "mappingDetails": [],
            "mappedPlatformsValueSet": [],
            "mappedPlatformsIdSet": [],
            "list": [
                {
                    "id": 4005,
                    "name": "ig_search",
                    "platformId": 3,
                    "isActive": 1,
                    "platformName": "Meta",
                    "displayName": "Instagram Search Results",
                    "mappingDetails": []
                }
            ]
        },
        {
            "id": 107,
            "name": "OnScreen_Position_Audience_Network_Apps_And_Sites",
            "platformId": 3,
            "isActive": 1,
            "platformName": "Meta",
            "displayName": "OnScreen_Position_Audience_Network_Apps_And_Sites",
            "description": "",
            "mappingDetails": [],
            "mappedPlatformsValueSet": [],
            "mappedPlatformsIdSet": [],
            "list": [
                {
                    "id": 4007,
                    "name": "classic",
                    "platformId": 3,
                    "isActive": 1,
                    "platformName": "Meta",
                    "displayName": "Audience Network native, banner and interstitial",
                    "mappingDetails": []
                },
                {
                    "id": 4009,
                    "name": "rewarded_video",
                    "platformId": 3,
                    "isActive": 1,
                    "platformName": "Meta",
                    "displayName": "Audience Network rewarded videos",
                    "mappingDetails": []
                }
            ]
        },
        {
            "id": 108,
            "name": "OnScreen_Position_Messenger_Stories_And_Reels",
            "platformId": 3,
            "isActive": 1,
            "platformName": "Meta",
            "displayName": "OnScreen_Position_Messenger_Stories_And_Reels",
            "description": "",
            "mappingDetails": [],
            "mappedPlatformsValueSet": [],
            "mappedPlatformsIdSet": [],
            "list": [
                {
                    "id": 4011,
                    "name": "story",
                    "platformId": 3,
                    "isActive": 1,
                    "platformName": "Meta",
                    "displayName": "Messenger Stories",
                    "mappingDetails": []
                }
            ]
        },
        {
            "id": 109,
            "name": "Publisher_Platforms",
            "platformId": 3,
            "isActive": 1,
            "platformName": "Meta",
            "displayName": "Publisher_Platforms",
            "description": "",
            "mappingDetails": [],
            "mappedPlatformsValueSet": [],
            "mappedPlatformsIdSet": [],
            "list": [
                {
                    "id": 4013,
                    "name": "facebook",
                    "platformId": 3,
                    "isActive": 1,
                    "platformName": "Meta",
                    "displayName": "Facebook ",
                    "mappingDetails": []
                },
                {
                    "id": 4015,
                    "name": "instagram",
                    "platformId": 3,
                    "isActive": 1,
                    "platformName": "Meta",
                    "displayName": "Instagram",
                    "mappingDetails": []
                },
                {
                    "id": 4017,
                    "name": "messenger",
                    "platformId": 3,
                    "isActive": 1,
                    "platformName": "Meta",
                    "displayName": "Messenger",
                    "mappingDetails": []
                },
                {
                    "id": 4019,
                    "name": "audience_network",
                    "platformId": 3,
                    "isActive": 1,
                    "platformName": "Meta",
                    "displayName": "Audience Network",
                    "mappingDetails": []
                }
            ]
        },
        {
            "id": 110,
            "name": "OnScreen_Position_Messenger_Messages",
            "platformId": 3,
            "isActive": 1,
            "platformName": "Meta",
            "displayName": "OnScreen_Position_Messenger_Messages",
            "description": "",
            "mappingDetails": [],
            "mappedPlatformsValueSet": [],
            "mappedPlatformsIdSet": [],
            "list": [
                {
                    "id": 4021,
                    "name": "sponsored_messages",
                    "platformId": 3,
                    "isActive": 1,
                    "platformName": "Meta",
                    "displayName": "Messenger sponsored messages",
                    "mappingDetails": []
                }
            ]
        },
        {
            "id": 111,
            "name": "OnScreen_Position_Facebook_Instream_Ads",
            "platformId": 3,
            "isActive": 1,
            "platformName": "Meta",
            "displayName": "OnScreen_Position_Facebook_Instream_Ads",
            "description": "",
            "mappingDetails": [],
            "mappedPlatformsValueSet": [],
            "mappedPlatformsIdSet": [],
            "list": [
                {
                    "id": 4023,
                    "name": "instream_video",
                    "platformId": 3,
                    "isActive": 1,
                    "platformName": "Meta",
                    "displayName": "Facebook in-stream videos",
                    "mappingDetails": []
                },
                {
                    "id": 4025,
                    "name": "facebook_reels",
                    "platformId": 3,
                    "isActive": 1,
                    "platformName": "Meta",
                    "displayName": "Ads on Facebook Reels",
                    "mappingDetails": []
                }
            ]
        },
        {
            "id": 112,
            "name": "OnScreen_Position_Messenger_Feeds",
            "platformId": 3,
            "isActive": 1,
            "platformName": "Meta",
            "displayName": "OnScreen_Position_Messenger_Feeds",
            "description": "",
            "mappingDetails": [],
            "mappedPlatformsValueSet": [],
            "mappedPlatformsIdSet": [],
            "list": [
                {
                    "id": 4027,
                    "name": "messenger_home",
                    "platformId": 3,
                    "isActive": 1,
                    "platformName": "Meta",
                    "displayName": "Messenger inbox",
                    "mappingDetails": []
                }
            ]
        },
        {
            "id": 113,
            "name": "Bidding_Strategy_Video",
            "platformId": 4,
            "isActive": 1,
            "platformName": "Google Ads",
            "displayName": "Bidding Strategy Video",
            "description": "",
            "attributeMapping": 66,
            "mappingDetails": [
                {
                    "id": 66,
                    "name": "Bidding_Strategy_Video",
                    "platformId": 1,
                    "isActive": 1,
                    "platformName": "Beki",
                    "displayName": "Bidding_Strategy_Video"
                }
            ],
            "mappedPlatformsValueSet": [],
            "mappedPlatformsIdSet": [],
            "list": [
                {
                    "id": 4042,
                    "name": "TARGET_SPEND",
                    "platformId": 4,
                    "isActive": 1,
                    "platformName": "Google Ads",
                    "displayName": "Click",
                    "attributeMapping": 1779,
                    "mappingDetails": [
                        {
                            "id": 1779,
                            "name": "Maximize Click",
                            "platformId": 1,
                            "isActive": 1,
                            "platformName": "Beki",
                            "displayName": "Maximize Click",
                            "dbMappingId": 1132
                        }
                    ]
                },
                {
                    "id": 4044,
                    "name": "MAXIMIZE_CONVERSIONS",
                    "platformId": 4,
                    "isActive": 1,
                    "platformName": "Google Ads",
                    "displayName": "Conversion",
                    "mappingDetails": []
                },
                {
                    "id": 4046,
                    "name": "TARGET_CPA",
                    "platformId": 4,
                    "isActive": 1,
                    "platformName": "Google Ads",
                    "displayName": "Cost per Action",
                    "mappingDetails": []
                }
            ]
        }
    ],
    "length": 0
}

// Campaign Filters Data
export const campaignFilterData = {
    "bekiCampaign": [
        {
            "value": "DV360 Campaign",
            "key": 928
        },
        {
            "value": "Meta Campaign",
            "key": 887
        },
        {
            "value": "Google Ads Campaign",
            "key": 884
        },
        {
            "value": "Google Ads Recommended Campaign",
            "key": 765
        }
    ],
    "platformCampaign": [
        {
            "value": "DV360 Campaign_dv360_1",
            "key": 1406
        },
        {
            "value": "DV360 Campaign_dv360_2",
            "key": 1407
        },
        {
            "value": "Meta Campaign_meta_1",
            "key": 1351
        },
        {
            "value": "Google Ads Campaign_ads_1",
            "key": 1348
        },

    ],
}

// Creatives Data
export const creativesData = {
    "responseCode": {
        "msg": "Creative List Fetched Successfully",
        "status": "Success",
        "code": 4053
    },
    "length": 0,
    "responseObj": {
        "data": {
            "Recently Added": [
                {
                    "id": 1045,
                    "platId": 5,
                    "title": "Meta Creative",
                    "isApproved": 0,
                    "crType": 21,
                    "description": "Warning: Our flavors are addictive! Try it once, and you'll keep coming back.",
                    "heading": "",
                    "landingUrl": "https://devbeki.torcai.com/atd",
                    "tags": [],
                    "isRecActive": 0,
                    "isActive": 1,
                    "mediaList": [
                        {
                            "id": 1064,
                            "gcId": 1045,
                            "adSize": "588X754",
                            "isRecActive": 1,
                            "isActive": 1,
                            "url": "https://stagecdn.torcai.com/image/1872/1738048891605_starbucks-facebook-ad.gif",
                            "mimeType": "image/gif",
                            "bitrate": 0,
                            "duration": 0,
                            "tagUrl": "",
                            "isApproved": 0,
                            "trackers": []
                        }
                    ],
                    "mappedCampaigns": [
                        {
                            "key": 1260,
                            "value": "TestDevDv360_Nov25_dv360_1"
                        }
                    ],
                    "isSynced": 0
                },
                {
                    "id": 1145,
                    "platId": 5,
                    "title": "DV360 Creative",
                    "isApproved": 0,
                    "crType": 21,
                    "description": "Satisfy your hunger with the crunchiest, juiciest bites in town.",
                    "heading": "",
                    "landingUrl": "https://devbeki.torcai.com/atd",
                    "tags": [],
                    "isRecActive": 0,
                    "isActive": 1,
                    "mediaList": [
                        {
                            "id": 1064,
                            "gcId": 1045,
                            "adSize": "588X754",
                            "isRecActive": 1,
                            "isActive": 1,
                            "url": "https://stagecdn.torcai.com/image/1872/1738048891605_starbucks-facebook-ad.gif",
                            "mimeType": "image/gif",
                            "bitrate": 0,
                            "duration": 0,
                            "tagUrl": "",
                            "isApproved": 0,
                            "trackers": []
                        }
                    ],
                    "mappedCampaigns": [
                        {
                            "key": 1260,
                            "value": "TestDevDv360_Nov25_dv360_1"
                        }
                    ],
                    "isSynced": 0
                },
                {
                    "id": 1041,
                    "platId": 3,
                    "title": "Meta Creative",
                    "isApproved": 0,
                    "crType": 19,
                    "description": "Because every burger should be a masterpiece!",
                    "heading": "Food & Beverages",
                    "landingUrl": "https://devbeki.torcai.com/atd",
                    "tags": [],
                    "isRecActive": 1,
                    "isActive": 1,
                    "mediaList": [
                        {
                            "id": 1060,
                            "gcId": 1041,
                            "adSize": "588X754",
                            "isRecActive": 1,
                            "isActive": 1,
                            "url": "https://stagecdn.torcai.com/image/1872/1737959390990_starbucks-facebook-ad.gif",
                            "mimeType": "image/gif",
                            "bitrate": 0,
                            "duration": 0,
                            "tagUrl": "",
                            "isApproved": 0,
                            "trackers": []
                        }
                    ],
                    "mappedCampaigns": [
                        {
                            "key": 1396,
                            "value": "RecoDemoAdvPlan_meta_display1737724381054"
                        }
                    ],
                    "isSynced": 0
                },
                {
                    "id": 1040,
                    "platId": 3,
                    "title": "Meta Creative",
                    "isApproved": 0,
                    "crType": 20,
                    "description": "Bold coffee, smooth taste—start your day with a cup that wakes your soul.",
                    "heading": "Cafe & Beverages",
                    "landingUrl": "https://devbeki.torcai.com/atd",
                    "tags": [],
                    "isRecActive": 1,
                    "thumbnailUrl": "https://stagecdn.torcai.com/image/1872/1737959354986_starbucks-facebook-ad.gif",
                    "isActive": 1,
                    "mediaList": [
                        {
                            "id": 1059,
                            "gcId": 1040,
                            "adSize": "1280X720",
                            "isRecActive": 1,
                            "isActive": 1,
                            "url": "https://stagecdn.torcai.com/video/1872/1737959352992_114918-702646988_small.mp4",
                            "mimeType": "video/mp4",
                            "bitrate": 640,
                            "duration": 7.253,
                            "tagUrl": "",
                            "isApproved": 0,
                            "trackers": []
                        }
                    ],
                    "mappedCampaigns": [
                        {
                            "key": 1396,
                            "value": "RecoDemoAdvPlan_meta_display1737724381054"
                        }
                    ],
                    "isSynced": 0
                },
                {
                    "id": 1039,
                    "platId": 3,
                    "title": "Meta Creative",
                    "isApproved": 0,
                    "crType": 20,
                    "description": "Whether it's bubble tea or a fruit smoothie, we serve refreshment in every sip!",
                    "heading": "",
                    "landingUrl": "https://devbeki.torcai.com/atd",
                    "tags": [],
                    "isRecActive": 0,
                    "thumbnailUrl": "https://stagecdn.torcai.com/image/1872/1737959115584_images_(1).jpg",
                    "isActive": 1,
                    "mediaList": [
                        {
                            "id": 1058,
                            "gcId": 1039,
                            "adSize": "1280X720",
                            "isRecActive": 1,
                            "isActive": 1,
                            "url": "https://stagecdn.torcai.com/video/1872/1737959113554_114918-702646988_small.mp4",
                            "mimeType": "video/mp4",
                            "bitrate": 640,
                            "duration": 7.253,
                            "tagUrl": "",
                            "isApproved": 0,
                            "trackers": []
                        }
                    ],
                    "mappedCampaigns": [],
                    "isSynced": 0
                },
                {
                    "id": 1038,
                    "platId": 3,
                    "title": "Meta Creative",
                    "isApproved": 0,
                    "crType": 19,
                    "description": "The finest tea leaves, the richest flavors—experience pure relaxation in every cup.",
                    "heading": "Cafe & Beverages",
                    "landingUrl": "https://devbeki.torcai.com/atd",
                    "tags": [],
                    "isRecActive": 1,
                    "isActive": 1,
                    "mediaList": [
                        {
                            "id": 1057,
                            "gcId": 1038,
                            "adSize": "300X100",
                            "isRecActive": 1,
                            "isActive": 1,
                            "url": "https://stagecdn.torcai.com/image/1872/1737958626221_images_(1).jpg",
                            "mimeType": "image/jpeg",
                            "bitrate": 0,
                            "duration": 0,
                            "tagUrl": "",
                            "isApproved": 0,
                            "trackers": []
                        }
                    ],
                    "mappedCampaigns": [],
                    "isSynced": 0
                }
            ],
            "Google Ads": [
                {
                    "id": 1037,
                    "platId": 4,
                    "title": "Google Ads Creative",
                    "isApproved": 0,
                    "crType": 18,
                    "description": "Premium bird food packed with nutrients—because happy birds start with healthy meals!",
                    "heading": "Fuel Their Flight!",
                    "landingUrl": "https://devbeki.torcai.com/atd",
                    "tags": [],
                    "isRecActive": 1,
                    "isActive": 1,
                    "mediaList": [
                        {
                            "id": 1056,
                            "gcId": 1037,
                            "adSize": "300X100",
                            "isRecActive": 1,
                            "isActive": 1,
                            "url": "https://stagecdn.torcai.com/image/1872/1737958570809_images_(1).jpg",
                            "mimeType": "image/jpeg",
                            "bitrate": 0,
                            "duration": 0,
                            "tagUrl": "",
                            "isApproved": 0,
                            "trackers": []
                        }
                    ],
                    "mappedCampaigns": [
                        {
                            "key": 1395,
                            "value": "RecoDemoAdvPlan_ads_display1737724381030"
                        }
                    ],
                    "isSynced": 0
                }
            ],
            "DV360": [
                {
                    "id": 1045,
                    "platId": 5,
                    "title": "DV360 Creative",
                    "isApproved": 0,
                    "crType": 21,
                    "description": "Decadent, dreamy, and oh-so-creamy! Treat yourself to something unforgettable.",
                    "heading": "Too Sweet to Resist!",
                    "landingUrl": "https://devbeki.torcai.com/atd",
                    "tags": [],
                    "isRecActive": 1,
                    "isActive": 1,
                    "mediaList": [
                        {
                            "id": 1064,
                            "gcId": 1045,
                            "adSize": "588X754",
                            "isRecActive": 1,
                            "isActive": 1,
                            "url": "https://stagecdn.torcai.com/image/1872/1738048891605_starbucks-facebook-ad.gif",
                            "mimeType": "image/gif",
                            "bitrate": 0,
                            "duration": 0,
                            "tagUrl": "",
                            "isApproved": 0,
                            "trackers": []
                        }
                    ],
                    "mappedCampaigns": [
                        {
                            "key": 1260,
                            "value": "TestDevDv360_Nov25_dv360_1"
                        }
                    ],
                    "isSynced": 0
                },
                {
                    "id": 1036,
                    "platId": 5,
                    "title": "DV360 Creative",
                    "isApproved": 0,
                    "crType": 21,
                    "description": "Life is short—eat dessert first! Indulge guilt-free with our heavenly treats.",
                    "heading": "Your Cheat Day Just Got Better!",
                    "landingUrl": "https://images.pexels.com/photos/247851/pexels-photo-247851.jpeg?auto=compress&cs=tinysrgb&w=600",
                    "tags": [],
                    "isRecActive": 1,
                    "isActive": 1,
                    "mediaList": [
                        {
                            "id": 1055,
                            "gcId": 1036,
                            "adSize": "3840X2160",
                            "isRecActive": 1,
                            "isActive": 1,
                            "url": "https://stagecdn.torcai.com/image/1872/1737722780048_Nestle-Logo.png",
                            "mimeType": "image/png",
                            "bitrate": 0,
                            "duration": 0,
                            "tagUrl": "",
                            "isApproved": 0,
                            "trackers": []
                        }
                    ],
                    "mappedCampaigns": [
                        {
                            "key": 1394,
                            "value": "TestForDemoAdvertiserCampaign_dv360_1"
                        }
                    ],
                    "isSynced": 0
                }
            ],
            "Meta": [

                {
                    "id": 1041,
                    "platId": 3,
                    "title": "Meta Creative",
                    "isApproved": 0,
                    "crType": 19,
                    "description": " Enjoy all the flavor without the regrets—our clean, natural snacks are made for you.",
                    "heading": "Guilt-Free Indulgence",
                    "landingUrl": "https://devbeki.torcai.com/atd",
                    "tags": [],
                    "isRecActive": 1,
                    "isActive": 1,
                    "mediaList": [
                        {
                            "id": 1060,
                            "gcId": 1041,
                            "adSize": "588X754",
                            "isRecActive": 1,
                            "isActive": 1,
                            "url": "https://stagecdn.torcai.com/image/1872/1737959390990_starbucks-facebook-ad.gif",
                            "mimeType": "image/gif",
                            "bitrate": 0,
                            "duration": 0,
                            "tagUrl": "",
                            "isApproved": 0,
                            "trackers": []
                        }
                    ],
                    "mappedCampaigns": [
                        {
                            "key": 1396,
                            "value": "RecoDemoAdvPlan_meta_display1737724381054"
                        }
                    ],
                    "isSynced": 0
                },
                {
                    "id": 1040,
                    "platId": 3,
                    "title": "Meta Creative",
                    "isApproved": 0,
                    "crType": 20,
                    "description": "Bold spices, slow-cooked perfection—every bite is a masterpiece.",
                    "heading": "Where Flavor Meets Fire!",
                    "landingUrl": "https://devbeki.torcai.com/atd",
                    "tags": [],
                    "isRecActive": 1,
                    "thumbnailUrl": "https://stagecdn.torcai.com/image/1872/1737959354986_starbucks-facebook-ad.gif",
                    "isActive": 1,
                    "mediaList": [
                        {
                            "id": 1059,
                            "gcId": 1040,
                            "adSize": "1280X720",
                            "isRecActive": 1,
                            "isActive": 1,
                            "url": "https://stagecdn.torcai.com/video/1872/1737959352992_114918-702646988_small.mp4",
                            "mimeType": "video/mp4",
                            "bitrate": 640,
                            "duration": 7.253,
                            "tagUrl": "",
                            "isApproved": 0,
                            "trackers": []
                        }
                    ],
                    "mappedCampaigns": [
                        {
                            "key": 1396,
                            "value": "RecoDemoAdvPlan_meta_display1737724381054"
                        }
                    ],
                    "isSynced": 0
                },
                {
                    "id": 1039,
                    "platId": 3,
                    "title": "Meta Creative",
                    "isApproved": 0,
                    "crType": 20,
                    "description": "Premium bird food packed with nutrients—because happy birds start with healthy meals!",
                    "heading": "Fuel Their Flight!",
                    "landingUrl": "https://devbeki.torcai.com/atd",
                    "tags": [],
                    "isRecActive": 1,
                    "thumbnailUrl": "https://stagecdn.torcai.com/image/1872/1737959115584_images_(1).jpg",
                    "isActive": 1,
                    "mediaList": [
                        {
                            "id": 1058,
                            "gcId": 1039,
                            "adSize": "1280X720",
                            "isRecActive": 1,
                            "isActive": 1,
                            "url": "https://stagecdn.torcai.com/video/1872/1737959113554_114918-702646988_small.mp4",
                            "mimeType": "video/mp4",
                            "bitrate": 640,
                            "duration": 7.253,
                            "tagUrl": "",
                            "isApproved": 0,
                            "trackers": []
                        }
                    ],
                    "mappedCampaigns": [],
                    "isSynced": 0
                },
                {
                    "id": 1038,
                    "platId": 3,
                    "title": "Meta Creative",
                    "isApproved": 0,
                    "crType": 19,
                    "description": "Premium bird food packed with nutrients—because happy birds start with healthy meals!",
                    "heading": "Fuel Their Flight!",
                    "landingUrl": "https://devbeki.torcai.com/atd",
                    "tags": [],
                    "isRecActive": 1,
                    "isActive": 1,
                    "mediaList": [
                        {
                            "id": 1057,
                            "gcId": 1038,
                            "adSize": "300X100",
                            "isRecActive": 1,
                            "isActive": 1,
                            "url": "https://stagecdn.torcai.com/image/1872/1737958626221_images_(1).jpg",
                            "mimeType": "image/jpeg",
                            "bitrate": 0,
                            "duration": 0,
                            "tagUrl": "",
                            "isApproved": 0,
                            "trackers": []
                        }
                    ],
                    "mappedCampaigns": [],
                    "isSynced": 0
                }
            ],
            "Beki": [],
            "ION": [],
            "ViAds": [],
            "IOH": []
        },
        "length": {
            "Recently Added": 8,
            "Google Ads": 1,
            "DV360": 2,
            "Meta": 5,
            "Beki": 0,
            "ION": 0,
            "ViAds": 0,
            "IOH": 0
        }
    }
}

// All Creatives Data
export const allCreativesData = {
    "responseCode": {
        "msg": "Creative List Fetched Successfully",
        "status": "Success",
        "code": 4053
    },
    "length": 0,
    "responseObj": {
        "data": {
            "Recently Added": [
                {
                    "id": 1045,
                    "platId": 5,
                    "title": "DV360 Creative",
                    "isApproved": 0,
                    "crType": 21,
                    "description": "Satisfy your hunger with the crunchiest, juiciest bites in town.",
                    "heading": "",
                    "landingUrl": "https://devbeki.torcai.com/atd",
                    "tags": [],
                    "isRecActive": 0,
                    "isActive": 1,
                    "mediaList": [
                        {
                            "id": 1064,
                            "gcId": 1045,
                            "adSize": "588X754",
                            "isRecActive": 1,
                            "isActive": 1,
                            "url": "https://stagecdn.torcai.com/image/1872/1738048891605_starbucks-facebook-ad.gif",
                            "mimeType": "image/gif",
                            "bitrate": 0,
                            "duration": 0,
                            "tagUrl": "",
                            "isApproved": 0,
                            "trackers": []
                        }
                    ],
                    "mappedCampaigns": [
                        {
                            "key": 1260,
                            "value": "TestDevDv360_Nov25_dv360_1"
                        }
                    ],
                    "isSynced": 0
                },
                {
                    "id": 1145,
                    "platId": 5,
                    "title": "DV360 Creative",
                    "isApproved": 0,
                    "crType": 21,
                    "description": "Satisfy your hunger with the crunchiest, juiciest bites in town.",
                    "heading": "",
                    "landingUrl": "https://devbeki.torcai.com/atd",
                    "tags": [],
                    "isRecActive": 0,
                    "isActive": 1,
                    "mediaList": [
                        {
                            "id": 1064,
                            "gcId": 1045,
                            "adSize": "588X754",
                            "isRecActive": 1,
                            "isActive": 1,
                            "url": "https://stagecdn.torcai.com/image/1872/1738048891605_starbucks-facebook-ad.gif",
                            "mimeType": "image/gif",
                            "bitrate": 0,
                            "duration": 0,
                            "tagUrl": "",
                            "isApproved": 0,
                            "trackers": []
                        }
                    ],
                    "mappedCampaigns": [
                        {
                            "key": 1260,
                            "value": "TestDevDv360_Nov25_dv360_1"
                        }
                    ],
                    "isSynced": 0
                },
                {
                    "id": 1041,
                    "platId": 3,
                    "title": "Meta Creative",
                    "isApproved": 0,
                    "crType": 19,
                    "description": "Because every burger should be a masterpiece!",
                    "heading": "Food & Beverages",
                    "landingUrl": "https://devbeki.torcai.com/atd",
                    "tags": [],
                    "isRecActive": 1,
                    "isActive": 1,
                    "mediaList": [
                        {
                            "id": 1060,
                            "gcId": 1041,
                            "adSize": "588X754",
                            "isRecActive": 1,
                            "isActive": 1,
                            "url": "https://stagecdn.torcai.com/image/1872/1737959390990_starbucks-facebook-ad.gif",
                            "mimeType": "image/gif",
                            "bitrate": 0,
                            "duration": 0,
                            "tagUrl": "",
                            "isApproved": 0,
                            "trackers": []
                        }
                    ],
                    "mappedCampaigns": [
                        {
                            "key": 1396,
                            "value": "RecoDemoAdvPlan_meta_display1737724381054"
                        }
                    ],
                    "isSynced": 0
                },
                {
                    "id": 1040,
                    "platId": 3,
                    "title": "Meta Creative",
                    "isApproved": 0,
                    "crType": 20,
                    "description": "Bold coffee, smooth taste—start your day with a cup that wakes your soul.",
                    "heading": "Cafe & Beverages",
                    "landingUrl": "https://devbeki.torcai.com/atd",
                    "tags": [],
                    "isRecActive": 1,
                    "thumbnailUrl": "https://stagecdn.torcai.com/image/1872/1737959354986_starbucks-facebook-ad.gif",
                    "isActive": 1,
                    "mediaList": [
                        {
                            "id": 1059,
                            "gcId": 1040,
                            "adSize": "1280X720",
                            "isRecActive": 1,
                            "isActive": 1,
                            "url": "https://stagecdn.torcai.com/video/1872/1737959352992_114918-702646988_small.mp4",
                            "mimeType": "video/mp4",
                            "bitrate": 640,
                            "duration": 7.253,
                            "tagUrl": "",
                            "isApproved": 0,
                            "trackers": []
                        }
                    ],
                    "mappedCampaigns": [
                        {
                            "key": 1396,
                            "value": "RecoDemoAdvPlan_meta_display1737724381054"
                        }
                    ],
                    "isSynced": 0
                },
                {
                    "id": 1039,
                    "platId": 3,
                    "title": "Meta Creative",
                    "isApproved": 0,
                    "crType": 20,
                    "description": "Premium bird food packed with nutrients—because happy birds start with healthy meals!",
                    "heading": "Fuel Their Flight!",
                    "landingUrl": "https://devbeki.torcai.com/atd",
                    "tags": [],
                    "isRecActive": 0,
                    "thumbnailUrl": "https://stagecdn.torcai.com/image/1872/1737959115584_images_(1).jpg",
                    "isActive": 1,
                    "mediaList": [
                        {
                            "id": 1058,
                            "gcId": 1039,
                            "adSize": "1280X720",
                            "isRecActive": 1,
                            "isActive": 1,
                            "url": "https://stagecdn.torcai.com/video/1872/1737959113554_114918-702646988_small.mp4",
                            "mimeType": "video/mp4",
                            "bitrate": 640,
                            "duration": 7.253,
                            "tagUrl": "",
                            "isApproved": 0,
                            "trackers": []
                        }
                    ],
                    "mappedCampaigns": [],
                    "isSynced": 0
                },
                {
                    "id": 1038,
                    "platId": 3,
                    "title": "Meta Creative",
                    "isApproved": 0,
                    "crType": 19,
                    "description": "Premium bird food packed with nutrients—because happy birds start with healthy meals!",
                    "heading": "Fuel Their Flight!",
                    "landingUrl": "https://devbeki.torcai.com/atd",
                    "tags": [],
                    "isRecActive": 1,
                    "isActive": 1,
                    "mediaList": [
                        {
                            "id": 1057,
                            "gcId": 1038,
                            "adSize": "300X100",
                            "isRecActive": 1,
                            "isActive": 1,
                            "url": "https://stagecdn.torcai.com/image/1872/1737958626221_images_(1).jpg",
                            "mimeType": "image/jpeg",
                            "bitrate": 0,
                            "duration": 0,
                            "tagUrl": "",
                            "isApproved": 0,
                            "trackers": []
                        }
                    ],
                    "mappedCampaigns": [],
                    "isSynced": 0
                },
                {
                    "id": 1037,
                    "platId": 4,
                    "title": "Google Ads Creative",
                    "isApproved": 0,
                    "crType": 18,
                    "description": "Premium bird food packed with nutrients—because happy birds start with healthy meals!",
                    "heading": "Fuel Their Flight!",
                    "landingUrl": "https://devbeki.torcai.com/atd",
                    "tags": [],
                    "isRecActive": 1,
                    "isActive": 1,
                    "mediaList": [
                        {
                            "id": 1056,
                            "gcId": 1037,
                            "adSize": "300X100",
                            "isRecActive": 1,
                            "isActive": 1,
                            "url": "https://stagecdn.torcai.com/image/1872/1737958570809_images_(1).jpg",
                            "mimeType": "image/jpeg",
                            "bitrate": 0,
                            "duration": 0,
                            "tagUrl": "",
                            "isApproved": 0,
                            "trackers": []
                        }
                    ],
                    "mappedCampaigns": [
                        {
                            "key": 1395,
                            "value": "RecoDemoAdvPlan_ads_display1737724381030"
                        }
                    ],
                    "isSynced": 0
                },
                {
                    "id": 1036,
                    "platId": 5,
                    "title": "DV360 Creative",
                    "isApproved": 0,
                    "crType": 21,
                    "description": "Decadent, dreamy, and oh-so-creamy! Treat yourself to something unforgettable.",
                    "heading": "Too Sweet to Resist!",
                    "landingUrl": "https://images.pexels.com/photos/247851/pexels-photo-247851.jpeg?auto=compress&cs=tinysrgb&w=600",
                    "tags": [],
                    "isRecActive": 1,
                    "isActive": 1,
                    "mediaList": [
                        {
                            "id": 1055,
                            "gcId": 1036,
                            "adSize": "3840X2160",
                            "isRecActive": 1,
                            "isActive": 1,
                            "url": "https://stagecdn.torcai.com/image/1872/1737722780048_Nestle-Logo.png",
                            "mimeType": "image/png",
                            "bitrate": 0,
                            "duration": 0,
                            "tagUrl": "",
                            "isApproved": 0,
                            "trackers": []
                        }
                    ],
                    "mappedCampaigns": [
                        {
                            "key": 1394,
                            "value": "TestForDemoAdvertiserCampaign_dv360_1"
                        }
                    ],
                    "isSynced": 0
                }
            ]
        },
        "length": {
            "Recently Added": 8
        }
    }
}